WS.ui = {};
WS.ui.productImageAlt = function(rawAlt, productTitle, position, total) {
  var title = String(productTitle || 'Product').trim();
  var alt = String(rawAlt || '').trim();
  return alt && alt !== title ? alt : title + ', product image ' + position + ' of ' + (total || position);
};
/**
 * 请求接口地址集合
 * html片段
 */
(function () {
  var routes = {
    getCartListUrl: `${WS.site.baseUrl}/cart?sections=westyle-cart`,
    addCartItemUrl: `${WS.site.baseUrl}/cart/add.js`,
    updateCartItemUrl: `${WS.site.baseUrl}/cart/update.js`,
    changeCarItemtUrl: `${WS.site.baseUrl}/cart/change.js`,
    getCarJSONUrl: `${WS.site.baseUrl}/cart?sections=westyle-cart-data`,
    // 投票答题接口
    writeQuestionApi: "/global/rest/v1/api/activity/vote/question/fillOutQuestion",
    questionListApi: "/global/rest/v1/api/activity/vote/question/list",
    // 用户登录注册忘记密码模块
    userLoginMailApi: "/global/rest/v1/api/user/login/mail",
    userRegisterMailApi: "/global/rest/v1/api/user/mail/register",
    userForgetPswMailApi: "/global/rest/v1/api/user/sendForgetPasswordEmail",
    resetPasswordApi: "/global/rest/v1/api/user/changePassword",
    // 发送邮箱登录验证码
    sendLoginVerifyCode: "/global/rest/v1/api/user/sendLoginVerifyCode",
    // 通过邮箱验证码登录
    loginByVerifyCode: "/global/rest/v1/api/user/loginByVerifyCode",
    // 发送登录链接到邮箱
    sendLoginLinkToEmail: "/global/rest/v1/api/user/sendLoginLinkToEmail",
    // 通过邮箱链接登录
    loginFromEmailLoginLink: "/global/rest/v1/api/user/loginFromEmailLoginLink",
    // 第三方登录
    loginFromFacebook: "/global/rest/v1/api/user/login/from/facebook",
    loginFromGoogle: "/global/rest/v1/api/user/login/from/google",
    loginFromApple: "/global/rest/v1/api/user/login/from/apple",
    // 评论
    getProductCommentInfo: '/global/rest/v1/api/shopify/comment/getProductCommentInfo',
    getRecomComments: '/global/rest/v1/api/shopify/comment/queryMainPageComments',
    batchGetProductRating: '/global/rest/v1/api/shopify/comment/batchGetProductRating',
    getUserOrderCommentInfoApi: '/global/rest/v1/api/shopify/comment/getUserOrderCommentInfo',
    saveUserOrderCommentApi: '/global/rest/v1/api/shopify/comment/saveUserOrderComment',
    fileUploadImagesApi: '/global/rest/v1/api/shopify/file/uploadImages',
    getShopCommentConfigApi: '/global/rest/v1/api/shopify/comment/getShopCommentConfig',

    // 个人中心
    getUserInfo: '/global/rest/v1/api/user/points/queryUserPointsInfo',
    // 我的订单
    getMyOrders: '/global/rest/v1/api/shopify/order/queryShopifyOrderPageV2',
    // 用户积分服务
    queryUserPointsInfoApi: "/global/rest/v1/api/user/points/queryUserPointsInfo",
    redeemDiscountCodeApi: "/global/rest/v1/api/user/points/redeemDiscountCode",
    queryUserPointsDetailApi: "/global/rest/v1/api/user/points/queryUserPointsDetail",
    queryVipInfoApi: "/global/rest/v1/api/user/points/queryVipInfo",
    doPointsTaskApi: "/global/rest/v1/api/user/points/doPointsTask",
    queryUserCouponsApi: "/global/rest/v1/api/user/points/queryUserCoupons",
    checkAndReceiveDiscountCode: "/global/rest/v1/api/user/points/checkAndReceiveDiscountCode",
    // 多语言
    changeUserLanguage: '/global/rest/v1/api/shopify/i18n/changeUserLanguage',

    // 查询Shopify商品列表
    productQueryProductList: '/global/rest/v1/api/shopify/product/queryProductList',

    // 查询集合banner组件配置
    listBannerByCollectionId: '/global/rest/v1/api/shopify/collection/listBannerByCollectionId',
    // 网红关联商品集合
    getKolProducts: `${WS.site.baseUrl}/collections/grae-cove-irl?sections=ws-kol-data`,
    // 查询邮箱是否有上传尺码
    checkHasSizeByEmail: '/global/rest/v1/api/shopify/body/size/hasWriteBodySize',
    // 提交用户尺码
    submitUserBodySize: '/global/rest/v1/api/shopify/body/size/saveUserBodySize',
    // 获取退款订单
    getOrderRefundList: '/global/rest/v1/api/shopify/order/queryOrderRefundList',
    // 提交退款数据
    submitOrderRefundList: '/global/rest/v1/api/shopify/order/submitOrderRefundList',
    getCanExchangeProducts: `${WS.site.baseUrl}/collections/all-clothing?sections=ws-exchange-data`,
    getCollectionFilter: '/global/rest/v1/api/shopify/product/getCollectionFilter',
    getCollectionSkcList: '/global/rest/v1/api/shopify/product/pageCollectionSkc',
    getOrderInfo: '/global/rest/v1/api/order/pageOrder',
    submitVoteEmail: '/global/rest/v1/api/user/tagUserByEmail',
    // 获取赠品库存信息
    getGiftStock: '/global/rest/v1/api/shopify/product/fetchPillowcasesStock',
    // 消耗赠品库存
    consumeGiftStock: '/global/rest/v1/api/shopify/product/consumeOnePillowcasesStock',
    submitUserRedeemInfo: '/global/rest/v1/api/shopify/order/submitUserRedeemInfo',
    getUserRedeemInfo: '/global/rest/v1/api/shopify/order/getUserRedeemInfo'
  };

  WS.ui.routes = routes;
})();

/**
 * GraphQL 请求基础方法（Shopify Storefront API）
 * @param {Object} opts 配置项
 * @param {string} opts.query - GraphQL 查询/变更字符串（必填）
 * @param {Object} [opts.variables] - 查询变量
 * @param {string} [opts.accessToken] - Storefront Access Token，不传则使用默认值
 * @param {Function} [opts.success] - 成功回调 (res) => {}，res 为统一格式化后的 { success, data, errors, message }
 * @param {Function} [opts.error] - 失败回调 (err) => {}
 * @returns {Promise<{success: boolean, data: *, errors: Array, message: string}>}
 *
 * @example
 * // 简单 query
 * WS.ui.graphql({
 *   query: '{ shop { name } }',
 *   success: function(res) { console.log(res.data); }
 * });
 *
 * @example
 * // 带变量的 query
 * WS.ui.graphql({
 *   query: 'query($id: ID!) { product(id: $id) { title } }',
 *   variables: { id: 'gid://shopify/Product/123' },
 *   success: function(res) { if (res.success) console.log(res.data); }
 * });
 *
 * @example
 * // Promise 方式
 * var res = await WS.ui.graphql({ query: '...' });
 */
(function () {
  var GRAPHQL_URL = location.origin + '/api/2026-01/graphql.json';
  var DEFAULT_ACCESS_TOKEN = '3583d2c371e749b28715768c80b9d7e0';

  function formatGraphQLResponse(raw) {
    var hasData = raw && raw.data !== undefined;
    var hasErrors = raw && raw.errors && raw.errors.length > 0;
    var success = hasData && !hasErrors;
    var message = '';
    if (hasErrors) {
      message = raw.errors.map(function (e) { return (e && e.message) || ''; }).filter(Boolean).join('; ') || 'GraphQL request failed';
    }
    return {
      success: success,
      data: hasData ? raw.data : null,
      errors: hasErrors ? raw.errors : [],
      message: message
    };
  }

  WS.ui.graphql = function (opts) {
    if (!opts || !opts.query) {
      var invalidRes = formatGraphQLResponse({});
      invalidRes.success = false;
      invalidRes.message = 'graphql: query is required';
      opts && opts.error && opts.error(invalidRes);
      return Promise.resolve(invalidRes);
    }
    var token = opts.accessToken || (WS.site && WS.site.graphqlAccessToken) || DEFAULT_ACCESS_TOKEN;
    var payload = opts.variables ? { query: opts.query, variables: opts.variables } : opts.query;
    var contentType = opts.variables ? 'application/json' : 'application/graphql';
    var requestData = typeof payload === 'string' ? payload : JSON.stringify(payload);

    return new Promise(function (resolve, reject) {
      WS.ajax({
        url: GRAPHQL_URL,
        type: 'post',
        contentType: contentType,
        headers: {
          'Content-Type': contentType,
          'X-Shopify-Storefront-Access-Token': token
        },
        data: requestData,
        dataType: 'json',
        success: function (raw) {
          var res = formatGraphQLResponse(raw || {});
          opts.success && opts.success(res);
          resolve(res);
        },
        error: function (xhr, status, err) {
          var res = formatGraphQLResponse(xhr && xhr.responseJSON ? xhr.responseJSON : {});
          res.success = false;
          if (!res.message) {
            res.message = (err && err.message) || status || 'Network error';
          }
          opts.error && opts.error(res);
          reject(res);
        }
      });
    });
  };
})();

/**
 * 常量
 * reportType 上报类型
 * reportMap 上报字段  这里区分了购物车页面和侧边栏
 */
(function() {
  var reportType = {
    'moduleShow': 'module_show',
    'click': 'click',
    'custom': 'custom',
    'forTest': 'for_test'
  }
  // 侧边栏
  var reportMap = {
    'cartDrawerOpen': 'bag_drawer.clc_push',
    'cartDrawerAutoOpen': 'bag_drawer.self_push',
    'cartCheckout': 'checkout.bag_drawer',
    'couponCode': 'copy_code.bag_drawer',
    'changeSku': 'changeSku',
    'changeSkuByOnSell': 'change_sku.bag_items.bag_drawer',
    'changeSkuBySoldout': 'change_sku.sold_out_items.bag_drawer',
    'increaseCartItemQuantity': 'add_quantity.bag_drawer',
    'minusCartItemQuantity': 'subtract_quantity.bag_drawer',
    'delCartItem': 'delCartItem',
    'delCartItemByOnSell': 'delete.bag_items.bag_drawer',
    'delCartItemBySoldout': 'delete.sold_out_items.bag_drawer',
    'delAllSoldout': 'delete_all.sold_out_items.bag_drawer',    
    'updateCartItem': 'update_bag_items.bag_drawer',
    'checkoutSoldout': 'sold_out_tip.checkout.bag_drawer',
    'confirmCheckoutSoldout': 'delete_and_continue_chekout.sold_out_items.bag_drawer',
    'closeCartDrawer': 'ic_close.bag_drawer',
    'closeSoldoutDrawer': 'ic_close.sold_out_tips',
    'closeChangeSkuDrawer': 'ic_close.change_sku',
    'clickCartDrawerOverlay': 'blank.bag_drawer',
    'clickChangeSkuOverlay': 'blank.change_sku',
    'clickSoldOoutOverlay': 'blank.sold_out_tips',
    'visitProductDetails': 'visitProductDetails',
    'visitProductDetailsByOnSell': 'product_details.bag_items.bag_drawer',
    'visitProductDetailsBySoldout': 'product_details.sold_out_items.bag_drawer',
    'visitProductDetailsByBoughtTother': 'product_details.bought_together.bag_drawer',
    'visitProductDetailsByCollection': 'product_details.collection.bag_drawer',
    'showBoughtTogether': 'product_show.bought_together.bag_drawer',
    'showBestTogether': 'product_show.collection.bag_drawer',
    'clickGoCheckout': 'go_checkout',
    'clickApplyCode': 'apply_code',
    'clickTotalDetail': 'total_detail',
    'showSalePop': 'sale_pop',
    'cartStateEmpty': 'bag_state.empty',
    'cartStateNormal': 'bag_state.normal',
    'cartStateHasSoldOut': 'bag_state.has_sold_out',
    'cartStateError': 'bag_state.error',
    'cartStateOnlySoldOut': 'bag_state.only_sold_out',
    'clickCouponsListOpen': 'coupons_list_open',
    'showCouponsListPop': 'coupons_list_pop',
    'clickBtnCocnfirm': 'btn_cocnfirm',
    'clickCancelUse': 'cancel_use',
    'clickIcCloseCouponsListPop': 'ic_close.coupons_list_pop',
    'clickBlankCouponsListPop': 'blank.coupons_list_pop',
  }

  // 购物车页面上报字段
  if (WS.site.page == 'cart') {
    reportMap = {
      'cartCheckout': 'checkout',
      'couponCode': 'copy_code',
      'changeSku': 'changeSku',
      'changeSkuByOnSell': 'change_sku.bag_items',
      'changeSkuBySoldout': 'change_sku.sold_out_items',
      'increaseCartItemQuantity': 'add_quantity',
      'minusCartItemQuantity': 'subtract_quantity',
      'delCartItem': 'delCartItem',
      'delCartItemByOnSell': 'delete.bag_item',
      'delCartItemBySoldout': 'delete.sold_out_items',
      'delAllSoldout': 'delete_all.sold_out_items',
      'updateCartItem': 'update_bag_items',
      'checkoutSoldout': 'sold_out_tip.checkout',
      'confirmCheckoutSoldout': 'delete_and_continue_chekout.sold_out_items',
      'closeSoldoutDrawer': 'ic_close.sold_out_tips',
      'closeChangeSkuDrawer': 'ic_close.change_sku',
      'clickChangeSkuOverlay': 'blank.change_sku',
      'clickSoldOoutOverlay': 'blank.sold_out_tips',
      'visitProductDetails': 'visitProductDetails',
      'visitProductDetailsByOnSell': 'product_details.bag_items',
      'visitProductDetailsBySoldout': 'product_details.sold_out_items',
      'visitProductDetailsByBoughtTother': 'product_details.bought_together',
      'showBoughtTogether': 'product_show.bought_together',
      'showBestTogether': 'product_show.collection',
      'clickGoCheckout': 'go_checkout',
      'clickApplyCode': 'apply_code',
      'clickTotalDetail': 'total_detail',
      'showSalePop': 'sale_pop',
      'cartStatsEmpty': 'bag_state.empty',
      'cartStateNormal': 'bag_state.normal',
      'cartStateHasSoldOut': 'bag_state.has_sold_out',
      'cartStateError': 'bag_state.error',
      'cartStateOnlySoldOut': 'bag_state.only_sold_out',
      'clickCouponsListOpen': 'coupons_list_open',
      'showCouponsListPop': 'coupons_list_pop',
      'clickBtnCocnfirm': 'btn_cocnfirm',
      'clickCancelUse': 'cancel_use',
      'clickIcCloseCouponsListPop': 'ic_close.coupons_list_pop',
      'clickBlankCouponsListPop': 'blank.coupons_list_pop',
    }
  }

  // 商品详情页
  var productReportMap = {
    'showProductPicture': 'product_picture',
    'showProductAlsoLike': 'product_show.also_like',
    'clickProductAlsoLike': 'product_details.also_like',
    'showProductPairItWith': 'product_show.pair_it_with',
    'clickProductPairItWith': 'product_details.pair_it_with',
    'clickProductPicture': 'product_picture',
    'clickProductColor': 'color_click.product',
    'clickCollectionColor': 'color_click.',
    'clickBagPopColor': 'color_click.add_to_bag_pop',
    'clickProductSize': 'size_click.product',
    'clickBagPopSize': 'size_click.add_to_bag_pop',
    'clickSelectSize': 'size_click.select_pop',
    'clickSizeSelectProduct': 'size_select_click_product',
    'showSizeSelectPopProduct': 'size_select_pop_product',
    'showSizeSelectPopProductsize': 'size_select_pop_productsize',
    'showSizeSelectPopBodysize': 'size_select_pop_bodysize',
    'showSizeSelectPopFittag': 'size_select_pop_fittag',
    'showSizeSelectPopModelsize': 'size_select_pop_modelsize',
    'showSizeGuidePop': 'size_guide_pop',
    'showSizeGuidePopProductSize': 'size_guide_pop_productsize',
    'clickSizeGuidePopProductSize': 'size_guide_pop_productsize',
    'clickSizeGuidePopBodySize': 'size_guide_pop_bodysize',
    'clickSizeGuidePopCountry': 'size_guide_pop_country',
    'clickCheckoutBuyitnow': 'checkout.buy_it_now',
    'clickBuyitnowToAddToBag': 'add_to_bag.product.buy_it_now',
    'clickAddtobagProductPop': 'add_to_bag.product_pop',
    'clickAddtobagProduct': 'add_to_bag.product',
    'clickAddtobagHomeCollection': 'add_to_bag.home',
    'clickAddtobagCollection': 'add_to_bag.collection',
    'clickAddtobagBottomCollection': 'add_to_bag.bottom_collection',
    'clickAddtobagRecentlyViewed': 'add_to_bag.recently_viewed',
    'clickAddtobagAlsoLike': 'add_to_bag.also_like',
    'clickAddtobagBoughtTogether': 'add_to_bag.bought_together',
    'clickAddtobagSearch': 'add_to_bag.search',
    'clickAddtobagIcon': 'add_to_bag_icon',
    'clickAddtobagPop': 'add_to_bag_pop',
    'clickReviews': 'reviews',
    'clickWriteReview': 'write_a_review',
    'clickShowMoreReview': 'show_more_review',
    'showReviews': 'reviews_show',
    'showBodySizeAbt': 'body_size.size_abt',
    'clickBodySizeAbt': 'body_size.size_abt',
    'showProductSizeAbt': 'product_size.size_abt',
    'clickProductSizeAbt': 'product_size.size_abt',
    'showStandardShipping': 'standard_shipping',
    'showFreeReturn': 'free_return',
    'showProductDetails': 'product_details',
    'showMatericalCare': 'materical_care',
    'clickSizeUnitCm': 'size_unit_cm',
    'clickSizeUnitInch': 'size_unit_inch',
    'showModelInformation': 'model_information',
    'showShoppingSecurity': 'shopping_security',
    'showShoppingSecurityPop': 'shopping_security_pop',
    'clickWhySoLow': 'why_so_low_click.product',
    'clickShoppingSecurityDetails': 'shopping_security_details',
    'clickShippingDetails':'shipping_details',
    'clickReturnDetails':'return_details',
    'clickDescDetails':'description_details',
    'clickCareInstrDetails':'care_instructions_details',
    'clickDetailsDetails':'details_details',
    'clickReviewsViewMore':'view_more_details',
    'showShopSecurityProduct':'shop_security.product',
    'clickShopSecurityProduct':'shop_security.product',
    'showShippingPopProduct':'shipping_pop.product',
    'showReturnPopProduct':'return_pop.product',
    'showShopSecurityPopProduct':'shop_security_pop.product',
    'showDescriptionDetailsProduct':'description_details.product',
    'showMaterialDetailsProduct':'material_details.product',
    'showCareInstructionsDetailsProduct':'care_instructions_details.product',
    'showDetailsDetailsProduct':'details_details.product',
    'showFeatureProduct':'feature.product',
    'showSchematicProduct':'Schematic.product',
    'showPriceComparisonProduct':'price_comparison.product',
    'showTotalCostProduct':'total_cost.product',
    'showBrandValueProduct':'brand_value.product',
    'showReferEarnProduct':'refer_earn.product',
    'showBagPopDiscountTipsProduct': 'bag_pop_discount_tips_product',
    'clickIcCloseBagPopDiscountTipsProduct': 'ic_close.bag_pop_discount_tips_product',
    'showBotDiscountTipsByGuest': 'join_us.bottom_discount_tips_product',
    'showBotMemberDiscountTipsByMember': 'member_coupon.bottom_discount_tips_product',
    'showBotMarketDiscountTipsByMember': 'sales_coupon.bottom_discount_tips_product',
    'showDiscountTipsByGuest': 'join_us.discount_tips_product',
    'showMemberDiscountTipsByMember': 'member_coupon.discount_tips_product',
    'showMarketDiscountTipsByMember': 'sales_coupon.discount_tips_product'
  }

  // 列表集合页
  var collectionReportMap = {
    'showProductCollection': 'product_show.collection',
    'clickProductCollection': 'product_details.collection',
    'clickRecentlyViewedCollection': 'product_details.recently_viewed',
    'clickBottomCollection': 'product_details.bottom_collection',
    'clickBestMatchCollection': 'best_match_click.collection',
    'clickNewestCollection': 'newest_click.collection',
    'clickPriceCollection': 'price_click.collection',
    'clickTagsCollection': 'tags_click.collection',
    'clickBackTop': 'top_click',
    'showTopBannerCollection': 'top_banner.collection',
    'showTopTextCollection': 'top_text.collection',
    'showRecentlyViewedCollection': 'product_show.recently_viewed',
    'clickRecentlyViewedProductCollection': 'product_details.recently_viewed',
    'showBottomBannerCollection': 'bottom_banner.collection',
    'clickBottomBannerCollection': 'bottom_banner.collection',
    'showBottomPictureCollection': 'bottom_picture.collection',
    'clickBottomPictureCollection': 'bottom_picture.collection',
    'showBottomCollectionCollection': 'bottom_collection.collection',
    'showBottomProductCollection': 'product_show.bottom_collection',
    'clickBottomProductCollection': 'product_details.bottom_collection',
  }

  // 首页
  var homeReportMap = {
    'showHomeSection': 'sections_show.home',
    'clickHomeSection': 'sections_click.home',
    'showProductHome': 'product_show.home',
    'clickProductHome': 'product_details.home',
    'showKolModule': 'irl_pop'
  }

  // 搜索页
  var searchReportMap = {
    'showProductSearch': 'product_show.search',
    'clickProductSearch': 'product_details.search',
    'clickHotSearches': 'hot_searches',
    'showRecentSearchBlock': 'recent_search_block',
    'clickRecentSearch': 'recent_search',
    'showDefaultSearch': 'default.search',
    'showResultsSearch': 'results.search',
    'clickSearch': 'search',
  }

  // 全局埋点
  var globalReportMap = {
    'clickLogo': 'logo_click',
    'clickMenu': 'menu_entry',
    'clickMenuLink': 'menu_sections',
    'clickSearch': 'search_entry',
    'clickBag': 'bag_entry',
    'showFooter': 'footer_show',
    'showGiveGet': 'give_get',
    'clickGiveGet': 'give_get',
    'clickFooterLink': 'footer_sections',
    'showMenu': 'menu_drawer',
    'clickAccountEntry': 'account_entry',
    'showLoginPop': 'login_pop',
    'showCreatePop': 'create_pop',
    'customEmailLogin': 'email.login',
    'customEmailCreate': 'email.create',
    'customFirstNameCreate': 'first_name.create',
    'customLastNameCreate': 'last_name.create',
    'customPhoneNumberCreate': 'phone_number.create',
    'clickDisagreePolicyCreate': 'disagree_policy.create',
    'clickAgreePolicyCreate': 'agree_policy.create',
    'clickFacebookLogin': 'facebook.login',
    'clickAppleLogin': 'apple.login',
    'clickGoogleLogin': 'google.login',
    'clickFacebookCreate': 'facebook.create',
    'clickAppleCreate': 'apple.create',
    'clickGoogleCreate': 'google.create',
    'clickBtnCreate': 'btn_create',
    'customFbackBtnCreateSuccess': 'fback.btn_create.success',
    'customFbackBtnCreateFail': 'fback.btn_create.fail',
    'clickBtnLogin': 'btn_login',
    'customFbackBtnLoginSuccess': 'fback.btn_login.success',
    'customFbackBtnLoginFail': 'fback.btn_login.fail',
    'clickForgetPassword': 'forget_password',
    'clickIcCloseLoginPop': 'ic_close.login_pop',
    'clickIcCloseCreatePop': 'ic_close.create_pop',
    'clickBlankLoginPop': 'blank.login_pop',
    'clickBlankCreatePop': 'blank.create_pop',
    'clickTabLogin': 'tab_login',
    'clickTabCreate': 'tab_create',
    'clickDisplayPassword': 'display.password',
    'clickHiddenPassword': 'hidden.password',
    'clickSubmitEmail': 'submit_email',
    'customFbackSubmitEmailSuccess': 'fback.submit_email.success',
    'customFbackSubmitEmailFail': 'fback.submit_email.fail',
    'customLogoutByDomainNoMatch': 'log_out.domain_no_match',
    'showSubtotalPop': 'subtotal_pop',
    'clickBlankSubtotalPop': 'blank_subtotal_pop',
    'clickDownArrowTopSubtotalPop': 'down_arrow_top.subtotal_pop',
    'clickDownArrowSubtotalPop': 'down_arrow.subtotal_pop',
    'showJoinUsDiscountTipsCart': 'join_us.discount_tips_cart',
    'showMemberDiscountTipsCart': 'member_coupon.discount_tips_cart',
    'showMarketDiscountTipsCart': 'sales_coupon.discount_tips_cart',
    'showJoinUsTopBanner': 'join_us.top_banner',
    'clickJoinUsTopBanner': 'join_us.top_banner',
    'clickSizeGuide': 'view_size_guide',
  }

  // 账户模块埋点
  var accountReportMap = {
    'clickPointAccountPage': 'point.account_page',
    'clickPointAccountMenu': 'point.account_menu',
    'clickCoupontAccountPage': 'coupont.account_page',
    'clickCoupontAccountMenu': 'coupont.account_menu',
    'clickMyOrderAccountPage': 'my_order.account_page',
    'clickMyOrderAccountMenu': 'my_order.account_menu',
    'clickMyProfileAccountPage': 'my_profile.account_page',
    'clickMyProfileAccountMenu': 'my_profile.account_menu',
    'clickContactUsAccountPage': 'contact_us.account_page',
    'clickContactUsAccountMenu': 'contact_us.account_menu',
    'clickVipCenterAccountMenu': 'vip_center.account_menu',
    'clickVipCenterAccountPage': 'vip_center.account_page',
    'clickRedeem': 'redeem',
    'clickPointsRules': 'points_rules',
    'showPointsRulesPop': 'points_rules_pop',
    'clickPointsHistory': 'points_history',
    'showPointsHistoryPop': 'points_history_pop',
    'clickBtnGoShoppingPoints': 'btn_go_shopping.points',
    'clickFollowFacebook': 'follow.facebook',
    'clickFollowInstagram': 'follow.instagram',
    'clickOrderDetails': 'order_details',
    'clickTabUnused': 'tab_unused ',
    'clickTabUsed': 'tab_used',
    'clickTabExpired': 'tab_expired',
    'clickVipRules': 'vip_rules',
    'showVipRulesPop': 'vip_rules_pop',
    'clickBtnGoShoppingVip': 'btn_go_shopping.vip'
  }

  // vote投票需求埋点
  var voteReportMap = {
    'showVoteBanner': 'vote_banner',
    'showVotePop': 'vote_pop',
    'clickLetsVoteBanner': 'lets_vote.banner',
    'clickLetsVotePop': 'lets_vote.pop',
    'clickBackVote': 'back_vote',
    'clickDoneVote': 'done_vote',
    'showQaVote': 'qa_vote',
    'clickAboutVote': 'about_vote',
    'showAboutVotePop': 'about_vote_pop',
    'clickQaVoteFeedback': 'qa_vote_feedback',
    'showDoneVotePop': 'done_vote_pop',
    'clickRedeemVotePop': 'redeem_vote.pop',
    'clickRedeemVotePage': 'redeem_vote.page',
    'clickJoinVote': 'join_vote',
    'clickCopyGfcode': 'copy _gfcode',
    'clickGooglePlay': 'google_play',
    'clickAppStore': 'app_store',
    'showGetStartedSurvey': 'show_started_survey',
    'clickGetStartedSurvey': 'get_started_survey',
  }

  // 订单调查需求埋点
  var orderSurveyReportMap = {
    'showOrderSurvey01': 'order_survey01',
    'showOrderSurvey02': 'order_survey02',
    'showOrderSurveyResults': 'order_survey_results',
    'clickBelowOrderSurvey': 'below.order_survey',
    'clickMetOrderSurvey': 'met.order_survey',
    'clickExceededOrderSurvey': 'exceeded.order_survey',
    'clickNextOrderSurvey': 'next.order_survey',
    'clickCancelOrderSurvey': 'cancel.order_survey',
    'clickSkipOrderSurvey': 'skip.order_survey',
    'clickDoneOrderSurvey': 'done.order_survey',
    'clickGoShoppingOrderSurvey': 'go_shopping.order_survey',
  }

  // 切换国家埋点
  var i18nReportMap = {
    'clickMenuBtn': 'country_language_entry.menu',
    'clickHeaderBtn': 'country_language_entry.topmenu',
    'clickFooterBtn': 'country_language_entry.footer',
    'showPopup': 'country_language.select_pop',
    'clickCountrySelector': 'country_entry.select_pop',
    'clickLangSelector': 'language_entry.select_pop',
    'changeCountry': 'country_change.select_pop',
    'changeLang': 'country_change.select_pop',
    'savePopup': 'country_language_save.select_pop',
    'closePopup': 'country_language_close.select_pop',
    'showGeoTipsPopup': 'local_tips_pop',
    'closeGeoTipsPopup': 'close.local_tips_pop',
    'comfirmGeoTipsPopup': 'confirm.local_tips_pop',
  }

  // 用户订阅注册引导埋点
  var userSubscriptionReportMap = {
    'showJoinCollectivePop': 'join_collective_pop',
    'clickEditJoinCollectivePop': 'edit.join_collective_pop',
    'clickEditFooter': 'edit.footer',
    'clickBtnSignupJoinCollectivePop': 'btn_signup.join_collective_pop',
    'clickBtnSignupFooter': 'btn_signup.footer',
    'clickTermsOfServiceJoinCollectivePop': 'terms_of_service.join_collective_pop',
    'clickPrivacyPolicyJoinCollectivePop': 'privacy_policy.join_collective_pop',
    'clickIcCloseJoinCollectivePop': 'ic_close.join_collective_pop',
    'clickBlankJoinCollectivePop': 'blank.join_collective_pop',
    'showCollectivePackagePop': 'collective_package_pop',
    'clickOtherCouponsCollectivePackagePop': 'other_coupons.collective_package_pop',
    'showOtherCouponsCollectivePackagePop': 'other_coupons.collective_package_pop',
    'clickGoShoppingCollectivePackagePop': 'go_shopping.collective_package_pop',
    'clickIcCloseCollectivePackagePop': 'ic_close.collective_package_pop',
    'clickbBlankCollectivePackagePop': 'blank.collective_package_pop',
    'showLoginPop': 'login-pop',
    'clickBtnLoginLoginPop': 'btn_login.login-pop',
    'clickForgetPasswordLoginPop': 'forget_password.login-pop',
    'clickSubmitLoginPop': 'submit.login-pop',
    'clickIcCloseLoginPop': 'ic_close.login-pop',
    'clickBlankLoginPop': 'blank.login-pop',
    'showEmailSubmitSuccessPop': 'email_submit_success_pop',
    'clickShopToStartEarningEmail': 'shop_now.welcome_to_the_graecove_family.email',
    'clickResetPasswordEmail': 'reset_password.welcome_to_the_graecove_family.email',
    'clickLogInNowEmail': 'log_in_now.account_verification_and_login.email',
    'clickIcCloseBottomDiscountTipsProduct': 'ic_close.bottom_discount_tips_product',
    'closeBotDiscountTip': 'ic_close.bottom_discount_tips_product',
    'clickJoinUsDiscountTip': 'join_us.discount_tips_product',
    'clickBotJoinUsDiscountTip': 'join_us.bottom_discount_tips_product',
    'registered': 'registered',
    'logged_in': 'logged_in'
  }

  // 登录注册流程相关需求埋点
  var loginRegistrationProcessMap = {
    'showJoinCollectivePopSelfPush': 'join_collective_pop.self_push',
    'showJoinCollectivePopClcBall': 'join_collective_pop.clc_ball',
    'showJoinCollectivePopClcTopbanner': 'join_collective_pop.clc_topbanner',
    'showJoinCollectivePopClcDiscountTipsProduct': 'join_collective_pop.clc_discount_tips_product',
    'showJoinCollectivePopClcBottomDiscountTipsProduct': 'join_collective_pop.clc_bottom_discount_tips_product',
    'showJoinCollectivePopClcDiscoutTipsBag': 'join_collective_pop.clc_discout_tips_bag',
    'clickViewCollectionCollectivePackagePop': 'view_collection.collective_package_pop',
    'showCollectivePackagePopTwoButton': 'collective_package_pop.two_button',
    'showCollectivePackagePopOneButton': 'collective_package_pop.one_button',
    'showJoinUsFloatBall': 'join_us.float_ball',
    'clickJoinUsFloatBall': 'join_us.float_ball',
    'showCouponsFloatBall': 'coupons.float_ball',
    'clickCouponsFloatBall': 'coupons.float_ball',
    'showCouponsPop': 'coupons_pop',
    'showJoinUsModule': 'join_us.module',
    'showSubscriptionIcon': 'subscription_icon',
    'showEmailSmsPopup': 'email_sms_popup',
    'formStarted': 'form_started',
    'emailSmsSubmit': 'email_sms_submit',
    'emailSmsSubscribeSuccess': 'email_sms_subscribe_success',
    'emailSmsPopupClose': 'email_sms_popup_close',
    'subscriptionIconClick': 'subscription_icon_click',
    'subscriptionClick': 'subscription_click',
    'subscriptionTopBannerClick': 'subscription_top_click'
  }

  var loginRegisterSourceFieldsMap = {
    'cart_guide': 'cart_guide',
    'product_guide': 'product_guide',
    'join_us_clc_topbanner': 'join_us_clc_topbanner',
    'join_us_self_push': 'join_us_self_push',
    'float_ball': 'float_ball',
    'footer_guide': 'footer_guide',
    'account': 'account',
    'other': 'other',
    'join_us_module': 'join_us_module'
  }

  var whatYouWantMap = {
    'submitForm': 'submit.what_you_want_pop',
    'clickWhatYouWant': 'what_you_want',
    'showWhatYouWant': 'what_you_want_pop',
    'color': 'color.what_you_want_pop',
    'size': 'size.what_you_want_pop',
    'email': 'email.what_you_want_pop',
  }

  var errorMsgMap = {
    baseError: WS.$t('public.toast.something_wrong'),
    noSize: WS.$t('public.add_pop.choose_size_tip'),
    noColor: WS.$t('public.add_pop.choose_color_tip'),
    lackOfSizeGuide: WS.$t('public.add_pop.lack_size_guide'),
    soldout: WS.$t('bag.product_sole_out_text'),
  }
  
  var countryInfoMap = {
    'US': { name: WS.$t('public.country.US'), key: 'US', lang: 'en', symbolCode: 'US', text: WS.$t('public.country.US') + ' - ' + 'USD $', symbol: '$', currency: 'USD', icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_us_3x_0b541a59-28b8-4f0f-8935-5f2eefba7081.png?v=1662621151', standard: '79.00', express: '119.00', standardPostage: '6.99', expressPostage: '11.99', standardDay: '6-9', expressDay: '4-6', dialCode: '1', mobilePossibleLengths: [10] },
    'CA': { name: WS.$t('public.country.CA'), key: 'CA', lang: 'en', symbolCode: 'CA', text: WS.$t('public.country.CA') + ' - ' + 'CAD $', symbol: '$', currency: 'CAD', icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_Can_3x_92f7ed77-90c5-4da6-934c-197c41bfb367.png?v=1662621151', standard: '99.00', express: '99.00', standardPostage: '10', expressPostage: '10', standardDay: '6-9', expressDay: '6-9', dialCode: '1', mobilePossibleLengths: [10] },
    'AL': { name: WS.$t('public.country.AL'), key: 'AL', lang: 'en', symbolCode: 'AL', text: WS.$t('public.country.AL') + ' - ' + 'ALL L', symbol: 'L', currency: 'ALL', dialCode: '355', mobilePossibleLengths: [9] },
    'DZ': { name: WS.$t('public.country.DZ'), key: 'DZ', lang: 'en', symbolCode: 'DZ', text: WS.$t('public.country.DZ') + ' - ' + 'DZD د.ج', symbol: 'د.ج', currency: 'DZD', dialCode: '213', mobilePossibleLengths: [9] },
    'AD': { name: WS.$t('public.country.AD'), key: 'AD', lang: 'en', symbolCode: 'AD', text: WS.$t('public.country.AD') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '376', mobilePossibleLengths: [6, 9] },
    'AO': { name: WS.$t('public.country.AO'), key: 'AO', lang: 'en', symbolCode: 'AO', text: WS.$t('public.country.AO') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '244', mobilePossibleLengths: [9] },
    'AI': { name: WS.$t('public.country.AI'), key: 'AI', lang: 'en', symbolCode: 'AI', text: WS.$t('public.country.AI') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'AG': { name: WS.$t('public.country.AG'), key: 'AG', lang: 'en', symbolCode: 'AG', text: WS.$t('public.country.AG') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'AR': { name: WS.$t('public.country.AR'), key: 'AR', lang: 'en', symbolCode: 'AR', text: WS.$t('public.country.AR') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '54', mobilePossibleLengths: [10, 11] },
    'AM': { name: WS.$t('public.country.AM'), key: 'AM', lang: 'en', symbolCode: 'AM', text: WS.$t('public.country.AM') + ' - ' + 'AMD դր.', symbol: 'դր.', currency: 'AMD', dialCode: '374', mobilePossibleLengths: [8] },
    'AW': { name: WS.$t('public.country.AW'), key: 'AW', lang: 'en', symbolCode: 'AW', text: WS.$t('public.country.AW') + ' - ' + 'AWG ƒ', symbol: 'ƒ', currency: 'AWG', dialCode: '297', mobilePossibleLengths: [7] },
    'AU': { name: WS.$t('public.country.AU'), key: 'AU', lang: 'en', symbolCode: 'AU', text: WS.$t('public.country.AU') + ' - ' + 'AUD $', symbol: '$', currency: 'AUD', icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_au_3x_98808e7f-1750-4fae-8e26-f037bd4c368c.png?v=1662621153', dialCode: '61', mobilePossibleLengths: [9] },
    'AT': { name: WS.$t('public.country.AT'), key: 'AT', lang: 'en', symbolCode: 'AT', text: WS.$t('public.country.AT') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '43', mobilePossibleLengths: [7, 8, 9, 10, 11, 12, 13] },
    'AZ': { name: WS.$t('public.country.AZ'), key: 'AZ', lang: 'en', symbolCode: 'AZ', text: WS.$t('public.country.AZ') + ' - ' + 'AZN ₼', symbol: '₼', currency: 'AZN', dialCode: '994', mobilePossibleLengths: [9] },
    'BS': { name: WS.$t('public.country.BS'), key: 'BS', lang: 'en', symbolCode: 'BS', text: WS.$t('public.country.BS') + ' - ' + 'BSD $', symbol: '$', currency: 'BSD', dialCode: '1', mobilePossibleLengths: [10] },
    'BH': { name: WS.$t('public.country.BH'), key: 'BH', lang: 'en', symbolCode: 'BH', text: WS.$t('public.country.BH') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '973', mobilePossibleLengths: [8] },
    'BD': { name: WS.$t('public.country.BD'), key: 'BD', lang: 'en', symbolCode: 'BD', text: WS.$t('public.country.BD') + ' - ' + 'BDT ৳', symbol: '৳', currency: 'BDT', dialCode: '880', mobilePossibleLengths: [10] },
    'BB': { name: WS.$t('public.country.BB'), key: 'BB', lang: 'en', symbolCode: 'BB', text: WS.$t('public.country.BB') + ' - ' + 'BBD $', symbol: '$', currency: 'BBD', dialCode: '1', mobilePossibleLengths: [10] },
    'BE': { name: WS.$t('public.country.BE'), key: 'BE', lang: 'en', symbolCode: 'BE', text: WS.$t('public.country.BE') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '32', mobilePossibleLengths: [9] },
    'BZ': { name: WS.$t('public.country.BZ'), key: 'BZ', lang: 'en', symbolCode: 'BZ', text: WS.$t('public.country.BZ') + ' - ' + 'BZD $', symbol: '$', currency: 'BZD', dialCode: '501', mobilePossibleLengths: [7] },
    'BJ': { name: WS.$t('public.country.BJ'), key: 'BJ', lang: 'en', symbolCode: 'BJ', text: WS.$t('public.country.BJ') + ' - ' + 'XOF Fr', symbol: 'Fr', currency: 'XOF', dialCode: '229', mobilePossibleLengths: [10] },
    'BM': { name: WS.$t('public.country.BM'), key: 'BM', lang: 'en', symbolCode: 'BM', text: WS.$t('public.country.BM') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '1', mobilePossibleLengths: [10] },
    'BO': { name: WS.$t('public.country.BO'), key: 'BO', lang: 'en', symbolCode: 'BO', text: WS.$t('public.country.BO') + ' - ' + 'BOB Bs.', symbol: 'Bs.', currency: 'BOB', dialCode: '591', mobilePossibleLengths: [8] },
    'BA': { name: WS.$t('public.country.BA'), key: 'BA', lang: 'en', symbolCode: 'BA', text: WS.$t('public.country.BA') + ' - ' + 'BAM КМ', symbol: 'КМ', currency: 'BAM', dialCode: '387', mobilePossibleLengths: [8, 9] },
    'BW': { name: WS.$t('public.country.BW'), key: 'BW', lang: 'en', symbolCode: 'BW', text: WS.$t('public.country.BW') + ' - ' + 'BWP P', symbol: 'P', currency: 'BWP', dialCode: '267', mobilePossibleLengths: [8] },
    'BR': { name: WS.$t('public.country.BR'), key: 'BR', lang: 'en', symbolCode: 'BR', text: WS.$t('public.country.BR') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '55', mobilePossibleLengths: [10, 11] },
    'VG': { name: WS.$t('public.country.VG'), key: 'VG', lang: 'en', symbolCode: 'VG', text: WS.$t('public.country.VG') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '1', mobilePossibleLengths: [10] },
    'BN': { name: WS.$t('public.country.BN'), key: 'BN', lang: 'en', symbolCode: 'BN', text: WS.$t('public.country.BN') + ' - ' + 'BND $', symbol: '$', currency: 'BND', dialCode: '673', mobilePossibleLengths: [7] },
    'BG': { name: WS.$t('public.country.BG'), key: 'BG', lang: 'en', symbolCode: 'BG', text: WS.$t('public.country.BG') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '359', mobilePossibleLengths: [8, 9] },
    'BF': { name: WS.$t('public.country.BF'), key: 'BF', lang: 'en', symbolCode: 'BF', text: WS.$t('public.country.BF') + ' - ' + 'XOF Fr', symbol: 'Fr', currency: 'XOF', dialCode: '226', mobilePossibleLengths: [8] },
    'BI': { name: WS.$t('public.country.BI'), key: 'BI', lang: 'en', symbolCode: 'BI', text: WS.$t('public.country.BI') + ' - ' + 'BIF Fr', symbol: 'Fr', currency: 'BIF', dialCode: '257', mobilePossibleLengths: [8] },
    'KH': { name: WS.$t('public.country.KH'), key: 'KH', lang: 'en', symbolCode: 'KH', text: WS.$t('public.country.KH') + ' - ' + 'KHR ៛', symbol: '៛', currency: 'KHR', dialCode: '855', mobilePossibleLengths: [8, 9] },
    'CM': { name: WS.$t('public.country.CM'), key: 'CM', lang: 'en', symbolCode: 'CM', text: WS.$t('public.country.CM') + ' - ' + 'XAF CFA', symbol: 'CFA', currency: 'XAF', dialCode: '237', mobilePossibleLengths: [9] },
    'CV': { name: WS.$t('public.country.CV'), key: 'CV', lang: 'en', symbolCode: 'CV', text: WS.$t('public.country.CV') + ' - ' + 'CVE $', symbol: '$', currency: 'CVE', dialCode: '238', mobilePossibleLengths: [7] },
    'BQ': { name: WS.$t('public.country.BQ'), key: 'BQ', lang: 'en', symbolCode: 'BQ', text: WS.$t('public.country.BQ') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '599', mobilePossibleLengths: [7] },
    'KY': { name: WS.$t('public.country.KY'), key: 'KY', lang: 'en', symbolCode: 'KY', text: WS.$t('public.country.KY') + ' - ' + 'KYD $', symbol: '$', currency: 'KYD', dialCode: '1', mobilePossibleLengths: [10] },
    'TD': { name: WS.$t('public.country.TD'), key: 'TD', lang: 'en', symbolCode: 'TD', text: WS.$t('public.country.TD') + ' - ' + 'XAF CFA', symbol: 'CFA', currency: 'XAF', dialCode: '235', mobilePossibleLengths: [8] },
    'CL': { name: WS.$t('public.country.CL'), key: 'CL', lang: 'en', symbolCode: 'CL', text: WS.$t('public.country.CL') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '56', mobilePossibleLengths: [9] },
    'CN': { name: WS.$t('public.country.CN'), key: 'CN', lang: 'en', symbolCode: 'CN', text: WS.$t('public.country.CN') + ' - ' + 'CNY ¥', symbol: '¥', currency: 'CNY', dialCode: '86', mobilePossibleLengths: [11] },
    'CO': { name: WS.$t('public.country.CO'), key: 'CO', lang: 'en', symbolCode: 'CO', text: WS.$t('public.country.CO') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '57', mobilePossibleLengths: [10] },
    'KM': { name: WS.$t('public.country.KM'), key: 'KM', lang: 'en', symbolCode: 'KM', text: WS.$t('public.country.KM') + ' - ' + 'KMF Fr', symbol: 'Fr', currency: 'KMF', dialCode: '269', mobilePossibleLengths: [7] },
    'CK': { name: WS.$t('public.country.CK'), key: 'CK', lang: 'en', symbolCode: 'CK', text: WS.$t('public.country.CK') + ' - ' + 'NZD $', symbol: '$', currency: 'NZD', dialCode: '682', mobilePossibleLengths: [5] },
    'CR': { name: WS.$t('public.country.CR'), key: 'CR', lang: 'en', symbolCode: 'CR', text: WS.$t('public.country.CR') + ' - ' + 'CRC ₡', symbol: '₡', currency: 'CRC', dialCode: '506', mobilePossibleLengths: [8] },
    'HR': { name: WS.$t('public.country.HR'), key: 'HR', lang: 'en', symbolCode: 'HR', text: WS.$t('public.country.HR') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '385', mobilePossibleLengths: [8, 9] },
    'CW': { name: WS.$t('public.country.CW'), key: 'CW', lang: 'en', symbolCode: 'CW', text: WS.$t('public.country.CW') + ' - ' + 'ANG ƒ', symbol: 'ƒ', currency: 'ANG', dialCode: '599', mobilePossibleLengths: [7, 8] },
    'CY': { name: WS.$t('public.country.CY'), key: 'CY', lang: 'en', symbolCode: 'CY', text: WS.$t('public.country.CY') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '357', mobilePossibleLengths: [8] },
    'CZ': { name: WS.$t('public.country.CZ'), key: 'CZ', lang: 'en', symbolCode: 'CZ', text: WS.$t('public.country.CZ') + ' - ' + 'CZK Kč', symbol: 'Kč', currency: 'CZK', dialCode: '420', mobilePossibleLengths: [9] },
    'DK': { name: WS.$t('public.country.DK'), key: 'DK', lang: 'en', symbolCode: 'DK', text: WS.$t('public.country.DK') + ' - ' + 'DKK kr.', symbol: 'kr.', currency: 'DKK', dialCode: '45', mobilePossibleLengths: [8] },
    'DJ': { name: WS.$t('public.country.DJ'), key: 'DJ', lang: 'en', symbolCode: 'DJ', text: WS.$t('public.country.DJ') + ' - ' + 'DJF Fdj', symbol: 'Fdj', currency: 'DJF', dialCode: '253', mobilePossibleLengths: [8] },
    'DM': { name: WS.$t('public.country.DM'), key: 'DM', lang: 'en', symbolCode: 'DM', text: WS.$t('public.country.DM') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'DO': { name: WS.$t('public.country.DO'), key: 'DO', lang: 'en', symbolCode: 'DO', text: WS.$t('public.country.DO') + ' - ' + 'DOP $', symbol: '$', currency: 'DOP', dialCode: '1', mobilePossibleLengths: [10] },
    'EC': { name: WS.$t('public.country.EC'), key: 'EC', lang: 'en', symbolCode: 'EC', text: WS.$t('public.country.EC') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '593', mobilePossibleLengths: [9] },
    'EG': { name: WS.$t('public.country.EG'), key: 'EG', lang: 'en', symbolCode: 'EG', text: WS.$t('public.country.EG') + ' - ' + 'EGP ج.م', symbol: 'ج.م', currency: 'EGP', dialCode: '20', mobilePossibleLengths: [10] },
    'SV': { name: WS.$t('public.country.SV'), key: 'SV', lang: 'en', symbolCode: 'SV', text: WS.$t('public.country.SV') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '503', mobilePossibleLengths: [8] },
    'GQ': { name: WS.$t('public.country.GQ'), key: 'GQ', lang: 'en', symbolCode: 'GQ', text: WS.$t('public.country.GQ') + ' - ' + 'XAF CFA', symbol: 'CFA', currency: 'XAF', dialCode: '240', mobilePossibleLengths: [9] },
    'EE': { name: WS.$t('public.country.EE'), key: 'EE', lang: 'en', symbolCode: 'EE', text: WS.$t('public.country.EE') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '372', mobilePossibleLengths: [7, 8] },
    'SZ': { name: WS.$t('public.country.SZ'), key: 'SZ', lang: 'en', symbolCode: 'SZ', text: WS.$t('public.country.SZ') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '268', mobilePossibleLengths: [8] },
    'ET': { name: WS.$t('public.country.ET'), key: 'ET', lang: 'en', symbolCode: 'ET', text: WS.$t('public.country.ET') + ' - ' + 'ETB Br', symbol: 'Br', currency: 'ETB', dialCode: '251', mobilePossibleLengths: [9] },
    'FK': { name: WS.$t('public.country.FK'), key: 'FK', lang: 'en', symbolCode: 'FK', text: WS.$t('public.country.FK') + ' - ' + 'FKP £', symbol: '£', currency: 'FKP', dialCode: '500', mobilePossibleLengths: [5] },
    'FO': { name: WS.$t('public.country.FO'), key: 'FO', lang: 'en', symbolCode: 'FO', text: WS.$t('public.country.FO') + ' - ' + 'DKK kr.', symbol: 'kr.', currency: 'DKK', dialCode: '298', mobilePossibleLengths: [6] },
    'FJ': { name: WS.$t('public.country.FJ'), key: 'FJ', lang: 'en', symbolCode: 'FJ', text: WS.$t('public.country.FJ') + ' - ' + 'FJD $', symbol: '$', currency: 'FJD', dialCode: '679', mobilePossibleLengths: [7] },
    'FI': { name: WS.$t('public.country.FI'), key: 'FI', lang: 'en', symbolCode: 'FI', text: WS.$t('public.country.FI') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '358', mobilePossibleLengths: [6, 7, 8, 9, 10] },
    'FR': { name: WS.$t('public.country.FR'), key: 'FR', lang: 'en', symbolCode: 'FR', text: WS.$t('public.country.FR') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '33', mobilePossibleLengths: [9] },
    'GF': { name: WS.$t('public.country.GF'), key: 'GF', lang: 'en', symbolCode: 'GF', text: WS.$t('public.country.GF') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '594', mobilePossibleLengths: [9] },
    'PF': { name: WS.$t('public.country.PF'), key: 'PF', lang: 'en', symbolCode: 'PF', text: WS.$t('public.country.PF') + ' - ' + 'XPF Fr', symbol: 'Fr', currency: 'XPF', dialCode: '689', mobilePossibleLengths: [8] },
    'GA': { name: WS.$t('public.country.GA'), key: 'GA', lang: 'en', symbolCode: 'GA', text: WS.$t('public.country.GA') + ' - ' + 'XOF Fr', symbol: 'Fr', currency: 'XOF', dialCode: '241', mobilePossibleLengths: [7, 8] },
    'GM': { name: WS.$t('public.country.GM'), key: 'GM', lang: 'en', symbolCode: 'GM', text: WS.$t('public.country.GM') + ' - ' + 'GMD D', symbol: 'D', currency: 'GMD', dialCode: '220', mobilePossibleLengths: [7] },
    'GE': { name: WS.$t('public.country.GE'), key: 'GE', lang: 'en', symbolCode: 'GE', text: WS.$t('public.country.GE') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '995', mobilePossibleLengths: [9] },
    'DE': { name: WS.$t('public.country.DE'), key: 'DE', lang: 'en', symbolCode: 'DE', text: WS.$t('public.country.DE') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '49', mobilePossibleLengths: [10, 11] },
    'GH': { name: WS.$t('public.country.GH'), key: 'GH', lang: 'en', symbolCode: 'GH', text: WS.$t('public.country.GH') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '233', mobilePossibleLengths: [9] },
    'GI': { name: WS.$t('public.country.GI'), key: 'GI', lang: 'en', symbolCode: 'GI', text: WS.$t('public.country.GI') + ' - ' + 'GBP £', symbol: '£', currency: 'GBP', dialCode: '350', mobilePossibleLengths: [8] },
    'GR': { name: WS.$t('public.country.GR'), key: 'GR', lang: 'en', symbolCode: 'GR', text: WS.$t('public.country.GR') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '30', mobilePossibleLengths: [10] },
    'GL': { name: WS.$t('public.country.GL'), key: 'GL', lang: 'en', symbolCode: 'GL', text: WS.$t('public.country.GL') + ' - ' + 'DKK kr.', symbol: 'kr.', currency: 'DKK', dialCode: '299', mobilePossibleLengths: [6] },
    'GD': { name: WS.$t('public.country.GD'), key: 'GD', lang: 'en', symbolCode: 'GD', text: WS.$t('public.country.GD') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'GP': { name: WS.$t('public.country.GP'), key: 'GP', lang: 'en', symbolCode: 'GP', text: WS.$t('public.country.GP') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '590', mobilePossibleLengths: [9] },
    'GT': { name: WS.$t('public.country.GT'), key: 'GT', lang: 'en', symbolCode: 'GT', text: WS.$t('public.country.GT') + ' - ' + 'GTQ Q', symbol: 'Q', currency: 'GTQ', dialCode: '502', mobilePossibleLengths: [8] },
    'GG': { name: WS.$t('public.country.GG'), key: 'GG', lang: 'en', symbolCode: 'GG', text: WS.$t('public.country.GG') + ' - ' + 'GBP £', symbol: '£', currency: 'GBP', dialCode: '44', mobilePossibleLengths: [10] },
    'GN': { name: WS.$t('public.country.GN'), key: 'GN', lang: 'en', symbolCode: 'GN', text: WS.$t('public.country.GN') + ' - ' + 'GNF Fr', symbol: 'Fr', currency: 'GNF', dialCode: '224', mobilePossibleLengths: [9] },
    'GW': { name: WS.$t('public.country.GW'), key: 'GW', lang: 'en', symbolCode: 'GW', text: WS.$t('public.country.GW') + ' - ' + 'XOF Fr', symbol: 'Fr', currency: 'XOF', dialCode: '245', mobilePossibleLengths: [9] },
    'GY': { name: WS.$t('public.country.GY'), key: 'GY', lang: 'en', symbolCode: 'GY', text: WS.$t('public.country.GY') + ' - ' + 'GYD $', symbol: '$', currency: 'GYD', dialCode: '592', mobilePossibleLengths: [7] },
    'HT': { name: WS.$t('public.country.HT'), key: 'HT', lang: 'en', symbolCode: 'HT', text: WS.$t('public.country.HT') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '509', mobilePossibleLengths: [8] },
    'HN': { name: WS.$t('public.country.HN'), key: 'HN', lang: 'en', symbolCode: 'HN', text: WS.$t('public.country.HN') + ' - ' + 'HNL L', symbol: 'L', currency: 'HNL', dialCode: '504', mobilePossibleLengths: [8] },
    'HK': { name: WS.$t('public.country.HK'), key: 'HK', lang: 'en', symbolCode: 'HK', text: WS.$t('public.country.HK') + ' - ' + 'HKD $', symbol: '$', currency: 'HKD', dialCode: '852', mobilePossibleLengths: [8] },
    'HU': { name: WS.$t('public.country.HU'), key: 'HU', lang: 'en', symbolCode: 'HU', text: WS.$t('public.country.HU') + ' - ' + 'HUF Ft', symbol: 'Ft', currency: 'HUF', dialCode: '36', mobilePossibleLengths: [9] },
    'IS': { name: WS.$t('public.country.IS'), key: 'IS', lang: 'en', symbolCode: 'IS', text: WS.$t('public.country.IS') + ' - ' + 'ISK kr', symbol: 'kr', currency: 'ISK', dialCode: '354', mobilePossibleLengths: [7, 9] },
    'IN': { name: WS.$t('public.country.IN'), key: 'IN', lang: 'en', symbolCode: 'IN', text: WS.$t('public.country.IN') + ' - ' + 'INR ₹', symbol: '₹', currency: 'INR', dialCode: '91', mobilePossibleLengths: [10] },
    'ID': { name: WS.$t('public.country.ID'), key: 'ID', lang: 'en', symbolCode: 'ID', text: WS.$t('public.country.ID') + ' - ' + 'IDR Rp', symbol: 'Rp', currency: 'IDR', dialCode: '62', mobilePossibleLengths: [9, 10, 11, 12] },
    'IE': { name: WS.$t('public.country.IE'), key: 'IE', lang: 'en', symbolCode: 'IE', text: WS.$t('public.country.IE') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '353', mobilePossibleLengths: [9] },
    'IL': { name: WS.$t('public.country.IL'), key: 'IL', lang: 'en', symbolCode: 'IL', text: WS.$t('public.country.IL') + ' - ' + 'ILS ₪', symbol: '₪', currency: 'ILS', dialCode: '972', mobilePossibleLengths: [9] },
    'IT': { name: WS.$t('public.country.IT'), key: 'IT', lang: 'en', symbolCode: 'IT', text: WS.$t('public.country.IT') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '39', mobilePossibleLengths: [9, 10] },
    'JM': { name: WS.$t('public.country.JM'), key: 'JM', lang: 'en', symbolCode: 'JM', text: WS.$t('public.country.JM') + ' - ' + 'JMD $', symbol: '$', currency: 'JMD', dialCode: '1', mobilePossibleLengths: [10] },
    'JP': { name: WS.$t('public.country.JP'), key: 'JP', lang: 'en', symbolCode: 'JP', text: WS.$t('public.country.JP') + ' - ' + 'JPY ¥', symbol: '¥', currency: 'JPY', dialCode: '81', mobilePossibleLengths: [10] },
    'JE': { name: WS.$t('public.country.JE'), key: 'JE', lang: 'en', symbolCode: 'JE', text: WS.$t('public.country.JE') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '44', mobilePossibleLengths: [10] },
    'JO': { name: WS.$t('public.country.JO'), key: 'JO', lang: 'en', symbolCode: 'JO', text: WS.$t('public.country.JO') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '962', mobilePossibleLengths: [9] },
    'KZ': { name: WS.$t('public.country.KZ'), key: 'KZ', lang: 'en', symbolCode: 'KZ', text: WS.$t('public.country.KZ') + ' - ' + 'KZT ₸', symbol: '₸', currency: 'KZT', dialCode: '7', mobilePossibleLengths: [10] },
    'KE': { name: WS.$t('public.country.KE'), key: 'KE', lang: 'en', symbolCode: 'KE', text: WS.$t('public.country.KE') + ' - ' + 'KES KSh', symbol: 'KSh', currency: 'KES', dialCode: '254', mobilePossibleLengths: [9] },
    'KI': { name: WS.$t('public.country.KI'), key: 'KI', lang: 'en', symbolCode: 'KI', text: WS.$t('public.country.KI') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '686', mobilePossibleLengths: [8] },
    'KW': { name: WS.$t('public.country.KW'), key: 'KW', lang: 'en', symbolCode: 'KW', text: WS.$t('public.country.KW') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '965', mobilePossibleLengths: [8] },
    'KG': { name: WS.$t('public.country.KG'), key: 'KG', lang: 'en', symbolCode: 'KG', text: WS.$t('public.country.KG') + ' - ' + 'KGS som', symbol: 'som', currency: 'KGS', dialCode: '996', mobilePossibleLengths: [9] },
    'LA': { name: WS.$t('public.country.LA'), key: 'LA', lang: 'en', symbolCode: 'LA', text: WS.$t('public.country.LA') + ' - ' + 'LAK ₭', symbol: '₭', currency: 'LAK', dialCode: '856', mobilePossibleLengths: [9, 10] },
    'LV': { name: WS.$t('public.country.LV'), key: 'LV', lang: 'en', symbolCode: 'LV', text: WS.$t('public.country.LV') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '371', mobilePossibleLengths: [8] },
    'LS': { name: WS.$t('public.country.LS'), key: 'LS', lang: 'en', symbolCode: 'LS', text: WS.$t('public.country.LS') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '266', mobilePossibleLengths: [8] },
    'LI': { name: WS.$t('public.country.LI'), key: 'LI', lang: 'en', symbolCode: 'LI', text: WS.$t('public.country.LI') + ' - ' + 'CHF CHF', symbol: 'CHF', currency: 'CHF', dialCode: '423', mobilePossibleLengths: [7, 9] },
    'LT': { name: WS.$t('public.country.LT'), key: 'LT', lang: 'en', symbolCode: 'LT', text: WS.$t('public.country.LT') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '370', mobilePossibleLengths: [8] },
    'LU': { name: WS.$t('public.country.LU'), key: 'LU', lang: 'en', symbolCode: 'LU', text: WS.$t('public.country.LU') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '352', mobilePossibleLengths: [9] },
    'MO': { name: WS.$t('public.country.MO'), key: 'MO', lang: 'en', symbolCode: 'MO', text: WS.$t('public.country.MO') + ' - ' + 'MOP P', symbol: 'P', currency: 'MOP', dialCode: '853', mobilePossibleLengths: [8] },
    'MG': { name: WS.$t('public.country.MG'), key: 'MG', lang: 'en', symbolCode: 'MG', text: WS.$t('public.country.MG') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '261', mobilePossibleLengths: [9] },
    'MW': { name: WS.$t('public.country.MW'), key: 'MW', lang: 'en', symbolCode: 'MW', text: WS.$t('public.country.MW') + ' - ' + 'MWK MK', symbol: 'MK', currency: 'MWK', dialCode: '265', mobilePossibleLengths: [9] },
    'MY': { name: WS.$t('public.country.MY'), key: 'MY', lang: 'en', symbolCode: 'MY', text: WS.$t('public.country.MY') + ' - ' + 'MYR RM', symbol: 'RM', currency: 'MYR', dialCode: '60', mobilePossibleLengths: [9, 10] },
    'MV': { name: WS.$t('public.country.MV'), key: 'MV', lang: 'en', symbolCode: 'MV', text: WS.$t('public.country.MV') + ' - ' + 'MVR MVR', symbol: 'MVR', currency: 'MVR', dialCode: '960', mobilePossibleLengths: [7] },
    'MT': { name: WS.$t('public.country.MT'), key: 'MT', lang: 'en', symbolCode: 'MT', text: WS.$t('public.country.MT') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '356', mobilePossibleLengths: [8] },
    'MQ': { name: WS.$t('public.country.MQ'), key: 'MQ', lang: 'en', symbolCode: 'MQ', text: WS.$t('public.country.MQ') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '596', mobilePossibleLengths: [9] },
    'MR': { name: WS.$t('public.country.MR'), key: 'MR', lang: 'en', symbolCode: 'MR', text: WS.$t('public.country.MR') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '222', mobilePossibleLengths: [8] },
    'MU': { name: WS.$t('public.country.MU'), key: 'MU', lang: 'en', symbolCode: 'MU', text: WS.$t('public.country.MU') + ' - ' + 'MUR ₨', symbol: '₨', currency: 'MUR', dialCode: '230', mobilePossibleLengths: [8] },
    'YT': { name: WS.$t('public.country.YT'), key: 'YT', lang: 'en', symbolCode: 'YT', text: WS.$t('public.country.YT') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '262', mobilePossibleLengths: [9] },
    'MX': { name: WS.$t('public.country.MX'), key: 'MX', lang: 'en', symbolCode: 'MX', text: WS.$t('public.country.MX') + ' - ' + 'MXN $', symbol: '$', currency: 'MXN', dialCode: '52', mobilePossibleLengths: [10] },
    'MD': { name: WS.$t('public.country.MD'), key: 'MD', lang: 'en', symbolCode: 'MD', text: WS.$t('public.country.MD') + ' - ' + 'MDL L', symbol: 'L', currency: 'MDL', dialCode: '373', mobilePossibleLengths: [8] },
    'MC': { name: WS.$t('public.country.MC'), key: 'MC', lang: 'en', symbolCode: 'MC', text: WS.$t('public.country.MC') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '377', mobilePossibleLengths: [8, 9] },
    'MN': { name: WS.$t('public.country.MN'), key: 'MN', lang: 'en', symbolCode: 'MN', text: WS.$t('public.country.MN') + ' - ' + 'MNT ₮', symbol: '₮', currency: 'MNT', dialCode: '976', mobilePossibleLengths: [8] },
    'ME': { name: WS.$t('public.country.ME'), key: 'ME', lang: 'en', symbolCode: 'ME', text: WS.$t('public.country.ME') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '382', mobilePossibleLengths: [8] },
    'MS': { name: WS.$t('public.country.MS'), key: 'MS', lang: 'en', symbolCode: 'MS', text: WS.$t('public.country.MS') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'MA': { name: WS.$t('public.country.MA'), key: 'MA', lang: 'en', symbolCode: 'MA', text: WS.$t('public.country.MA') + ' - ' + 'MAD د.م.', symbol: 'د.م.', currency: 'MAD', dialCode: '212', mobilePossibleLengths: [9] },
    'MZ': { name: WS.$t('public.country.MZ'), key: 'MZ', lang: 'en', symbolCode: 'MZ', text: WS.$t('public.country.MZ') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '258', mobilePossibleLengths: [9] },
    'NA': { name: WS.$t('public.country.NA'), key: 'NA', lang: 'en', symbolCode: 'NA', text: WS.$t('public.country.NA') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '264', mobilePossibleLengths: [9] },
    'NR': { name: WS.$t('public.country.NR'), key: 'NR', lang: 'en', symbolCode: 'NR', text: WS.$t('public.country.NR') + ' - ' + 'AUD $', symbol: '$', currency: 'AUD', dialCode: '674', mobilePossibleLengths: [7] },
    'NP': { name: WS.$t('public.country.NP'), key: 'NP', lang: 'en', symbolCode: 'NP', text: WS.$t('public.country.NP') + ' - ' + 'NPR Rs.', symbol: 'Rs.', currency: 'NPR', dialCode: '977', mobilePossibleLengths: [10] },
    'NL': { name: WS.$t('public.country.NL'), key: 'NL', lang: 'en', symbolCode: 'NL', text: WS.$t('public.country.NL') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '31', mobilePossibleLengths: [9, 11] },
    'NC': { name: WS.$t('public.country.NC'), key: 'NC', lang: 'en', symbolCode: 'NC', text: WS.$t('public.country.NC') + ' - ' + 'XPF Fr', symbol: 'Fr', currency: 'XPF', dialCode: '687', mobilePossibleLengths: [6] },
    'NZ': { name: WS.$t('public.country.NZ'), key: 'NZ', lang: 'en', symbolCode: 'NZ', text: WS.$t('public.country.NZ') + ' - ' + 'NZD $', symbol: '$', currency: 'NZD', icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/20220930-171214.png?v=1664529276', standard: '129.00', express: '129.00', standardPostage: '18.00', expressPostage: '18.00', standardDay: '6-9', expressDay: '6-9', dialCode: '64', mobilePossibleLengths: [8, 9, 10] },
    'NI': { name: WS.$t('public.country.NI'), key: 'NI', lang: 'en', symbolCode: 'NI', text: WS.$t('public.country.NI') + ' - ' + 'NIO C$', symbol: 'C$', currency: 'NIO', dialCode: '505', mobilePossibleLengths: [8] },
    'NG': { name: WS.$t('public.country.NG'), key: 'NG', lang: 'en', symbolCode: 'NG', text: WS.$t('public.country.NG') + ' - ' + 'NGN ₦', symbol: '₦', currency: 'NGN', dialCode: '234', mobilePossibleLengths: [10] },
    'NU': { name: WS.$t('public.country.NU'), key: 'NU', lang: 'en', symbolCode: 'NU', text: WS.$t('public.country.NU') + ' - ' + 'NZD $', symbol: '$', currency: 'NZD', dialCode: '683', mobilePossibleLengths: [4, 7] },
    'MK': { name: WS.$t('public.country.MK'), key: 'MK', lang: 'en', symbolCode: 'MK', text: WS.$t('public.country.MK') + ' - ' + 'MKD ден', symbol: 'ден', currency: 'MKD', dialCode: '389', mobilePossibleLengths: [8] },
    'NO': { name: WS.$t('public.country.NO'), key: 'NO', lang: 'en', symbolCode: 'NO', text: WS.$t('public.country.NO') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '47', mobilePossibleLengths: [8] },
    'OM': { name: WS.$t('public.country.OM'), key: 'OM', lang: 'en', symbolCode: 'OM', text: WS.$t('public.country.OM') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '968', mobilePossibleLengths: [8] },
    'PK': { name: WS.$t('public.country.PK'), key: 'PK', lang: 'en', symbolCode: 'PK', text: WS.$t('public.country.PK') + ' - ' + 'PKR ₨', symbol: '₨', currency: 'PKR', dialCode: '92', mobilePossibleLengths: [10] },
    'PA': { name: WS.$t('public.country.PA'), key: 'PA', lang: 'en', symbolCode: 'PA', text: WS.$t('public.country.PA') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '507', mobilePossibleLengths: [7, 8] },
    'PG': { name: WS.$t('public.country.PG'), key: 'PG', lang: 'en', symbolCode: 'PG', text: WS.$t('public.country.PG') + ' - ' + 'PGK K', symbol: 'K', currency: 'PGK', dialCode: '675', mobilePossibleLengths: [8] },
    'PY': { name: WS.$t('public.country.PY'), key: 'PY', lang: 'en', symbolCode: 'PY', text: WS.$t('public.country.PY') + ' - ' + 'PYG ₲', symbol: '₲', currency: 'PYG', dialCode: '595', mobilePossibleLengths: [9] },
    'PE': { name: WS.$t('public.country.PE'), key: 'PE', lang: 'en', symbolCode: 'PE', text: WS.$t('public.country.PE') + ' - ' + 'PEN S/', symbol: 'S/', currency: 'PEN', dialCode: '51', mobilePossibleLengths: [9] },
    'PH': { name: WS.$t('public.country.PH'), key: 'PH', lang: 'en', symbolCode: 'PH', text: WS.$t('public.country.PH') + ' - ' + 'PHP ₱', symbol: '₱', currency: 'PHP', dialCode: '63', mobilePossibleLengths: [10] },
    'PL': { name: WS.$t('public.country.PL'), key: 'PL', lang: 'en', symbolCode: 'PL', text: WS.$t('public.country.PL') + ' - ' + 'PLN zł', symbol: 'zł', currency: 'PLN', dialCode: '48', mobilePossibleLengths: [9] },
    'PT': { name: WS.$t('public.country.PT'), key: 'PT', lang: 'en', symbolCode: 'PT', text: WS.$t('public.country.PT') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '351', mobilePossibleLengths: [9] },
    'QA': { name: WS.$t('public.country.QA'), key: 'QA', lang: 'en', symbolCode: 'QA', text: WS.$t('public.country.QA') + ' - ' + 'QAR ر.ق', symbol: 'ر.ق', currency: 'QAR', dialCode: '974', mobilePossibleLengths: [8] },
    'RE': { name: WS.$t('public.country.RE'), key: 'RE', lang: 'en', symbolCode: 'RE', text: WS.$t('public.country.RE') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '262', mobilePossibleLengths: [9] },
    'RO': { name: WS.$t('public.country.RO'), key: 'RO', lang: 'en', symbolCode: 'RO', text: WS.$t('public.country.RO') + ' - ' + 'RON Lei', symbol: 'Lei', currency: 'RON', dialCode: '40', mobilePossibleLengths: [9] },
    'RW': { name: WS.$t('public.country.RW'), key: 'RW', lang: 'en', symbolCode: 'RW', text: WS.$t('public.country.RW') + ' - ' + 'RWF FRw', symbol: 'FRw', currency: 'RWF', dialCode: '250', mobilePossibleLengths: [9] },
    'WS': { name: WS.$t('public.country.WS'), key: 'WS', lang: 'en', symbolCode: 'WS', text: WS.$t('public.country.WS') + ' - ' + 'WST T', symbol: 'T', currency: 'WST', dialCode: '685', mobilePossibleLengths: [7, 10] },
    'SM': { name: WS.$t('public.country.SM'), key: 'SM', lang: 'en', symbolCode: 'SM', text: WS.$t('public.country.SM') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '378', mobilePossibleLengths: [8] },
    'ST': { name: WS.$t('public.country.ST'), key: 'ST', lang: 'en', symbolCode: 'ST', text: WS.$t('public.country.ST') + ' - ' + 'STD Db', symbol: 'Db', currency: 'STD', dialCode: '239', mobilePossibleLengths: [7] },
    'SA': { name: WS.$t('public.country.SA'), key: 'SA', lang: 'en', symbolCode: 'SA', text: WS.$t('public.country.SA') + ' - ' + 'SAR ر.س', symbol: 'ر.س', currency: 'SAR', dialCode: '966', mobilePossibleLengths: [9] },
    'SN': { name: WS.$t('public.country.SN'), key: 'SN', lang: 'en', symbolCode: 'SN', text: WS.$t('public.country.SN') + ' - ' + 'XOF Fr', symbol: 'Fr', currency: 'XOF', dialCode: '221', mobilePossibleLengths: [9] },
    'RS': { name: WS.$t('public.country.RS'), key: 'RS', lang: 'en', symbolCode: 'RS', text: WS.$t('public.country.RS') + ' - ' + 'RSD РСД', symbol: 'РСД', currency: 'RSD', dialCode: '381', mobilePossibleLengths: [8, 9, 10] },
    'SC': { name: WS.$t('public.country.SC'), key: 'SC', lang: 'en', symbolCode: 'SC', text: WS.$t('public.country.SC') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '248', mobilePossibleLengths: [7] },
    'SL': { name: WS.$t('public.country.SL'), key: 'SL', lang: 'en', symbolCode: 'SL', text: WS.$t('public.country.SL') + ' - ' + 'SLL Le', symbol: 'Le', currency: 'SLL', dialCode: '232', mobilePossibleLengths: [8] },
    'SG': { name: WS.$t('public.country.SG'), key: 'SG', lang: 'en', symbolCode: 'SG', text: WS.$t('public.country.SG') + ' - ' + 'SGD $', symbol: '$', currency: 'SGD', dialCode: '65', mobilePossibleLengths: [8] },
    'SK': { name: WS.$t('public.country.SK'), key: 'SK', lang: 'en', symbolCode: 'SK', text: WS.$t('public.country.SK') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '421', mobilePossibleLengths: [9] },
    'SI': { name: WS.$t('public.country.SI'), key: 'SI', lang: 'en', symbolCode: 'SI', text: WS.$t('public.country.SI') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '386', mobilePossibleLengths: [8] },
    'SB': { name: WS.$t('public.country.SB'), key: 'SB', lang: 'en', symbolCode: 'SB', text: WS.$t('public.country.SB') + ' - ' + 'SBD $', symbol: '$', currency: 'SBD', dialCode: '677', mobilePossibleLengths: [5, 7] },
    'ZA': { name: WS.$t('public.country.ZA'), key: 'ZA', lang: 'en', symbolCode: 'ZA', text: WS.$t('public.country.ZA') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '27', mobilePossibleLengths: [5, 6, 7, 8, 9] },
    'KR': { name: WS.$t('public.country.KR'), key: 'KR', lang: 'en', symbolCode: 'KR', text: WS.$t('public.country.KR') + ' - ' + 'KRW ₩', symbol: '₩', currency: 'KRW', dialCode: '82', mobilePossibleLengths: [9, 10] },
    'ES': { name: WS.$t('public.country.ES'), key: 'ES', lang: 'en', symbolCode: 'ES', text: WS.$t('public.country.ES') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '34', mobilePossibleLengths: [9] },
    'LK': { name: WS.$t('public.country.LK'), key: 'LK', lang: 'en', symbolCode: 'LK', text: WS.$t('public.country.LK') + ' - ' + 'LKR ₨', symbol: '₨', currency: 'LKR', dialCode: '94', mobilePossibleLengths: [9] },
    'BL': { name: WS.$t('public.country.BL'), key: 'BL', lang: 'en', symbolCode: 'BL', text: WS.$t('public.country.BL') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '590', mobilePossibleLengths: [9] },
    'KN': { name: WS.$t('public.country.KN'), key: 'KN', lang: 'en', symbolCode: 'KN', text: WS.$t('public.country.KN') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'LC': { name: WS.$t('public.country.LC'), key: 'LC', lang: 'en', symbolCode: 'LC', text: WS.$t('public.country.LC') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'MF': { name: WS.$t('public.country.MF'), key: 'MF', lang: 'en', symbolCode: 'MF', text: WS.$t('public.country.MF') + ' - ' + 'EUR €', symbol: '€', currency: 'EUR', dialCode: '590', mobilePossibleLengths: [9] },
    'VC': { name: WS.$t('public.country.VC'), key: 'VC', lang: 'en', symbolCode: 'VC', text: WS.$t('public.country.VC') + ' - ' + 'XCD $', symbol: '$', currency: 'XCD', dialCode: '1', mobilePossibleLengths: [10] },
    'SR': { name: WS.$t('public.country.SR'), key: 'SR', lang: 'en', symbolCode: 'SR', text: WS.$t('public.country.SR') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '597', mobilePossibleLengths: [7] },
    'SE': { name: WS.$t('public.country.SE'), key: 'SE', lang: 'en', symbolCode: 'SE', text: WS.$t('public.country.SE') + ' - ' + 'SEK kr', symbol: 'kr', currency: 'SEK', dialCode: '46', mobilePossibleLengths: [9] },
    'CH': { name: WS.$t('public.country.CH'), key: 'CH', lang: 'en', symbolCode: 'CH', text: WS.$t('public.country.CH') + ' - ' + 'CHF CHF', symbol: 'CHF', currency: 'CHF', dialCode: '41', mobilePossibleLengths: [9] },
    'TW': { name: WS.$t('public.country.TW'), key: 'TW', lang: 'en', symbolCode: 'TW', text: WS.$t('public.country.TW') + ' - ' + 'TWD $', symbol: '$', currency: 'TWD', dialCode: '886', mobilePossibleLengths: [9] },
    'TZ': { name: WS.$t('public.country.TZ'), key: 'TZ', lang: 'en', symbolCode: 'TZ', text: WS.$t('public.country.TZ') + ' - ' + 'TZS Sh', symbol: 'Sh', currency: 'TZS', dialCode: '255', mobilePossibleLengths: [9] },
    'TH': { name: WS.$t('public.country.TH'), key: 'TH', lang: 'en', symbolCode: 'TH', text: WS.$t('public.country.TH') + ' - ' + 'THB ฿', symbol: '฿', currency: 'THB', dialCode: '66', mobilePossibleLengths: [9] },
    'TL': { name: WS.$t('public.country.TL'), key: 'TL', lang: 'en', symbolCode: 'TL', text: WS.$t('public.country.TL') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '670', mobilePossibleLengths: [8] },
    'TG': { name: WS.$t('public.country.TG'), key: 'TG', lang: 'en', symbolCode: 'TG', text: WS.$t('public.country.TG') + ' - ' + 'XOF Fr', symbol: 'Fr', currency: 'XOF', dialCode: '228', mobilePossibleLengths: [8] },
    'TO': { name: WS.$t('public.country.TO'), key: 'TO', lang: 'en', symbolCode: 'TO', text: WS.$t('public.country.TO') + ' - ' + 'TOP T$', symbol: 'T$', currency: 'TOP', dialCode: '676', mobilePossibleLengths: [7] },
    'TT': { name: WS.$t('public.country.TT'), key: 'TT', lang: 'en', symbolCode: 'TT', text: WS.$t('public.country.TT') + ' - ' + 'TTD $', symbol: '$', currency: 'TTD', dialCode: '1', mobilePossibleLengths: [10] },
    'TN': { name: WS.$t('public.country.TN'), key: 'TN', lang: 'en', symbolCode: 'TN', text: WS.$t('public.country.TN') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '216', mobilePossibleLengths: [8] },
    'TR': { name: WS.$t('public.country.TR'), key: 'TR', lang: 'en', symbolCode: 'TR', text: WS.$t('public.country.TR') + ' - ' + 'TRY ₺', symbol: '₺', currency: 'TRY', dialCode: '90', mobilePossibleLengths: [10] },
    'TC': { name: WS.$t('public.country.TC'), key: 'TC', lang: 'en', symbolCode: 'TC', text: WS.$t('public.country.TC') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '1', mobilePossibleLengths: [10] },
    'TV': { name: WS.$t('public.country.TV'), key: 'TV', lang: 'en', symbolCode: 'TV', text: WS.$t('public.country.TV') + ' - ' + 'AUD $', symbol: '$', currency: 'AUD', dialCode: '688', mobilePossibleLengths: [6, 7] },
    'UG': { name: WS.$t('public.country.UG'), key: 'UG', lang: 'en', symbolCode: 'UG', text: WS.$t('public.country.UG') + ' - ' + 'UGX USh', symbol: 'USh', currency: 'UGX', dialCode: '256', mobilePossibleLengths: [9] },
    'AE': { name: WS.$t('public.country.AE'), key: 'AE', lang: 'en', symbolCode: 'AE', text: WS.$t('public.country.AE') + ' - ' + 'AED د.إ', symbol: 'د.إ', currency: 'AED', dialCode: '971', mobilePossibleLengths: [9] },
    'GB': { name: WS.$t('public.country.GB'), key: 'GB', lang: 'en', symbolCode: 'GB', text: WS.$t('public.country.GB') + ' - ' + 'GBP £', symbol: '£', currency: 'GBP', icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_gb_3x_58ad6633-3e23-4fa8-876a-e57eb5c72cae.png?v=1662621152', standard: '69.00', express: '99.00', standardPostage: '6.00', expressPostage: '11.00', standardDay: '6-9', expressDay: '4-6', dialCode: '44', mobilePossibleLengths: [10] },
    'UY': { name: WS.$t('public.country.UY'), key: 'UY', lang: 'en', symbolCode: 'UY', text: WS.$t('public.country.UY') + ' - ' + 'UYU $U', symbol: '$U', currency: 'UYU', dialCode: '598', mobilePossibleLengths: [8] },
    'UZ': { name: WS.$t('public.country.UZ'), key: 'UZ', lang: 'en', symbolCode: 'UZ', text: WS.$t('public.country.UZ') + ' - ' + 'UZS so\'m', symbol: 'so\'m', currency: 'UZS', dialCode: '998', mobilePossibleLengths: [9] },
    'VU': { name: WS.$t('public.country.VU'), key: 'VU', lang: 'en', symbolCode: 'VU', text: WS.$t('public.country.VU') + ' - ' + 'VUV Vt', symbol: 'Vt', currency: 'VUV', dialCode: '678', mobilePossibleLengths: [7] },
    'VN': { name: WS.$t('public.country.VN'), key: 'VN', lang: 'en', symbolCode: 'VN', text: WS.$t('public.country.VN') + ' - ' + 'VND ₫', symbol: '₫', currency: 'VND', dialCode: '84', mobilePossibleLengths: [9] },
    'ZM': { name: WS.$t('public.country.ZM'), key: 'ZM', lang: 'en', symbolCode: 'ZM', text: WS.$t('public.country.ZM') + ' - ' + 'USD $', symbol: '$', currency: 'USD', dialCode: '260', mobilePossibleLengths: [9] }
};

  var languageMap = {};
  for (var key in countryInfoMap) {
    languageMap[key] = countryInfoMap[key].name;
  }

  var abtMap = {
    aatest: 'aatest',
  };
 
  // 需要授权登录的页面集合
  var authList = ['/pages/my', '/pages/refer', '/pages/vip-center', '/pages/my-point', 'pages/my-coupon', 'pages/forgetPwd'];

  // 生成商品block模块（data.baseIndex 可选，用于集合分页时的正确序号）
  var productBlockDom = `
    <% for ( let [ index, item ] of new Map( data.record.map( ( item, index ) => [ index, item ] ) ) ) { %>
      <% var displayIndex = (data.baseIndex != null && data.baseIndex !== '') ? (Number(data.baseIndex) + index) : index; %>
      <div stat-module-show="true" stat-module-show-id="<%= item.productId %>" data-skc-title="<%= item.skcTitle %>" stat-module-show-aid="<%= item.algorithmId %>" stat-module-show-title="<%= item.title %>" stat-module-show-price="<%= Number(item.displayPrice) %>" stat-module-show-selected-color="<%= item.currentSku %>" stat-module-show-color="<%= (item.variantList && item.variantList[0] && item.variantList[0].sku) || (item.mergeSkcDisplayList && item.mergeSkcDisplayList[0] && item.mergeSkcDisplayList[0].sku) || '' %>" data-product-id="<%= item.productId %>" class="ws-product-block" data-index="<%= displayIndex %>" data-is-new="<%= item.isNew %>">
        <div class="ws-product-block-innerbox">
          <div class="ws-product-block-image">
            <a class="ws-product-link" href="<%= item.initialProductUrl || (WS.site.dir + '/products/' + item.handle) %>" aria-label="<%= item.title %>" tabindex="-1">
              <div class="ws-product-block-image-box<% if ( item.hoverImageSrc ) { %> ws-product-block-image-box--hover<% } %>" data-media-id="<%= (item.image && item.image.imageId) || '' %>" data-src="<%= (item.initialImageSrc || item.imageSrc) || '' %>">
                <div class="ws-rimage-wrapper-box ws-img-lazyload-placeholder js-lazyload-img ws-rimage-wrapper-box--primary" style="padding-top:133.33333333333334%">
                  <img class="shop-featured-img" data-lazyload-src="<%= (item.initialImageSrc || item.imageSrc) || '' %>" alt="<%= WS.ui.productImageAlt(item.imageList && item.imageList[0] && (item.imageList[0].alt || item.imageList[0].altText), item.initialProductTitle || item.title, 1, item.imageList && item.imageList.length).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>">
                </div>
                <% if ( item.hoverImageSrc ) { %>
                <div class="ws-rimage-wrapper-box ws-img-lazyload-placeholder js-lazyload-img ws-rimage-wrapper-box--secondary" style="padding-top:133.33333333333334%">
                  <img class="shop-featured-img ws-product-hover-img" data-lazyload-src="<%= item.hoverImageSrc %>" loading="lazy" alt="<%= WS.ui.productImageAlt(item.imageList && item.imageList[1] && (item.imageList[1].alt || item.imageList[1].altText), item.initialProductTitle || item.title, 2, item.imageList && item.imageList.length).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>">
                </div>
                <% } %>
              </div>
            </a>
            <div class="ws-product-info-databox" target-product>
              <div class="js-product-json" style="display: none;">
                {
                  "id":<%= item.productId %>,
                  "title":"<%= item.title %>",
                  "handle":"<%= item.handle %>",
                  "product_url":"${WS.site.dir}/products/<%= item.handle %>",
                  "price":"<%= Number(item.displayPrice) %>",
                  "defaultPrice":"<%= Number(item.displayPrice) %>",
                  "price_code":"<%= item.displayPrice %>",
                  "compare_at_price":"<%= Number(item.displayComparePrice) %>",
                  "compare_at_price_code":"${WS.site.symbol}<%= (item.displayComparePrice / 100).toFixed(2) %>",
                  "currencyCode":"${WS.site.symbol}",
                  "images":<%= JSON.stringify(item.imageList) %>,
                  "variants":<%= JSON.stringify(item.variantList) %>,
                  "options_with_values":<%= JSON.stringify(item.optionList) %>,
                  "mergeSkcs":<%= JSON.stringify(item.mergeSkcs || []) %>
                }
              </div>
              <button type="button" class="ws-product__add-bag-btn" id="ws-product-cart-popup-<%= item.initialProductId || item.productId %>" data-product-url="<%= item.initialProductUrl || (WS.site.dir + '/products/' + item.handle) %>" data-product-id="<%= item.initialProductId || item.productId %>" aria-label="Add <%= String(item.initialProductTitle || item.title || '').replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %> to cart" aria-haspopup="dialog">
                <img class="ws-product__add-bag-icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/westyle-icon-addtobag.png?v=1772516514" width="24" height="24" loading="lazy" alt="" />
              </button>
              <a class="ws-product-link ws-product-quick-buy" href="<%= item.initialProductUrl || (WS.site.dir + '/products/' + item.handle) %>"></a>
              <div class="ws-quick-buy-btn">${WS.$t('public.add_pop.add_to_bag_btn')}</div>
            </div>
            <% if ( item.isNew && !item.hasComparePrice ) { %>
              <div class="ws-product-new-label">NEW</div>
            <% } %>
            <% if ( item.hasComparePrice ) { %>
              <div class="ws-product-label-box">
                <div class="ws-product-label-box-discount">
                  <div class="label-box-discount-wrapper label-box-discount-wrapper_abt">
                    <div class="discount-box">
                    -<%= 100 -  Math.ceil((item.displayPrice * 100) / item.displayComparePrice) %>%
                    </div>
                  </div>
                </div>
              </div>
            <% } %>
          </div>
          <div class="ws-product-block-info">
            <a class="ws-product-link" href="<%= item.initialProductUrl || (WS.site.dir + '/products/' + item.handle) %>">
              <div class="ws-product-block-title"><%= item.initialProductTitle || item.title %></div>
              <div class="reviews-star-box"></div>
            </a>
            <%
              var _sym = (countryInfoMap[WS.site.country] && countryInfoMap[WS.site.country].symbol) || WS.site.symbol || '$';
              var _cur = (countryInfoMap[WS.site.country] && countryInfoMap[WS.site.country].currency) || WS.site.currency || 'USD';
              var _priceFmt = _sym + WS.i18n.fmtAmount((item.displayPrice/100).toFixed(2)) + ' ' + _cur;
              var _compareFmt = item.hasComparePrice ? (_sym + WS.i18n.fmtAmount((item.displayComparePrice/100).toFixed(2)) + ' ' + _cur) : '';
            %>
            <div class="ws-product-block-price <% if ( item.hasComparePrice ) { %>wrap<% } %>" data-price="<%= Number(item.displayPrice) %>" data-compare-at-price="<%= Number(item.displayComparePrice) %>" data-price-formatted="<%= _priceFmt %>" data-compare-formatted="<%= _compareFmt %>">
              <div class="product-block-amount-wrapper">
                <span class="ws-price-amount-sale <% if ( item.hasComparePrice ) { %>ws-price-amount-sale-red<% } %>"><%= _priceFmt %></span>
                <% if ( item.hasComparePrice ) { %>
                  <span class="ws-price-amount-compare"><%= _compareFmt %></span>
                <% } %>
              </div>
            </div>
          </div>
          <div class="ws-product-block-variants" data-variants-count="<%= (item.mergeSkcDisplayList && item.mergeSkcDisplayList.length) || (item.filteredVariantList && item.filteredVariantList.length) || 0 %>">
            <% if ( item.mergeSkcDisplayList && item.mergeSkcDisplayList.length >= 1 ) { %>
              <%
                var variantsCount = item.mergeSkcDisplayList.length;
                var showScrollBtns = variantsCount > 6;
              %>
              <div class="ws-product-variants-scroll-wrapper">
                <% if ( showScrollBtns ) { %><button type="button" class="ws-variants-scroll-btn ws-variants-scroll-prev" aria-label="Previous variants"><img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-arrow.svg?v=1773226641" width="24" height="24" loading="lazy" alt="" /></button><% } %>
                <div class="ws-product-variants-scroll-viewport">
                  <div class="ws-product-variants-list" role="group" aria-label="Colors for <%= String(item.initialProductTitle || item.title || '').replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>">
                <% for ( var [skcIdx, skcItem] of item.mergeSkcDisplayList.entries() ) {
                  var priceFmt = _sym + WS.i18n.fmtAmount((skcItem.price / 100).toFixed(2)) + ' ' + _cur;
                  var compareFmt = skcItem.compareAtPrice > skcItem.price ? (_sym + WS.i18n.fmtAmount((skcItem.compareAtPrice / 100).toFixed(2)) + ' ' + _cur) : '';
                  var isActive = item.mergeSkcDisplayList.length === 1 || (item.defaultColor ? skcItem.option1 == item.defaultColor : skcIdx == 0);
                  var colorName = skcItem.option1;
                  if (!colorName || /^(?:XXS|XS|S|M|L|XL|XXL|\d{1,2})$/i.test(colorName)) colorName = ((skcItem.productTitle || '').match(/Black|White|Pink|Red|Blue|Green|Yellow|Brown|Ivory|Cream|Beige|Purple|Gold|Silver|Orange|Navy|Lilac|Grey|Gray|Burgundy/i) || [skcItem.productTitle || 'Color'])[0];
                %>
                  <button type="button" class="ws-variants-image-box <% if ( isActive ) { %>ws-variants-image-active<% } %>" aria-label="<%= String(colorName).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>" aria-pressed="<%= isActive ? 'true' : 'false' %>" data-value="<%= colorName %>" data-variant-id="<%= skcItem.variantId %>" data-sku="<%= skcItem.sku %>" data-img="<%= skcItem.imageSrc || '' %>" data-img-alt="<%= String(skcItem.imageAlt || skcItem.productTitle || '').replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>" data-product-url="<%= skcItem.productUrl || '' %>" data-product-id="<%= skcItem.productId %>" data-product-title="<%= skcItem.productTitle %>" data-price="<%= skcItem.price %>" data-compare-at-price="<%= skcItem.compareAtPrice %>" data-price-formatted="<%= priceFmt %>" data-compare-formatted="<%= compareFmt %>"<% if ( skcItem.colorHex ) { %> data-color-hex="<%= skcItem.colorHex %>"<% } %>>
                    <% if ( skcItem.colorHex ) { %>
                      <span class="ws-variants-color-dot" style="background-color: <%= skcItem.colorHex %>;"></span>
                    <% } else if ( skcItem.selectOptImageSrc ) { %>
                      <img class="ws-variants-color-image color-image merge-skc" data-origin-src="<%= skcItem.selectOptImageSrc %>" data-origin-src="<%= skcItem.selectOptImageSrc %>" data-lazyload-src="<%= skcItem.selectOptImageSrc %>" width="60" height="60" loading="lazy" alt="">
                    <% } else { %>
                      <span class="ws-variants-color-dot"></span>
                    <% } %>
                  </button>
                <% } %>
                  </div>
                </div>
                <% if ( showScrollBtns ) { %><button type="button" class="ws-variants-scroll-btn ws-variants-scroll-next" aria-label="Next variants"><img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-arrow.svg?v=1773226641" width="24" height="24" loading="lazy" alt="" /></button><% } %>
              </div>
            <% } else if ( item.filteredVariantList && item.filteredVariantList.length >= 1 ) { %>
              <%
                var variantsCount = item.filteredVariantList.length;
                var showScrollBtns = variantsCount > 6;
              %>
              <div class="ws-product-variants-scroll-wrapper">
                <% if ( showScrollBtns ) { %><button type="button" class="ws-variants-scroll-btn ws-variants-scroll-prev" aria-label="Previous variants">&lt;</button><% } %>
                <div class="ws-product-variants-scroll-viewport">
                <div class="ws-product-variants-list" role="group" aria-label="Colors for <%= String(item.title || '').replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>">
                <% for ( var [colorVairantIndex, colorVairantItem] of item.filteredVariantList.entries() ) {
                  var variantPrice = (colorVairantItem.presentmentPrice && colorVairantItem.presentmentPrice.price && colorVairantItem.presentmentPrice.price.amount != null) ? Math.round(parseFloat(colorVairantItem.presentmentPrice.price.amount) * 100) : (colorVairantItem.price || item.displayPrice);
                  var variantComparePrice = (colorVairantItem.presentmentPrice && colorVairantItem.presentmentPrice.compareAtPrice && colorVairantItem.presentmentPrice.compareAtPrice.amount != null) ? Math.round(parseFloat(colorVairantItem.presentmentPrice.compareAtPrice.amount) * 100) : (item.displayComparePrice || 0);
                  var variantUrl = WS.site.dir + '/products/' + item.handle + '?color=' + encodeURIComponent(colorVairantItem.option1 || '') + '&variant=' + colorVairantItem.variantId;
                  var priceFmt = _sym + WS.i18n.fmtAmount((variantPrice / 100).toFixed(2)) + ' ' + _cur;
                  var compareFmt = variantComparePrice > variantPrice ? (_sym + WS.i18n.fmtAmount((variantComparePrice / 100).toFixed(2)) + ' ' + _cur) : '';
                  var isVariantActive = item.filteredVariantList.length === 1 || (item.defaultColor ? colorVairantItem.option1 == item.defaultColor : colorVairantIndex == 0);
                  var variantColorName = colorVairantItem.option1;
                  if (!variantColorName || /^(?:XXS|XS|S|M|L|XL|XXL|\d{1,2})$/i.test(variantColorName)) variantColorName = ((item.title || '').match(/Black|White|Pink|Red|Blue|Green|Yellow|Brown|Ivory|Cream|Beige|Purple|Gold|Silver|Orange|Navy|Lilac|Grey|Gray|Burgundy/i) || [item.title || 'Color'])[0];
                %>
                  <button type="button" class="ws-variants-image-box <% if ( isVariantActive ) { %>ws-variants-image-active<% } %>" aria-label="<%= String(variantColorName).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>" aria-pressed="<%= isVariantActive ? 'true' : 'false' %>" data-value="<%= variantColorName %>" data-variant-id="<%= colorVairantItem.variantId %>" data-sku="<%= colorVairantItem.sku%>" data-img="<%= colorVairantItem.imageSrc ? colorVairantItem.imageSrc : '' %>" data-img-alt="<%= String(colorVairantItem.imageAlt || item.title || '').replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>" data-product-url="<%= variantUrl %>" data-product-id="<%= item.productId %>" data-product-title="<%= item.title %>" data-price="<%= variantPrice %>" data-compare-at-price="<%= variantComparePrice %>" data-price-formatted="<%= priceFmt %>" data-compare-formatted="<%= compareFmt %>"<% if ( colorVairantItem.colorHex ) { %> data-color-hex="<%= colorVairantItem.colorHex %>"<% } %>>
                    <% if ( colorVairantItem.colorHex ) { %>
                      <span class="ws-variants-color-dot" style="background-color: <%= colorVairantItem.colorHex %>;"></span>
                    <% } else if ( colorVairantItem.selectOptImageSrc ) { %>
                      <img class="ws-variants-color-image color-image filter" data-origin-src="<%= colorVairantItem.selectOptImageSrc %>" data-lazyload-src="<%= colorVairantItem.selectOptImageSrc %>" width="60" height="60" loading="lazy" alt="">
                    <% } else { %>
                      <span class="ws-variants-color-dot"></span>
                    <% } %>
                  </button>
                <% } %>
                  </div>
                </div>
                <% if ( showScrollBtns ) { %><button type="button" class="ws-variants-scroll-btn ws-variants-scroll-next" aria-label="Next variants"><img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-arrow.svg?v=1773226641" width="24" height="24" loading="lazy" alt="" /></button><% } %>
              </div>
            <% } %>
          </div>
        </div>
      </div>
    <% } %>
  `;

var emptyDom = `
  <div class="ws-empty-results common-empty-wrapper">
    <div class="ws-empty-results__icon">
      <img class="common-empty-img ws-empty-results__img" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-empty-data.png?v=1773905221" width="144" height="144" loading="lazy" alt="" />
    </div>
    <h2 class="ws-empty-results__title">No Products Found</h2>
    <p class="ws-empty-results__text">
      Use Fewer Filters Or <a href="#" class="ws-empty-results__remove-all" role="button">Remove All</a>
    </p>
  </div>
`;
            
  var currencySymbol = 'US';
  var normalCouponList = [{
    currencyCode: WS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'SA20',
    discountId: '999',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '20%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 2,
    minimalProductCount: 2
  }, {
    currencyCode: WS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'SA25',
    discountId: '998',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '25%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 2,
    minimalProductCount: 3
  }, {
    currencyCode: WS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'SA30',
    discountId: '997',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '30%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 2,
    minimalProductCount: 4
  }];

  // var normalCouponList = [];

  // if (WS.site.country !== 'US') {
  //   normalCouponList = [];
  // }
  
  // 多店铺集合
  var shopMain = 'graecove';
  var shopAU = 'au-graecove';
  var shopUK = 'uk-graecove';
  var shopCA = 'ca-graecove';
  var shopMap = {
    '10001': shopMain,
    '10002': shopAU,
    '10003': shopUK,
    '10004': shopCA,
  }

  var isShopAU = shopMap[WS.site.shop] === shopAU;

  // 可兑换积分比例 美国US$1 = 300积分 澳大利亚 AU$1 = 450积分
  var pointRatio = WS.site.country === 'AU' ? 450 : 300;

  // 日期格式
  var dateFormat = WS.site.country === 'AU' ? 'dd.MM.yyyy' : 'MM.dd.yyyy';
  var dateTimeFormat = WS.site.country === 'AU' ? 'dd.MM.yyyy hh:mm:ss' : 'MM.dd.yyyy hh:mm:ss';

  // 评论积分奖励
  var textReviewPointNum = WS.site.country === 'AU' ? 300 : 200; // 文字
  var textImgReviewPointNum = WS.site.country === 'AU' ? 450 : 300; // 文字+图片

  WS.ui.abtMap = abtMap;
  WS.ui.reportType = reportType;
  WS.ui.reportMap = reportMap;
  WS.ui.homeReportMap = homeReportMap;
  WS.ui.searchReportMap = searchReportMap;
  WS.ui.productReportMap = productReportMap;
  WS.ui.collectionReportMap = collectionReportMap;
  WS.ui.globalReportMap = globalReportMap;
  WS.ui.accountReportMap = accountReportMap;
  WS.ui.voteReportMap = voteReportMap;
  WS.ui.orderSurveyReportMap = orderSurveyReportMap;
  WS.ui.errorMsgMap = errorMsgMap;
  WS.ui.countryInfoMap = countryInfoMap;
  WS.ui.languageMap = languageMap;
  WS.ui.authList = authList;
  WS.ui.productBlockDom = productBlockDom;
  WS.ui.emptyDom = emptyDom;
  WS.ui.i18nReportMap = i18nReportMap;
  WS.ui.loginRegistrationProcessMap = loginRegistrationProcessMap;
  WS.ui.normalCouponList = normalCouponList;
  WS.ui.shopMain = shopMain;
  WS.ui.shopAU = shopAU;
  WS.ui.shopMap = shopMap;
  WS.ui.isShopAU = isShopAU;
  WS.ui.pointRatio = pointRatio;
  WS.ui.dateFormat = dateFormat;
  WS.ui.dateTimeFormat = dateTimeFormat;
  WS.ui.textReviewPointNum = textReviewPointNum;
  WS.ui.textImgReviewPointNum = textImgReviewPointNum;
  WS.ui.loginRegisterSourceFieldsMap = loginRegisterSourceFieldsMap;
  WS.ui.whatYouWantMap = whatYouWantMap;
})();

/**
 * 正则校验
 */
(function() {
  var validator = {
    easyEmailReg: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    emailReg: /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
    numberReg: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
  }

  WS.ui.validator = validator
})();

(function () {
  var SECTION_ID = 'westyle-collection-data';
  var LS_SET_WIDTH = 700;

  /** 变体颜色/选项列解析（Liquid JSON + 推荐接口共用，避免重复逻辑） */
  function _variantColorOptName(name) {
    if (name == null || name === '') return false;
    var n = String(name).toLowerCase();
    return n.indexOf('color') >= 0 || n.indexOf('colour') >= 0 || String(name).indexOf('颜色') >= 0;
  }
  function _variantSizeOptName(name) {
    if (name == null || name === '') return false;
    var n = String(name).toLowerCase();
    return n.indexOf('size') >= 0 || String(name).indexOf('尺码') >= 0 || String(name).indexOf('尺寸') >= 0;
  }
  function _variantColorColumnIndex(optionsWithValues) {
    if (!optionsWithValues || !optionsWithValues.length) return 0;
    for (var i = 0; i < optionsWithValues.length; i++) {
      if (_variantColorOptName((optionsWithValues[i] && optionsWithValues[i].name) || '')) return i;
    }
    return 0;
  }
  function _variantSizeColumnIndex(optionsWithValues) {
    if (!optionsWithValues || !optionsWithValues.length) return 1;
    for (var si = 0; si < optionsWithValues.length; si++) {
      if (_variantSizeOptName((optionsWithValues[si] && optionsWithValues[si].name) || '')) return si;
    }
    return 1;
  }
  function _variantValueAtOptionIndex(variant, idx) {
    if (!variant) return '';
    if (idx === 1) return variant.option2 != null ? String(variant.option2) : '';
    if (idx === 2) return variant.option3 != null ? String(variant.option3) : '';
    return variant.option1 != null ? String(variant.option1) : '';
  }
  /**
   * 展示用颜色值：有 selectedOptions（Storefront）按名称取；否则按 options / options_with_values 列从 option1/2/3 取
   */
  function variantDisplayColor(variant, optionsWithValues) {
    if (!variant) return '';
    var sel = variant.selectedOptions;
    if (sel && sel.length) {
      for (var oi = 0; oi < sel.length; oi++) {
        var o = sel[oi] || {};
        if (_variantColorOptName(o.name)) return String(o.value != null ? o.value : '');
      }
      var fv = sel[0] && sel[0].value;
      return fv != null ? String(fv) : '';
    }
    var ci = _variantColorColumnIndex(optionsWithValues || []);
    return _variantValueAtOptionIndex(variant, ci);
  }

  /**
   * 与后台「Color → Size」展示一致：将 options_with_values 排为 Color 选项在前、Size 其次、其余保持相对顺序
   */
  // function sortOptionsWithValuesColorFirst(optionsWithValues) {
  //   if (!optionsWithValues || !optionsWithValues.length) return optionsWithValues || [];
  //   var colorOptName = _variantColorOptName;
  //   var sizeOptName = _variantSizeOptName;
  //   var colorIdx = -1;
  //   var sizeIdx = -1;
  //   for (var i = 0; i < optionsWithValues.length; i++) {
  //     var n = optionsWithValues[i] && optionsWithValues[i].name;
  //     if (colorIdx < 0 && colorOptName(n)) colorIdx = i;
  //     if (sizeIdx < 0 && sizeOptName(n)) sizeIdx = i;
  //   }
  //   if (colorIdx < 0 && sizeIdx < 0) return optionsWithValues.slice();
  //   var used = {};
  //   var order = [];
  //   if (colorIdx >= 0) {
  //     order.push(colorIdx);
  //     used[colorIdx] = 1;
  //   }
  //   if (sizeIdx >= 0 && !used[sizeIdx]) {
  //     order.push(sizeIdx);
  //     used[sizeIdx] = 1;
  //   }
  //   for (var j = 0; j < optionsWithValues.length; j++) {
  //     if (!used[j]) order.push(j);
  //   }
  //   return order.map(function (idx) {
  //     return optionsWithValues[idx];
  //   });
  // }

  /** 根据 options_with_values 解析颜色列、尺码列下标（与 variant 的 option1/2/3 下标一致） */
  // function getVariantColumnIndicesFromOptions(ows) {
  //   var list = ows || [];
  //   var _cIdx = _variantColorColumnIndex(list);
  //   var _sIdx = _variantSizeColumnIndex(list);
  //   if (_sIdx === _cIdx && list.length > 1) {
  //     _sIdx = _cIdx === 0 ? 1 : 0;
  //   }
  //   return { cIdx: _cIdx, sIdx: _sIdx };
  // }

  // function variantValueAtOptionColumn(v, colIdx) {
  //   var x = _variantValueAtOptionIndex(v, colIdx);
  //   return x != null ? String(x) : '';
  // }

  WS.ui.variantDisplayColor = variantDisplayColor;
  WS.ui.variantOption = {
    displayColor: variantDisplayColor,
    colorColumnIndex: _variantColorColumnIndex,
    sizeColumnIndex: _variantSizeColumnIndex,
    valueAtIndex: _variantValueAtOptionIndex,
    colorOptName: _variantColorOptName,
    sizeOptName: _variantSizeOptName,
    // getVariantColumnIndices: getVariantColumnIndicesFromOptions,
    // variantValueAtColumn: variantValueAtOptionColumn,
    // sortOptionsWithValuesColorFirst: sortOptionsWithValuesColorFirst
  };

  /**
   * 集合页 orderBy → Shopify sort_by（与 resetShopifyCollection 一致）
   */
  var COLLECTION_PAGE_SORT_MAP = {
    'sales': 'best-selling',
    'price_asc': 'price-ascending',
    'price_desc': 'price-descending',
    'created_desc': 'created-descending',
    'created_asc': 'created-ascending',
    'title_asc': 'title-ascending',
    'title_desc': 'title-descending',
    'manual': 'manual'
  };

  /**
   * 从 collectionPageParams 得到 sort_by 与 filter 查询串（仅用于 Section 请求，不写浏览器地址栏）
   */
  function collectionParamsToSortFilterQuery(params) {
    params = params || {};
    var sortBy = params.orderBy ? (COLLECTION_PAGE_SORT_MAP[params.orderBy] || params.orderBy) : '';
    var parts = [];
    (params.colorFilters || []).forEach(function (c) {
      var param = c.param || 'filter.v.option.color';
      var val = (typeof c.value === 'string') ? c.value : String(c.value || '');
      if (val) parts.push(param + '=' + encodeURIComponent(val));
    });
    (params.sizes || []).forEach(function (s) {
      parts.push('filter.v.option.size=' + encodeURIComponent(s));
    });
    (params.productTypes || []).forEach(function (pt) {
      parts.push('filter.p.product_type=' + encodeURIComponent(pt));
    });
    var pr = params.priceRange && params.priceRange[0];
    if (pr) {
      if (pr.startPrice) parts.push('filter.v.price.gte=' + encodeURIComponent(pr.startPrice));
      if (pr.endPrice) parts.push('filter.v.price.lte=' + encodeURIComponent(pr.endPrice));
    }
    return { sortBy: sortBy || '', filterQuery: parts.join('&') };
  }

  // Infinite-scroll HTML comes from a generic section, so add collection labels from variant warehouse metadata after fetching.
  function formatUsa2DayDeliveryLabelHtml(labelText) {
    return labelText === 'SELECT US 2-DAY'
      ? '<span>SELECT</span><span>US 2-DAY</span>'
      : WS.ui.escapeXSS(labelText);
  }

  function appendUsa2DayDeliveryLabels(items) {
    if (!items || !items.length) return;
    $(items).each(function () {
      var $item = $(this);
      if ($item.attr('data-usa-2-day-delivery') !== 'true') return;
      var $image = $item.find('.ws-product-block-image').first();
      if (!$image.length || $image.find('.ws-product-delivery-label').length) return;
      var labelText = $item.attr('data-usa-2-day-delivery-label') || 'SELECT US 2-DAY';
      $('<div class="ws-product-delivery-label"></div>').html(formatUsa2DayDeliveryLabelHtml(labelText)).appendTo($image);
    });
  }

  var infiniteScroll = {
    _instances: [],

    /**
     * 通过 Intersection Observer 监听 loadmore 元素可见性触发加载
     * 支持多实例，每个容器独立运转，分页参数从 DOM data 属性读取
     * @param {Object} opts - 配置项
     * @param {jQuery} opts.listContainer - 列表容器（含 .ws-featured-collection-listing 或带 data-collection-handle 的 DOM）
     * @param {jQuery} [opts.triggerDom] - 触发加载的观察元素，默认 listContainer.find('.ws-featured-collection-loadmore')
     * @param {Function} opts.loadMore - 加载更多回调，接收 (containerDom) 参数
     * @param {Function} opts.hasMore - 返回 boolean
     * @param {Function} [opts.isBusy] - 返回 boolean，防重复
     * @param {jQuery} [opts.loadmoreImg] - loading 图标，默认 listContainer.find('.ws-loadmore-img')
     * @param {string} [opts.rootMargin] - IntersectionObserver rootMargin；未传时默认底部为约 1.5 倍视口高度（window.innerHeight），用于提前触发加载
     * @returns {Object} { destroy }
     */
    init: function (opts) {
      var listContainer = opts.listContainer;
      var triggerDom = opts.triggerDom || listContainer.find('.ws-featured-collection-loadmore');
      var loadMore = opts.loadMore;
      var hasMore = opts.hasMore;
      var isBusy = opts.isBusy || function () { return false; };
      var loadmoreImg = opts.loadmoreImg || listContainer.find('.ws-loadmore-img');
      var rootMargin = opts.rootMargin;
      if (!rootMargin) {
        var bottomPx = WS.screenHeight > 0 ? Math.round(WS.screenHeight * 1.5) : 1200;
        rootMargin = '0px 0px ' + bottomPx + 'px 0px';
        // console.log('rootMargin =>', rootMargin);
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || !hasMore() || isBusy()) return;
            loadMore(listContainer);
          });
        },
        { root: null, rootMargin: rootMargin, threshold: 0 }
      );

      if (triggerDom.length && triggerDom[0]) {
        observer.observe(triggerDom[0]);
      }

      var instance = { observer: observer, triggerDom: triggerDom };
      infiniteScroll._instances.push(instance);

      return {
        destroy: function () {
          if (triggerDom.length && triggerDom[0]) {
            observer.unobserve(triggerDom[0]);
          }
          var idx = infiniteScroll._instances.indexOf(instance);
          if (idx > -1) infiniteScroll._instances.splice(idx, 1);
        }
      };
    },

    /**
     * 基于 DOM 的 Shopify 集合分页初始化（通用化）
     * 从 listContainer 读取 data-collection-handle、data-current-page、data-total-pages、data-per-page、data-ssr-count 等
     * 每次加载时读取最新分页参数，支持多实例独立运转
     * @param {jQuery} listContainer - 带 data-collection-handle 的 .ws-featured-collection-listing 容器
     * @param {Object} [opts] - 可选，{ sectionId, scrollRoot, loadImmediately, onReachLastPage }
     * @param {Function} [opts.onReachLastPage] - 滚动到最后一页时的回调
     * @returns {Object} { destroy }
     */
    initShopifyCollection: function (listContainer, opts) {
      opts = opts || {};
      var sectionId = opts.sectionId || SECTION_ID;

      var busyMap = {};
      var getKey = function (el) { return el && el.getAttribute && el.getAttribute('data-collection-handle') || ''; };

      var loadMore = function (container) {
        var $c = $(container);
        var handle = $c.attr('data-collection-handle');
        if (!handle) return;
        var key = getKey(container);
        if (busyMap[key]) return;
        var currentPage = parseInt($c.attr('data-current-page') || '0', 10);
        var totalPages = parseInt($c.attr('data-total-pages') || '0', 10);
        if (handle === 'search') {
          if (totalPages > 0 && currentPage >= totalPages) return;
        } else {
          if (totalPages > 0 && currentPage >= totalPages) return;
          if ($c.attr('data-has-next') === 'false') return;
        }

        var nextPage = currentPage + 1;
        var ssrCount = parseInt($c.attr('data-ssr-count') || '0', 10);
        var sortBy = $c.attr('data-sort-by') || '';
        var filterQuery = $c.attr('data-filter') || '';

        busyMap[key] = true;
        var loadmoreWrap = $c.find('.ws-featured-collection-loadmore');
        loadmoreWrap.show();

        var url;
        var reqSectionId = sectionId;
        if (handle === 'search') {
          reqSectionId = opts.searchSectionId || 'westyle-search-data';
          try {
            var urlObjSearch = new URL(window.location.href);
            urlObjSearch.searchParams.set('page', nextPage);
            urlObjSearch.searchParams.set('sections', reqSectionId);
            url = urlObjSearch.toString();
          } catch (e) {
            url = location.href + (location.href.indexOf('?') > -1 ? '&' : '?') + 'page=' + nextPage + '&sections=' + reqSectionId;
          }
        } else {
          var pageParams = WS.getData('collectionPageParams') || {};
          var sf = collectionParamsToSortFilterQuery(pageParams);
          if (!sortBy) sortBy = sf.sortBy;
          if (!filterQuery) filterQuery = sf.filterQuery;
          url = WS.site.baseUrl + '/collections/' + encodeURIComponent(handle) + '?sections=' + encodeURIComponent(reqSectionId) + '&page=' + nextPage;
          if (sortBy) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'sort_by=' + encodeURIComponent(sortBy);
          if (filterQuery) url += (url.indexOf('?') >= 0 ? '&' : '?') + filterQuery;
        }
        WS.ajax({
          url: url,
          type: 'GET',
          dataType: 'html',
          success: function (res) {
            var data = JSON.parse(res || 'null');
            var sectionHtml = data[reqSectionId];
            if (!sectionHtml) return;
            var $frag = $(sectionHtml);
            var $data = $frag.find('.ws-collection-data');
            var $meta = $frag.find('.ws-collection-pagination-meta');
            var $items = $data.find('.ws-product-block');
            var skip = (nextPage === 1 && ssrCount > 0) ? Math.min(ssrCount, $items.length) : 0;
            var $toAppend = skip > 0 ? $items.slice(skip) : $items;
            var listDom = $c.find('.ws-featured-collection-product-list');
            // Collection page infinite-scroll labels follow the same product tag as the product detail page.
            if ($c.closest('#collection-conatiner').length) {
              appendUsa2DayDeliveryLabels($toAppend);
            }
            if (nextPage === 1 && $items.length === 0) {
              listDom.empty().append(WS.ui.emptyDom);
            } else {
              $toAppend.each(function () { listDom.append(this); });
            }
            var newCurrent = parseInt($meta.attr('data-current-page') || nextPage, 10);
            var newTotal = parseInt($meta.attr('data-total-pages') || '0', 10);
            $c.attr('data-current-page', newCurrent);
            if (newTotal > 0) $c.attr('data-total-pages', newTotal);
            WS.ui.globalListExposureHandle && WS.ui.globalListExposureHandle();
            if (newTotal > 0 && newCurrent >= newTotal) {
              $c.find('.ws-featured-collection-loadmore').hide();
              if (typeof opts.onReachLastPage === 'function') opts.onReachLastPage($c);
            } else if (nextPage === 1 && $items.length === 0) {
              $c.find('.ws-featured-collection-loadmore').hide();
            }
            WS.ui.initImgLazyloadHandle && WS.ui.initImgLazyloadHandle();
          },
          complete: function () {
            busyMap[key] = false;
            if (hasMore($c)) {
              loadmoreWrap.show();
            } else {
              loadmoreWrap.hide();
            }
          },
          error: function () {
            busyMap[key] = false;
            if (hasMore($c)) {
              loadmoreWrap.show();
            } else {
              loadmoreWrap.hide();
            }
          }
        });
      };

      var hasMore = function (container) {
        var $c = $(container);
        var handle = $c.attr('data-collection-handle') || '';
        var current = parseInt($c.attr('data-current-page') || '0', 10);
        var total = parseInt($c.attr('data-total-pages') || '0', 10);
        if (handle === 'search') {
          return total === 0 || current < total;
        }
        if (total > 0) return current < total;
        return $c.attr('data-has-next') !== 'false';
      };

      var isBusy = function (container) {
        return busyMap[getKey(container)] || false;
      };

      var result = infiniteScroll.init({
        listContainer: listContainer,
        loadMore: loadMore,
        hasMore: function () { return hasMore(listContainer); },
        isBusy: function () { return isBusy(listContainer); }
      });
      listContainer.on('ws-trigger-load', function () {
        if (hasMore(listContainer) && !isBusy(listContainer)) loadMore(listContainer);
      });
      if (opts.loadImmediately !== false && hasMore(listContainer) && !isBusy(listContainer)) {
        setTimeout(function () { loadMore(listContainer); }, 0);
      }
      return result;
    },

    /**
     * Shopify 集合筛选/排序重置：清空列表，更新 data 属性，交由 IO 触发下一轮加载
     * orderBy 映射到 Shopify sort_by；colors/sizes/priceRange 映射到 filter 参数
     */
    SORT_BY_MAP: COLLECTION_PAGE_SORT_MAP,
    resetShopifyCollection: function () {
      var $listing = $('#collection-conatiner').find('.js-infinite-scroll-listing');
      if (!$listing.length) return;
      var params = WS.getData('collectionPageParams') || {};
      var sf = collectionParamsToSortFilterQuery(params);
      $listing.attr('data-sort-by', sf.sortBy || '');
      $listing.attr('data-filter', sf.filterQuery || '');
      $listing.attr('data-current-page', '0');
      $listing.attr('data-total-pages', '');
      $listing.attr('data-ssr-count', '0');
      $listing.attr('data-end-cursor', '');
      $listing.attr('data-has-next', 'true');
      $listing.find('.ws-featured-collection-product-list').empty();
      $listing.find('.ws-featured-collection-loadmore').show();
      $(window).scrollTop(0);
    }
  };
  WS.ui.infiniteScroll = infiniteScroll;
})();

/**
 * 集合列表
 */
(function () {
  var busyLoading = false;
  // 列表是否有下一页
  var isNextPage = "";
  // 购物车底部列表分页
  var cartCollectionPageNo = 0;
  var cartCollectionPageCount = 0;
  // 集合模块分页
  var collectionModulePageNo = 0;
  var collectionModulePageCount = 0;
  var collectionFn = {
    updateFeaturedCollectionScrollbar: function (listingDom) {
      var $listing = $(listingDom);
      var $list = $listing.find('.ws-featured-collection-product-list').first();
      var $bar = $listing.find('.ws-featured-collection-scrollbar').first();
      var $thumb = $bar.find('.ws-featured-collection-scrollbar__thumb').first();
      if (!$list.length || !$bar.length || !$thumb.length) return;

      var listEl = $list.get(0);
      var barEl = $bar.get(0);
      if (!listEl || !barEl) return;

      var scrollWidth = listEl.scrollWidth || 0;
      var clientWidth = listEl.clientWidth || 0;
      if (scrollWidth <= clientWidth || clientWidth <= 0) {
        $bar.hide();
        return;
      }

      $bar.show();
      var ratio = clientWidth / scrollWidth;
      var barWidth = barEl.clientWidth || 0;
      var minThumbWidth = 36;
      var thumbWidth = Math.max(Math.round(barWidth * ratio), minThumbWidth);
      thumbWidth = Math.min(thumbWidth, barWidth);
      $thumb.css({ width: thumbWidth + 'px' });

      var maxListScroll = scrollWidth - clientWidth;
      var maxThumbMove = Math.max(barWidth - thumbWidth, 0);
      var left = maxListScroll > 0 ? (listEl.scrollLeft / maxListScroll) * maxThumbMove : 0;
      $thumb.css({ transform: 'translateX(' + left + 'px)' });
    },
    updateFeaturedCollectionArrows: function (listingDom) {
      var $listing = $(listingDom);
      var $list = $listing.find('.ws-featured-collection-product-list').first();
      var $prev = $listing.find('.ws-featured-collection-arrow--prev').first();
      var $next = $listing.find('.ws-featured-collection-arrow--next').first();
      if (!$list.length || !$prev.length || !$next.length) return;

      var listEl = $list.get(0);
      if (!listEl) return;

      var scrollWidth = listEl.scrollWidth || 0;
      var clientWidth = listEl.clientWidth || 0;
      var scrollLeft = listEl.scrollLeft || 0;
      var epsilon = 2;

      if (scrollWidth <= clientWidth + epsilon) {
        $prev.prop('disabled', true).addClass('is-disabled').attr('aria-disabled', 'true');
        $next.prop('disabled', true).addClass('is-disabled').attr('aria-disabled', 'true');
        return;
      }

      var atStart = scrollLeft <= epsilon;
      var atEnd = scrollLeft + clientWidth >= scrollWidth - epsilon;

      $prev.prop('disabled', atStart).toggleClass('is-disabled', atStart).attr('aria-disabled', atStart ? 'true' : 'false');
      $next.prop('disabled', atEnd).toggleClass('is-disabled', atEnd).attr('aria-disabled', atEnd ? 'true' : 'false');
    },
    /** PC：箭头垂直居中于首张商品主图区域（相对 carousel-shell），避免相对整卡含标题/价格偏高 */
    layoutFeaturedCollectionCarouselArrows: function (listingDom) {
      if (typeof window.matchMedia === 'function' && !window.matchMedia('(min-width: 750px)').matches) {
        return;
      }
      var $listing = $(listingDom);
      var $shell = $listing.find('.ws-featured-collection-carousel-shell').first();
      var $list = $listing.find('.ws-featured-collection-product-list').first();
      var $prev = $listing.find('.ws-featured-collection-arrow--prev');
      var $next = $listing.find('.ws-featured-collection-arrow--next');
      if (!$shell.length || !$list.length || !$prev.length || !$next.length) return;

      var $imgWrap = $list.find('.ws-product-block .ws-product-block-image').first();
      if (!$imgWrap.length) return;

      var shellEl = $shell[0];
      var imgEl = $imgWrap[0];
      var shellRect = shellEl.getBoundingClientRect();
      var imgRect = imgEl.getBoundingClientRect();
      var centerY = (imgRect.top - shellRect.top) + (imgRect.height / 2);
      $prev.add($next).css({ top: centerY + 'px', transform: 'translateY(-50%)' });
    },
    /**
     * 轮播单步滚动距离：按「每屏列数」取第 N 张卡相对首张的水平偏移（含卡片宽度与间距），避免用 clientWidth 漏算 gap 导致多页后错位。
     */
    getFeaturedCollectionCarouselScrollStep: function (listEl) {
      var $list = $(listEl);
      var $cards = $list.children('.ws-product-block');
      if ($cards.length < 2) return listEl.clientWidth || 0;
      var gridMatch = (listEl.className || '').match(/ws-product-list-row-(\d+)/);
      var columnsPerView = gridMatch ? parseInt(gridMatch[1], 10) : 4;
      if (columnsPerView < 1) columnsPerView = 4;
      if (typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 750px)').matches) {
        if ($list.closest('.ws-featured-collection-sliderbox').length) {
          var configuredItemsPerView = parseFloat($list.attr('data-desktop-items-per-view') || '');
          columnsPerView = configuredItemsPerView > 0 ? Math.floor(configuredItemsPerView) : 4;
          if (columnsPerView < 1) columnsPerView = 1;
        }
      }
      if ($cards.length <= columnsPerView) {
        return Math.max(0, listEl.scrollWidth - listEl.clientWidth);
      }
      var first = $cards[0];
      var targetCard = $cards[columnsPerView];
      if (!targetCard) return listEl.clientWidth || 0;
      var step = targetCard.getBoundingClientRect().left - first.getBoundingClientRect().left;
      if (step <= 0) return listEl.clientWidth || 0;
      return step;
    },
    /** 横向列表平滑滚动一屏（direction: -1 左，1 右） */
    scrollFeaturedCollectionByViewport: function (listEl, direction) {
      if (!listEl || !direction) return;
      var step = collectionFn.getFeaturedCollectionCarouselScrollStep(listEl);
      var delta = direction * step;
      var target = Math.max(0, Math.min(listEl.scrollWidth - listEl.clientWidth, listEl.scrollLeft + delta));
      if (typeof listEl.scrollTo === 'function') {
        try {
          listEl.scrollTo({ left: target, behavior: 'smooth' });
          return;
        } catch (e) {}
      }
      listEl.scrollLeft = target;
    },
    ensureFeaturedCollectionSeeAll: function (listingDom) {
      var $listing = $(listingDom);
      var hasMobileHorizontalLayout = $listing.attr('data-mobile-layout') === 'horizontal';
      var hasDesktopCarousel = $listing.attr('data-enable-carousel') === 'true';
      if (!hasMobileHorizontalLayout && !hasDesktopCarousel) return;

      var $list = $listing.find('.ws-featured-collection-product-list').first();
      if (!$list.length) return;
      if ($list.find('.ws-featured-collection-see-all').length) return;

      var collectionUrl = $listing.attr('data-collection-url') || '#';
      var viewMoreText = $listing.attr('data-view-more-text') || 'View All >>';
      var seeAllHtml = `
        <a class="ws-featured-collection-see-all" href="${collectionUrl}">
          <span class="ws-featured-collection-see-all__text">${viewMoreText}</span>
        </a>
      `;
      $list.append(seeAllHtml);
    },
    applyFeaturedCollectionMobileLimit: function (listingDom) {
      var $listing = $(listingDom);
      if ($listing.attr('data-mobile-grid') !== 'true') return;

      var productLimit = parseInt($listing.attr('data-mobile-products-to-show') || '4', 10);
      if (isNaN(productLimit) || productLimit < 1) productLimit = 4;

      var $products = $listing
        .find('.ws-featured-collection-product-list')
        .first()
        .children('.ws-product-block');
      $products
        .removeClass('ws-featured-collection-product--mobile-hidden')
        .slice(productLimit)
        .addClass('ws-featured-collection-product--mobile-hidden');
    },
    handleCollectionDesc: function() {
      var descList = $('.sub-collection-desc-origin');
      for (var i = 0, len = descList.length; i < len; i++) {
        var descItem = $(descList[i]);
        var descText = descItem.find('.collection-sub-desc_text');
        if (!descText) return;
        var maxHeight = descText.css('max-height');
        if (!maxHeight) return;
        maxHeight = maxHeight.replace('px', '');
        var descHeight = descItem.find('.collection-sub-desc_info').height();
        if (descHeight > maxHeight) {
          descText.addClass('limit-height');
        }
        descItem.removeClass('sub-collection-desc-origin');
      }
    },
    getCollectionModule: function(obj) {
      var dom = obj.dom;
      var collectionHandle = $(dom).attr('data-collection-handle') || '';
      var canLoadMore = obj.canLoadMore || false;
      busyLoading = true;
      var loadmoreDom = null;
      if (canLoadMore) {
        loadmoreDom = $(dom).find('.ws-loadmore-img');
        loadmoreDom.show();
      }
    
      if (!busyLoading) return;
      WS.ajax({
        url: `${WS.site.baseUrl}/collections/${encodeURIComponent(collectionHandle)}?sections=westyle-collection-data`,
        type: 'GET',
        dataType: 'html',
        success: function (res) {
          var responseHTML = JSON.parse(res || 'null')['westyle-collection-data'];
          var productItems = $($(responseHTML).find('.ws-collection-data .ws-product-block'));
          $(dom).find('.ws-featured-collection-product-list').append(productItems);
          collectionFn.applyFeaturedCollectionMobileLimit(dom);
          collectionFn.ensureFeaturedCollectionSeeAll(dom);
          collectionFn.updateFeaturedCollectionScrollbar(dom);
          collectionFn.updateFeaturedCollectionArrows(dom);
          var layoutArrows = function () {
            collectionFn.layoutFeaturedCollectionCarouselArrows(dom);
          };
          layoutArrows();
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(layoutArrows);
            });
          }
          setTimeout(layoutArrows, 80);
          setTimeout(layoutArrows, 400);
          $(dom).find('.ws-featured-collection-product-list img').on('load.wsFeatImg', layoutArrows);
          $(dom)
            .find('.ws-featured-collection-product-list')
            .off('scroll.wsFeaturedScrollbar')
            .on('scroll.wsFeaturedScrollbar', function () {
              collectionFn.updateFeaturedCollectionScrollbar(dom);
              collectionFn.updateFeaturedCollectionArrows(dom);
            });
          WS.ui.globalListExposureHandle();
          busyLoading = false;
        },
        complete: function () {
          busyLoading = false;
          canLoadMore && loadmoreDom.hide();
        },
        error: function (error) {
          busyLoading = false;
        },
      });
    },
    handleCollectionData: function(productList) {
      var vdc = WS.ui.variantDisplayColor;
      if (typeof vdc !== 'function') {
        vdc = function (v, o) { return (v && v.option1 != null) ? String(v.option1) : ''; };
      }
      var productIds = [];
      var skcList = [];
      for (var i = 0, len = productList.length; i < len; i++) {
        var tagretProduct = productList[i];
        var tagretProductHandle = tagretProduct.handle;
        var targetVariantList = tagretProduct.variantList || [];
        var targetVariantLen = targetVariantList.length;
        var createTime = Number(tagretProduct.createTime) || 0;
        var newProductThresholdMs = 30 * 24 * 60 * 60 * 1000;
        var minPrice = tagretProduct.minPrice;
        var price = targetVariantLen && targetVariantList[0] && targetVariantList[0].presentmentPrice && targetVariantList[0].presentmentPrice.price && targetVariantList[0].presentmentPrice.price.amount || '';
        var comparePrice = targetVariantLen && targetVariantList[0] && targetVariantList[0].presentmentPrice && targetVariantList[0].presentmentPrice.compareAtPrice && targetVariantList[0].presentmentPrice.compareAtPrice.amount || '';
        var _optList = tagretProduct.optionList;
        !tagretProduct.defaultColor && targetVariantLen && (tagretProduct.defaultColor = vdc(targetVariantList[0], _optList));
        var colorHandle = tagretProduct.defaultColor ? tagretProduct.defaultColor.replace(' ', '-') : '';
        tagretProduct.displayPrice = minPrice ? minPrice : price;
        tagretProduct.displayComparePrice = comparePrice;
        tagretProduct.hasComparePrice = tagretProduct.displayPrice && tagretProduct.displayComparePrice && tagretProduct.displayPrice != tagretProduct.displayComparePrice;
        tagretProduct.isNew = !tagretProduct.hasComparePrice && createTime > 0 && new Date().getTime() - createTime >= 0 && new Date().getTime() - createTime <= newProductThresholdMs;
        productIds.push(tagretProduct.productId);
        tagretProduct.defaultColorIndex = 0;
        tagretProduct.skcTitle = colorHandle ? tagretProductHandle + '-' + colorHandle : '';
        tagretProduct.skcTitle && skcList.push(tagretProduct.skcTitle);
        var targetImageList = tagretProduct.imageList;
        var lowestPrices = {};
        var baseDir = (typeof WS !== 'undefined' && WS.site && WS.site.dir) ? WS.site.dir : '';
        // 集合页主图统一使用商品主图/首图，不取 variant 绑定图（避免 variant 绑面料图时展示面料图）
        var productMainRawSrc = targetImageList && targetImageList[0] ? (targetImageList[0].src || (targetImageList[0].preview_image && targetImageList[0].preview_image.src) || '') : '';
        var productMainImageSrc = productMainRawSrc ? productMainRawSrc.replace(".jpg", "_700x.jpg").replace(".png", "_700x.png") : '';
        var productMainSelectOptSrc = productMainRawSrc ? productMainRawSrc.replace(".jpg", "_60x.jpg").replace(".png", "_60x.png") : '';
        for (var j = 0; j < targetVariantLen; j++) {
          var colorVariantItem = targetVariantList[j];
          var colorVariantItemColor = vdc(colorVariantItem, _optList);
          var colorVariantItemPrice = colorVariantItem.price;
          var colorVariantItemImageId = colorVariantItem.imageId;
          var imageObj = targetImageList && targetImageList.find(function(item) { return String(item.imageId || item.id) === String(colorVariantItemImageId); });
          if (!imageObj && targetImageList && targetImageList.length) {
            imageObj = targetImageList[0];
          }
          var rawImgSrc = imageObj ? (imageObj.src || (imageObj.preview_image && imageObj.preview_image.src) || '') : '';
          var selectOptImageSrc = rawImgSrc ? rawImgSrc.replace(".jpg", "_60x.jpg").replace(".png", "_60x.png") : productMainSelectOptSrc;
          colorVariantItem.imageSrc = productMainImageSrc;
          colorVariantItem.imageAlt = WS.ui.productImageAlt(targetImageList && targetImageList[0] && (targetImageList[0].alt || targetImageList[0].altText), tagretProduct.title, 1, targetImageList && targetImageList.length);
          colorVariantItem.selectOptImageSrc = selectOptImageSrc;

          if (colorVariantItemColor === tagretProduct.defaultColor) {
            var targetVariantItemId = tagretProduct.currentVariantId || colorVariantItem.variantId;
            tagretProduct.currentSku = colorVariantItem.sku;
            tagretProduct.imageSrc = productMainImageSrc;
            tagretProduct.initialProductUrl = baseDir + '/products/' + tagretProductHandle + '?color=' + encodeURIComponent(tagretProduct.defaultColor || '').replace(/ /g, '%20') + '&variant=' + targetVariantItemId;
          }
          // 如果当前颜色不存在或当前价格更低，则更新最低价格
          if (!lowestPrices[colorVariantItemColor] || colorVariantItemPrice < lowestPrices[colorVariantItemColor]) {
            lowestPrices[colorVariantItemColor] = colorVariantItemPrice;
          }
        }

        var filteredVariantList = targetVariantList.filter(function(item, index, arr) {
          var variantColorVal = vdc(item, _optList);
          var variantPrice = Math.round(Number(item.price || 0));
          return variantPrice === lowestPrices[variantColorVal] && arr.findIndex(function(i) {
            return vdc(i, _optList) === variantColorVal;
          }) === index;
        });
        tagretProduct.filteredVariantList = filteredVariantList;

        // merge_skcs：按 westyle-product-block 逻辑，每个 SKC 一个 swatch
        var mergeSkcs = Array.isArray(tagretProduct.mergeSkcs) ? tagretProduct.mergeSkcs : [];
        if (mergeSkcs.length >= 1) {
          var mergeSkcDisplayList = [];
          var baseDir = (typeof WS !== 'undefined' && WS.site && WS.site.dir) ? WS.site.dir : '';
          for (var mk = 0; mk < mergeSkcs.length; mk++) {
            var skc = mergeSkcs[mk];
            if (!skc || skc.id == null) continue;
            var skcVariant = (skc.variants && skc.variants[0]) || {};
            var skcColor = vdc(skcVariant, skc.options_with_values || skc.options || []);
            var skcPrice = (skcVariant.presentmentPrice && skcVariant.presentmentPrice.price && skcVariant.presentmentPrice.price.amount != null)
              ? Math.round(parseFloat(skcVariant.presentmentPrice.price.amount) * 100) : (skcVariant.price || skc.price || 0);
            var skcCompare = (skcVariant.presentmentPrice && skcVariant.presentmentPrice.compareAtPrice && skcVariant.presentmentPrice.compareAtPrice.amount != null)
              ? Math.round(parseFloat(skcVariant.presentmentPrice.compareAtPrice.amount) * 100) : (skcVariant.comparePrice || skc.compare_at_price || 0);
            var skcImgList = skc.imageList || skc.images || [];
            var skcImgSrc = '';
            var skcSelectImgSrc = '';
            // merge_skcs 主图统一使用 SKC 商品主图/首图，不取 variant 绑定图（避免 variant 绑面料图时展示面料图）
            if (skcImgList.length) {
              var firstImg = skcImgList[0];
              var rawSrc = firstImg.src || (firstImg.preview_image && firstImg.preview_image.src) || '';
              skcImgSrc = rawSrc ? rawSrc.replace('.jpg', '_700x.jpg').replace('.png', '_700x.png') : '';
              skcSelectImgSrc = rawSrc ? rawSrc.replace('.jpg', '_60x.jpg').replace('.png', '_60x.png') : '';
            }
            var skcColorHexRaw = (skc.color_hex && String(skc.color_hex).trim()) || '';
            var skcColorHex = skcColorHexRaw ? (skcColorHexRaw.indexOf('#') === 0 ? skcColorHexRaw : '#' + skcColorHexRaw) : '';
            var skcColorImage = (skc.color_image && String(skc.color_image).trim()) || '';
            if (skcColorHex) {
              skcSelectImgSrc = '';
            } else if (skcColorImage) {
              skcSelectImgSrc = skcColorImage;
              // imageSrc 保持商品主图，不改为 color_image（色块图仅用于 swatch 展示）
            }
            var skcUrl = skc.product_url;
            if (!skcUrl && baseDir && skc.handle) skcUrl = baseDir + '/products/' + skc.handle;
            mergeSkcDisplayList.push({
              option1: skcColor,
              variantId: skcVariant.variantId || skcVariant.id,
              sku: skcVariant.sku || '',
              imageSrc: skcImgSrc,
              imageAlt: WS.ui.productImageAlt(skcImgList[0] && (skcImgList[0].alt || skcImgList[0].altText), skc.title || tagretProduct.title, 1, skcImgList.length),
              selectOptImageSrc: skcSelectImgSrc,
              colorHex: skcColorHex || '',
              productUrl: skcUrl,
              productId: skc.id,
              productTitle: skc.title || tagretProduct.title || '',
              price: skcPrice,
              compareAtPrice: skcCompare,
              presentmentPrice: skcVariant.presentmentPrice
            });
          }
          tagretProduct.mergeSkcDisplayList = mergeSkcDisplayList;
          if (mergeSkcDisplayList.length) {
            if (!tagretProduct.defaultColor) tagretProduct.defaultColor = mergeSkcDisplayList[0].option1;
            if (!tagretProduct.displayPrice && mergeSkcDisplayList[0].price) tagretProduct.displayPrice = mergeSkcDisplayList[0].price;
            if (tagretProduct.displayComparePrice == null && mergeSkcDisplayList[0].compareAtPrice != null) tagretProduct.displayComparePrice = mergeSkcDisplayList[0].compareAtPrice;
            var activeSkc = mergeSkcDisplayList.find(function(s) { return s.option1 === tagretProduct.defaultColor; }) || mergeSkcDisplayList[0];
            tagretProduct.initialProductUrl = activeSkc.productUrl;
            tagretProduct.initialProductId = activeSkc.productId;
            tagretProduct.initialProductTitle = activeSkc.productTitle;
            tagretProduct.initialImageSrc = activeSkc.imageSrc || tagretProduct.imageSrc;
            tagretProduct.currentSku = activeSkc.sku;
            var skcColorHandle = (tagretProduct.defaultColor || '').replace(/ /g, '-');
            tagretProduct.skcTitle = skcColorHandle ? tagretProductHandle + '-' + skcColorHandle : tagretProduct.skcTitle;
          }
        }
      }
      return { productIds: productIds, skcList: skcList }
    },
    // 调用列表方法
    handleCollectAll: function () {
      // 当页面为集合页时，使用 Shopify 集合分页 + Intersection Observer 加载更多（前4个直出，后续异步）
      if (WS.site.page == 'collection') {
        var listings = $('#collection-conatiner').find('.js-infinite-scroll-listing');

        var onReachLastPage = function () {
          $('.ws-category-card.ws-category-card--five-square').addClass('ws-category-card--visible');
        };
        listings.each(function () {
          var $listing = $(this);
          if ($listing.attr('data-collection-handle')) {
            var inst = WS.ui.infiniteScroll.initShopifyCollection($listing, {
              onReachLastPage: onReachLastPage
            });
            var cur = parseInt($listing.attr('data-current-page') || '0', 10);
            var total = parseInt($listing.attr('data-total-pages') || '0', 10);
            if (total > 0 && cur >= total) {
              onReachLastPage();
            }
          }
        });
      }

      // Featured collection 轮播：PC 端左右箭头，每次滚动约一屏宽度
      $(document)
        .off('click.wsFeaturedCarouselPrev')
        .on('click.wsFeaturedCarouselPrev', '.ws-featured-collection-arrow--prev', function (e) {
          var $btn = $(this);
          if ($btn.hasClass('is-disabled') || $btn.prop('disabled')) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          e.preventDefault();
          var $listing = $btn.closest('.ws-featured-collection-listing');
          var listEl = $listing.find('.ws-featured-collection-product-list').get(0);
          if (!listEl) return;
          collectionFn.scrollFeaturedCollectionByViewport(listEl, -1);
          var sync = function () {
            collectionFn.updateFeaturedCollectionScrollbar($listing[0]);
            collectionFn.updateFeaturedCollectionArrows($listing[0]);
          };
          sync();
          setTimeout(sync, 450);
        });
      $(document)
        .off('click.wsFeaturedCarouselNext')
        .on('click.wsFeaturedCarouselNext', '.ws-featured-collection-arrow--next', function (e) {
          var $btn = $(this);
          if ($btn.hasClass('is-disabled') || $btn.prop('disabled')) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          e.preventDefault();
          var $listing = $btn.closest('.ws-featured-collection-listing');
          var listEl = $listing.find('.ws-featured-collection-product-list').get(0);
          if (!listEl) return;
          collectionFn.scrollFeaturedCollectionByViewport(listEl, 1);
          var sync = function () {
            collectionFn.updateFeaturedCollectionScrollbar($listing[0]);
            collectionFn.updateFeaturedCollectionArrows($listing[0]);
          };
          sync();
          setTimeout(sync, 450);
        });
      $(window)
        .off('resize.wsFeaturedCarousel')
        .on('resize.wsFeaturedCarousel', function () {
          $('.ws-featured-collection-listing[data-enable-carousel="true"], .ws-featured-collection-listing[data-mobile-layout="horizontal"]').each(function () {
            collectionFn.updateFeaturedCollectionScrollbar(this);
            collectionFn.updateFeaturedCollectionArrows(this);
            collectionFn.layoutFeaturedCollectionCarouselArrows(this);
          });
        });

      // 列表颜色使用原生 radio；方向键切换后同样更新对应卡片。
      function updateProductCardColor($this) {
        var $innerBox = $this.parents(".ws-product-block-innerbox");
        var $productLinks = $innerBox.find(".ws-product-link");
        var $productBLock = $innerBox.closest('.ws-product-block');
        var activeClassName = 'ws-variants-image-active';
        var currentSku = $this.attr('data-sku');
        // 更改选中的样式
        $this.parents(".ws-product-variants-list").find(".ws-variants-image-box")
          .removeClass(activeClassName).attr('aria-pressed', 'false');
        $this.addClass(activeClassName).attr('aria-pressed', 'true');
        // 更新主图
        var variantsImg = $this.attr("data-img") || '';
        if (variantsImg) {
          var shopFeaturedImgWrapper = $innerBox.find(".ws-rimage-wrapper-box--primary")
          var shopFeaturedImgDom = shopFeaturedImgWrapper.find(".shop-featured-img");
          shopFeaturedImgDom.attr("src", variantsImg).attr("data-lazyload-src", variantsImg);
          shopFeaturedImgDom.attr('alt', $this.attr('data-img-alt') || $this.attr('data-product-title') || '');
          var $imgBox = $innerBox.find(".ws-product-block-image-box");
          if ($imgBox.length) $imgBox.attr("data-src", variantsImg);
        }
        $productLinks.attr('href', $this.attr("data-product-url"));
        // 更新价格
        var price = $this.attr("data-price");
        var compareAtPrice = $this.attr("data-compare-at-price");
        var priceFormatted = $this.attr("data-price-formatted");
        var compareFormatted = $this.attr("data-compare-formatted");
        if (price != null && price !== '' && priceFormatted) {
          var $priceWrap = $innerBox.find(".ws-product-block-price");
          $priceWrap.attr("data-price", price).attr("data-compare-at-price", compareAtPrice || '');
          if (!(compareAtPrice && parseFloat(compareAtPrice) > parseFloat(price))) compareFormatted = '';
          var $saleSpan = $priceWrap.find(".ws-price-amount-sale");
          var $compareSpan = $priceWrap.find(".ws-price-amount-compare");
          $saleSpan.text(priceFormatted).toggleClass("ws-price-amount-sale-red", !!compareFormatted);
          if (compareFormatted) {
            if ($compareSpan.length) $compareSpan.text(compareFormatted).show();
            else $priceWrap.find(".product-block-amount-wrapper").append('<span class="ws-price-amount-compare">' + compareFormatted + '</span>');
          } else {
            $compareSpan.hide();
          }
          $priceWrap.toggleClass("wrap", !!compareFormatted);
        }
        // 更新标题（merge SKC 可能不同商品）
        var productTitle = $this.attr("data-product-title");
        if (productTitle != null && productTitle !== '') {
          $innerBox.find(".ws-product-block-title").text(decodeURIComponent(productTitle));
          $innerBox.find('.ws-product-variants-list').attr('aria-label', 'Colors for ' + productTitle);
        }
        $productBLock.attr('stat-module-show-selected-color', currentSku).attr('stat-module-show-price', price || $productBLock.attr('stat-module-show-price'));
        var productId = $this.attr("data-product-id");
        var hoverImage = $this.attr("data-hover-img");
        if (hoverImage) {
          // 先清空之前图片后再赋值
          var $hoverImg = $innerBox.find(".ws-product-hover-img");
          $hoverImg.removeAttr('src'); // 先移除 src
          // 触发浏览器彻底清理图片
          $hoverImg[0] && ($hoverImg[0].src = ''); 
          $hoverImg.attr("src", hoverImage);
        }
        var $addBagBtn = $innerBox.find(".ws-product__add-bag-btn");
        if ($addBagBtn.length && productId) {
          var newUrl = $productLinks.first().attr('href');
          $addBagBtn.attr("data-product-url", newUrl).attr("data-product-id", productId);
          $addBagBtn.attr('aria-label', 'Add ' + ($innerBox.find('.ws-product-block-title').text() || productTitle) + ' to cart');
        }
        // 上报
        var param = {
          "products": {
            id: $productBLock.attr('data-product-id') + '',
            color: currentSku,
          }
        };
        // 如果集合携带aid，则上报aid
        var aid = $productBLock.attr('stat-module-show-aid');
        var listInnerDom = $this.parents('.ws-featured-collection-product-list');
        var listType = listInnerDom.attr('data-list-type') || 'collection';
        WS.stat({
          eid: WS.ui.reportType['click'],
          aid: aid || 'empty',
          ext1: WS.ui.productReportMap['clickCollectionColor'] + listType,
          ext2: JSON.stringify(param || {})
        });
      }

      $(document).on('click', '.ws-product-block-innerbox .ws-variants-image-box', function() {
        updateProductCardColor($(this));
      });

      // 变体列表左右滚动按钮：分页式滑动，每页4个，当前页最后一个点击后变为下一页第一个；不满4个滑到最后一页；对齐到变体边界
      $(document).on("click", ".ws-product-block-innerbox .ws-variants-scroll-btn", function() {
        var $btn = $(this);
        var $viewport = $btn.siblings(".ws-product-variants-scroll-viewport");
        var $list = $viewport.find(".ws-product-variants-list");
        if (!$viewport.length || !$list.length) return;
        var $items = $list.children(".ws-variants-image-box");
        if ($items.length < 2) return;
        var listEl = $list[0];
        var firstItem = $items[0][0];
        var style = getComputedStyle(listEl);
        var gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 12;
        var slotWidth = firstItem ? (firstItem.offsetWidth + gap) : 38;
        var pageStep = Math.round(slotWidth * 3);
        var scrollLeft = Math.round($viewport.scrollLeft());
        var maxScroll = Math.round($viewport[0].scrollWidth - $viewport[0].clientWidth);
        if (maxScroll <= 0) return;
        var targetLeft;
        var currentPage = Math.floor(scrollLeft / pageStep);
        if ($btn.hasClass("ws-variants-scroll-prev")) {
          var prevPage = Math.max(0, currentPage - 1);
          targetLeft = prevPage * pageStep;
        } else {
          var nextPageLeft = (currentPage + 1) * pageStep;
          targetLeft = nextPageLeft >= maxScroll ? maxScroll : nextPageLeft;
        }
        $viewport[0].scrollTo({ left: targetLeft, behavior: "smooth" });
      });

      // 变体滚动区：根据是否溢出动态显示/隐藏切换按钮
      function toggleVariantsScrollButtons() {
        var ResizeObserver = window.ResizeObserver;
        $(".ws-product-variants-scroll-wrapper").each(function() {
          var $wrapper = $(this);
          if (!$wrapper.find(".ws-variants-scroll-btn").length) return;
          var viewport = $wrapper.find(".ws-product-variants-scroll-viewport")[0];
          if (!viewport) return;
          var hasOverflow = viewport.scrollWidth > viewport.clientWidth + 1;
          $wrapper.toggleClass("ws-variants-no-overflow", !hasOverflow);
          if (ResizeObserver && !$wrapper.attr("data-ws-variants-observer")) {
            $wrapper.attr("data-ws-variants-observer", "1");
            var ro = new ResizeObserver(function() {
              var v = $wrapper.find(".ws-product-variants-scroll-viewport")[0];
              if (!v) return;
              var overflow = v.scrollWidth > v.clientWidth + 1;
              $wrapper.toggleClass("ws-variants-no-overflow", !overflow);
            });
            ro.observe(viewport);
          }
        });
      }
      WS.ui.toggleVariantsScrollButtons = toggleVariantsScrollButtons;
      var variantsScrollResizeTimer;
      $(function() {
        toggleVariantsScrollButtons();
        setTimeout(toggleVariantsScrollButtons, 600); // 懒加载图片加载后重新检测
        $(window).on("resize", function() {
          clearTimeout(variantsScrollResizeTimer);
          variantsScrollResizeTimer = setTimeout(toggleVariantsScrollButtons, 100);
        });
      });

      // 全局列表点击上报（集合页点击商品时保存滚动位置与列表状态，便于返回恢复）
      $(document).on("click", ".ws-product-block .ws-product-link", function() {
        // 获取dom结构，判断是否为侧边栏购物车加购
        var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
        // 获取页面类型
        var pageType = cartDrawerOpen ? 'cart' : WS.site.page;
        // 判断加购类型
        var clickType = "";
        // 定义加购商品来源参数
        var addToBagProductFrom = "none";
        switch (pageType) {
          case 'index':
            clickType = WS.ui.homeReportMap['clickProductHome'];
            addToBagProductFrom = "home_collection";
            break;
          case 'search':
            clickType = WS.ui.searchReportMap['clickProductSearch'];
            addToBagProductFrom = "search";
            break;
          case 'collection':
            var listType =  $(this).parents('.ws-featured-collection-product-list').attr('data-list-type');
            if (listType == 'recently_viewed') {
              clickType = WS.ui.collectionReportMap['clickRecentlyViewedCollection'];
              addToBagProductFrom = "recently_viewed";
            } else if (listType == 'bottom_collection') {
              clickType = WS.ui.collectionReportMap['clickBottomCollection'];
              addToBagProductFrom = "bottom_collection";
            } else {
              clickType = WS.ui.collectionReportMap['clickProductCollection'];
              addToBagProductFrom = "collection";
            }
            break;
          case 'product':
            var type = $(this).parents('.ws-featured-collection-listing').attr('data-title');
            if (type === 'pair_it_with') {
              clickType = WS.ui.productReportMap['clickProductPairItWith'];
              addToBagProductFrom = "pair_it_with";
            } else {
              clickType = WS.ui.productReportMap['clickProductAlsoLike'];
              addToBagProductFrom = "also_like";
            }
            break;
          case 'cart':
            var isEmptyCart = !$('#cart-sum').text();
            if (isEmptyCart) {
              clickType = WS.ui.reportMap['visitProductDetailsByCollection'];
              addToBagProductFrom = "best_seller";
            } else {
              clickType = WS.ui.reportMap['visitProductDetailsByBoughtTother'];
              addToBagProductFrom = "bought_together";
            }
           
            break;
        }
        WS.ui.reporterCollection(clickType, this);
        // 存储加购来源
        WS.cookie.set("ws-pagefrom", addToBagProductFrom, 24);
      });

      // 全局列表曝光方法
      WS.ui.globalListExposureHandle();
    },
    // 滚动的商品集合类型
    bindScrollType: function (type) {
      // 判断列表来源
      if (type == "drawerCart") {
        // 监听滚动
        $(".cart-drawer_container_content-wrapper").scroll(function (event) {
          if (cartCollectionPageCount <= cartCollectionPageNo) return;
          // 调用商品集合滚动方法
          collectionFn.collectionScroll(type, $(this));
        });
      } else {
        window.addEventListener("scroll", function (e) {
          if (type == 'cartPage') {
            if (cartCollectionPageCount <= cartCollectionPageNo) return;
          } else if (type == 'searchPage') { 
            isNextPage = $("body")
            .find(".ws-featured-collection-loadmore")
            .attr("next");
            if (isNextPage === 'false') {
              return;
            }
          } else {
            if (collectionModulePageCount <= collectionModulePageNo) return;
          }
          // 调用商品集合滚动方法
          collectionFn.collectionScroll(type, $("body"));
        });
      }
    },

    // 调用商品集合滚动方法
    collectionScroll: function (type, dom) {
      // 获取滚动的高度，窗体的高度
      if (type == "drawerCart") {
        // 视图滚动的高度
        var scrollH = dom.scrollTop();
        // 视图的高度
        var contentH = dom.find(".cart-drawer_container_content").height();
        // 差值（窗口滚动到这个差值的时候，加载下一页）视图高度+一半商品块的高度
        var differenceH = $(window).height() + dom.find(".cart-drawer_container_content").find('.ws-product-block').height()*4;
      } else {
        var scrollH = $(window).scrollTop();
        var contentH = dom.height();
        // 差值（窗口滚动到这个差值的时候，加载下一页）视图高度+一半商品块的高度
        // 判断是否为搜索页推荐列表
        if (type == 'tab-collection') {
          var differenceH = $(window).height() + dom.find('.current-active').find('.ws-product-block').height()*5;
        } else {
          var differenceH = $(window).height() + dom.find('.ws-product-block').height()*7;
        }
      }
      // 窗体的高度-滚动的高度
      var differH = contentH - scrollH;
      if (differH <= differenceH) {
        if (busyLoading) {
          return;
        }
        // 调用加载下一页列表的方法
        collectionFn.loadMoreCollectionPage(type, dom);
      }
    },

    // 调用加载下一页列表的方法
    loadMoreCollectionPage: function (type, dom) {
      if (type == 'tab-collection') {
        var listDom = dom.find(".tab-collection-list .current-active");
        collectionFn.getCollectionModule({
          dom: listDom, 
          canLoadMore: true
        });
      } else if (type == 'drawerCart' || type == 'cartPage') {
        var listDom = dom.find('.ws-cart-collection .ws-featured-collection-listing');
        collectionFn.getCollectionModule({
          dom: listDom, 
          canLoadMore: true
        });
      } else if (WS.site.page == 'search' && type == 'searchPage') {
        var dom = dom.find(".ws-search-model-list");
        var totalPages = parseInt(
          dom.find(".ws-featured-collection-listing").attr("totalpage")
        );
        var currentPage = parseInt(
          dom.find(".ws-featured-collection-listing").attr("currentpage")
        );
        // 获取是否限制最大商品页数
        var maxPage = parseInt(
          dom.find(".ws-featured-collection-listing").attr("maxpage")
        );
        var nextPage = currentPage + 1;
        if (nextPage > totalPages || ( maxPage && maxPage <= currentPage )) {
          return;
        }
        var getCollectionListUrl = `${location.href}&sections=ws-main-search&page=${nextPage}`;
        var getCollectionName = 'ws-main-search';
        dom.find(".ws-loadmore-img").show();
        busyLoading = true;
        // 调用下一页接口
        WS.ajax({
          url: getCollectionListUrl,
          type: "GET",
          dataType: "html",
          success: function (res) {
            busyLoading = false;
            // 获取接口数据
            var responseHTML = JSON.parse(res || 'null')[getCollectionName];
            // 赋值当前页参数
            dom
              .find(".ws-featured-collection-listing")
              .attr("currentpage", nextPage);
            // 加入页面
            dom
              .find(
                ".ws-featured-collection-listing .ws-featured-collection-product-list"
              )
              .append(
                $(responseHTML)
                  .find(
                    ".ws-featured-collection-listing .ws-featured-collection-product-list"
                  )
                  .html()
              );
            // 全局列表曝光方法
            WS.ui.globalListExposureHandle();
          },
          complete: function () {
            busyLoading = false;
            dom.find(".ws-loadmore-img").hide();
            if (nextPage > totalPages) {
              dom.find(".ws-featured-collection-loadmore").hide();
            }
          },
          error: function (error) {
            busyLoading = false;
          },
        });
      }
    }
  };

  WS.ui.collectionFn = {
    handleCollectAll: collectionFn.handleCollectAll,
    processingProductData: collectionFn.processingProductData,
    bindScrollType: collectionFn.bindScrollType,
    getCollectionModule: collectionFn.getCollectionModule,
    handleCollectionData: collectionFn.handleCollectionData,
    updateFeaturedCollectionScrollbar: collectionFn.updateFeaturedCollectionScrollbar,
    updateFeaturedCollectionArrows: collectionFn.updateFeaturedCollectionArrows,
    layoutFeaturedCollectionCarouselArrows: collectionFn.layoutFeaturedCollectionCarouselArrows
  };
})();

/**
 * 搜索页
 */
(function () {
  var searchFn = {
    _hotSearchCache: null,
    // 调用搜索页面方法
    handleSearchAll: function () {
      if (WS.ui.isThemeEditor()) {
        // 主题编辑器仅保留静态预览，避免交互触发跳转导致配置面板被刷新
        return;
      }
      // var type = $('.ws-search-model-list').attr('type');
      var $listing = $('.ws-search-model-list .js-infinite-scroll-listing');
      if ($listing.length) {
        WS.ui.infiniteScroll.initShopifyCollection($listing, { searchSectionId: 'westyle-search-data' });
      }
      
      var $recommendListing = $('.ws-search-recommend__listbox .js-infinite-scroll-listing');
      if ($recommendListing.length) {
        WS.ui.infiniteScroll.initShopifyCollection($recommendListing, { searchSectionId: 'westyle-search-data' });
      }
      // 点击事件方法
      searchFn.bindEvent();
      // 渲染搜索模块
      searchFn.initSearchLabel();
    },
    // 渲染搜索模块
    initSearchLabel: function () {
      // 定义模块
      var searchHtml = `
        <% if ( data.recentList && data.recentList.length > 0 ) { %>
          <div class="ws-search-label-list ws-search-label-recent" type="recent">
            <div class="label-list-title">
              <p class="title"><%t('search.recent_search_title') %></p>
              <img class="ws-search-delect-all" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-delete.svg?v=1774507894" width="22" height="22" loading="lazy" alt="recent search delete" />
            </div>
            <div class="label-list-li">
              <% for ( var i = 0; i < data.recentList.length; i++ ) { %>
                <div class="li-box" value="<%= data.recentList[i] %>"><%= data.recentList[i] %><span class="li-box-remove" data-index="<%= i %>" aria-label="Remove"><img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484" width="10" height="10" loading="lazy" alt="recent search delete" /></span></div>
              <% } %>
            </div>
          </div>
        <% } %>
        <div class="ws-search-label-list ws-search-label-hot" type="hot">
          <div class="label-list-title label-list-title-hot">
            <p class="title"><%t('search.hot_searches_title') %></p>
          </div>
          <div class="label-list-li">
            <% for ( var item of data.hotList ) { %>
              <div class="li-box" value="<%= item.text %>"><%= item.value %></div>
            <% } %>
          </div>
        </div>
      `;
      // 获取记录用户搜索数组
      var searchLabel = localStorage.getItem("ws-search-label");
      var listArr = searchLabel ? searchLabel.split(',') : [];
      // 从 section 配置读取热门搜索词（支持 1~多条）
      // 性能优化：优先使用缓存，仅缓存为空时解析 DOM 配置
      var configuredHotList = Array.isArray(searchFn._hotSearchCache) ? searchFn._hotSearchCache.slice() : [];
      if (!configuredHotList.length) {
        try {
          var hotSearchesRaw = $('.ws-search-config').first().attr('data-hot-searches');
          if (hotSearchesRaw) {
            var decodeNode = document.createElement('textarea');
            decodeNode.innerHTML = hotSearchesRaw;
            var decodedHotSearchesRaw = decodeNode.value || hotSearchesRaw;
            var parsedHotSearches = JSON.parse(decodedHotSearchesRaw);
            if (Array.isArray(parsedHotSearches)) {
              configuredHotList = parsedHotSearches
                .filter(function (item) { return typeof item === 'string' && item.trim(); })
                .map(function (item) {
                  var text = item.trim();
                  return { value: text, text: text };
                });
              searchFn._hotSearchCache = configuredHotList.slice();
            }
          }
        } catch (e) {}
      }

      // 定义数据
      var searchLabelInfo = {
        recentList: listArr,
        hotList: configuredHotList
      };
      // 生成模块
      var getInfoListHtmlStr = WS.tmpl(searchHtml, searchLabelInfo);
      // 添加到弹窗
      $(".ws-search-model-header .ws-search-label").html(getInfoListHtmlStr);
      // 曝光模块
      // 历史搜索模块
      WS.ui.globalModelShowHandle(document.querySelector('.ws-search-label-recent'), WS.ui.searchReportMap['showRecentSearchBlock']);
      // 搜索默认页
      WS.ui.globalModelShowHandle(document.querySelector('.ws-search-label'), WS.ui.searchReportMap['showDefaultSearch']);
      // 搜索结果页
      WS.ui.globalModelShowHandle(document.querySelector('.ws-search-model-list'), WS.ui.searchReportMap['showResultsSearch'], {ext2: $('.ws-search-model-list').attr('num') }, 0);
    },
    
    // 点击事件方法
    bindEvent: function () {
      // 搜索提交时显示整屏 loading（输入框下方），提升体感
      $(document).on('submit', '.ws-main-search-modelbox .search-header-inp-form', function (e) {
        if (WS.ui.isThemeEditor()) {
          e.preventDefault();
          return false;
        }
        try {
          var $box = $('.ws-main-search-modelbox');
          if (!$box.length) return;
          var $inpBox = $box.find('.ws-search-model-header .search-header-inpbox');
          var top = 0;
          if ($inpBox.length && $inpBox.get(0) && $inpBox.get(0).getBoundingClientRect) {
            top = Math.max(0, Math.round($inpBox.get(0).getBoundingClientRect().bottom));
          }
          $box.get(0).style.setProperty('--ws-search-loading-top', top + 'px');
          $box.addClass('ws-search-is-loading');
          $box.find('.ws-search-loading-box').prop('hidden', false);
          document.documentElement.classList.add('ws-search-loading-lock');
          document.body.classList.add('ws-search-loading-lock');
        } catch (e) {}
      });

      // 点击搜索按钮储存搜索词
      $(document).on("click", ".search-header-button", function () {
        // 获取输入框内容
        var val = $('.search-header-input').val();
        $('.search-header-input-hidden').val(val);
        // 定义数组
        var searchList = [];
        // 判断输入框是否有值
        if ( !val || val.length > 200 ) { return false };
        // 判断储存值
        if ( localStorage.getItem("ws-search-label") ) {
          // 获取数据
          var list = localStorage.getItem("ws-search-label").split(',');
          // 判断搜索词是否数组里已经有了
          var index = list.indexOf(val);
          // 如果已经有了，则删除，并重新拼接至头部
          if ( index > -1 ) {
            list.splice(index, 1);
            // 然后把该参数添加至头部位置
            list.unshift(val);
          } else {
            // 判断已经储存的数组长度，如果大于20，则删除最后一条
            if ( list.length >= 20 ) {
              // 删除最后一个
              list.pop();
              // 把该参数添加至头部位置
              list.unshift(val);
            } else {
              // 把该参数添加至头部位置
              list.unshift(val);
            }
          }
          // 赋值
          searchList = list;
        } else {
          // 把该参数添加至头部位置
          searchList.unshift(val);
        }
        // 存储用户搜索关键词
        localStorage.setItem("ws-search-label", searchList);
        // 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.searchReportMap['clickSearch'],
          ext2: val,
        });
      });

      // 删除储存的搜索词
      $(document).on("click", ".ws-search-delect-all", function () {
        // 删除缓存值
        localStorage.removeItem("ws-search-label");
        // 去除模块
        $('.ws-search-label-recent').remove();
      });

      // 点击label搜索（排除点击 X 删除时，含 li-box-remove 内的 img）
      $(document).on("click", ".ws-search-label-list .li-box", function (e) {
        if (WS.ui.isThemeEditor()) return;
        if ($(e.target).closest('.li-box-remove').length) return;
        // text
        var text =  $(this).attr('value');
        // 赋值给输入框，然后调用点击事件
        $('.search-header-input').val(text);
        $('.search-header-input-hidden').val(text);
        // 触发一次输入同步（启用按钮/显示清空）并提交，确保直接跳转搜索结果
        try { $('.search-header-input').trigger('input'); } catch (e) {}
        try {
          $('.search-header-button').prop('disabled', false).attr('aria-disabled', 'false');
        } catch (e) {}
        $('.search-header-button').trigger('click');
        // 上报
        var type = $(this).parents('.ws-search-label-list').attr('type');
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.searchReportMap[type == 'recent' ? 'clickRecentSearch' : 'clickHotSearches'],
          ext2: text,
        });
      });

      // 点击 recent 单条删除
      $(document).on("click", ".li-box-remove", function (e) {
        e.stopPropagation();
        var idx = parseInt($(this).attr('data-index'), 10);
        var searchLabel = localStorage.getItem("ws-search-label");
        if (searchLabel && !isNaN(idx)) {
          var list = searchLabel.split(',');
          list.splice(idx, 1);
          if (list.length > 0) {
            localStorage.setItem("ws-search-label", list.join(','));
          } else {
            localStorage.removeItem("ws-search-label");
          }
          WS.ui.searchFn.initSearchLabel();
        }
      });

      // 删除输入框的值相关事件
      $('.search-header-input').bind('input propertychange',function(){
        var v = ($(this).val() || '').trim();
        $('.search-header-input-hidden').val(v);
        var $btn = $('.search-header-button');
        var hasVal = v !== '';
        $btn.prop('disabled', !hasVal).attr('aria-disabled', hasVal ? 'false' : 'true');
        if ( hasVal ) {
          $(".search-header-inp-close").show();
        } else {
          $(".search-header-inp-close").hide();
        }
      })
      $(".search-header-input").focus(function() { 
        if ( $(this).val() != '' ) {
          $(".search-header-inp-close").show();
        }
      }); 
      $(".search-header-inp-close").click(function() {
        $('.search-header-input').val('');
        $('.search-header-input-hidden').val('');
        $('.search-header-button').prop('disabled', true).attr('aria-disabled', 'true');
        $(this).hide();
        if (WS.ui.isThemeEditor()) return;
        try {
          var searchParams = new URLSearchParams(window.location.search || '');
          var isSearchResultState = !!(
            searchParams.get('q') ||
            searchParams.get('q_display') ||
            searchParams.get('type') ||
            $('.ws-search-model-list').length > 0
          );
          if (isSearchResultState) {
            var searchBaseUrl = $('.search-header-inp-form').attr('action') || '/search';
            window.location.href = searchBaseUrl;
          }
        } catch (e) {}
      });

      // 初始化：根据默认值同步 close/disabled 状态
      try {
        var initVal = ($('.search-header-input').val() || '').trim();
        $('.search-header-input-hidden').val(initVal);
        var hasVal = initVal !== '';
        $('.search-header-button').prop('disabled', !hasVal).attr('aria-disabled', hasVal ? 'false' : 'true');
        if (hasVal) $(".search-header-inp-close").show();
      } catch (e) {}
    }
  };

  WS.ui.searchFn = {
    handleSearchAll: searchFn.handleSearchAll,
    initSearchLabel: searchFn.initSearchLabel
  };
})();

/**
 * 集合商品弹窗加购物车方法
 */
(function () {
  var selectedColor = "";
  var selectedSize = "";
  var selectedSku = "";
  var quickPopupTrigger = null;
  var quickPopupInerted = [];

  function releaseQuickPopupA11y(restoreFocus) {
    quickPopupInerted.forEach(function(entry) { entry.node.inert = entry.wasInert; });
    quickPopupInerted = [];
    if (restoreFocus && quickPopupTrigger && quickPopupTrigger.isConnected) quickPopupTrigger.focus();
  }

  function inertQuickPopupBackground(root) {
    if (quickPopupInerted.length || !root) return;
    Array.prototype.forEach.call(document.body.children, function(node) {
      if (node === root) return;
      quickPopupInerted.push({ node: node, wasInert: node.inert });
      node.inert = true;
    });
  }

  function visibleQuickPopupPanel(root) {
    return Array.prototype.find.call(root.querySelectorAll('.product-popup-design'), function(panel) {
      return panel.getClientRects().length && getComputedStyle(panel).display !== 'none';
    });
  }

  function setQuickPopupStatus(scope, message) {
    var status = scope && scope.querySelector('.product-popup__status');
    if (status) status.textContent = message || '';
  }

  function syncQuickPopupRadioGroups(root) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('[role="radiogroup"]'), function(group) {
      var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
      var tabStop = radios.find(function(radio) { return radio.getAttribute('aria-checked') === 'true'; })
        || radios.find(function(radio) { return radio.getAttribute('aria-disabled') !== 'true'; })
        || radios[0];
      radios.forEach(function(radio) { radio.tabIndex = radio === tabStop ? 0 : -1; });
    });
  }

  function activateQuickPopupA11y(root, trigger) {
    releaseQuickPopupA11y(false);
    quickPopupTrigger = trigger && trigger.nodeType === 1 ? trigger : document.activeElement;
    inertQuickPopupBackground(root);
    var panel = visibleQuickPopupPanel(root);
    var close = panel && panel.querySelector('.title-close');
    syncQuickPopupRadioGroups(root);
    if (close) close.focus();
    root.addEventListener('keydown', function(event) {
      var active = visibleQuickPopupPanel(root);
      if (!active || root.style.display === 'none' || document.querySelector('.ws-size-chart.is-visible')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        active.querySelector('.title-close').click();
        return;
      }
      var group = event.target.closest && event.target.closest('[role="radiogroup"]');
      if (group && (event.key === 'ArrowRight' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowUp' || event.key === 'Home' || event.key === 'End')) {
        var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
        var available = radios.filter(function(radio) { return radio.getAttribute('aria-disabled') !== 'true'; });
        var choices = available.length ? available : radios;
        if (choices.length) {
          event.preventDefault();
          var index = choices.indexOf(event.target);
          var next = event.key === 'Home' ? choices[0]
            : event.key === 'End' ? choices[choices.length - 1]
            : choices[(index + (event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length];
          if (next) { next.focus(); next.click(); }
        }
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(active.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])'), function(item) {
        return item.getClientRects().length > 0 && item.tabIndex >= 0;
      });
      if (!focusable.length) return;
      if (event.shiftKey && document.activeElement === focusable[0]) {
        event.preventDefault(); focusable[focusable.length - 1].focus();
      } else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
        event.preventDefault(); focusable[0].focus();
      }
    });
  }

  document.addEventListener('focusin', function(event) {
    var root = event.target.closest && event.target.closest('.ws-main-popupbox-product');
    if (root && root.style.display !== 'none' && !document.querySelector('.ws-size-chart.is-visible')) inertQuickPopupBackground(root);
  });

  var productPopupHtml = `
    <div class="ws-main-popupbox-overlay"></div>
    <div class="ws-main-popupbox-con fix-pos-bot product-popup-design product-popup-design--mobile" role="dialog" aria-modal="true" aria-labelledby="product-popup-title-mobile" style="max-height: 90%;">
      <div class="product-popup-header">
        <button type="button" class="product-popup-header_back title-close" aria-label="Close quick add">
          <img class="product-popup-header_back-icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-arrow-down.png?v=1774525109" width="24" height="24" loading="lazy" alt="" />
        </button>
      </div>
      <div class="product-popup-campaign-message" aria-live="polite"></div>
      <div class="main-popupbox-con-model">
        <div class="product-popup-summary">
          <div class="product-popup-summary_img-wrap">
            <%
              var mainImageUrl = data?.preview_image?.src ? WS.addParam({ width: 1176, quality: 90 }, data.preview_image.src) : '';
            %>
            <img
              class="product-popup-summary_img featureimage"
              data-popup-main-image
              src="<%= mainImageUrl %>"
              width="132"
              height="176"
              loading="lazy"
              alt="<%= WS.ui.productImageAlt(data && data.preview_image && data.preview_image.alt, data && data.title, 1, data && data.images && data.images.length).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>"
            />
          </div>
          <div class="product-popup-summary_info">
            <h2 class="product-popup-summary_title" id="product-popup-title-mobile"><%= data.title || '' %></h2>
            <div class="product-popup-summary_price">
              <%
                var hasComparePrice = data.compare_at_price && Number(data.compare_at_price) > Number(data.price);
              %> 
              <span class="price-current product-popup-price <% if ( hasComparePrice ) { %>sale-price<% } %>" id="product-popup__price">${(WS.site && WS.site.symbol) ? WS.site.symbol : '$'}<%= (data.price/100).toFixed(2) %> ${(WS.site && WS.site.currency) ? WS.site.currency : 'USD'}</span>
              <% if ( hasComparePrice ) { %>
                <span class="price-compare" id="product-popup__compare-price"><%= (WS.site && WS.site.symbol) ? WS.site.symbol : '$' %><%= (data.compare_at_price/100).toFixed(2) %> ${(WS.site && WS.site.currency) ? WS.site.currency : 'USD'}</span>
              <% } %>
            </div>
            <a href="${(typeof WS !== 'undefined' && WS.site && WS.site.dir) ? WS.site.dir : ''}/products/<%= data.handle || '' %>" class="product-popup-view-detail">View Detail &gt;</a>
          </div>
        </div>
        <div class="ws-popupbox-con-model-content">
          
        </div>
        <div class="ws-popupbox-con-model-footer fix-padding-bot product-popup-footer">
          <div class="con-model-popupbox-footer-btn product-popup-footer-btn">
            <button type="button" class="popupbox-footer-btn footer-addbag-button" id="ws-popup-addbag-button" data-add-to-cart-text="Add to Cart">
              <% if (!data.oldId) { %>
                <%t('public.add_pop.add_to_bag_btn') %>
              <% } else { %>
                <%t('public.add_pop.update_btn') %>
              <% } %>
            </button>
          </div>
          <div class="product-popup-paylater">
            <span class="product-popup-paylater-text">Shop now, pay later with</span>
            <img class="product-popup-paylater-logo" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-afterpay-or-shop.png?v=1772697399" width="136" height="20" loading="lazy" alt="" />
          </div>
        </div>
      </div>
    </div>


    <div class="ws-main-popupbox-con fix-pos-bot product-popup-design product-popup-design--desktop" role="dialog" aria-modal="true" aria-labelledby="product-popup-title-desktop">
      <div class="main-popupbox-con-model">
        <div class="product-popup-summary_img-wrap">
          <%
            var mainImageUrl = data?.preview_image?.src ? WS.addParam({ width: 1176, quality: 90 }, data.preview_image.src) : '';
          %>
          <img
            class="product-popup-summary_img featureimage"
            data-popup-main-image
            src="<%= mainImageUrl %>"
            width="132"
            height="176"
            loading="lazy"
            alt="<%= WS.ui.productImageAlt(data && data.preview_image && data.preview_image.alt, data && data.title, 1, data && data.images && data.images.length).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;') %>"
          />
        </div>

        <div class="product-popup-summary">
          <div class="product-popup-header">
            <button type="button" class="product-popup-header_back title-close" aria-label="Close quick add">
              <img class="product-popup-header_back-icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484" width="24" height="24" loading="lazy" alt="" />
            </button>
          </div>
          <div class="product-popup-campaign-message" aria-live="polite"></div>
          <div class="product-popup-summary_info">
            <h2 class="product-popup-summary_title" id="product-popup-title-desktop"><%= data.title || '' %></h2>
            <div class="product-popup-summary_price">
              <%
                var hasComparePrice = data.compare_at_price && Number(data.compare_at_price) > Number(data.price);
              %> 
              <span class="price-current product-popup-price <% if ( hasComparePrice ) { %>sale-price<% } %>" id="product-popup__price">${(WS.site && WS.site.symbol) ? WS.site.symbol : '$'}<%= (data.price/100).toFixed(2) %> ${(WS.site && WS.site.currency) ? WS.site.currency : 'USD'}</span>
              <% if ( hasComparePrice ) { %>
                <span class="price-compare" id="product-popup__compare-price"><%= (WS.site && WS.site.symbol) ? WS.site.symbol : '$' %><%= (data.compare_at_price/100).toFixed(2) %> ${(WS.site && WS.site.currency) ? WS.site.currency : 'USD'}</span>
              <% } %>
            </div>
            <!-- <a href="${(typeof WS !== 'undefined' && WS.site && WS.site.dir) ? WS.site.dir : ''}/products/<%= data.handle || '' %>" class="product-popup-view-detail">View Detail &gt;</a> -->
          </div>
          <div class="ws-popupbox-con-model-content"></div>
          <div class="ws-popupbox-con-model-footer fix-padding-bot product-popup-footer">
            <div class="con-model-popupbox-footer-btn product-popup-footer-btn">
              <button type="button" class="popupbox-footer-btn footer-addbag-button" id="ws-popup-addbag-button" data-add-to-cart-text="Add to Cart">
                <% if (!data.oldId) { %>
                  <%t('public.add_pop.add_to_bag_btn') %>
                <% } else { %>
                  <%t('public.add_pop.update_btn') %>
                <% } %>
              </button>
            </div>
            <div class="product-popup-paylater">
              <span class="product-popup-paylater-text">Shop now, pay later with</span>
              <img class="product-popup-paylater-logo" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-afterpay-or-shop.png?v=1772697399" width="136" height="20" loading="lazy" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  // sizeguide数据
  var productSizeGuideDataInfo = '';
  // 新版 size chart section 动态加载（避免加购弹窗场景页面未注入 section）
  var _wsSizeChartLoading = false;
  function ensureSizeChartAsyncAndOpen(triggerEl) {
    try {
      if (window.wsSizeChartOpen && document.querySelector('[data-size-chart-section]')) {
        window.wsSizeChartOpen(triggerEl || null);
        return;
      }
      if (_wsSizeChartLoading) return;
      _wsSizeChartLoading = true;
      var sectionUrl = `${WS.site.baseUrl}${window.location.pathname}?sections=westyle-size-chart`;
      WS.ajax({
        url: sectionUrl,
        type: 'GET',
        dataType: 'html',
        success: function(res) {
          var responseHTML = '';
          if (typeof res === 'string') {
            try {
              responseHTML = JSON.parse(res || 'null')['westyle-size-chart'] || '';
            } catch (e) {
              responseHTML = '';
            }
          } else if (res && typeof res === 'object') {
            responseHTML = res['westyle-size-chart'] || '';
          }
          if (!responseHTML) return;

          var wrap = document.createElement('div');
          wrap.innerHTML = responseHTML;
          var chartEl = wrap.querySelector('[data-size-chart-section]');
          if (chartEl && !document.querySelector('[data-size-chart-section]')) {
            document.body.appendChild(chartEl);
          }

          // 动态插入 section 后，手动执行其中的内联脚本
          var scriptEls = wrap.querySelectorAll('script');
          scriptEls.forEach(function(oldScript) {
            var nextScript = document.createElement('script');
            if (oldScript.src) {
              nextScript.src = oldScript.src;
            } else {
              nextScript.text = oldScript.textContent || '';
            }
            document.body.appendChild(nextScript);
          });

          // 注入完成后，再次同步触发元素携带的 handle/type 到容器（避免 section 初始值覆盖）
          try {
            var triggerHandle = triggerEl && triggerEl.getAttribute ? (triggerEl.getAttribute('data-product-handle') || '') : '';
            var triggerType = triggerEl && triggerEl.getAttribute ? (triggerEl.getAttribute('data-product-type') || '') : '';
            var liveChart = document.querySelector('[data-size-chart-section]');
            if (liveChart) {
              if (triggerHandle) liveChart.setAttribute('data-product-handle', triggerHandle);
              if (triggerType) liveChart.setAttribute('data-product-type', String(triggerType).toLowerCase());
              else liveChart.removeAttribute('data-product-type');
            }
          } catch (e) {}

          if (window.wsSizeChartOpen) {
            window.wsSizeChartOpen(triggerEl || null);
          }
        },
        complete: function() {
          _wsSizeChartLoading = false;
        }
      });
    } catch (e) {
      _wsSizeChartLoading = false;
    }
  }
  // 对外暴露统一入口：允许 PDP/弹窗等统一从 WS.ui 触发
  WS.ui.ensureSizeChartAsyncAndOpen = ensureSizeChartAsyncAndOpen;

  var addPopCampaignConfigCache = null;

  // 活动文案统一从 Liquid 输出的 JSON 读取，加购弹窗、PDP 共用同一份配置。
  // JSON 来源：sections/westyle-activity-popup.liquid 中的 #ws-add-pop-campaign-messages。
  // 这样做的原因：
  // - 开关和文案都维护在 locales，非活动期间只需要关闭 campaign_message_enabled；
  // - 加购弹窗是 JS 模板，PDP 是页面 DOM，两者都不能直接在运行时重新跑 Liquid；
  // - 读取后缓存，避免每次渲染弹窗都重新解析 JSON。
  function getAddPopCampaignConfig() {
    if (addPopCampaignConfigCache) return addPopCampaignConfigCache;
    var configEl = document.getElementById('ws-add-pop-campaign-messages');
    if (!configEl) return { enabled: false, messages: {} };
    try {
      addPopCampaignConfigCache = JSON.parse(configEl.textContent || '{}') || {};
    } catch (e) {
      addPopCampaignConfigCache = {};
    }
    addPopCampaignConfigCache.enabled = addPopCampaignConfigCache.enabled === true;
    addPopCampaignConfigCache.messages = addPopCampaignConfigCache.messages || {};
    return addPopCampaignConfigCache;
  }

  // 复用购物车模块维护的活动有效件数，避免再额外请求一次 cart 接口。
  // getCampaignCartCount 读取的是 Liquid 已经排除后的活动有效件数：
  // - Vendor 不是 No Sale / Nana Jacqueline 的商品；
  // - Product Type 为 Gift Cards 的商品。
  // cart-data 未 ready 时返回 null，先隐藏文案；等 ws:cart-count-updated 触发后再展示正确档位。
  function getAddPopCampaignCartCount() {
    if (WS.ui && WS.ui.cartFn && typeof WS.ui.cartFn.getCampaignCartCount === 'function') {
      var rawCampaignCount = WS.ui.cartFn.getCampaignCartCount();
      if (rawCampaignCount === null || typeof rawCampaignCount === 'undefined') return null;
      var campaignCount = Number(rawCampaignCount);
      return !isNaN(campaignCount) && campaignCount > 0 ? campaignCount : 0;
    }
    return null;
  }

  // 根据当前活动有效件数返回活动文案：0/1/2/3+ 四档。
  // messages 来自 `_html` 翻译 key，允许 `<strong>` 标签在三端统一加粗显示。
  function getAddPopCampaignMessage() {
    var config = getAddPopCampaignConfig();
    if (!config.enabled) return '';
    var cartCount = getAddPopCampaignCartCount();
    if (cartCount === null) return '';
    if (cartCount >= 3) return config.messages[3] || '';
    if (cartCount === 2) return config.messages[2] || '';
    if (cartCount === 1) return config.messages[1] || '';
    return config.messages[0] || '';
  }
  WS.ui.getCampaignMessageByCartCount = getAddPopCampaignMessage;

  var productPopupFn = {
    // 加购弹窗每次重新渲染商品信息后，同步刷新活动文案。
    // 弹窗 HTML 是整段替换的，所以必须在 `.html(htmlStr)` 之后重新查找节点并写入文案。
    // 没有文案或总开关关闭时，清空并隐藏节点，避免上一次弹窗内容残留。
    renderAddPopCampaignMessage: function (scope) {
      var $scope = scope ? $(scope) : $('.ws-main-popupbox-product');
      var message = getAddPopCampaignMessage();
      var $messageNodes = $scope.find('.product-popup-campaign-message');
      if (!$messageNodes.length) return;
      if (!message) {
        $messageNodes.empty().removeClass('is-active').hide();
        return;
      }
      $messageNodes
        .html('<span class="product-popup-campaign-message__text">' + message + '</span>')
        .addClass('is-active')
        .show();
    },
    handleProductSkuModule: function() {
      // 商品卡数据可能缺少 mergeSkcs，弹窗需兜底用当前商品，避免颜色/尺码模块整体渲染失败。
      var productObj = WS.ui.productObj || {};
      var productVariants = Array.isArray(productObj.variants) ? productObj.variants : [];
      var mergeSkcsList = Array.isArray(productObj.mergeSkcs) ? productObj.mergeSkcs : [];
      var targetProduct = mergeSkcsList.find((skc) => String(skc.id) === String(productObj.id)) || productObj;
      var colorSkcsList = mergeSkcsList.length ? mergeSkcsList : [targetProduct];
      if (!productVariants.length) return '';
      var colorIndex = WS.ui.getOptionIndexByKeyword(targetProduct, 'color');
      var sizeIndex = WS.ui.getOptionIndexByKeyword(targetProduct, 'size');
      var colorOptionPosition = 'option' + colorIndex;
      var sizeOptionPosition = 'option' + sizeIndex;
      var currentColorValue = productVariants[0][colorOptionPosition];

      // 每次打开弹窗都重置尺码状态，避免沿用上一次弹窗选择的 variant。
      selectedColor = String(productObj.id || '');
      selectedSize = '';
      selectedSku = '';

      var popupSizeGuideHandle = String((targetProduct && targetProduct.handle) || productObj.handle || '').replace(/"/g, '&quot;');
      var popupSizeGuideType = String((targetProduct && targetProduct.type) || productObj.type || '')
        .toLowerCase()
        .replace(/"/g, '&quot;');
      var popupSizeGuideTypeAttr = popupSizeGuideType ? ' data-product-type="' + popupSizeGuideType + '"' : '';
      var escapePopupAttr = function(value) {
        return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
      };

      var productSkuModule = `
        <section class="product-sku-wrapper">
          <div class="sku-wrapper color-wrapper">
            ${currentColorValue ?
              `<div class="ws-sku-wrapper-title">
                <p class="title">Color:</p>
                <p class="value-text color-selected-value">${currentColorValue}</p>
              </div>`
              : ''
            }
            <div class="sku-box" role="radiogroup" aria-label="Colors for ${escapePopupAttr(productObj.title)}">
              ${
                colorSkcsList.map((skc) => {
                  var colorImage = skc.color_image || '';
                  var colorHex = skc.color_hex || '';
                  var skcColorIndex = WS.ui.getOptionIndexByKeyword(skc, 'color');
                  var skcColorOptionPosition = 'option' + skcColorIndex;
                  var skcVariants = Array.isArray(skc.variants) ? skc.variants : [];
                  var skcColorValue = skcVariants[0] && skcVariants[0][skcColorOptionPosition];
                  if (!skcColorValue) return '';
                  return `
                    <button type="button"
                      class="color-item product-popup__color-item ${String(skc.id) === String(productObj.id) ? 'selected' : ''}"
                      role="radio" aria-label="${escapePopupAttr(skcColorValue)}" aria-checked="${String(skc.id) === String(productObj.id) ? 'true' : 'false'}" tabindex="-1"
                      data-value="${escapePopupAttr(skcColorValue)}"
                      data-url="${escapePopupAttr(skc.url)}"
                      data-product-id="${skc.id}"
                      data-color-hex="${colorHex}"
                      data-color-image="${colorImage}"
                    >
                      <div class="color-image-wrapper">
                        ${colorHex ? `<span class="ws-variants-color-dot" style="background-color: ${colorHex};"></span>` : ''}
                        ${colorImage ? 
                          `<img class="color-image" src="${colorImage}" width="160" height="160" loading="lazy" alt="" />` : '' }
                      </div>
                    </button>
                  `;
                }).join('')
              }
            </div>
          </div>
          <div class="sku-wrapper size-wrapper">
            <div class="ws-sku-wrapper-title">
              <p class="title">Size:</p>
              <p class="value-text size-selected-value"></p>
              <button type="button" class="size-guide-btn" data-open-size-chart data-product-handle="${popupSizeGuideHandle}"${popupSizeGuideTypeAttr} data-size-chart-title="${escapePopupAttr(productObj.title)}" productId="${productObj.id}">Size Guide</button>
            </div>
            <div class="sku-box">
              <div class="sku-sizes-inner over-5 ${productVariants.length > 5 ? 'over-5' : ''}" role="radiogroup" aria-label="Size for ${escapePopupAttr(productObj.title)}" data-size-options-index="${sizeOptionPosition}">
              ${
                productVariants.map((variant) => {
                  var sizeOptionValue = variant[sizeOptionPosition] || 'One Size';
                  var sizeLabel = productVariants.length > 1 ? sizeOptionValue : 'One Size';
                  // 初始弹窗先按 Shopify 原始状态渲染，插入后由 applySizeInventory 按线上库存修正。
                  return `
                    <button type="button"
                      class="size-item product-popup__size-item ${variant.available ? '' : 'sold-out'}"
                      role="radio" aria-checked="false" tabindex="-1" aria-disabled="${variant.available ? 'false' : 'true'}"
                      aria-label="${escapePopupAttr(sizeLabel)}, ${variant.available ? 'Available' : 'Sold out'}"
                      data-value="${sizeOptionValue}"
                      data-variant-id="${variant.id}"
                      data-available="${variant.available}"
                      data-low-stock-status="${variant.low_stock_status}"
                      data-eta="${variant.eta}"
                      data-available-count="${variant.available_count}"
                      data-pickup-available="${variant.pickup_available}"
                      data-is-us-warehouse="${variant.is_us_warehouse}"
                      data-pickup-addresses='${variant.pickup_addresses ? JSON.stringify(variant.pickup_addresses) : "[]"}'
                    >
                      <span>${sizeLabel}</span>
                    </button>
                  `;
                }).join('')
              }
              </div>
            </div>
          </div>

          <div class="in-stock-wrapper" id="ws-popup-in-stock-wrapper"></div>
          <p class="product-popup__status" role="status" aria-live="polite"></p>
        </section>
      `;
      return productSkuModule;
    },
    // 调用创建弹窗方法
    lsCreatePopupHandle: function (obj) {
      var data = obj.data || {};
      var handle = obj.handle || '';
      var listType = obj.listType || '';
      var aid = obj.aid || 'empty';
      var type = obj.type || 'addtobag';
      var dataDom = obj.dataDom || '';
      var productType = data.productType || '';
      var $socialTrackRoot = dataDom ? ($(dataDom).is('[data-social-post-id]') ? $(dataDom) : $(dataDom).closest('[data-social-post-id]')) : $();
      var socialPostId = obj.socialPostId || $socialTrackRoot.attr('data-social-post-id') || '';
      var socialPlatform = obj.socialPlatform || $socialTrackRoot.attr('data-social-platform') || '';
      var socialPos = obj.socialPos || $socialTrackRoot.attr('data-social-pos') || '';
      var socialProductId = obj.socialProductId || data.id || '';
      // 删除之前创建的弹窗
      $(".ws-main-popupbox-product").remove();
      // 创建弹窗
      var main_popup = document.createElement("div");
      main_popup.className = "ws-main-popupbox ws-main-popupbox-product";
      main_popup.setAttribute("productId", data.id);
      main_popup.setAttribute("handle", handle || '');
      main_popup.setAttribute("listType", listType || '');
      if (socialPostId) main_popup.setAttribute("data-social-post-id", socialPostId);
      if (socialPlatform) main_popup.setAttribute("data-social-platform", socialPlatform);
      if (socialPos) main_popup.setAttribute("data-social-pos", socialPos);
      if (socialProductId) main_popup.setAttribute("data-social-product-id", socialProductId);
      // 标记该弹窗由 lsCreatePopupHandle 创建，并携带弹窗商品品类
      // 用于 size guide：仅此场景把 productType 传给 ws-size-chart
      main_popup.setAttribute("data-from-ls-create-popup", "1");
      if (productType) {
        main_popup.setAttribute("productType", String(productType));
      }
      // 添加数据aid参数
      if ( aid ) {
        main_popup.setAttribute("aid", aid);
      }
      document.body.appendChild(main_popup);
      // 生成html片段代码
      try {
        var htmlStr = WS.tmpl(productPopupHtml, data);
      } catch (error) {
        //  WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
      }

      // 添加到弹窗页面
      $(".ws-main-popupbox-product").html(htmlStr);
      productPopupFn.renderAddPopCampaignMessage('.ws-main-popupbox-product');

      var productSkuModule = '';
      try {
        productSkuModule = productPopupFn.handleProductSkuModule();
      } catch (error) {
        productSkuModule = '';
      }
      if (productSkuModule) {
        $('.ws-popupbox-con-model-content').html(productSkuModule);
        WS.ui.applySizeInventory('.ws-main-popupbox-product');
        syncQuickPopupRadioGroups(main_popup);
        WS.ui.renderUsWarehouseStockTip && WS.ui.renderUsWarehouseStockTip({
          scope: '.ws-main-popupbox-product',
          wrapperSelector: '#ws-popup-in-stock-wrapper',
          sizeSelector: '.product-popup__size-item'
        });
      }
      activateQuickPopupA11y(main_popup, dataDom && $(dataDom)[0]);

      // 禁止弹窗底部滚动方法
      WS.ui.popupNoScrollHandle();

      if (type === 'addtobag' || type === 'selectsize' || type === 'selectsize_soldout') {
        $('.footer-addbag-button').show();
        $('.footer-buyitnow-button').hide();
        var textBtn = data.oldId ? WS.$t('public.add_pop.update_btn', '', 1) : WS.$t('public.add_pop.add_to_bag_btn', '', 1);
        $('.ws-main-popupbox-con').attr('data-popupbox-type', textBtn);

        if (type === 'selectsize_soldout') {
          WS.ui.toastShowHandle(
            WS.$t('public.add_pop.out_of_stock_tip')
          );
        }
      } else if (type === 'exchange') {
        $('.ws-popupbox-con-model-footer').html('<div class="return-form_exchange-select-btn-wrapper"><div class="common-submit-button" id="return-form-exchange-select-btn">Save</div></div>')
      } else {
        $('.footer-addbag-button').hide();
        $('.footer-buyitnow-button').show();
        $('.ws-main-popupbox-con').attr('data-popupbox-type', WS.$t('public.add_pop.buy_it_now_btn', '', 1));
      }


      // 初始参数
     

      // icon点击，弹窗曝光上报
      productPopupFn.addToBagReportExposureClickHanlde(data, WS.ui.reportType['moduleShow'], WS.ui.productReportMap['showSizeSelectPopProduct']);
    },

    // addtobag弹窗曝光、点击方法
    addToBagReportExposureClickHanlde(data, eid, reportType) {
      // 数据
      var param = {
        "products": {
          id: data.id + '',
          title: data.title,
          price: data.price/100,
        }
      };
      // 如果集合携带aid，则上报aid
      var aid = $('.ws-main-popupbox-product').attr('aid');
      var socialPostId = $('.ws-main-popupbox-product').attr('data-social-post-id') || '';
      if (socialPostId && eid === WS.ui.reportType['click']) {
        WS.stat({
          eid: eid,
          aid: aid || 'empty',
          ext1: 'social_product_cart_icon_click',
          ext2: data.id ? String(data.id) : '',
          ext3: socialPostId
        });
        return;
      }
      WS.stat({
        eid: eid,
        aid: aid || 'empty',
        ext1: reportType,
        ext2: JSON.stringify(param),
        ext3: WS.site.page,
        ext4: $('.ws-main-popupbox-product').attr('handle'),
      });
    },
    renderSizeOptions: function(variants, sizeIndex, sizeContainer, itemClass) {
      var $sizeInner = $(sizeContainer);
      if (!$sizeInner.length) return;
      var html = '';
      var isProductPageSize = String(itemClass || '').indexOf('product-page__size-item') !== -1;
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var optionLabel = 'option' + sizeIndex;
        var sizeValue = variant[optionLabel] || 'One Size';
        var sizeLabel = variants.length > 1 ? sizeValue : 'One Size';
        var sizeTag = 'button';
        var buttonAttrs = ' type="button" ' + (isProductPageSize ? 'aria-pressed="false"' : 'role="radio" aria-checked="false" tabindex="-1"') + ' aria-disabled="' + (variant.available ? 'false' : 'true') + '"'
          + (isProductPageSize ? '' : ' aria-label="' + String(sizeLabel).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + ', ' + (variant.available ? 'Available' : 'Sold out') + '"');
        // 色卡切换时先按 Shopify 原始状态渲染，切换完成后再用 applySizeInventory 按线上库存修正。
        html += `
          <${sizeTag}${buttonAttrs} class="size-item ${itemClass || ''} ${variant.available ? '' : 'sold-out'}"
            data-value="${sizeValue}"
            data-variant-id="${variant.id}"
            data-available="${variant.available}"
            data-low-stock-status="${variant.low_stock_status}"
            data-eta="${variant.eta}"
            data-available-count="${variant.available_count}"
            data-pickup-available="${variant.pickup_available}"
            data-is-us-warehouse="${variant.is_us_warehouse}"
            data-pickup-addresses='${variant.pickup_addresses ? JSON.stringify(variant.pickup_addresses) : "[]"}'
          ><span>${sizeLabel}</span></${sizeTag}>
          `;
      }
      $sizeInner.html(html);
    },
    handleSelectedVairantPrice: function(obj) {
      var variant = obj.variant;
      var productContainer = obj.productContainer;
      var priceWrapper = obj.priceWrapper;
      var comparePriceWrapper = obj.comparePriceWrapper;
      var price = variant.price;
      var comparePrice = variant.compare_at_price;
      var $productContainer = $(productContainer);
      var $priceWrapper = $(priceWrapper);
      var $comparePriceWrapper = $(comparePriceWrapper);
      var hasComparePrice = Number(comparePrice) > Number(price);
      $productContainer.attr('data-current-price', price);
      $priceWrapper
        .attr('data-price', price)
        .text(WS.ui.formatPrice(price))
        .toggleClass('sale-price', hasComparePrice);

      if (hasComparePrice) {
        if (!$comparePriceWrapper.length) {
          var isPopupPrice = $priceWrapper.hasClass('product-popup-price');
          var comparePriceTag = ($priceWrapper.prop('tagName') || 'span').toLowerCase();
          $comparePriceWrapper = $('<' + comparePriceTag + '>', {
            id: isPopupPrice ? 'product-popup__compare-price' : 'product-compare-price',
            class: isPopupPrice ? 'price-compare' : 'product-price__item compare-price'
          }).insertAfter($priceWrapper);
        }
        $comparePriceWrapper.attr('data-price', comparePrice).text(WS.ui.formatPrice(comparePrice));
      } else {
        $comparePriceWrapper.remove();
      }

      var $payLater = $productContainer.find('.ws-pay-later');
      var installments = Number($payLater.attr('data-installments'));
      if ($payLater.length && Number.isFinite(Number(price)) && installments > 0) {
        $payLater
          .attr('data-price-cents', price)
          .find('.js-pay-later-amount')
          .text(WS.ui.formatPrice(Number(price) / installments));
      }
    },
    switchMergeSkcProduct: function(obj) {
      var $colorItem = obj.colorItem;
      var mergeSkcsList = obj.mergeSkcsList;
      var productContainer = $(obj.productContainer);
      var titleWrapper = $(obj.titleWrapper);
      var currentId = productContainer.attr('data-product-id');
      var targetId = $colorItem.attr('data-product-id');
      var sizeContainer = obj.sizeContainer;
      var sizeItemClassName = obj.sizeItemClassName || '';
      var isReplaceUrl = obj.isReplaceUrl || false;
      var isReplaceJSON = obj.isReplaceJSON || false;
      var isRenderMedia = obj.isRenderMedia || false;
      var priceWrapper = obj.priceWrapper || '';
      var comparePriceWrapper = obj.comparePriceWrapper || '';
      var urlBtnDom = obj.urlBtnDom || '';
      var mainImageWrapper = obj.mainImageWrapper || '';
      if (!targetId) return false;
      
      if (String(targetId) === String(currentId)) return false;

      var targetProduct = mergeSkcsList.find(item => String(item.id) === String(targetId));
      if (!targetProduct) return false;

      var variants = targetProduct.variants || [];
      var sizeIndex = WS.ui.getOptionIndexByKeyword(targetProduct, 'size');
      WS.ui.productObj = Object.assign({}, WS.ui.productObj, targetProduct, { mergeSkcs: mergeSkcsList });

      // 更新商品信息
      productContainer.attr('data-product-id', targetProduct.id || '');
      $(titleWrapper).text(targetProduct.title || '');
      if (mainImageWrapper) {
        $(mainImageWrapper).attr('src', '');
        mainImageUrl = WS.addParam({ width: 1176, quality: 90 }, targetProduct?.preview_image?.src);

        $(mainImageWrapper).attr('src', mainImageUrl).attr('alt', WS.ui.productImageAlt(targetProduct.preview_image?.alt, targetProduct.title, 1, targetProduct.images && targetProduct.images.length));
      }

      // 渲染尺码选项
      productPopupFn.renderSizeOptions(variants, sizeIndex, sizeContainer, sizeItemClassName);
      productContainer.find('.size-wrapper .sku-sizes-inner[role="radiogroup"]')
        .attr('aria-label', 'Size for ' + (targetProduct.title || 'product'));
      // 渲染图片
      if (isRenderMedia) {
        WS.ui.productFn && WS.ui.productFn.renderSliderByMedia(targetProduct.images);
      }

      // 查询价格最低的 variant
      // 查询出价格最低的variant, 如果variants只有1条数据返回当前
      var selectedVariant;
      if (variants.length === 1) {
        selectedVariant = variants[0];
      } else {
        selectedVariant = variants.reduce(function(prev, curr) {
          return (prev == null || (curr.price != null && curr.price < prev.price)) ? curr : prev;
        }, null);
      }

      if (selectedVariant) {
        WS.ui.productPopupFn.handleSelectedVairantPrice({
          variant: selectedVariant,
          productContainer: productContainer,
          priceWrapper: priceWrapper,
          comparePriceWrapper: comparePriceWrapper
        });
      }

      if (isReplaceJSON) {
      var mergedRoot = Object.assign({}, targetProduct);
        delete mergedRoot.mergeSkcs;
        var newDetailJson = Object.assign({}, mergedRoot, { mergeSkcs: mergeSkcsList });
        productContainer.find(".js-product-detail-json").text(JSON.stringify(newDetailJson));
      }

      var url = $colorItem.attr('data-url');
      if (isReplaceUrl && url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', url);
      }

      if (urlBtnDom) {
        $(urlBtnDom).attr('href', url);
      }

      // 色卡切换主流程完成后，再按线上库存修正尺码售罄态，避免库存兜底影响色卡切换。
      try {
        WS.ui.applySizeInventory(sizeContainer);
      } catch (e) {}
      syncQuickPopupRadioGroups(productContainer.closest('.ws-main-popupbox-product')[0]);
      return true;
    },
    /**
     *
     * 商品弹窗事件方法
     */
    productPopBindEvent: function () {
      // 点击列表购物车icon，弹窗商品弹窗
      $(document).on("click", ".ws-product__add-bag-btn", function () {
        var $btn = $(this);
        var productId = $btn.attr('data-product-id');
        var productDataDom = $btn.parents('.ws-product-block').find('.js-product-json');
        var productInfo = WS.ui.getProductData(productId, productDataDom);
        // 判断列表的变体选项
        // var $innerBox = $btn.closest('.ws-product-block-innerbox');
        // var $activeSwatch = $innerBox.find('.ws-variants-image-active').first();
        // var variantsColor = $activeSwatch.attr("data-value") || '';
        // var domImg = $activeSwatch.attr('data-img') || '';
        // productInfo.id = $activeSwatch.attr('data-product-id') || '';
        // if (variantsColor) {
        //   productInfo.color = variantsColor;
        // }
        // if (domImg) {
        //   productInfo.mainImage = domImg;
        // }
        
        // 获取集合名，aid
        var handle = $(this).parents('.ws-featured-collection-listing').attr('data-title');
        var listType = $(this).parents('.ws-featured-collection-product-list').attr('data-list-type');
        var aid = $(this).parents('.ws-product-block').attr('stat-module-show-aid');

        WS.ui.operateZeSnippet(1);

        WS.ui.productPopupFn.lsCreatePopupHandle({
          // productInfoData, handle, aid
          data: productInfo,
          handle: handle,
          listType: listType,
          aid: aid,
          dataDom: this
        });
        // 点击icon上报
        WS.ui.productPopupFn.addToBagReportExposureClickHanlde(productInfo, WS.ui.reportType['click'], WS.ui.productReportMap['clickAddtobagIcon']);
      });

      $(document).on("click", ".product-popup__color-item", function () {
        var $colorItem = $(this);
        var $scopeCon = $colorItem.closest('.ws-main-popupbox-con');
        // 兜底：若找不到作用域容器，则退回到弹窗根
        if (!$scopeCon.length) {
          $scopeCon = $colorItem.closest('.ws-main-popupbox-product');
        }
        var $popupRoot = $colorItem.closest('.ws-main-popupbox-product');
        var $syncScope = $popupRoot.length ? $popupRoot : $scopeCon;
        var productData = WS.ui.productObj || {};
        var mergeSkcsList = Array.isArray(productData.mergeSkcs) ? productData.mergeSkcs : [];
        var targetColorId = $colorItem.attr('data-product-id');
        var targetProduct = mergeSkcsList.find(function(item) {
          return item && String(item.id) === String(targetColorId);
        }) || productData;
        if (mergeSkcsList.length >= 1) {
          WS.ui.productPopupFn.switchMergeSkcProduct(
            { 
              colorItem: $colorItem, 
              mergeSkcsList: mergeSkcsList,
              productContainer: $scopeCon.find('.main-popupbox-con-model'),
              titleWrapper: $scopeCon.find('.product-popup-summary_title'),
              sizeContainer: $scopeCon.find('.size-wrapper .sku-sizes-inner'),
              sizeItemClassName: 'product-popup__size-item',
              isReplaceUrl: false,
              isRenderMedia: false,
              isReplaceJSON: false,
              priceWrapper: $scopeCon.find('#product-popup__price'),
              comparePriceWrapper: $scopeCon.find('#product-popup__compare-price'),
              urlBtnDom: $scopeCon.find('.product-popup-view-detail'),
              mainImageWrapper: $scopeCon.find('[data-popup-main-image]')
            }
          );
        }
        var targetColorIndex = WS.ui.getOptionIndexByKeyword(targetProduct, 'color');
        var targetColorPosition = 'option' + targetColorIndex;
        var targetVariants = Array.isArray(targetProduct.variants) ? targetProduct.variants : [];
        var color = (targetVariants[0] && targetVariants[0][targetColorPosition]) || $colorItem.attr("data-value");
        selectedColor = targetColorId;
        WS.ui.selectedColor = color || '';
        // 切换颜色时清空已选尺码，避免误判库存
        selectedSize = '';
        selectedSku = '';
        // 色卡切换后按钮回到待选尺码状态；新尺码是否售罄由尺码 DOM 和加购前校验判断。
        $scopeCon.find('#ws-popup-addbag-button').removeClass('sold-out');
        WS.ui.renderUsWarehouseStockTip && WS.ui.renderUsWarehouseStockTip({
          scope: $scopeCon,
          wrapperSelector: '#ws-popup-in-stock-wrapper',
          sizeSelector: '.product-popup__size-item'
        });
        // 显示选中颜色
        $syncScope.find('.product-sku-wrapper .color-selected-value').text(color);
        var $popupColorItems = $syncScope.find('.product-popup__color-item');
        $popupColorItems.removeClass('selected').attr('aria-checked', 'false');
        var $selectedColorItem = $popupColorItems.filter(function() {
          return String($(this).attr('data-product-id')) === String(targetColorId);
        });
        ($selectedColorItem.length ? $selectedColorItem : $colorItem)
          .addClass('selected').attr('aria-checked', 'true');
        $syncScope.find('.color-wrapper .sku-box').attr('aria-label', 'Colors for ' + (targetProduct.title || 'product'));
        $syncScope.find('.product-popup__size-item').removeClass('selected').attr('aria-checked', 'false');
        syncQuickPopupRadioGroups($popupRoot[0]);
        setQuickPopupStatus($scopeCon[0], 'Color ' + color + ' selected. Choose a size.');

        // 重置size选择
        var $sizeSelectedValue = $scopeCon.find('.product-sku-wrapper .size-selected-value');
        $sizeSelectedValue.text(`${WS.$t('product.details.select_size')}`);
        // 弹窗内的加购按钮存在 PC/移动端两套结构，需限定作用域
        $scopeCon.find('#ws-popup-addbag-button').text(`${WS.$t('public.add_pop.add_to_bag_btn')}`);
      });

      $(document).on("click", ".product-popup__size-item", function () {
        var $sizeItem = $(this);
        var $scopeCon = $sizeItem.closest('.ws-main-popupbox-con');
        if (!$scopeCon.length) {
          $scopeCon = $sizeItem.closest('.ws-main-popupbox-product');
        }
        var skuWrapper = $scopeCon.find('.ws-popupbox-con-model-content .product-sku-wrapper');
        skuWrapper.find('.size-selected-value').text('');
        var size = $sizeItem.attr("data-value");
        var variantId = $sizeItem.attr("data-variant-id");
        selectedSku = variantId;
        // 获取尺码状态：是否售罄
        if ($sizeItem.hasClass('sold-out')) {
          selectedSize = '';
          skuWrapper.find('.size-selected-value').text('');
          selectedSku = '';
          $sizeItem.parent().find('.product-popup__size-item')
            .removeClass('selected').attr('aria-checked', 'false');
          WS.ui.renderUsWarehouseStockTip && WS.ui.renderUsWarehouseStockTip({
            scope: $scopeCon,
            wrapperSelector: '#ws-popup-in-stock-wrapper',
            sizeSelector: '.product-popup__size-item'
          });
          // 点击售罄尺码时，同步加购按钮售罄样式
          $scopeCon.find('#ws-popup-addbag-button').addClass('sold-out');
          setQuickPopupStatus($scopeCon[0], size + ' is sold out.');
          WS.ui.toastShowHandle(WS.ui.errorMsgMap.soldout);
        } else {
          selectedSize = size;
          $scopeCon.find('#ws-popup-addbag-button').removeClass('sold-out');
          $sizeItem.addClass('selected').attr('aria-checked', 'true')
            .siblings().removeClass('selected').attr('aria-checked', 'false');
          setQuickPopupStatus($scopeCon[0], 'Size ' + size + ' selected.');
          skuWrapper.find('.size-selected-value').text(selectedSize);

          var selectedVariant = WS.ui.productObj.variants.find(variantItem => String(variantItem.id) === String(variantId));

          // 更新价格；切换颜色后若数据短暂未同步，不阻断下方选中尺码提示刷新。
          if (selectedVariant) {
            WS.ui.productPopupFn.handleSelectedVairantPrice({
              variant: selectedVariant,
              productContainer: $scopeCon.find('.main-popupbox-con-model'),
              priceWrapper: $scopeCon.find('#product-popup__price'),
              comparePriceWrapper: $scopeCon.find('#product-popup__compare-price')
            });
          }
          
          // 显示选中尺码的 2 日达 / 库存 / 预售信息；当前尺码有 2 日达时，不再先跑旧库存逻辑。
          var tipStockHtml = WS.ui.formatSelectedUsWarehouseStockTipHtml
            ? WS.ui.formatSelectedUsWarehouseStockTipHtml($sizeItem)
            : '';
          if (!tipStockHtml) {
            tipStockHtml = WS.ui.formatVariantInStockTipHtml($sizeItem);
          }
         
          $scopeCon.find('#ws-popup-in-stock-wrapper').html(tipStockHtml || '');
        }
        syncQuickPopupRadioGroups($sizeItem.closest('.ws-main-popupbox-product')[0]);
      });

      // 点击弹窗加购按钮
      $(document).on("click", "#ws-popup-addbag-button", function () {
        var $button = $(this);
        if ($button.hasClass('sold-out')) { setQuickPopupStatus($button.closest('.ws-main-popupbox-con')[0], WS.ui.errorMsgMap.soldout); return; }
        // 弹窗同时渲染移动端和桌面端结构，必须先锁定当前点击按钮所在的弹窗作用域。
        var $scopeCon = $button.closest('.ws-main-popupbox-con');
        if (!$scopeCon.length) {
          $scopeCon = $button.closest('.ws-main-popupbox-product');
        }
        // 以当前弹窗中真实选中的尺码 DOM 为准，避免闭包里的 selectedSku 和界面选中态不同步。
        var $selectedSizeItem = $scopeCon.find('.product-popup__size-item.selected').first();
        var currentSelectedColor = $scopeCon.find('.product-popup__color-item.selected').attr('data-product-id') || selectedColor;
        var currentSelectedSize = $selectedSizeItem.attr('data-value') || selectedSize;
        var currentSelectedSku = $selectedSizeItem.attr('data-variant-id') || selectedSku;
        // 如果选中项已经被库存逻辑标记售罄，直接拦截，防止售罄 variant 被提交到购物车。
        if ($selectedSizeItem.length && $selectedSizeItem.hasClass('sold-out')) {
          $button.addClass('sold-out');
          setQuickPopupStatus($scopeCon[0], WS.ui.errorMsgMap.soldout);
          WS.ui.toastShowHandle(WS.ui.errorMsgMap.soldout);
          return;
        }
        // 判断是否选中color以及size
        // 移动端/桌面端弹窗结构并存，提交前以当前按钮所在弹窗里的选中尺码为准。
        if (currentSelectedColor && currentSelectedSize) {
          if (!currentSelectedSku) {
            setQuickPopupStatus($scopeCon[0], WS.ui.errorMsgMap.noSize);
            return WS.ui.toastShowHandle(WS.ui.errorMsgMap.noSize);
          }
          // 提交前回写闭包状态，兼容后续上报和旧逻辑读取 selectedSku 的场景。
          selectedColor = currentSelectedColor;
          selectedSize = currentSelectedSize;
          selectedSku = currentSelectedSku;
          var productData = {
            id: currentSelectedSku,
            quantity: 1,
            productId: WS.ui.productObj.id
          };
          if (WS.ui.productObj.oldId) {
            Object.assign(productData, { oldId: WS.ui.productObj.oldId, cartVariantList: WS.ui.productObj.cartVariantList });
          }

          var handleType = productData.oldId ? "update" : "add";
          productPopupFn.productAddToBag(productData, handleType, $button);
        } else {
          // toast方法
          setQuickPopupStatus($scopeCon[0], WS.ui.errorMsgMap.noSize);
          WS.ui.toastShowHandle(WS.ui.errorMsgMap.noSize);
          // 加购上报方法
          var source = WS.ui.getSourceByAddToCart();
          productPopupFn.addToBagReportHandle(WS.ui.productObj, 2, source);
        }
      });

      // 点击icon关闭弹窗
      $(document).on(
        "click",
        ".ws-main-popupbox .title-close, .popupbox-container_close-btn-outside, .popupbox-container_close-btn-inside",
        function () {
          var hasSocialModulePopup = $('.ws-vertical-popupbox-social-module').length > 0;
          // 恢复弹窗底部滚动方法
          WS.ui.popupRecoveryScrollHandle();
          $(this).parents(".ws-main-popupbox").hide();
          if ($(this).closest('.ws-main-popupbox-product').length) releaseQuickPopupA11y(true);
          if (hasSocialModulePopup) {
            WS.ui.popupNoScrollHandle();
          } else {
            WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(2);
          }
          // 判断是否为商品弹窗
          var id = $(this).parents(".ws-main-popupbox").attr('productid');
          if (id) {
            WS.stat({
              eid: WS.ui.reportType['click'],
              ext1: WS.ui.reportMap['closeChangeSkuDrawer'],
            });
          }
        }
      );

      // Size guide：加购弹窗内触发（仅新版 ws-size-chart）
      // - 若弹窗由 lsCreatePopupHandle 创建：传 productType（弹窗商品品类）
      // - 否则：不传 type，保持 ws-size-chart 使用商品自身（PDP/GraphQL）的默认逻辑
      $(document).on(
        "click",
        ".ws-main-popupbox-product .ws-look-sizeguide-btn, .ws-main-popupbox-product #size-guide, .ws-main-popupbox-product [data-open-size-chart]",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          try {
            var $popup = $(this).closest('.ws-main-popupbox-product');
            var handle =
              (WS.ui && WS.ui.productObj && WS.ui.productObj.handle) ||
              $popup.attr('handle') ||
              '';

            // 仅当来自 lsCreatePopupHandle 时，才把 productType 传给 size-chart
            var fromLs = $popup.attr('data-from-ls-create-popup') === '1';
            var popupProductType = fromLs ? ($popup.attr('productType') || '') : '';

            var $chart = $('[data-size-chart-section]').first();
            if ($chart && $chart.length) {
              if (handle) $chart.attr('data-product-handle', handle);
              if (fromLs) {
                if (popupProductType) $chart.attr('data-product-type', String(popupProductType).toLowerCase());
                else $chart.removeAttr('data-product-type');
              } else {
                // 非 ls 弹窗：用 GraphQL 商品自身 productType，清除上次（如首饰 quick view）残留的 type
                $chart.removeAttr('data-product-type');
              }
            }

            // 同步到触发元素，供 ws-size-chart openChart(trigger) 读取
            if (handle) this.setAttribute('data-product-handle', handle);
            if (fromLs) {
              if (popupProductType) this.setAttribute('data-product-type', String(popupProductType).toLowerCase());
              else this.removeAttribute('data-product-type');
            } else {
              this.removeAttribute('data-product-type');
            }
          } catch (err) {}

          // 确保 section 已注入后再打开
          releaseQuickPopupA11y(false);
          ensureSizeChartAsyncAndOpen(this);

          WS.stat({
            eid: WS.ui.reportType['click'],
            ext1: WS.ui.globalReportMap['clickSizeGuide'],
            ext2: WS.ui.productObj.id || '',
          });
        }
      );
    },

    /**
     * 加购下拉抽屉
     * @param {*} data
     * @param {*} type add添加、update购物车更新尺码
     */
    productAddToBag: function (data, type = "add", dom) {
      var requestUrl, params;
      var curId = data.id;
      var curQuantity = data.quantity;
      var oldId = data.oldId || '';
      // 弹窗加购前兜底，防止售罄尺码因按钮状态残留被提交。
      // isVariantOnlineSellable 定义在公共 WS.ui 作用域，跨模块调用时必须通过 WS.ui 访问。
      var targetVariant = WS.ui.productObj && Array.isArray(WS.ui.productObj.variants)
        ? WS.ui.productObj.variants.find(function(variantItem) {
          return variantItem && String(variantItem.id) === String(curId);
        })
        : null;
      if (targetVariant && WS.ui.isVariantOnlineSellable && !WS.ui.isVariantOnlineSellable(targetVariant)) {
        $(dom).addClass('sold-out');
        setQuickPopupStatus($(dom).closest('.ws-main-popupbox-con')[0], WS.ui.errorMsgMap.soldout);
        WS.ui.toastShowHandle(WS.ui.errorMsgMap.soldout);
        return;
      }
      if (type === "update") {
        var cartVariantList = data.cartVariantList || [];
        var cartVariantListLen = cartVariantList.length;
        if (cartVariantListLen) {
          for (var i = 0; i < cartVariantListLen; i++) {
            var cartVariantData = cartVariantList[i];
            // 变更的variantId已存在购物车列表中，需进行累加
            if (cartVariantData.variantId == curId) {
              curQuantity = Number(cartVariantData.quantity) + Number(curQuantity);
            }
          }
        }
        requestUrl = WS.ui.routes.updateCartItemUrl;
        params = {
          updates: {
            [oldId]: 0,
            [curId]: curQuantity,
          },
        };
      } else {
        requestUrl = WS.ui.routes.addCartItemUrl;
        params = {
          id: curId,
          quantity: curQuantity,
        };
      }
      WS.ajax({
        url: requestUrl,
        type: "POST",
        data: params,
        success: function (res) {
          setQuickPopupStatus($(dom).closest('.ws-main-popupbox-con')[0], WS.$t('public.toast.add_succ_toast'));
          releaseQuickPopupA11y(false);
          var source = WS.ui.getSourceByAddToCart();
          // toast方法
          WS.ui.toastShowHandle(
            oldId ? WS.$t('public.toast.update_succ_toast') : WS.$t('public.toast.add_succ_toast')
          );

          if (source === 'clickAddtobagBoughtTogether') {
            WS.ui.cartFn.request && WS.ui.cartFn.request(false, 1);
          } else {
            WS.ui.cartFn.getCartDataInfo && WS.ui.cartFn.getCartDataInfo(2, 1);
          }
          if ($('.ws-main-popupbox-product').attr('listType') === 'social-module') {
            $('.ws-vertical-popupbox-social-module').remove();
          }
          // 加购完成后打开购物车弹窗
          WS.ui.cartFn.handleOpenDrawer && WS.ui.cartFn.handleOpenDrawer('add_bag');
          // 购物车内容置顶
          $('.cart-drawer_container_content-wrapper').animate({
            scrollTop: 0
          }, 500);
          // 隐藏弹窗
          $(".ws-main-popupbox-product").hide();
          // 恢复弹窗底部滚动方法
          WS.ui.popupRecoveryScrollHandle();
          if (res && type === "update") {
            var cartItem = res.items && res.items.length > 0 ? res.items[0] : [];
            var ext2 = JSON.stringify([{ id: cartItem.product_id, sku: cartItem.sku }]);
            WS.stat({
              eid: WS.ui.reportType['click'],
              ext1: WS.ui.reportMap['updateCartItem'],
              ext2
            });
          } else if (res && type === "add") {
            // 加购上报方法
            productPopupFn.addToBagReportHandle(res, 1, source);
          }
          type === 'add' &&
            WS.ui.setAddCartAnimation(
              $('.ws-main-popupbox-product .list-img-active').attr('data-img') ||
                $('.ws-main-popupbox-product .list-img-active .imgbox').attr('src')
            );
          // 判断当为详情页加购物车时，滚动到alsolike区域
          // if (WS.site.page === 'product' && type === 'add') {
          //   setTimeout(function() {
          //     WS.ui.productFn.alsoLikeScrollToHandle();
          //   }, 1500);
          // }
        },
        error: function (error) {
          var popupError = WS.ui.errorMsgMap.baseError;
          try {
            var errorRes = error.response ? JSON.parse(error.response) : {};
            if (errorRes.message) {
              popupError = errorRes.message;
              WS.ui.toastShowHandle(errorRes.message);
            } else {
              WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
            }
          } catch (e) {
            WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
          }
          setQuickPopupStatus($(dom).closest('.ws-main-popupbox-con')[0], popupError);
        }
      });
    },

    // 加购上报方法
    addToBagReportHandle(dataInfo, type, addType) {
      // 判断加购类型，如果加购成功取接口返回数据，没有加购成功取弹窗商品信息
      if ( type == 1 ) {
        var param = {
          "products": {
            id: dataInfo.product_id + '',
            sku: dataInfo.sku,
            title: dataInfo.product_title,
            price: dataInfo.price/100
          }
        }
      } else if ( type == 2 ) {
        var param = {
          "products": {
            id: dataInfo.id + '',
            sku: '0',
            title: dataInfo.title,
            price: dataInfo.price/100
          }
        }
      }
      var ext2 = JSON.stringify(param);
      // 获取dom结构，判断是否为侧边栏购物车加购
      var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
      // 获取页面类型
      var pageType = cartDrawerOpen ? 'cart' : WS.site.page;
      // 判断加购类型
      // 定义加购商品来源
      var addToBagProductFrom = "none";
      pageType === 'product' && (addToBagProductFrom = ($('.ws-main-popupbox-product').attr('handle') || !document.referrer ) ? "none" : WS.cookie.get("ws-pagefrom"));
      // 如果集合携带aid，则上报aid
      var aid = $('.ws-main-popupbox-product').attr('aid');
      var socialPostId = $('.ws-main-popupbox-product').attr('data-social-post-id') || '';
      if (socialPostId) {
        var socialProductId = type == 1
          ? (dataInfo.product_id || $('.ws-main-popupbox-product').attr('data-social-product-id') || $('.ws-main-popupbox-product').attr('productId') || '')
          : (dataInfo.id || $('.ws-main-popupbox-product').attr('data-social-product-id') || $('.ws-main-popupbox-product').attr('productId') || '');
        WS.stat({
          eid: WS.ui.reportType['click'],
          aid: aid || 'empty',
          ext1: 'add_to_bag.social_post',
          ext2: socialProductId ? String(socialProductId) : '',
          ext3: socialPostId,
          ext6: `op=${type == 1 ? 'ok' : 'no_size'}`
        });
        return;
      }
      // 上报
      WS.stat({
        eid: WS.ui.reportType['click'],
        aid: aid || 'empty',
        ext1: WS.ui.productReportMap[addType],
        ext2: ext2,
        ext3: addToBagProductFrom,
        ext4: $('.ws-main-popupbox-product').attr('handle'),
        ext6: `op=${type == 1 ? 'ok' : 'no_size'}`
      });
    }
  };

  WS.ui.productPopupFn = {
    lsCreatePopupHandle: productPopupFn.lsCreatePopupHandle,
    productPopBindEvent: productPopupFn.productPopBindEvent,
    addToBagReportExposureClickHanlde: productPopupFn.addToBagReportExposureClickHanlde,
    switchMergeSkcProduct: productPopupFn.switchMergeSkcProduct,
    handleSelectedVairantPrice: productPopupFn.handleSelectedVairantPrice,
  };
})();

/**
 * 公共方法集合
 * 下拉抽屉 renderBottomDrawer
 * 确认框 genDialogConfirm
 * toast
 */
(function () {
  var productObj = {};
  var toastTimer = '';
  var pickupAddress = null;

  function initResize() {
    if (WS.ui.isThemeEditor()) return;
    var resizeTimer;
    var winWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      if (resizeTimer){
        clearTimeout(resizeTimer);
      }   
      resizeTimer = setTimeout(function(){   
        var resizeWidth = window.innerWidth;
        if (resizeWidth !== winWidth) {
          location.reload();
        }
      }, 200);   
    });
  }

  function reportInteractiveTime() {
    try {
      var perf = window.performance;
      var elapsed = 0;
      if (perf.timeOrigin) {
        elapsed = Math.round(Date.now() - perf.timeOrigin);
      } else if (perf.timing && perf.timing.navigationStart) {
        elapsed = Math.round(Date.now() - perf.timing.navigationStart);
      }
      WS.stat({
        eid: 'load_time',
        ext3: elapsed + '' // 可交互：从导航开始到 init 完成的耗时
      });
    } catch (e) {}
  }

  /**
   * 资源预加载或预取方法
   * @param {Object} urls - {css: [], js: []}
   * @param {string} [mode='preload'] - 'preload' 或 'prefetch'
   */
  function prefetchUrls(urls, mode) {
    var config = urls || (typeof window !== 'undefined' && window.WS_LOAD_URLS);
    if (!config || (!config.css && !config.js)) return;
    mode = mode === 'prefetch' ? 'prefetch' : 'preload';

    var cssList = Array.isArray(config.css) ? config.css : [];
    var jsList = Array.isArray(config.js) ? config.js : [];

    // 使用 <link rel="preload"> 或 <link rel="prefetch"> 优化资源加载
    cssList.forEach(function(href) {
      if (typeof href !== 'string') return;
      if (!document.querySelector('link[rel="' + mode + '"][as="style"][href="' + href + '"]')) {
        var linkEl = document.createElement('link');
        linkEl.setAttribute('rel', mode);
        linkEl.setAttribute('as', 'style');
        linkEl.setAttribute('href', href);
        document.head.appendChild(linkEl);
      }
    });

    jsList.forEach(function(src) {
      if (typeof src !== 'string') return;
      if (!document.querySelector('link[rel="' + mode + '"][as="script"][href="' + src + '"]')) {
        var linkEl = document.createElement('link');
        linkEl.setAttribute('rel', mode);
        linkEl.setAttribute('as', 'script');
        linkEl.setAttribute('href', src);
        document.head.appendChild(linkEl);
      }
    });
  }

  /**
   * 异步并行加载 css 和 js
   * 从 window.WS_ASYNC_LOAD_URLS 读取完整路径，或传入 urls 参数
   * @param {Object} [urls] 可选，格式 { css: [url1, url2], js: [url1, url2] }
   */
  function asyncLoadUrls(urls) {
    var config = urls || (typeof window !== 'undefined' && window.WS_ASYNC_LOAD_URLS);
    if (!config || (!config.css && !config.js)) return;

    var cssList = config.css || [];
    var jsList = config.js || [];
    var allUrls = cssList.concat(jsList);
    allUrls.forEach(function(url) {
      WS.loadUrl(url, function() {});
    });
  }

  function onRequestCollectionData() {
    var collectionDomList = $('.ws-collection');
    if (!collectionDomList.length) return;
    collectionDomList.each(function () {
      var $dom = $(this);
      var collectionHandle = $dom.attr('data-collection-handle');
      if (!collectionHandle) return;
      requestCollectionViewJson(collectionHandle, function(data) {
        renderCollectionList($dom, data);
      });
    });
  }

  function requestCollectionViewJson(collectionHandle, callback) {
    var url = buildCollectionViewUrl(collectionHandle);
    WS.ajax({
      url: url,
      type: 'GET',
      dataType: 'html',
      success: function(res) {
        var data = res && res.record ? res : safeParseJson(res);
        callback && typeof callback === 'function' && callback(data);
      }
    });
  }

  function buildCollectionViewUrl(collectionHandle) {
    var url = `${WS.site.baseUrl}/collections/${encodeURIComponent(collectionHandle)}?view=ws-collection-data`;
    // url += `&preview_theme_id=158080336090`;
    return url;
  }

  function safeParseJson(res) {
    try {
      return typeof res === 'string' ? JSON.parse(res) : res;
    } catch (e) {
      return null;
    }
  }

  function renderCollectionList($dom, data) {
    var productList = data && data.record ? data.record : [];
    if (!productList.length) return;
    WS.ui.collectionFn.handleCollectionData(productList);
    var productListHtml = WS.tmpl(WS.ui.productBlockDom, { record: productList });
    $dom.html(productListHtml);
    WS.ui.globalListExposureHandle();
    WS.ui.initImgLazyloadHandle();
  }
  /**
   * 下拉抽屉
   */
  function renderBottomDrawer(opts = { title: "", slot: "" }, handleType) {
    var drawer = `
        <div class="bottom-drawer" id="bottom-drawer">
        <div class="bottom-drawer_mask" id="bottom-drawer_mask"></div>
          <div class="bottom-drawer_container">
            <div class="bottom-drawer_header">
              <p class="title">${opts.title}</p>
              <img class="close-btn" id="bottom-drawer_close-btn" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/looksky_popup_close_phone2.png?v=1661931061" />
            </div>
            <div class="slot-wrapper">${opts.slot}</div>
          </div>
        </div>
    `;
    $('body').append(drawer);
    $('#bottom-drawer_close-btn').on("click", function () {
      $("#bottom-drawer").remove();
      if (handleType === 'checkout') {
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.reportMap['closeSoldoutDrawer'],
          ext3
        });
      }
    });
    $('#bottom-drawer_mask').on("click", function () {
      $("#bottom-drawer").remove();
      if (handleType === 'checkout') {
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.reportMap['clickSoldOoutOverlay'],
          ext3
        });
      }
    });


    if (handleType === 'checkout') {
      WS.ui.reporterMuti(3, WS.ui.reportMap['checkoutSoldout'], WS.ui.reportType['moduleShow']);
    }
  }

  function genDialogConfirm(opts) {
    opts = {
      // ...opts,
      confirmCallback: opts.confirmCallback || function() {},
      cancelCallback: opts.cancelCallback || function() {},
      showCancelBtn: opts.showCancelBtn != undefined ? opts.showCancelBtn : true,
      title: opts.title || "",
      text: opts.text || "",
      cancelBtnText: opts.cancelBtnText || WS.$t('bag.pop_cancel_btn', '', 1),
      confirmBtnText: opts.confirmBtnText || WS.$t('bag.pop_remove_btn', '', 1),
    };
    var returnFocus = document.activeElement;
    var inerted = [];
    _genConfirm(opts);
   
    function _genConfirm(opts) {
      var dom = `
            <div class="dialog-comfirm_wrapper" id="comfirm-wrapper" role="dialog" aria-modal="true" aria-labelledby="ws-confirm-title">
              <div class="confirm-box">
                <div class="content-box">
                  ${opts.title ? ` <div class="content-title" id="ws-confirm-title">${opts.title}</div>` : `<div class="content-text" id="ws-confirm-title">${opts.text}</div>`}
                  ${opts.title ? `<div class="content-text">${opts.text}</div>` : ''}
                </div>
                <div class="bottom-wrapper">
                  ${opts.showCancelBtn ? `<button type="button" class="dialog-confirm_btn cancel-btn" id="cancel-btn">${opts.cancelBtnText}</button>` : ''}
                  <button type="button" class="dialog-confirm_btn confirm-btn" id="confirm-btn">${opts.confirmBtnText}</button>
                </div>
              </div>
            </div>
        `;
      $("body").append(dom);
      var dialog = document.getElementById('comfirm-wrapper');
      Array.prototype.forEach.call(document.body.children, function(node) {
        if (node !== dialog && !node.hasAttribute('inert')) {
          node.setAttribute('inert', '');
          inerted.push(node);
        }
      });
      var firstButton = dialog.querySelector('button');
      if (firstButton) firstButton.focus();
      dialog.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && opts.showCancelBtn) {
          event.preventDefault();
          dialog.querySelector('#cancel-btn').click();
        } else if (event.key === 'Tab') {
          var buttons = dialog.querySelectorAll('button:not([disabled])');
          if (!buttons.length) return;
          if (event.shiftKey && document.activeElement === buttons[0]) {
            event.preventDefault();
            buttons[buttons.length - 1].focus();
          } else if (!event.shiftKey && document.activeElement === buttons[buttons.length - 1]) {
            event.preventDefault();
            buttons[0].focus();
          }
        }
      });
      _bindConfirmEvent(opts);
    }

    function _bindConfirmEvent(opts) {
      function closeConfirm() {
        $('#comfirm-wrapper').remove();
        inerted.forEach(function(node) { node.removeAttribute('inert'); });
        inerted = [];
        if (returnFocus && returnFocus.isConnected) returnFocus.focus();
      }
      $("#cancel-btn").on("click", async function () {
        if (
          opts.cancelCallback &&
          typeof opts.cancelCallback === "function"
        ) {
          await opts.cancelCallback(2);
        }
        closeConfirm();
      });
      $("#confirm-btn").on("click", async function () {
        if (
          opts.confirmCallback &&
          typeof opts.confirmCallback === "function"
        ) {
          await opts.confirmCallback(1);
        }
        closeConfirm();
      });
    }
  }

  function createPopup(className, innerHtml) {
    var popup = `
      <div class="ws-main-popupbox popupbox_${className}">
        <div class="ws-main-popupbox-overlay"></div>
        <div class="ws-main-popupbox-con common-popup-container popupbox-container_${className}">
          <img class="common-popup-close title-close popupbox-${className}_close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls_icon_close_white_2x_199b037d-e6bb-4ac2-b041-85247b544b1e.png?v=1665736507"/>
          <div class="popupbox-inner_${className}">
            ${innerHtml}
          </div>
        </div>
      </div>
    `;
    return popup;
  }

  // toast方法
  function toastShowHandle(text, time = 2000) {
    if (toastTimer) {
      clearTimeout(toastTimer);
      $(".ws-main-toast-tip-popup").remove();
    }
    var main_toast = document.createElement("div");
    main_toast.className = "ws-main-toast-tip-popup";
    main_toast.innerHTML = text;
    document.body.appendChild(main_toast);
    $(".ws-main-toast-tip-popup").show();
    toastTimer = setTimeout(() => {
      $(".ws-main-toast-tip-popup").remove();
    }, time);
  }

  // loading打开方法
  function loadingPopShow() {
    // 插入loading
    if (!$('.ws-main-loading-img-popup').length) {
      var loadingHtml = `
        <div class="ws-main-loading-img-popup">
          <div class="loading-img-popup-con">
            <img class="loading-img" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-loading.png?v=1772791107" />
          </div>
        </div>
      `;
      $("body").append(loadingHtml);
    } else {
      $('.ws-main-loading-img-popup').show();
    }
  }

  // loading隐藏方法
  function loadingPopHide() {
    // 删除loading
    $(".ws-main-loading-img-popup").hide();
  }

  // 按钮loading添加方法
  function loadingBtnShow(dom, type = 1) {
    // type: 1:往按钮里面添加load图片，2:load图片替换按钮内容
    if (dom.find('.main-button-loading').length) return;
    var load = `<img class="main-button-loading" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/button_loading.png?v=1660287889">`;
    if (type === 1) {
      // 尾部添加
      $(dom).append(load);
      // 添加距离样式
      $('.main-button-loading').attr('style', 'margin-left: 8px;');
    } else {
      // 整体替换
      $(dom).html(load);
    }
  }

  // 按钮loading去除方法
  function loadingBtnHide(dom, oldDom) {
    var loadingDom = $(dom).find('.main-button-loading');
    loadingDom && loadingDom.remove();
    // 判断如果要还原成原来的dom
    if (oldDom) {
      $(dom).html(oldDom);
    }
  }

  // copy方法
  function copyToClip(content, toast = '') {
    var copy = document.createElement("input");
    copy.setAttribute("value", content);
    copy.setAttribute('style', 'position: fixed;left: 0px;bottom: 0px;transform: translateX(-1000px);');
    document.body.appendChild(copy);
    copy.select();
    document.execCommand("copy");
    document.body.removeChild(copy);
    // 复制成功toast方法
    if (toast) {
      toastShowHandle(toast);
    } else {
      toastShowHandle(WS.$t('public.toast.copied_successfully'));
    }
  }

  /**
   * 文本 Read more 初始化（测量 + 二分截断）
   * 仅负责“初始渲染/重新计算”，展开/收起事件由调用方绑定
   * @param {Object} opts
   * @param {function(): boolean} [opts.htmlExpandIf] 与 fullHtmlSourceSelector 同用时，返回 true 才注入 HTML（否则用纯文本）
   */
  function initTextReadMore(opts) {
    opts = opts || {};
    var blockSelector = opts.blockSelector;
    var wrapSelector = opts.wrapSelector;
    var textSelector = opts.textSelector;
    var readMoreSelector = opts.readMoreSelector;
    var collapseSelector = opts.collapseSelector;

    if (!blockSelector || !wrapSelector || !textSelector || !readMoreSelector || !collapseSelector) return;

    var maxLines = Number(opts.maxLines || 3);
    var lineHeightFallbackMultiplier = Number(opts.lineHeightFallbackMultiplier || 1.4);
    var fullTextAttr = opts.fullTextAttr || 'data-full-text';
    var fullHtmlSourceSelector = opts.fullHtmlSourceSelector;
    var htmlExpandIf = typeof opts.htmlExpandIf === 'function' ? opts.htmlExpandIf : null;

    function resolveReadMoreHtmlSrc($block) {
      if (!fullHtmlSourceSelector) return $();
      if (htmlExpandIf && !htmlExpandIf()) return $();
      return $block.find(fullHtmlSourceSelector);
    }

    if (!WS.ui._textReadMoreMeasurer) {
      WS.ui._textReadMoreMeasurer = $('<div class="ws-short-desc-measurer" aria-hidden="true"></div>');
      $('body').append(WS.ui._textReadMoreMeasurer);
    }
    var $measurer = WS.ui._textReadMoreMeasurer;

    function normalizeText(text) {
      return (text || '').replace(/\s+/g, ' ').trim();
    }

    function trimWord(text, len) {
      var sliced = text.slice(0, len);
      var lastSpace = sliced.lastIndexOf(' ');
      if (lastSpace > Math.floor(len * 0.6)) return sliced.slice(0, lastSpace);
      return sliced;
    }

    /** 避免正文已以 … / ... 结尾时与末尾统一追加的 "..." 叠成 "... ..." */
    function stripTrailingEllipsisForSuffix(text) {
      var s = (text || '').trim();
      s = s.replace(/\s*(?:\.{3,}|…)\s*$/, '');
      return s.trim();
    }

    function measureHeight($ref, text, width) {
      $measurer.css({
        position: 'fixed',
        left: '-9999px',
        top: '0',
        visibility: 'hidden',
        width: width + 'px',
        fontSize: $ref.css('font-size'),
        lineHeight: $ref.css('line-height'),
        fontFamily: $ref.css('font-family'),
        fontWeight: $ref.css('font-weight'),
        letterSpacing: $ref.css('letter-spacing'),
        wordBreak: 'break-word',
        whiteSpace: 'normal'
      });
      $measurer.text(text);
      return $measurer[0].getBoundingClientRect().height;
    }

    $(blockSelector).each(function () {
      var $block = $(this);
      var $wrap = $block.find(wrapSelector);
      var $text = $block.find(textSelector);
      var $readMore = $block.find(readMoreSelector);
      var $collapse = $block.find(collapseSelector);
      if (!$wrap.length || !$text.length || !$readMore.length || !$collapse.length) return;

      var forceCollapse = $block.attr('data-ws-readmore-force-collapse') === '1';
      // resize 重算时保留已展开块；点击 Less 会带 forceCollapse 对本块强制重新截断
      if (
        !forceCollapse &&
        $text.attr('data-collapsed') === 'false' &&
        $collapse.is(':visible')
      ) {
        return;
      }

      var fullText = $block.attr(fullTextAttr);
      if (!fullText) {
        fullText = normalizeText($text.text());
        $block.attr(fullTextAttr, fullText);
      }
      if (!fullText) return;

      var wrapWidth = Math.floor($wrap.width());
      if (!wrapWidth) return;

      var lineHeight = parseFloat($text.css('line-height'));
      if (!lineHeight || Number.isNaN(lineHeight)) {
        lineHeight = parseFloat($block.css('font-size')) * lineHeightFallbackMultiplier;
      }
      var maxHeight = lineHeight * maxLines + 0.5;
      var readMoreLabel = normalizeText($readMore.text());

      var fullHeight = measureHeight($text, fullText, wrapWidth);
      if (fullHeight <= maxHeight) {
        var $htmlSrcShort = resolveReadMoreHtmlSrc($block);
        if ($htmlSrcShort.length) {
          $text.html($htmlSrcShort.html()).attr('data-collapsed', 'false');
        } else {
          $text.text(fullText).attr('data-collapsed', 'false');
        }
        $readMore.hide().attr('aria-expanded', 'false');
        $collapse.hide().attr('aria-expanded', 'false');
        $wrap.attr('data-ws-readmore-ready', '1');
        if (forceCollapse) $block.removeAttr('data-ws-readmore-force-collapse');
        return;
      }

      var left = 0;
      var right = fullText.length;
      var best = '';
      while (left <= right) {
        var mid = Math.floor((left + right) / 2);
        var base = normalizeText(trimWord(fullText, mid));
        var candidate = (base ? (base + '... ' + readMoreLabel) : readMoreLabel);
        var h = measureHeight($text, candidate, wrapWidth);
        if (h <= maxHeight) {
          best = base;
          left = mid + 1;
        } else {
          right = mid - 1;
        }
      }

      var rawBase = best ? best : fullText;
      var displayBase = stripTrailingEllipsisForSuffix(rawBase);
      $text.text(displayBase + '...').attr('data-collapsed', 'true');
      $readMore.show().attr('aria-expanded', 'false');
      $collapse.hide().attr('aria-expanded', 'false');
      $wrap.attr('data-ws-readmore-ready', '1');
      if (forceCollapse) $block.removeAttr('data-ws-readmore-force-collapse');
    });
  }

  /**
   * Read more 展开/收起事件 + resize 重算
   * - 与 initTextReadMore 配套使用
   * - 事件使用 namespace，重复调用会自动覆盖旧绑定
   * @param {Object} opts
   * @param {function(): boolean} [opts.htmlExpandIf] 与 fullHtmlSourceSelector 同用时，每次点击 Read more 时若返回 false 则展开为纯文本
   */
  function bindTextReadMoreEvents(opts) {
    opts = opts || {};
    var blockSelector = opts.blockSelector;
    var textSelector = opts.textSelector;
    var readMoreSelector = opts.readMoreSelector;
    var collapseSelector = opts.collapseSelector;
    var fullTextAttr = opts.fullTextAttr || 'data-full-text';
    var fullHtmlSourceSelector = opts.fullHtmlSourceSelector;
    var htmlExpandIf = typeof opts.htmlExpandIf === 'function' ? opts.htmlExpandIf : null;
    var ns = opts.eventNamespace ? String(opts.eventNamespace).replace(/^\./, '') : 'wsTextReadMore';
    var resizeDelay = Number(opts.resizeDelay != null ? opts.resizeDelay : 180);
    var onRecalc = typeof opts.onRecalc === 'function' ? opts.onRecalc : function () {};

    if (!blockSelector || !textSelector || !readMoreSelector || !collapseSelector) return;

    // click: read more
    $(document)
      .off('click.' + ns, readMoreSelector)
      .on('click.' + ns, readMoreSelector, function () {
        var $btn = $(this);
        var $block = $btn.closest(blockSelector);
        if (!$block.length) return;
        var $text = $block.find(textSelector);
        var $collapse = $block.find(collapseSelector);
        var fullText = $block.attr(fullTextAttr) || '';
        var $htmlSrc = $();
        if (fullHtmlSourceSelector && (!htmlExpandIf || htmlExpandIf())) {
          $htmlSrc = $block.find(fullHtmlSourceSelector);
        }
        if ($htmlSrc.length) {
          $text.html($htmlSrc.html()).attr('data-collapsed', 'false');
        } else {
          $text.text(fullText).attr('data-collapsed', 'false');
        }
        $btn.hide().attr('aria-expanded', 'true');
        $collapse.show().attr('aria-expanded', 'true');
      });

    // click: collapse
    $(document)
      .off('click.' + ns, collapseSelector)
      .on('click.' + ns, collapseSelector, function () {
        var $btn = $(this);
        var $block = $btn.closest(blockSelector);
        if (!$block.length) return;
        $block.attr('data-ws-readmore-force-collapse', '1');
        onRecalc();
        $block.removeAttr('data-ws-readmore-force-collapse');
        $btn.hide().attr('aria-expanded', 'false');
        $block.find(readMoreSelector).show().attr('aria-expanded', 'false');
      });

    // resize debounce（按 ns 隔离）
    if (!WS.ui._textReadMoreResizeTimers) WS.ui._textReadMoreResizeTimers = {};
    $(window).off('resize.' + ns).on('resize.' + ns, function () {
      clearTimeout(WS.ui._textReadMoreResizeTimers[ns]);
      WS.ui._textReadMoreResizeTimers[ns] = setTimeout(function () {
        onRecalc();
      }, resizeDelay);
    });
  }

  /**
   * 为 initTextReadMore / bindTextReadMoreEvents 生成「展开时注入隐藏节点 HTML」的配置片段。
   * 每个业务模块各自传 sourceSelector + when（如闭包读本模块的 { expandAsHtml }），互不共用开关；不传本片段则默认纯文本。
   * @param {Object} cfg
   * @param {string} [cfg.sourceSelector] 相对 read-more 块（block）内的隐藏 HTML 容器选择器
   * @param {string} [cfg.fullHtmlSourceSelector] 与 sourceSelector 二选一
   * @param {boolean|function(): boolean} [cfg.when=true] false 或返回 false 时不走 HTML，仅用 data-full-text 纯文本
   * @returns {Object} 含 fullHtmlSourceSelector、htmlExpandIf；无有效选择器时返回 {}
   * @example
   * var myReadMore = { expandAsHtml: false };
   * WS.ui.initTextReadMore($.extend({ blockSelector: '.js-foo', ... },
   *   WS.ui.makeTextReadMoreHtmlOpts({ sourceSelector: '.js-foo__html', when: function () { return myReadMore.expandAsHtml; } })));
   */
  function makeTextReadMoreHtmlOpts(cfg) {
    cfg = cfg || {};
    var sel = cfg.sourceSelector || cfg.fullHtmlSourceSelector;
    if (!sel || typeof sel !== 'string') return {};
    var when = cfg.when;
    if (when === undefined) when = true;
    return {
      fullHtmlSourceSelector: sel,
      htmlExpandIf:
        typeof when === 'function'
          ? when
          : function () {
              return !!when;
            }
    };
  }

  // time操作方法
  /**
   * 获取单天日期日期格式 例如：Apr.29,2022
   * @param {Number} timestamp 时间搓
   * @example
   * WS.ui.singleDayDateFormat(1651219815005);
   */
  function singleDayDateFormat(timestamp, status = true) {
    // 传值取传值的时间搓，没有传值取当前时间搓
    var getTimestamp = timestamp || new Date().getTime();
    // 获取对应时间参数
    var time = new Date(getTimestamp);
    var year = time.getFullYear();
    var month = getEnMonth(time.getMonth());
    var monthNum = time.getMonth()+1 < 10 ? `0${time.getMonth()+1}` : time.getMonth()+1;
    var day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
    if (status) {
      return month + '.' + day + ',' + year;
    } else {
      return monthNum + '/' + day + '/' + year;
    }
  }

  /**
   * 获取范围日期格式
   * 同年同月份日期范围 例如：Feb.20-22,2022
   * 同年不同月日期范围 例如：Feb.22-Mar.02,2022
   * 不同年日期范围 例如：Dec.30,2021-Jan.01,2022
   * @param {Number} start 时间搓
   * * @param {Number} end 时间搓
   * @example
   * 同年同月份日期范围 WS.ui.scopeDayDateFormat(1649493851965, 1651221851965);
   * 同年不同月日期范围 WS.ui.scopeDayDateFormat(1649493851965, 1661221851965);
   * 不同年日期范围 WS.ui.scopeDayDateFormat(1649493851965, 1761221851965);
   */
  function scopeDayDateFormat(start, end) {
    if (start && end) {
      // 获取对应开始和结束时间的对应参数
      // 开始
      var startTime = new Date(start);
      var startYear = startTime.getFullYear();
      var startMonth = getEnMonth(startTime.getMonth());
      var startDay = startTime.getDate() < 10 ? '0' + startTime.getDate() : startTime.getDate();
      // 结束
      var endTime = new Date(end);
      var endYear = endTime.getFullYear();
      var endMonth = getEnMonth(endTime.getMonth());
      var endDay = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
      // 判断范围状态
      if (startYear == endYear && startMonth == endMonth) {
        return startMonth + '.' + startDay + '-' + endDay + ',' + startYear;
      } else if (startYear == endYear && startMonth != endMonth) {
        return startMonth + '.' + startDay + '-' + endMonth + '.' + endDay + ',' + startYear;
      } else if (startYear != endYear && startMonth != endMonth) {
        return startMonth + '.' + startDay + ',' + startYear + '-' + endMonth + '.' + endDay + ',' + endYear;
      }
    }
  }

  /**
   * 获取英文月份
   * @param {Number} month 月份
   * @example
   * WS.time.getEnMonth(3); // 获取英文月份
   */
  function getEnMonth(month) {
    if (month) {
      var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return monthList[month];
    }
  }
 
  /**
   * 上报数据
   * 多条商品数据上报 
   * @param {*} status 1在售商品 2售罄商品 3checout弹窗校验商品状态-售罄、不够库存 4购物车点击bought together
   * @param {*} opts 
   */
  function reporterMuti(status, ext1, reportType, getCode = '', extInfo = '') {
    var params = {};
    if (status === 1) {
      var arr = WS.ui.getOnSellItems() || [];
      params.ext2 = JSON.stringify({ products: arr });
      params.ext3 = JSON.stringify(WS.ui.getCartInfo() || {});
      params.ext4 = getCode;
      params.ext5 = extInfo;
    } else if (status === 2) {
      var arr = WS.ui.getSoldoutItems() || [];
      params.ext2 = JSON.stringify({ products: arr });
    } else if (status === 3) {
      var arr = WS.ui.getSoldoutCheckout() || [];
      params.ext2 = JSON.stringify({ products: arr });
    } else if (status === 4) {
      var arr = WS.ui.getOnSellItems() || [];
      params.ext2 = JSON.stringify({ products: arr });
      params.ext3 = getCode;
      params.ext4 = extInfo;
    }
    var onSellItems = getOnSellItems();
    var soldoutItems = getSoldoutItems();
    var onSellLen = onSellItems.length;
    var soldoutLen = soldoutItems.length;
    if (onSellLen && !soldoutLen) {
      params.ext6 = 'bag=normal';
    }
    if (onSellLen && soldoutLen) {
      params.ext6 = 'bag=has_sold_out';
    }
    if (!onSellLen && soldoutLen) {
      params.ext6 = 'bag=only_sold_out';
    }
    WS.stat({
      eid: reportType,
      ext1,
      ...params
    });
  }

  /**
   * 上报类型
   * 单条商品数据上报
   * isSoldout 区分在售和售罄上报字段
   */
  function reporterSingle(ext1, self) {
    var { isSoldout, quantity, price, ...rest } = WS.ui.getCartItem(self) || {};
    var params = {
      ...rest
    };
    switch(ext1) {
      case WS.ui.reportMap['changeSku']:
        ext1 = isSoldout ? WS.ui.reportMap['changeSkuBySoldout'] : WS.ui.reportMap['changeSkuByOnSell'];
        break;
      case WS.ui.reportMap['increaseCartItemQuantity']:
      case WS.ui.reportMap['minusCartItemQuantity']:
        params.quantity = quantity;
        break;  
      case WS.ui.reportMap['delCartItem']:
        ext1 = isSoldout ? WS.ui.reportMap['delCartItemBySoldout'] : WS.ui.reportMap['delCartItemByOnSell'];
        break;
      case WS.ui.reportMap['visitProductDetails']:
        ext1 = isSoldout ? WS.ui.reportMap['visitProductDetailsBySoldout'] : WS.ui.reportMap['visitProductDetailsByOnSell'];
        params.quantity = quantity;
        params.price = price;
        break;      
      default:
        break;  
    }
    var productJson = {
      "products": params
    }
    WS.stat( {
      eid: WS.ui.reportType['click'],
      ext1,
      ext2: JSON.stringify(productJson)
    });
  }

  /**
   * 商品集合点击全局上报
   */
  function reporterCollection(ext1, self) {
    var moduleType = $(self).parents('.ws-featured-collection-listing').attr('data-title');
    var curProductBlock = $(self).parents('.ws-product-block');
    var index = curProductBlock.attr('stat-index');
    // 商品信息
    // 处理sku里面的颜色
    var itemSku = curProductBlock.attr('stat-module-show-color');
    var itemCurSku = curProductBlock.attr('stat-module-show-selected-color');
    var color = itemCurSku != undefined && itemCurSku != 'undefined' ? itemCurSku.split('-')[1] : itemSku.split('-')[1];
    var param = {
      "products": {
        id: curProductBlock.attr('stat-module-show-id') + '',
        title: curProductBlock.attr('stat-module-show-title'),
        price: curProductBlock.attr('stat-module-show-price')/100,
        color: color,
      }
    };
    // 如果集合携带aid，则上报aid
    var aid = curProductBlock.attr('stat-module-show-aid');
    WS.stat({
      eid: WS.ui.reportType['click'],
      aid: aid || 'empty',
      ext1,
      ext2: JSON.stringify(param || []),
      ext3: `pos=${index}`,
      ext4: moduleType
    }, null, null, { useBeacon: true });
  }

  /**
   * 全局列表集合曝光
   */
  function globalListExposureHandle() {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        WS.ui.toggleVariantsScrollButtons && WS.ui.toggleVariantsScrollButtons();
      });
    });
    WS.ui.initElementExposure('[stat-module-show]', {
      id: 'module-show-id',
      aid: 'module-show-aid',
      index: 'index',
      title: 'module-show-title',
      price: 'module-show-price',
      color: 'module-show-color',
      currentColor: 'module-show-selected-color'
    }, function(data) {
      if (!data.length) return;
      // 购物车数量
      var isEmptyCart = !$('#cart-sum').text();
      // 获取dom结构，判断是否为侧边栏购物车加购
      var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
      // 获取页面类型
      var pageType = cartDrawerOpen ? 'cart' : WS.site.page;
      // 判断加购类型
      var showType = "";
      var collectionTitle = $(data[0].htmlDom).parents('.ws-featured-collection-listing').attr('data-title');
      switch (pageType) {
        case 'index':
          showType = WS.ui.homeReportMap['showProductHome'];
          break;
        case 'search':
          showType = WS.ui.searchReportMap['showProductSearch'];
          break;
        case 'collection':
          // 集合页判断类型
          if ($(data[0].htmlDom).parents('.box-recently-viewed').length > 0) {
            showType = WS.ui.collectionReportMap['showRecentlyViewedCollection'];
          } else if ($(data[0].htmlDom).parents('.box-collection-list').length > 0) {
            showType = WS.ui.collectionReportMap['showBottomProductCollection'];
          } else {
            showType = WS.ui.collectionReportMap['showProductCollection'];
          }
          break;
        case 'product':
          var type = $(data[0].htmlDom).parents('.ws-featured-collection-listing').attr('data-title');
          if (type === 'complete_the_look') {
            showType = WS.ui.productReportMap['showProductPairItWith'];
          } else {
            showType = WS.ui.productReportMap['showProductAlsoLike'];
          }
          break;
        case 'cart':
          showType = isEmptyCart ? WS.ui.reportMap['showBestTogether'] : WS.ui.reportMap['showBoughtTogether'];
          collectionTitle = $('.cart-drawer_container').find('.ws-featured-collection-listing').attr('data-title');
          break;
      }
      var list = data.map(item => {
        var colorText = item.currentColor != undefined && item.currentColor != 'undefined' ? item.currentColor.split('-')[1] : item.color.split('-')[1];
        var param = {
          "products": {
            id: item.id + '',
            title: item.title,
            price: item.price/100,
            color: colorText,
          }
        }
        return {
          eid: WS.ui.reportType['moduleShow'],
          aid: item.aid || 'empty',
          ext1: showType,
          ext2: JSON.stringify(param),
          ext3: `pos=${item.index}`,
          ext4: collectionTitle
        }
      });
      WS.stat(list);
    });
  }

  /**
   * 初始化曝光元素
   * @param {*} dom 
   */
  function initElementExposure(obTarget, opts, callback, root = '') {
    var config = {
      // threshold属性决定了什么时候触发回调函数。它是一个数组，每个成员都是一个门槛值，默认为[0]，即交叉比例（intersectionRatio）达到0时触发回调函数,目标元素50% 可见时，会触发callback回调。
      threshold: [0.5],
      // rootMargin: "900px 0px 0px 0px" 
    }
    // var cacheList = JSON.parse(sessionStorage.getItem('_productExposureList_') || 'null') || [];
    var reportList = [];
    // root属性指定目标元素所在的容器节点（即根元素）。注意，容器元素必须是目标元素的祖先节点。
    if (root) {
      config.root = root;
    }
    function _callback (entries, observer) {
      for (let i = 0, len = entries.length; i < len; i++) {
        var entry = entries[i];
        var id = $(entry.target).attr('stat-module-show-id');
        var optsData = {};
        for (let i in opts) {
          optsData[i] = $(entry.target).attr(`stat-${opts[i]}`);
        }
        optsData.htmlDom = $(entry.target);
        // 存在stat-comlete或者cacheList不重复曝光
        if (entry.target.classList.contains("stat-complete")) return;
        // 回调会触发2次，一次是目标刚进入视口，一次是完成离开视口，IntersectionObserverEntry对象的isIntersecting属性解决，通过这个属性判断是否是开始可见。 
        if (entry.isIntersecting) {
          entry.target.classList.add("stat-complete");
          reportList.push(optsData);
          observer.unobserve(entry.target);
        }
      }
      if (reportList.length >= 10) {
        _handleReport();
        return;
      }

      setTimeout(() => {
        _handleReport();
      }, 500);

      function _handleReport() {
        callback && typeof callback === "function" && callback(reportList);
        // var arr = Array.from(new Set(cacheList.concat(reportList.map(item => item.id))));
        // sessionStorage.setItem('_productExposureList_', JSON.stringify(arr));
        reportList = [];
      }
    };

    let collectionAll = $('.ws-featured-collection-listing') || [];
    try {
      collectionAll.length > 0 && collectionAll.forEach((item, index) => {
        let obTargets = item.querySelectorAll(obTarget);
        // 开始观察
        obTargets.length > 0 && obTargets.forEach((item2, index2) => {
          $(item2).attr('stat-index', index2+1);
          if (!$(item2).hasClass('stat-complete')) {
            // io.observe(item);
            WS.observe.intersection(item2, _callback, config)
          }
        })
      })
    } catch (error) {
      
    }
  }

  // 图片懒加载公共方法
  function initImgLazyloadHandle() {
    var bottomPx = WS.screenHeight > 0 ? Math.round(WS.screenHeight * 2) : 1600;
    var rootMarginRight = 800;

    var config = {
      // threshold属性决定了什么时候触发回调函数。它是一个数组，每个成员都是一个门槛值，默认为[0]，即交叉比例（intersectionRatio）达到0时触发回调函数,目标元素50% 可见时，会触发callback回调。
      threshold: [0],
      rootMargin: `0px 0px ${bottomPx}px ${rootMarginRight}px`
    }

    // 获取所有拥有data-lazyload-src属性的img元素
    let lazyImages = document.querySelectorAll('img[data-lazyload-src]');
    // 开始观察
    lazyImages.length > 0 && lazyImages.forEach((item) => {
      WS.observe.intersection(item, _callback, config)
    })  

    function _callback (entries, observer) {
      for (let i = 0, len = entries.length; i < len; i++) {
        var entry = entries[i];
        // 存在stat-comlete或者cacheList不重复曝光
        if (entry.target.classList.contains("img-lazyload-complete")) return;
        // 回调会触发2次，一次是目标刚进入视口，一次是完成离开视口，IntersectionObserverEntry对象的isIntersecting属性解决，通过这个属性判断是否是开始可见。 
        if (entry.isIntersecting) {
          entry.target.classList.add("img-lazyload-complete");
          observer.unobserve(entry.target);
          // target属性为被观察的目标元素
          _imageLoad(entry.target);
        }
      }
    };

    // 定义img元素的src属性赋值方法，实现显示正确图片
    function _imageLoad (image) {
      // 将img元素的data-lazyload-src属性值设置给src属性
      image.setAttribute('src', image.getAttribute('data-lazyload-src'));
      // 监听图片加载事件
      image.addEventListener('load', function() {
        // 删除已加载img元素的data-lazyload-src属性
        image.removeAttribute("data-lazyload-src");
      })
    }
  }

  function setFirstView() {
    var img = document.querySelector(".cart-image_wrapper .cart-image") || null; 
    if (img) {
      if (img.complete) {
        _report();
      } else {
        img.onload = img.onerror = function() {
          img.onerror = img.onload = null;
          _report();
        };
      }
    } 
    function _report() {
      if (window.imgReport && window.performance) {
        window.imgReport({
          eid: "load_time",
          ext2: (Date.now() - window.performance.timing.navigationStart) + ''
        });
      }
    }
  }
  function setInteractive() {
    if (window.imgReport && window.performance) {
      window.imgReport({
        eid: "load_time",
        ext3: (Date.now() - window.performance.timing.navigationStart) + ''
      });
    }
  }

  /**
   * 加购动画
   * 目标点需每次 getBoundingClientRect（与 position:fixed 一致用视口坐标），勿用页面加载时缓存的 cart 位置
   */
  function setAddCartAnimation(productImg, callback) {
    var flyDom = '.add-cart-flyer';
    $(flyDom).length && $(flyDom).remove();
    if (!productImg) {
      typeof callback === 'function' && callback();
      return;
    }
    var cartEl = window.innerWidth < 750 ? document.querySelector('.ws-cart-bag__phone') : document.querySelector('.ws-cart-bag__pc');
    var cartBagRect = cartEl && cartEl.getBoundingClientRect();
    if (!cartBagRect || !cartBagRect.width) {
      typeof callback === 'function' && callback();
      return;
    }

    var imgBox = $('<img class="add-cart-flyer" alt="" />').attr('src', productImg);
    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    imgBox.css({
      left: vw / 2 - 25,
      top: vh / 2,
    });
    $('body').append(imgBox);
    var imgRect = imgBox[0].getBoundingClientRect();
    if (!imgRect.width && !imgRect.height) {
      imgRect = { left: vw / 2 - 25, top: vh / 2, width: 50, height: 65 };
    }
    var x = cartBagRect.left + cartBagRect.width - (imgRect.left + imgRect.width);
    var y = imgRect.top - cartBagRect.top;
    function setAni() {
      imgBox.css({
        transform: 'translate3d(' + x + 'px,-' + y + 'px, 0px)',
        transition: 'all 1.5s ease',
      });
      setTimeout(function () {
        typeof callback === 'function' && callback();
        $(flyDom).length && $(flyDom).remove();
      }, 1000);
    }
    window.requestAnimationFrame(setAni);
  }

  function getCartItem(self) {
    var target = $(self).parents('.cart-item_container');
    var itemData =
    JSON.parse(target.find('.js-product-json').text() || 'null') || {};
    return {
      id: itemData.productId + '',  
      sku: itemData.sku, 
      isSoldout: itemData.isSoldout,
      quantity: itemData.quantity,
      price: itemData.price,
      color: itemData.sku.split('-')[1],
    };
  }

  function getSoldoutCheckout() {
    var soldoutItemsCheckout = $("#cart-slot").find(".cart-item_container");
    var len = soldoutItemsCheckout.length;
    var arr = [];
    if (len > 0) {
      for (var i = 0; i < len; i++) {
        var itemData =
        JSON.parse($(soldoutItemsCheckout[i]).find('.js-product-json').text() || 'null') || {};
        arr.push({
          id: itemData.productId,
          sku: itemData.sku,
          quantity: itemData.quantity
        });
      }
    }
    return arr;
  }

  function getOnSellItems() {
    var onSellItems = $("#on-sell-items").find(".cart-item_container");
    var onSellItemsLen = onSellItems.length;
    var arr = [];
    if (onSellItemsLen > 0) {
      for (var i = 0; i < onSellItemsLen; i++) {
        var onSellItemData =
        JSON.parse($(onSellItems[i]).find('.js-product-json').text() || 'null') || {};
        arr.push({
          id: onSellItemData.productId,
          sku: onSellItemData.sku,
          price: onSellItemData.price,
          num: onSellItemData.quantity,
        });
      }
    }
    return arr;
  }

  /**
		 * 获取购物车checkout
		 */
   function getCartInfo() {
    var currency = $('#cart-currency').text();
    var total = $('#cart-total').text();
    var sum = $('#cart-sum').text();
    return {
      currency,
      total,
      sum
    }
  }

  function getSoldoutItems() {
    var soldoutItems = $("#sold-out-items").find(".cart-item_container");
    var soldoutLen = soldoutItems.length;
    var arr = [];
    if (soldoutLen > 0) {
      for (var i = 0; i < soldoutLen; i++) {
        var soldoutItemData =
        JSON.parse($(soldoutItems[i]).find('.js-product-json').text() || 'null') || {};
        arr.push({
          id: soldoutItemData.id,
          sku: soldoutItemData.sku
        });
      }
    }
    return arr;
  }

  function getSourceByAddToCart() {
    // 获取dom结构，判断是否为侧边栏购物车加购
    var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
    var listType = $('.ws-main-popupbox-product').attr('listType');
    // 获取页面类型
    var pageType = cartDrawerOpen ? 'cart' : WS.site.page;
    // 判断加购类型
    var addType = "";
    // 定义加购商品来源
    switch (pageType) {
      case 'index':
        addType = 'clickAddtobagHomeCollection';
        break;
      case 'search':
        addType = 'clickAddtobagSearch';
        break;
      case 'collection':
        if (listType == 'recently_viewed') {
          addType = 'clickAddtobagRecentlyViewed';
        } else if (listType == 'bottom_collection') {
          addType = 'clickAddtobagBottomCollection';
        } else {
          addType = 'clickAddtobagCollection';
        }
        break;
      case 'product':
        addType = $('.ws-main-popupbox-product').attr('handle') ? 'clickAddtobagAlsoLike' : 'clickAddtobagProductPop';
        break;
      case 'cart':
        addType = 'clickAddtobagBoughtTogether';
        break;
    }
    return addType;
  }

  function reporterCartState() {
    var onSellItems = getOnSellItems();
    var soldoutItems = getSoldoutItems();
    var onSellLen = onSellItems.length;
    var soldoutLen = soldoutItems.length;
    var reportType = WS.ui.reportMap['cartStateError'];
    if (!onSellLen && !soldoutLen) {
      reportType = WS.ui.reportMap['cartStateEmpty'];
    }
    if (onSellLen && !soldoutLen) {
      reportType = WS.ui.reportMap['cartStateNormal'];
    }
    if (onSellLen && soldoutLen) {
      reportType = WS.ui.reportMap['cartStateHasSoldOut'];
    }
    if (!onSellLen && soldoutLen) {
      reportType = WS.ui.reportMap['cartStateOnlySoldOut'];
    }

    WS.stat({
      eid: WS.ui.reportType['custom'],
      ext1: reportType
    })
  }

  function handleBuyitnowBtn() {
    if ($('.shopify-payment-button__more-options')) {
      $('.shopify-payment-button__more-options').click();
    } else if ($('.shopify-payment-button__button').html() === 'Buy it now') {
      $('.shopify-payment-button__button').click();
    } else {
      $('.shopify-cleanslate div').click();
    }
  }
  
  // 触发弹窗底部页面禁止滑动
  function popupNoScrollHandle() {
    $('body').css('overflow', 'hidden');
    // 因为设置overflow后，顶部吸顶的头部sticky会被隐藏，所以更改为fixed
    var headerDom = $('#shopify-section-westyle-header').find('.ws-header-model-con');
    WS.setData('isHeaderFixedTop', headerDom.hasClass('white-bg-header') ? 1 : 0);
    headerDom.addClass('white-bg-header');
  }

  // 关闭弹窗底部页面恢复滑动
  function popupRecoveryScrollHandle(removeHeadStyle) {
    $('body').css('overflow', 'auto');
    document.body.style.overflow = '';
    var headerDom = $('#shopify-section-westyle-header').find('.ws-header-model-con');
    var isHeaderFixedTop = WS.getData('isHeaderFixedTop') || 0;
    if (isHeaderFixedTop) {
      headerDom.addClass('white-bg-header')
    } else {
      // 这2个页面有header滑动效果才需要移除样式, 特殊处理汉堡页内弹窗的场景
      if (WS.site.page === 'index' || location.href.indexOf("pages/about-us") > 0) {
        if (removeHeadStyle) {
          headerDom.removeClass('white-bg-header');
          return;
        }
      }
    }
  }

  /**
   * 
   * @param {*} tests String、Object、Array
   * 多个，array: WS.ui.initAbt(['aatest']);
   * 单个，string: WS.ui.initAbt('aatest');
   * 多个，object: 
   * WS.ui.initAbt({
      'also-like': {
        'a': 0.5,
        'b': 0.5
      },
      'buy-it-now': {
        'a': 10,
        'b': 30,
        'c': 20
      },
      'custom': {
        'a': 0.1,
        'b': 0.2,
        'c': 0.3,
        'd': 0.4
      }
    });
   */
    function initAbt(tests) {
      var abtKey = {};
      var plan = {
        'a': 0.5,
        'b': 0.5
      }
      if (Object.prototype.toString.call(tests) === '[object Object]') {
        for (var t in tests) {
          abtKey[WS.ui.abtMap[t]] = tests[t];
        }
      } else if (Object.prototype.toString.call(tests) === '[object Array]') {
        for (var i = 0, len = tests.length; i < len; i++) {
          abtKey[WS.ui.abtMap[tests[i]]] = plan;
        }
      } else {
        abtKey[WS.ui.abtMap[tests]] = plan;
      }
      WS.abt.shunt && WS.abt.shunt(abtKey);
    }

  // 全局模块曝光方法
  function globalModelShowHandle (dom, reportType, data, threshold = 1) {
    if ($(dom).length == 0) {
      return false;
    }
    var config = {
      threshold: [threshold]
    }
    WS.observe.intersection(dom, function(entries, observer) {
      for (let i = 0, len = entries.length; i < len; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          // 上报
          WS.stat({
            eid: WS.ui.reportType['moduleShow'],
            ext1: reportType,
            ...data
          });
        }
      }
    }, config)
  }

  /**
   * 
   * @param {number} score 评分：1-5
   * @param {string} wrapper 容器类名：会查找该容器下类名为reviews-star-wrapper的元素插入节点
   * @param {string} color star颜色: yellow、brown
   * @param {string} size star大小: large、small
   */
  function genReviewsStar(score = 5, wrapper, color = 'yellow', size = 'large', isShowReviewNum = true) {
    var fullScore = 5;
    var full = Math.floor(score);
    var empty = Math.floor(fullScore - score);
    var half = fullScore - full - empty;
    var fullStarDom = `<div class="reviews-star ${color}-full-star ${size}"></div>`;
    var halfStarDom = `<div class="reviews-star ${color}-half-star ${size}"></div>`;
    var emptyStarDom = `<div class="reviews-star ${color}-empty-star ${size}"></div>`;
    var innerText = '';
    if (full > 0) {
      for (var i = 0; i < full; i++) {
        innerText += fullStarDom;
      }
    }
    if (half > 0) {
      for (var i = 0; i < half; i++) {
        innerText += halfStarDom;
      }
    }
    if (empty > 0) {
      for (var i = 0; i < empty; i++) {
        innerText += emptyStarDom;
      }
    }
    var starHtml = `<div class="reviews-star-wrapper">${innerText}</div>`
    // var starWrapper = `
    //   <div class="reviews-item_score-wrapper">
    //     ${starHtml}
    //     <div class="reviews-item_score-num" style="${!isShowReviewNum ? 'display: none;' : ''}">${Number(score).toFixed(1) + '/' + fullScore.toFixed(1) }</div>
    //   </div>
    // `
    var starWrapper = `
      <div class="reviews-item_score-wrapper">
        ${starHtml}
      </div>
    `
    $(wrapper).find('.reviews-star-box').append(starWrapper);
  }

  /**
   * 批量获取并插入商品评分模块
   */
  function batchInsertReviewsModule(arr, skcTitleList) {
    if (!arr.length) return;
    WS.ajax({
      url: WS.ui.routes.batchGetProductRating,
      type: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        productIds: arr
      }),
      success: function (res) {
        for (var i = 0, len = skcTitleList.length; i < len; i++) {
          var score = res.data[i];
          var skcTitle = skcTitleList[i];
          var target = $('#collection-conatiner').find(`.ws-product-block[data-skc-title="${skcTitle}"]`);
          if (!$(target).find('.reviews-item_score-wrapper').length) {
            WS.ui.genReviewsStar(score, target, 'yellow', 'small');
          }
        }
      },
      error: function (error) {
      },
    });
  }

  function handleHeaderBar(callback, showTitle = '') {
    $('.header-left-icon_search').hide();
    $('.header-drawer-close').show();

    if (showTitle) {
      $('.ws-header-model').find('.header-modelcon-content_icon').hide();
      $('.ws-header-model').find('.header-modelcon-content_title').text(showTitle);
    }

    $('#header-drawer-close').off('click').on('click', function() {
      callback && typeof callback === "function" && callback();
      $('.header-left-icon_search').show();
      $('.header-drawer-close').hide();
    });
  }

  function resetHeaderBar() {
    $('.header-left-icon_search').show();
    $('.header-drawer-close').hide();
  }

  function setAnnouncementBarScrollProgress(progress) {
    progress = Math.max(0, Math.min(1, progress));
    var progressValue = (progress * 100) + '%';
    $('.ws-announcement-bar-model--transparent').css(
      '--ws-announcement-scroll-progress',
      progressValue
    );
    $('.ws-announcement-bar-model--transparent, #shopify-section-westyle-header .ws-header-model-con')
      .toggleClass('ws-topbar-mask-hidden', progress > 0);
    $('.ws-header-appointment-button--desktop').css(
      '--ws-header-scroll-progress',
      progressValue
    );
  }

  function initScrollInteractive(scrollHeight = 50, $nav) {
    var H = scrollHeight || 50;   // 滚动范围高度
    var T = 0.9;  // 最低透明度阈值，防止导航看不清楚
    var syncAnnouncementBar = $nav.hasClass('ws-header-model-con');

    function updateScrollInteractive() {
      var sh = $(this).scrollTop();
      var br = 1 - sh / H;
      var wr = (sh - H ) / H;
      var bo = br > 1 ? 1 : (br < T ? T : br);
      var wo = wr > 1 ? 1 : (wr < T ? T : wr);
      // console.log('sh ======>', sh, H, scrollHeight, $nav);
      if (sh < H) {
        $nav.removeClass('white-bg-header').css('opacity', bo);
      } else {
        wo <= 1 && $nav.addClass('white-bg-header').css('opacity', wo);
      }

      if (syncAnnouncementBar) {
        setAnnouncementBarScrollProgress(sh / H);
      }
    }

    $(window).on('scroll', updateScrollInteractive);
    updateScrollInteractive.call(window);
  }

  function isLogin() {
    var userInfo = WS.user.getInfo();
    return userInfo.token ? true : false;
  }

  function isFunctionOpenCountry() {
    if (WS.ui.shopMap[WS.site.shop] === WS.ui.shopAU) {
      return false;
    } else if (WS.ui.shopMap[WS.site.shop] === WS.ui.shopMain) {
      return WS.site.country === 'US';
    }
    return false;
  }

  function hidePopupBox(self) {
    var $popup = $(self).parents(".ws-vertical-popupbox");
    var isSocialModulePopup = $popup.hasClass("ws-vertical-popupbox-social-module");
    // 恢复弹窗底部滚动方法
    WS.ui.popupRecoveryScrollHandle();
    // 隐藏弹窗
    $popup.remove();
    if (isSocialModulePopup) {
      WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(2);
    }
  }

  // 全局公共事件绑定方法
  function publicEventBind() {
    var headerIconReportPages = ['index', 'collection', 'product', 'search'];
    function reportHeaderIconClick(eventName) {
      if (!eventName || headerIconReportPages.indexOf(WS.site.page) === -1) return;
      WS.stat({
        eid: WS.ui.reportType['click'],
        event_name: eventName
      }, null, null, { useBeacon: true });
    }

    // 全站品牌logo点击
    $(document).on("click", ".header-modelcon-content a", function () {
      // 上报
      WS.stat({
        eid: WS.ui.reportType['click'],
        ext1: WS.ui.globalReportMap['clickLogo'],
        ext2: document.referrer,
      });
    })

    $(document).on("click", ".ws-header-menu-wrapper .nav-children-li-item-link", function () {
      // 上报
      WS.stat({
        eid: WS.ui.reportType['click'],
        ext1: WS.ui.globalReportMap['clickMenu'],
        ext2: document.referrer,
      });
    })

    // 全站footer page点击
    $(document).on("click", ".ws-footer-model .con-menu a", function () {
      // 上报
      var param = {
        page: $(this).text(),
        url: $(this).attr('href'),
      }
      WS.stat({
        eid: WS.ui.reportType['click'],
        ext1: WS.ui.globalReportMap['clickFooterLink'],
        ext2: JSON.stringify(param),
      });
    })

    // 全站汉堡菜单集合点击
    $(document).on("click", "#ws-header-model-menubox a", function () {
      // 上报
      var param = {
        page: $(this).text(),
        url: $(this).attr('href'),
      }
      WS.stat({
        eid: WS.ui.reportType['click'],
        ext1: WS.ui.globalReportMap['clickMenuLink'],
        ext2: JSON.stringify(param),
      });
    })

    // 全站搜索入口点击
    $(document).on("click", ".header-modelcon-right .header-left-icon_search, .header-modelcon-right .right-search-link", function () {
      reportHeaderIconClick('search');
    });

    // 全站右上角bag入口点击：读取 data-href 进行页面跳转
    $(document).on("click", "#ws-cart-bag", function (e) {
      var href = $(this).attr("data-href");
      if (href) {
        e.preventDefault();
        window.location.href = href;
      }
      // 上报
      WS.stat({
        eid: WS.ui.reportType['click'],
        ext1: WS.ui.globalReportMap['clickBag'],
        ext2: document.referrer,
      });
    })

    $(document).on('click', '.js-my-click-btn', function() {
      sessionStorage.setItem('login_register_source', WS.ui.loginRegisterSourceFieldsMap['other']);
      WS.ui.loginFn.createLoginPopup(true, `${WS.site.baseUrl}/pages/my`);
    });

    // 点击头像
    $(document).on('click', '#header-account', function() {
      reportHeaderIconClick('profile');
    });

    // 点击我的订单
    $(document).on('click', '#ws-menu-myorder-account', function() {
      sessionStorage.setItem('login_register_source', WS.ui.loginRegisterSourceFieldsMap['other']);
      WS.ui.loginFn.createLoginPopup(true, `${WS.site.baseUrl}/pages/my`, 'my_order');
      // 上报
      WS.stat({
        eid: WS.ui.reportType['click'],
        ext1: WS.ui.globalReportMap['clickAccountEntry'],
      });
    });

    // 判断地址栏参数，看是否需要唤起弹窗并跳转到对应页面
    var loginPop = WS.getParam('loginPop') || '';
    var jumpUrl = WS.getParam('jumpUrl') || '';
    if (loginPop && location.href.indexOf('pages/register') < 0) {
      setTimeout(function() {
        WS.ui.loginFn && WS.ui.loginFn.createLoginPopup(true, (jumpUrl ? `${WS.site.baseUrl}${jumpUrl}` : ''));
      }, 1000)
    }

    $(document).on('click', '.ws-vertical-popupbox-social-module .ws-social-module-popup__blogger', function() {
      reportSocialEvent('social_account_click', WS.ui.reportType['click'], this);
    });

    $(document).on('click', '.ws-vertical-popupbox-social-module .js-social-module-popup-desc', function() {
      reportSocialEvent('social_profile_click', WS.ui.reportType['click'], this);
    });

    $(document).on('click', '.ws-vertical-popupbox-social-module .ws-social-module-popup__product', function(e) {
      if ($(e.target).closest('.ws-social-module-popup__product-action').length) return;
      var productId = $(this).attr('data-product-id') || $(this).find('.ws-social-module-popup__product-action').attr('data-product-id') || '';
      reportSocialEvent('social_product_click', WS.ui.reportType['click'], this, { productId: productId });
    });

    // 客服入口交互方法
    var timer = setInterval(function() {
      if ( $('#tidio-chat-iframe').length ) {
        // 打开购物车隐藏客服
        $('#tidio-chat-iframe').length && WS.ui.customerServiceEntrance();
        // 更改客服层级
        $('#tidio-chat-iframe').css('z-index', '501 !important');
        // 清除定时器
        clearInterval(timer)
      }
    }, 200);
  }

  // 客服入口交互方法
  function customerServiceEntrance() {
    // 状态
    var status = true;
    // 滚动记录位置
    var oldScroll = 0;
    var newScroll = 0;
    // 监听滑动
    window.addEventListener("scroll", function (e) {
      // 获取滚动的高度
      var scrollTop = $(window).scrollTop();
      newScroll = scrollTop;
      if (scrollTop !== 0 && status && (oldScroll !== newScroll || oldScroll == 0 )) {
        // 判断是否已经打开了客服弹窗
        if ($("#tidio-chat-iframe").contents().find("#new-message-textarea").length) {
          return;
        }
        // 重置状态
        status = false;
        // 收起聊天
        $('#tidio-chat-iframe').css('transition', 'opacity 600ms ease-in-out !important;');
        $('#tidio-chat-iframe').css('opacity', '0');
        // 插入展开icon
        var upImgHtml = `
          <div id='chat-iframe-open-btn'>
            <img class='fix-padding-bot' src='https://cdn.shopify.com/s/files/1/0568/2895/2624/files/floatball_service2.png?v=1673342176' />
          </div>
        `;
        setTimeout(function() {
          // 判断
          if ($('#chat-iframe-open-btn').length == 0) {
            $('#tidio-chat').prepend(upImgHtml);
          }
          // 处理收起icon
          $('#chat-iframe-open-btn').css('display', 'block');
          setTimeout(function() {
            $('#chat-iframe-open-btn').css('opacity', '1');
          }, 50)
        }, 400)
        // 隐藏聊天icon
        setTimeout(function() {
          $('#tidio-chat-iframe').css('display', 'none');
        }, 600)
      }
    });

    // 点击打开聊天窗口
    $(document).on('click', '#chat-iframe-open-btn', function() {
      // 打开聊天
      $('#tidio-chat-iframe').css('display', 'block');
      setTimeout(function() {
        $('#tidio-chat-iframe').css('opacity', '1');
        // 重置状态
        status = true;
        oldScroll = newScroll;
      }, 50)
      // 隐藏按钮
      $('#chat-iframe-open-btn').css('opacity', '0');
      setTimeout(function() {
        $('#chat-iframe-open-btn').css('display', 'none');
      }, 400)
    });
  }

  /**
   * 
   * @param {*} container 插入节点容器
   * @param {*} type 1 显示在底部
   */
  function insertDeliveryDelayTipModule(container, type = 0) {
    var closeBtn = `delivery-delay-tip_close-btn-${type}`;
    var icon = type === 1 
      ? 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_remind_2x_2.png?v=1661848164' 
      : 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_remind_2x_bdc410c9-669a-4563-be2e-647d1249cdd6.png?v=1661848165';
    var deliveryDelayTipHtml = `
      <div class="delivery-delay-tip-box ${type === 1 ? 'bottom' : 'inner'}">
        <img class='delivery-delay-tip_icon' src="${icon}">
        <p class="delivery-delay-tip_content">${WS.$t('public.topbar.delayed_text_tip')}</p>
        <img class="delivery-delay-tip_close-btn ${closeBtn}" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_close_light_2x_9ff95637-0ac9-4c90-82d8-41429c1b5f5f.png?v=1661848164"/>
      </div>
    `;
    $(container).append(deliveryDelayTipHtml);
    $('.' + closeBtn).on('click', function() {
      $(container).remove();
    });
  }

  /**
   * 校验已登录用户的国家跟访问的国家站点是否匹配，不匹配则清空登陆态刷新页面
   */
  function checkUserCountry() {
    var userInfo = WS.user.getInfo();
    if (userInfo.country && userInfo.country !== WS.site.country) {
      WS.stat({
        eid: WS.ui.reportType['custom'],
        ext1: WS.ui.globalReportMap['customLogoutByDomainNoMatch']
      })

      sessionStorage.clear();
      WS.user.delUserInfo();
      location.reload();
      return;
    }
  }

  function renderCountDownTimer(couponBoxWrapperDom) {
    WS.couponListTimer && clearInterval(WS.couponListTimer);
    var countDownDomList = $(couponBoxWrapperDom).find('.count-down-wrapper');
    var len = countDownDomList.length;
    var over48 = 48 * 60 * 60 * 1000;
    var timeStampArr = [];
    if (!len) return;
    for (var i = 0; i < len; i++) {
     var timeStamp = $(countDownDomList[i]).attr('data-end-time');
     var code = $(countDownDomList[i]).attr('data-discount-code');
     var couponDiffTime = (timeStamp - new Date().getTime()) / 1000;
     var isLess = timeStamp > 0 && couponDiffTime <=  over48;
     var dom = '.count-down-wrapper-' + code;
     if (isLess) {
      timeStampArr.push({
        diffTime: couponDiffTime,
        dom: dom
      })
     }
    }
    WS.couponListTimer = setInterval(() => {
      if (!timeStampArr.length) return clearInterval(WS.couponListTimer);
      timeStampArr.forEach(function(item, index) {
        var targetDom = item.dom;
        item.diffTime--;
        if (item.diffTime <= 0) {
          timeStampArr.splice(index, 1);
          var couponDom = $(targetDom).parents('.coupon-item');
          couponDom.removeClass('available').addClass('disabled');
          couponDom.find('.coupon-code-status').addClass('expired');
          return
        }
        var h = parseInt(item.diffTime / 60 / 60 % 24);
        let m = parseInt(item.diffTime / 60 % 60);
        let s = parseInt(item.diffTime % 60);
        var res = `
          <div class="count-down-container">
            <div class="count-down-item">${h < 10 ? '0' + h : h}</div>
            <span class="count-down-symbol">:</span>
            <div class="count-down-item">${m < 10 ? '0' + m : m}</div>
            <span class="count-down-symbol">:</span>
            <div class="count-down-item">${s < 10 ? '0' + s : s}</div>
        </div>`
      $(targetDom).html(res);
      })
    }, 1000)
  }

  /**
   * 生成单个优惠券
   * @param {object} couponData 优惠券数据
   * couponItem 单个优惠券数据
   * type 1: 展示 2:可选择 3:可兑换
   * checkedCoupon 已选择的优惠券
   * needCopyBtn 是否需要复制
   * @returns 
   */
  function renderCouponItem(couponData) {
    var couponItem = couponData.couponItem;
    var type = couponData.couponType;
    var checkedCoupon = couponData.checkedCoupon;
    var needCopyBtn = couponData.needCopyBtn;
    var dateFmt = WS.ui.dateFormat;
    // 单个优惠券
    // 用户优惠券类型: userCouponType @unused:1:未使用 @used:2:已使用 @expired:3:已过期
    // 小于48小时生成倒计时器 isLess48
    var less48Hour = 48 * 60 * 60 * 1000;
    var isLess48 = couponItem.endTime > 0 && couponItem.endTime - new Date().getTime() <= less48Hour;
    couponItem.isLess48 = isLess48;
    couponItem.type = type;
    couponItem.checked = couponItem.discountCode === checkedCoupon.discountCode;
    couponItem.needCopyBtn = needCopyBtn;
    couponItem.discountMinimalPurchaseAmountStr = couponItem.discountMinimalPurchaseAmount ? (Number(couponItem.discountMinimalPurchaseAmount)).toFixed(2) : '';

    var couponStatus = '';
    if (couponItem.vailable !== undefined ) {
      couponStatus = couponItem.vailable ? 
        couponItem.userCouponType == 1 ? couponItem.isLess48 ? 'is-less-48' : 'available' : 'disabled' 
        : 'disabled';
    } else {
      couponStatus = couponItem.userCouponType == 1 ? couponItem.isLess48 ? 'is-less-48' : 'available' : 'disabled';
    }

    var couponItemHtml = `
      <div class="coupon-item ${couponStatus}">
        <div class="coupon-left">                         
          <div class="coupon-left-header">
            <% if (data.redeemCouponAmount && data.redeemCouponAmount > 0) { %>
              <div class="coupon-disount"><%= data.currencySymbol %><%= data.currencyCode %><%= data.redeemCouponAmount %> OFF</div>
            <% } else if (data.discountPercentage && data.discountPercentage != "0%") { %>
              <div class="coupon-disount"><%= data.discountPercentage %> OFF</div>
            <% } %>
          </div>
          <% if (data.discountMinimalPurchaseAmount) { %>
            <div class="coupon-left-middle">
              On orders over <%= data.currencySymbol %><%=data.currencyCode %><%= data.discountMinimalPurchaseAmountStr %>
            </div>
          <% } else if (data.minimalProductCount > 0) { %>
            <div class="coupon-left-middle">
              On orders over <%= data.minimalProductCount %> items
            </div>
          <% } else { %>
            <div class="coupon-left-middle">No minimum requirements</div>
          <% } %>
          <% if (data.isLess48) { %>
            <div class="coupon-left-bottom">
              Ends in <div class="count-down-wrapper count-down-wrapper-<%= data.discountCode %>" data-discount-code="<%= data.discountCode %>" data-end-time="<%= data.endTime %>"></div>
            </div>
          <% } else if (data.startTime > 0 && data.endTime > 0){ %>
              <div class="coupon-left-bottom">Valid from <%= WS.formatTime(data.startTime, "${dateFmt}") %> to <%= WS.formatTime(data.endTime, "${dateFmt}") %></div>
          <% } else if (data.type === 3 && data.redeemCouponExpiredDays > 0){ %>
            <div class="coupon-left-bottom">Valid for <%= data.redeemCouponExpiredDays/30 %> month after redeem.</div>
          <% } else { %>
            <div class="coupon-left-bottom">Valid time is not limited</div>
          <% } %>
        </div>
        <% if (data.type === 3) { %>
          <div class="coupon-right">      
            <div class="coupon-redeem-text">Redeem <%= data.redeemPointsAmount %></div>
            <div class="coupon-redeem-text">points</div>
            <% if ( data.vailable ) { %>
              <div class="coupon-redeem-btn ws-coupon-redeem-btn" amount="<%= data.redeemCouponAmount %>" couponid="<%= data.pointsCouponRedeemSettingsId %>">Redeem</div>
            <% } else { %>
              <div class="coupon-redeem-text mrt-4">Insufficient</div>
              <div class="coupon-redeem-text">points</div>
             <% } %>
          </div>
        <% } else { %> 
          <div class="coupon-right <% if (data.needCopyBtn) { %>code-copy-btn<% } %>" value="<%= data.discountCode %>">      
            <% if (data.type === 2) { %>
              <div class="coupon-checkbox icon-coupon-checkbox <% if (data.checked) { %>icon-coupon-checked<% } %>" code="<%= data.discountCode %>"></div>     
            <% } %>
            <div class="coupon-code"><%= data.discountCode %></div>
            <div class="coupon-code-btn">CODE</div>
            <div class="coupon-code-status <% if (data.userCouponType == 2) { %>used<% } else if (data.userCouponType == 3) { %>expired<% } %>"></div>
          </div>
        <% } %>
      </div>          
    `;
    var couponItemDomStr = WS.tmpl(couponItemHtml, couponItem);
    return couponItemDomStr;
  }

  /**
   * 生成优惠券列表
   * @param {object} arr 数据集合 
   * arr 优惠券集合 
   * className 优惠券列表累吗
   * type 1: 展示 2:可选择 3:可兑换
   * checkedCoupon 已选中的优惠券
   * needCopyBtn 复制功能
   * @returns 
   */
  function renderCouponListHtml(data) {
    var arr = data.arr || [];
    var className = data.className || '';
    var type = data.type || 1;
    var checkedCoupon = data.checkedCoupon || {};
    var needCopyBtn = data.needCopyBtn || false;
    var dom = '';
    if (arr.length) {
      arr.forEach(function(item) {
        var couponItemDom = WS.ui.renderCouponItem({
          couponItem: item, 
          couponType: type,
          checkedCoupon: checkedCoupon,
          needCopyBtn: needCopyBtn,
        });
        dom += `${couponItemDom}`
      })
    }
    var listDom = `<div class="coupon-box ${className}">${dom}</div>`
    return listDom;
  }

  function showPage(page) {
    // if ($('.ws-main-popupbox-page').length > 0) {
    //   $('.ws-main-popupbox-page').show();
    //   return;
    // }

    try {
      WS.ajax({
        url: `${WS.site.baseUrl}?sections=${page}`,
        dataType: "html",
        success: function (res) {
          var responseHTML = JSON.parse(res || 'null')[page] || '';
          var tmpl = `
            <div class="ws-main-popupbox ws-main-popupbox-page">
              <div class="ws-main-popupbox-overlay"></div>
              <div class="ws-main-popupbox-con fix-pos-bot">
                <img class="ws-main-popupbox-page_close title-close" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484" />
                <div class="main-popupbox-con-model popup-page-container">
                  ${responseHTML}
                </div>
              </div>
            </div>
          `;
          $('body').append(tmpl);
        },
        error: function(e) {}
      });
    } catch(e) {} 
  }

  function showPageBlock(path, selector) {
    try {
      WS.ajax({
        url: WS.site.baseUrl + path,
        dataType: "html",
        success: function(res) {
          var doc = new DOMParser().parseFromString(res || '', "text/html"),
            blockHTML = doc.querySelector(selector).outerHTML,
            tmpl = `
              <div class="ws-main-popupbox ws-main-popupbox-page">
                <div class="ws-main-popupbox-overlay"></div>
                <div class="ws-main-popupbox-con fix-pos-bot">
                  <img class="ws-main-popupbox-page_close title-close" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484" />
                  <div class="main-popupbox-con-model popup-page-container">
                    ${blockHTML}
                  </div>
                </div>
              </div>
            `;
          $("body").append(tmpl)
        },
        error: function(e) {}
      })
    } catch {}
  }

  function getMemberIcon(currrentVip) {
    switch (currrentVip) {
      case 'C0': 
        return 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/c0_72x.png?v=1673504697';
      case 'C1':   
        return 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/c1_3x_c50c39ee-9bdf-4e08-82c3-9c09048765eb_72x.png?v=1673243154';
      case 'C2':
        return 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/c2_3x_bdceac0a-0b48-4138-90f4-cebd2f31c57b_72x.png?v=1673243154'  
    }
  }
 
  /**
   * 统一处理接口返回的报错
   */
  function watchAjaxError() {
    try {
      $(document).on("ajaxSuccess", function (event, xhr, opts, data) {
        if (data && data.hasError) {
          var errorObj = data.error;
          var errorCode = errorObj ? errorObj.code : '';
          // token无效
          if (errorCode === 'A10106') {
            WS.user.delUserInfo();
            location.reload();
          }
        }
      });
    } catch (e) {}
  }

  function formatMonthToEnglish(time) {
    var fmtTime = ''
    var timeArr = time.split('/');
    var month = timeArr[0];
    var date = timeArr[1];
    var year = timeArr[2];
    switch(month) {
      case '01':
        month = 'Jan';
        break; 
      case '02':
        month = 'Feb';
        break; 
      case '03':
        month = 'Mar';
        break; 
      case '04':
        month = 'Apr';
        break; 
      case '05':
        month = 'May';
        break;  
      case '06':
        month = 'Jun';
        break; 
      case '07':
        month = 'Jul';
        break; 
      case '08':
        month = 'Aug';
        break; 
      case '09':
        month = 'Sept';
        break; 
      case '10':
        month = 'Oct';
        break; 
      case '11':
        month = 'Nov';
        break; 
      case '12':
        month = 'Dec';
        break;  
    }
    fmtTime =  `${month} ${date}, ${year}`;
    return fmtTime;
  }

  function handleUrlAndDataByLogin(data, url) {
    var token = data.accessToken || '';
    var userId = data.userId;
    var accessTokenExpireTimestamp = data.accessTokenExpireTimestamp || '';
    var timestampNow = new Date().getTime();
    var hour = (accessTokenExpireTimestamp - timestampNow)/(60*60*1000);
    WS.user.setUserInfo({
      accessToken: token,
      userId: userId,
      hour: hour,
      userCountry: WS.site.country
    })
    setTimeout(function() {
      location.replace(url)
    }, 500);
  }

  function getResultHtml(info, title, img) {
    title = title || 'Submit successful!';
    img = img || 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_Thank_you_succeed_2x_1_9655296c-b112-47e3-b88c-005956c99d8a.png?v=1679470310';
    var resultHtml = `
      <div class="common-success-result-wrapper">
        <img class="common-success-result-img" src="${img}" />
        <div class="common-success-result-title">${title}</div>
        <div class="common-success-result-info">${info}</div>
      </div>
    `;
    return resultHtml;
  }
  
  function escapeXSS(str) {
    let pattern = /[&<>"`=\/]/g;
    let replaceMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "\"": "&quot;",
      // "'": "&#39;",
      "`": "&#x60;",
      "=": "&#x3D;",
      "/": "&#x2F;"
    };
    return str.replace(pattern, match => replaceMap[match]);
  }   

  // 页面居中弹窗
  function createDialog(className, innerHtml) {
    var dialog = `
      <div class="ws-vertical-popupbox ws-vertical-popupbox-${className}">
        <div class="ws-vertical-popupbox-overlay"></div>
        <div class="ws-vertical-popupbox-con common-dialog-container ws-vertical-popupbox-con_${className}">
          <img class="common-dialog-close con-close-btn popupbox-${className}_close" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484"/>
          <div class="dialog-inner_${className}">
            ${innerHtml}
          </div>
        </div>
      </div>
    `;
    return dialog;
  }

  function storeIsRegisteAd() {
    var isRegisteAd = WS.getParam('isRegisteAd');
    if (isRegisteAd == 1) {
      sessionStorage.setItem('isRegisteAd', 1);
    }
  }

  function showRegisteModule() {
    var urlField = WS.getParam('isRegisteAd');
    var sessionField = sessionStorage.getItem('isRegisteAd');
    var isLogin = WS.ui.isLogin();
    return (urlField || sessionField) && !isLogin ? true : false;
  }

  function handleHeaderInteractive() {
    const page = WS.site.page;
    const isIndexPage = page === 'index';
    const isCollectionPage = page === 'collection';
    const isAboutUsPage = location.href.includes("pages/about-us");
    const isReferPage = location.href.includes("pages/refer");
    const isSpecialPage = isIndexPage || isCollectionPage || isAboutUsPage || isReferPage;
    var hasHeaderScrollInteractive = false;

    if (isSpecialPage) {
      // 仅集合页需要判断topBanner的存在，否则直接初始化header交互效果
      // 移动端/PC端分别配置，需按视口判断对应banner是否存在（断点与 westyle-collection.css 750px 一致）
      if (isCollectionPage) {
        var isPcViewport = window.innerWidth >= 750;
        var topMdoule = isPcViewport ? $('#collection-top-module-pc') : $('#collection-top-module-mobile');
        var hasVisibleBanner = topMdoule.find('.ws-collection__top-banner__wrapper').length > 0;
        var hasShortDescription = topMdoule.find('.js-collection-short-desc').length > 0;
        var filterWrapperStickyHeight = isPcViewport ? 128 : 76;
        if (hasVisibleBanner) {
          WS.ui.initScrollInteractive(50, $('.ws-header-model-con'));
          hasHeaderScrollInteractive = true;
          WS.ui.initScrollInteractive(filterWrapperStickyHeight, $('.ws-collection-title-filter-box'));
        }

        if (hasShortDescription) {
          WS.ui.initScrollInteractive(50, $('.ws-collection-title-filter-box'));
        }
      } else {
        WS.ui.initScrollInteractive(50, $('.ws-header-model-con'));
        hasHeaderScrollInteractive = true;
      }
    } else {
      $('.ws-header-model-con').addClass('white-bg-header');
    }

    if (!hasHeaderScrollInteractive) {
      setAnnouncementBarScrollProgress(1);
    }
  }

  function getProductData(productId, productDataDom) {
    var productJson = JSON.parse($(productDataDom).text() || 'null') || {};
    var mergeSkcs = Array.isArray(productJson.mergeSkcs) ? productJson.mergeSkcs : [];
    var currentId = String(productId || '');
    var skcItem = mergeSkcs.find(function(m) {
      return m && String(m.id) === currentId;
    });
    if (skcItem) {
      Object.assign(productJson, skcItem);
    }
    
    WS.ui.productObj = productJson;
    return productJson;
  }


  function applySizeInventory(container) {
    var $container = $(container);
    var $items = $container.find('.sku-sizes-inner .size-item');
    if (!$items.length && $container.hasClass('sku-sizes-inner')) {
      $items = $container.find('.size-item');
    }
    if (!$items.length && $container.hasClass('size-item')) {
      $items = $container;
    }
    if (!$items.length) return;
    for (var j = 0; j < $items.length; j++) {
      var $el = $($items[j]);
      var soldOut = !isSizeItemOnlineSellable($el);
      if (soldOut) {
        $el.addClass('sold-out');
      } else {
        $el.removeClass('sold-out');
      }
      if ($el.is('button')) {
        var $group = $el.closest('.sku-sizes-inner');
        var statusLabel = soldOut
          ? ($group.attr('data-sold-out-label') || 'Sold out')
          : ($group.attr('data-available-label') || 'Available');
        $el.attr('aria-disabled', soldOut ? 'true' : 'false');
        $el.attr('aria-label', String($el.attr('data-value') || $el.text()).trim() + ', ' + statusLabel);
      }
    }
  }

  function getSizeItemVariant(sizeItem) {
    var $sizeItem = $(sizeItem);
    var variantId = String($sizeItem.attr('data-variant-id') || '');
    var variants = WS.ui.productObj && Array.isArray(WS.ui.productObj.variants) ? WS.ui.productObj.variants : [];
    if (!variantId || !variants.length) return null;
    return variants.find(function(variantItem) {
      return variantItem && String(variantItem.id) === variantId;
    }) || null;
  }

  function isTruthyDataValue(value) {
    return value === true || String(value || '').toLowerCase() === 'true';
  }

  // Shopify 缺货续售的 variant 优先遵循 available。
  // 其它 variant 优先使用同步后的 available_count，避免其它 location 库存影响官网售罄状态。
  function hasDataValue(value) {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  function getOnlineAvailableCountValue(variant, sizeItem) {
    if (variant && hasDataValue(variant.available_count)) {
      return variant.available_count;
    }
    var $sizeItem = sizeItem ? $(sizeItem) : $();
    if ($sizeItem.length && hasDataValue($sizeItem.attr('data-available-count'))) {
      return $sizeItem.attr('data-available-count');
    }
    return null;
  }

  function isVariantOnlineSellable(variant) {
    if (!variant) return false;
    if (String(variant.inventory_policy || '').toLowerCase() === 'continue') {
      return isTruthyDataValue(variant.available);
    }
    var count = getOnlineAvailableCountValue(variant);
    if (count !== null) {
      count = Number(count);
      return !isNaN(count) && count > 0;
    }
    return isTruthyDataValue(variant.available);
  }

  function isSizeItemOnlineSellable(sizeItem) {
    var $sizeItem = $(sizeItem);
    var variant = getSizeItemVariant(sizeItem);
    if (variant) return isVariantOnlineSellable(variant);
    var onlineSellable = $sizeItem.attr('data-online-sellable');
    if (hasDataValue(onlineSellable)) return isTruthyDataValue(onlineSellable);
    var count = getOnlineAvailableCountValue(null, $sizeItem);
    if (count !== null) {
      count = Number(count);
      return !isNaN(count) && count > 0;
    }
    return $sizeItem.attr('data-available') !== 'false';
  }

  function isUs2DayDeliveryEnabled() {
    var value = WS.ui.productObj && WS.ui.productObj.enable_us_2_day_delivery;
    if (value == null || value === '') {
      value = $('#product-page').attr('data-enable-us-2-day-delivery');
    }
    return isTruthyDataValue(value);
  }

  function syncUsWarehouseShippingInfo(shouldShow) {
    var $shippingInfo = $('#ws-shipping-info');
    if (!$shippingInfo.length) return;
    $shippingInfo.toggleClass('show', !!shouldShow);
  }

  // 单个尺码是否可走 NJ LA Warehouse：优先按当前 variant 数据判断，兜底读取尺码 DOM 上的 data-is-us-warehouse。
  function isUsWarehouseSizeItem(sizeItem) {
    if (!isUs2DayDeliveryEnabled()) return false;
    var $sizeItem = $(sizeItem);
    var variant = getSizeItemVariant(sizeItem);
    var isUsWarehouse = variant && variant.is_us_warehouse != null
      ? variant.is_us_warehouse
      : $sizeItem.attr('data-is-us-warehouse');
    return (
      isSizeItemOnlineSellable(sizeItem) &&
      isTruthyDataValue(isUsWarehouse)
    );
  }

  // 读取当前 SKU 总库存，用于没有 LA 仓库存时回退展示低库存提示。
  function getSizeItemAvailableCount(sizeItem) {
    var $sizeItem = $(sizeItem);
    var variant = getSizeItemVariant(sizeItem);
    var count = Number(variant && variant.available_count != null ? variant.available_count : $sizeItem.attr('data-available-count'));
    return isNaN(count) ? 0 : count;
  }

  // 当前商品是否为 SELECT US 2-DAY：部分尺码支持 NJ Warehouse 2 日达，部分尺码不支持。
  function isSelectUsWarehouseProduct(sizeItem) {
    if (!isUs2DayDeliveryEnabled()) return false;
    var variants = WS.ui.productObj && Array.isArray(WS.ui.productObj.variants) ? WS.ui.productObj.variants : [];
    var totalCount = 0;
    var usWarehouseCount = 0;
    var hasWarehouseMeta = false;

    if (variants.length) {
      for (var i = 0; i < variants.length; i++) {
        totalCount += 1;
        if (variants[i] && variants[i].is_us_warehouse != null) {
          hasWarehouseMeta = true;
        }
        if (isTruthyDataValue(variants[i] && variants[i].is_us_warehouse)) {
          usWarehouseCount += 1;
        }
      }
    }

    if (!hasWarehouseMeta) {
      var $sizeItems = $(sizeItem).closest('.product-sku-wrapper').find('.size-item');
      totalCount = $sizeItems.length;
      usWarehouseCount = 0;
      $sizeItems.each(function() {
        if (isTruthyDataValue($(this).attr('data-is-us-warehouse'))) {
          usWarehouseCount += 1;
        }
      });
    }

    return totalCount > 0 && usWarehouseCount > 0 && usWarehouseCount < totalCount;
  }

  function formatStandardDeliveryForSizeTipHtml() {
    return '<div class="in-stock-tip-text ws-us-warehouse-tip">Size not eligible for 2-day shipping. </div>';
  }

  // 统一获取尺码展示文案，优先用 data-value，避免读取到多余空白。
  function getSizeItemLabel(sizeItem) {
    var $sizeItem = $(sizeItem);
    var label = $sizeItem.attr('data-value') || $sizeItem.text() || '';
    label = String(label).replace(/\s+/g, ' ').trim();
    return label || 'One Size';
  }

  // 拼接尺码列表，并给每个尺码加粗。
  function formatUsWarehouseSizeListHtml(sizeLabels) {
    var strongLabels = sizeLabels.map(function(sizeLabel) {
      return '<strong>' + escapeXSS(String(sizeLabel)) + '</strong>';
    });
    if (strongLabels.length <= 1) return strongLabels[0] || '';
    if (strongLabels.length === 2) return strongLabels[0] + ' and ' + strongLabels[1];
    return strongLabels.slice(0, -1).join(', ') + ', and ' + strongLabels[strongLabels.length - 1];
  }

  // 未选中尺码时使用：汇总当前颜色所有 LA Warehouse 有库存尺码，生成默认提示。
  function formatUsWarehouseStockTipHtml(sizeItems) {
    var $sizeItems = $(sizeItems);
    if (!$sizeItems.length) return '';

    var totalSizeCount = $sizeItems.length;
    var usWarehouseSizeCount = 0;
    var usWarehouseSizeLabels = [];
    var seenSizeLabels = {};
    $sizeItems.each(function() {
      if (!isUsWarehouseSizeItem(this)) return;
      usWarehouseSizeCount += 1;
      var sizeLabel = getSizeItemLabel(this);
      if (seenSizeLabels[sizeLabel]) return;
      seenSizeLabels[sizeLabel] = true;
      usWarehouseSizeLabels.push(sizeLabel);
    });

    if (!usWarehouseSizeLabels.length) return '';

    var deliveryHtml = '<strong>2-day delivery.</strong>';
    var textHtml = '';
    if (usWarehouseSizeCount === totalSizeCount) {
      textHtml = 'All sizes ship with ' + deliveryHtml;
    } else if (usWarehouseSizeLabels.length === 1) {
      textHtml = 'Size ' + formatUsWarehouseSizeListHtml(usWarehouseSizeLabels) + ' ships with ' + deliveryHtml;
    } else {
      textHtml = 'Sizes ' + formatUsWarehouseSizeListHtml(usWarehouseSizeLabels) + ' ship with ' + deliveryHtml;
    }

    return '<div class="in-stock-tip-text ws-us-warehouse-tip">' + textHtml + '</div>';
  }

  // 已选中尺码时使用：只展示当前尺码的 2 日达提示，不展示其它尺码。
  function formatSelectedUsWarehouseStockTipHtml(sizeItem) {
    if (!isUsWarehouseSizeItem(sizeItem)) return '';
    var sizeHtml = formatUsWarehouseSizeListHtml([getSizeItemLabel(sizeItem)]);
    return (
      '<div class="in-stock-tip-text ws-us-warehouse-tip">' +
      'Size ' +
      sizeHtml +
      ' ship with <strong>2-day delivery.</strong>' +
      '</div>'
    );
  }

  // 写入尺码下方提示容器；没有 LA Warehouse 库存时清空容器，由调用方决定是否展示旧库存提示。
  function renderUsWarehouseStockTip(options) {
    options = options || {};
    var $scope = options.scope ? $(options.scope) : $(document);
    var $wrapper = options.wrapper ? $(options.wrapper) : $scope.find(options.wrapperSelector || '.in-stock-wrapper').first();
    var $sizeItems = options.sizeItems ? $(options.sizeItems) : $scope.find(options.sizeSelector || '.sku-sizes-inner .size-item');
    var html = formatUsWarehouseStockTipHtml($sizeItems);
    if ($wrapper.length) $wrapper.html(html || '');
    if (options.syncShippingInfo) syncUsWarehouseShippingInfo(!!html);
    return html;
  }

  function getOptionIndexByKeyword(product, keyword) {
    var idx = null;
    var optionsJson = product.options_with_values || [];
    for (var i = 0; i < optionsJson.length; i++) {
      var name = String((optionsJson[i] && optionsJson[i].name) || '').toLowerCase();
      if (name === keyword || (keyword && name.includes(keyword))) {
        idx = optionsJson[i].position;
        break;
      }
    }
    return idx;
  }

    /**
   * 价格（分）→ 「符号 + 千分位 + 两位小数 + 空格 + ISO 币种」
   * 优先在 countryInfoMap 中按 currency 与 WS.site.currency 匹配；否则按 WS.site.country；最后回退 WS.site。
   */
  function formatPrice(priceCents) {
    var cents = Number(priceCents);
    if (!isFinite(cents)) return '';

    var map = WS.ui.countryInfoMap;
    var targetCur = (WS.site && WS.site.currency) ? String(WS.site.currency).toUpperCase() : '';
    var countryCode = (WS.site && WS.site.country) ? String(WS.site.country).toUpperCase() : '';

    var info = null;
    if (targetCur) {
      for (var cc in map) {
        if (!map.hasOwnProperty(cc)) continue;
        var row = map[cc];
        if (row && row.currency && String(row.currency).toUpperCase() === targetCur) {
          info = row;
          break;
        }
      }
    }
    if (!info && countryCode && map[countryCode]) {
      info = map[countryCode];
    }

    var symbol = (info && info.symbol) || (WS.site && WS.site.symbol) || '$';
    var code = (info && info.currency) || (WS.site && WS.site.currency) || 'USD';
    code = String(code).toUpperCase();

    var amount = cents / 100;
    var num = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return symbol + num + ' ' + code;
  }
  
  function isThemeEditor() {
    return typeof Shopify !== 'undefined' && Shopify.designMode === true;
  }

  /**
   * 判断主题编辑器事件是否来自包含指定 data-section-type 的 section
   * @param {Event} event - shopify:section:* / shopify:block:* 等
   * @param {string} sectionType - 与 Liquid 中 data-section-type 一致，如 slideshow、ws-featured-collection
   * @returns {boolean}
   */
  function matchesShopifyEditorSectionType(event, sectionType) {
    if (!event || sectionType == null) return false;
    var st = String(sectionType).trim();
    if (!st || !/^[a-zA-Z0-9_-]+$/.test(st)) return false;
    var sel = '[data-section-type="' + st + '"]';
    var detail = event.detail || {};
    if (detail.sectionId) {
      var sec = document.getElementById('shopify-section-' + detail.sectionId);
      return !!(sec && sec.querySelector(sel));
    }
    var t = event.target;
    if (!t || !t.closest) return false;
    if (t.closest(sel)) return true;
    var wrap = t.closest('.shopify-section');
    return !!(wrap && wrap.querySelector(sel));
  }

  /**
   * 解析事件对应的带 data-section-type 的根节点（在 .shopify-section 内）
   * @returns {Element|null}
   */
  function resolveShopifyEditorSectionRoot(event, sectionType) {
    if (!matchesShopifyEditorSectionType(event, sectionType)) return null;
    var st = String(sectionType).trim();
    var sel = '[data-section-type="' + st + '"]';
    var detail = event.detail || {};
    if (detail.sectionId) {
      var sec = document.getElementById('shopify-section-' + detail.sectionId);
      return sec ? sec.querySelector(sel) : null;
    }
    var t = event.target;
    if (!t || !t.closest) return null;
    var inner = t.closest(sel);
    if (inner) return inner;
    var wrap = t.closest('.shopify-section');
    return wrap ? wrap.querySelector(sel) : null;
  }

  /**
   * 注册主题编辑器事件（按 data-section-type 匹配 section）
   * @param {Object} opts
   * @param {string} opts.sectionType - 必填，对应节点 data-section-type
   * @param {Function} opts.callback - 匹配时调用 (event, payload) => void
   * @param {string|string[]} [opts.events] - 默认 ['shopify:section:load','shopify:block:select']；可传如 'shopify:section:select' 等
   * @param {string} [opts.sectionRootClass] - 可选，根节点上的 class 名，用于同页多个同 sectionType 时区分，如 Liquid 的 section-id-{{ section.id }}
   * @param {string|number} [opts.matchSectionId] - 可选，仅当 event.detail.sectionId 与之相等时触发（与 sectionRootClass 二选一或组合使用）
   * @returns {Function} destroy - 取消本次注册的所有监听
   */
  function initShopifyEditorEvent(opts) {
    if (!opts || typeof opts.callback !== 'function') {
      return function () {};
    }
    var sectionType = opts.sectionType != null ? String(opts.sectionType).trim() : '';
    if (!sectionType || !/^[a-zA-Z0-9_-]+$/.test(sectionType)) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[WS.ui.initShopifyEditorEvent] invalid sectionType:', opts.sectionType);
      }
      return function () {};
    }
    var sectionRootClass = opts.sectionRootClass != null ? String(opts.sectionRootClass).trim() : '';
    if (sectionRootClass && !/^([a-zA-Z0-9_-]+)$/.test(sectionRootClass)) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[WS.ui.initShopifyEditorEvent] invalid sectionRootClass:', opts.sectionRootClass);
      }
      return function () {};
    }
    var matchSectionId = opts.matchSectionId;
    var events = opts.events || ['shopify:section:load', 'shopify:block:select'];
    if (typeof events === 'string') events = [events];
    var cb = opts.callback;

    function handler(event) {
      if (!matchesShopifyEditorSectionType(event, sectionType)) return;
      var detail = event.detail || {};
      if (matchSectionId != null && matchSectionId !== '' && String(detail.sectionId) !== String(matchSectionId)) {
        return;
      }
      var sectionEl = resolveShopifyEditorSectionRoot(event, sectionType);
      if (sectionRootClass) {
        if (!sectionEl || !sectionEl.classList.contains(sectionRootClass)) return;
      }
      cb(event, {
        sectionType: sectionType,
        sectionEl: sectionEl,
        sectionId: detail.sectionId,
        blockId: detail.blockId,
        sectionRootClass: sectionRootClass || undefined,
      });
    }

    events.forEach(function (name) {
      document.addEventListener(name, handler);
    });

    return function destroy() {
      events.forEach(function (name) {
        document.removeEventListener(name, handler);
      });
    };
  }

  /**
   * 根据 variant.available + ETA 元字段生成「有货/预售/低库存」提示 HTML（售罄由调用方处理）。
   * variantStockMeta: { [variantId]: { eta, low_stock_status, available_count, ... } }
   */
  function formatVariantInStockTipHtml(sizeItem) {
    var sizeDom = $(sizeItem);
    if (!isSizeItemOnlineSellable(sizeDom)) return '';

    var isUsWarehouse = isUsWarehouseSizeItem(sizeDom);

    var eta = sizeDom.attr("data-eta");
    if (isUsWarehouse) {
      $('#ws-shipping-info').addClass('show');
    } else {
      $('#ws-shipping-info').removeClass('show');
    }

    if (eta) {
      var etaMs = Date.parse(String(eta));
      if (!isNaN(etaMs) && Date.now() < etaMs) {
        var d = new Date(etaMs);
        var timeStr = '';
        if (!isNaN(d.getTime())) {
          try {
            timeStr = new Intl.DateTimeFormat('en-US', {
              month: 'short',
              day: 'numeric',
            }).format(d);
          } catch (e) {
            timeStr = d.toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
            });
          }
        }
        return (
          '<div class="in-stock-tip-text">' +
          WS.$t('product.details.pre_order_text1', { time: timeStr }) +
          '</div>'
        );
      }
    }
    // SELECT US 2-DAY 商品选中非 NJ Warehouse 尺码时，优先提示该尺码走标准配送；否则再回到低库存提示。
    var lowCount = getSizeItemAvailableCount(sizeDom);
    if (!isUsWarehouse && isSelectUsWarehouseProduct(sizeDom)) {
      return formatStandardDeliveryForSizeTipHtml();
    }

    if (!isUsWarehouse && lowCount > 0 && lowCount < 5) {
      return (
        '<div class="in-stock-tip-text">' +
        WS.$t('public.add_pop.text_in_stock', { count: lowCount }) +
        '</div>'
      );
    }

    return '';
  }

  function openAddressPopup() {
    if (!pickupAddress) {
      return;
    }
    $('.ws-vertical-popupbox-address-pickup').remove();

    var title = (WS.ui.productObj && WS.ui.productObj.title) || '';
    var colorVal = WS.ui.selectedColor != null ? String(WS.ui.selectedColor) : '';
    var sizeVal = WS.ui.selectedSize != null ? String(WS.ui.selectedSize) : '';
    var metaParts = [];
    if (colorVal) {
      metaParts.push('color: ' + escapeXSS(colorVal));
    }
    if (sizeVal) {
      metaParts.push('Size: ' + escapeXSS(sizeVal));
    }
    var metaLine = metaParts.join(', ');

    var pa = pickupAddress;
    var addr = pa.address || {};
    var serviceLine = '';
    if (pa.pickupTime === 'TWENTY_FOUR_HOURS') {
      serviceLine =
        WS.$t('product.details.pickup_popup_service') ||
        'Pickup available, - ready in 24 hours';
    }

    var addrHtml = '';
    if (addr.address1) {
      addrHtml += '<p class="ws-address-popup__addr-line">' + escapeXSS(String(addr.address1)) + '</p>';
    }
    if (addr.address2) {
      addrHtml += '<p class="ws-address-popup__addr-line">' + escapeXSS(String(addr.address2)) + '</p>';
    }
    var cityLine = [addr.city, addr.province, addr.zip]
      .filter(function (x) {
        return x != null && x !== '';
      })
      .join(' ');
    if (cityLine) {
      addrHtml += '<p class="ws-address-popup__addr-line">' + escapeXSS(cityLine) + '</p>';
    }
    if (addr.country) {
      addrHtml += '<p class="ws-address-popup__addr-line">' + escapeXSS(String(addr.country)) + '</p>';
    }
    if (addr.phone) {
      addrHtml += '<p class="ws-address-popup__addr-line">' + escapeXSS(String(addr.phone)) + '</p>';
    }

    var innerHtml =
      '<div class="ws-address-popup">' +
      '<div class="ws-address-popup__product">' +
      '<h2 class="ws-address-popup__product-title">' +
      escapeXSS(title) +
      '</h2>' +
      (metaLine ? '<p class="ws-address-popup__product-meta">' + metaLine + '</p>' : '') +
      '</div>' +
      '<div class="ws-address-popup__divider" role="presentation"></div>' +
      '<div class="ws-address-popup__pickup">' +
      '<h3 class="ws-address-popup__loc-title">' +
      escapeXSS(String(pa.locationName || '')) +
      '</h3>' +
      (serviceLine
        ? '<p class="ws-address-popup__service"><span class="ws-address-popup__check" aria-hidden="true">✓</span> ' +
          escapeXSS(serviceLine) +
          '</p>'
        : '') +
      '<div class="ws-address-popup__addr-block">' +
      addrHtml +
      '</div>' +
      '</div>' +
      '</div>';
    $('body').append(createDialog('address-pickup', innerHtml));
    WS.ui.popupNoScrollHandle();
  }

  function setClientClassName() {
    if (WS.client.isAndroid) {
      $('body').addClass('android-client');
    } else if (WS.client.isIOS) {
      $('body').addClass('ios-client');
    }
  }

  function operateZeSnippet(type = 1) {
    var $launcher = $('iframe#launcher');
    if ($launcher.length) {
      if (type === 1) {
        $launcher.parent().parent().attr('style', 'display: none !important;');
      } else {
        $launcher.parent().parent().attr('style', '');
      }
    }
  }

  function getSocialPostTrackData(scope) {
    var $scope = $(scope);
    var $trackRoot = $scope.is('[data-social-post-id]') ? $scope : $scope.closest('[data-social-post-id]');
    if (!$trackRoot.length) {
      var $popupRoot = $scope.closest('.ws-vertical-popupbox-social-module');
      if ($popupRoot.attr('data-social-post-id')) {
        $trackRoot = $popupRoot;
      }
    }
    if (!$trackRoot.length) {
      $trackRoot = $('.ws-vertical-popupbox-social-module[data-social-post-id]').last();
    }
    return {
      postId: $trackRoot.attr('data-social-post-id') || '',
      platform: $trackRoot.attr('data-social-platform') || '',
      pos: $trackRoot.attr('data-social-pos') || ''
    };
  }

  function reportSocialEvent(eventName, eid, scope, opts) {
    if (!eventName || !window.WS || !WS.stat || !WS.ui || !WS.ui.reportType) return;
    opts = opts || {};
    var socialData = getSocialPostTrackData(scope);
    var payload = {
      eid: eid || WS.ui.reportType['click'],
      ext1: eventName
    };
    if (opts.productId !== undefined && opts.productId !== null && opts.productId !== '') {
      payload.ext2 = String(opts.productId);
      payload.ext3 = socialData.postId;
    } else {
      payload.ext3 = socialData.postId;
      if (opts.includePosition) {
        payload.ext4 = socialData.pos ? 'pos=' + socialData.pos : '';
        payload.ext5 = socialData.platform;
      }
    }
    WS.stat(payload);
  }

  function initSocialPopupProductExposure(root) {
    var $root = root ? $(root) : $(document);
    $root.find('.ws-social-module-popup__product').each(function() {
      var productDom = this;
      if (productDom.__wsSocialProductShowReported) return;
      var reportProductShow = function() {
        if (productDom.__wsSocialProductShowReported) return;
        productDom.__wsSocialProductShowReported = true;
        var productId = $(productDom).attr('data-product-id') || $(productDom).find('.ws-social-module-popup__product-action').attr('data-product-id') || '';
        reportSocialEvent('product_show.social', WS.ui.reportType['moduleShow'], productDom, { productId: productId });
      };
      if (WS.observe && WS.observe.intersection) {
        WS.observe.intersection(productDom, function(entries, observer) {
          for (var i = 0, len = entries.length; i < len; i++) {
            if (entries[i].isIntersecting) {
              observer.unobserve(entries[i].target);
              reportProductShow();
            }
          }
        }, { threshold: [0.5] });
      } else {
        reportProductShow();
      }
    });
  }
  
  /**
   * 数字千分位分隔符
   * @param {number} number 数字
   * @returns {string} 千分位分隔符数字
   */
  function numberWithDelimiter(number) {
    return number.toLocaleString('en-US');
  }

  function getScreenHeight() {
    WS.screenHeight = window.innerHeight;
    return WS.screenHeight;
  }

  /**
   * 回到顶部：插入固定按钮，滚动超过一屏高时显示，点击平滑滚回顶部。
   */
  function initScrollToTop() {
    var WS_SCROLL_TO_TOP_ID = 'ws-scroll-to-top';
    var WS_SCROLL_TO_TOP_IMG = 'https://cdn.shopify.com/s/files/1/1994/9649/files/ws-scroll-to-top_v2.png';
    if (document.getElementById(WS_SCROLL_TO_TOP_ID)) {
      return;
    }

    var $btn = $(
      '<div class="ws-scroll-to-top ws-scroll-to-top--hidden" id="' +
        WS_SCROLL_TO_TOP_ID +
        '" aria-label="Back to top">' +
        '<img src="' +
        WS_SCROLL_TO_TOP_IMG +
        '" alt="" width="48" height="48" loading="lazy" class="ws-scroll-to-top__img" draggable="false">' +
        '</div>'
    );
    $('body').append($btn);

    function syncVisibility() {
      var y = $(window).scrollTop() || 0;
      var h = window.innerHeight || document.documentElement.clientHeight || 0;
      if (y >= h) {
        $btn.removeClass('ws-scroll-to-top--hidden');
      } else {
        $btn.addClass('ws-scroll-to-top--hidden');
      }
    }

    $(window).on('scroll.wsScrollToTop', syncVisibility);
    $(window).on('resize.wsScrollToTop', syncVisibility);
    syncVisibility();

    $btn.on('click', function () {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (e) {
        $(window).scrollTop(0);
      }
    });
  }

  WS.ui.numberWithDelimiter = numberWithDelimiter;
  WS.ui.getScreenHeight = getScreenHeight;
  WS.ui.operateZeSnippet = operateZeSnippet;
  WS.ui.getSocialPostTrackData = getSocialPostTrackData;
  WS.ui.reportSocialEvent = reportSocialEvent;
  WS.ui.initSocialPopupProductExposure = initSocialPopupProductExposure;
  WS.ui.formatUsWarehouseStockTipHtml = formatUsWarehouseStockTipHtml;
  WS.ui.formatSelectedUsWarehouseStockTipHtml = formatSelectedUsWarehouseStockTipHtml;
  WS.ui.renderUsWarehouseStockTip = renderUsWarehouseStockTip;
  WS.ui.formatVariantInStockTipHtml = formatVariantInStockTipHtml;
  WS.ui.isVariantOnlineSellable = isVariantOnlineSellable;
  WS.ui.isSizeItemOnlineSellable = isSizeItemOnlineSellable;
  WS.ui.openAddressPopup = openAddressPopup;
  WS.ui.setClientClassName = setClientClassName;
  WS.ui.isThemeEditor = isThemeEditor;
  WS.ui.matchesShopifyEditorSectionType = matchesShopifyEditorSectionType;
  WS.ui.initShopifyEditorEvent = initShopifyEditorEvent;
  /** @deprecated 与 initShopifyEditorEvent 相同，保留别名 */
  WS.ui.bindShopifyEditorEvent = initShopifyEditorEvent;
  WS.ui.productObj = productObj;
  WS.ui.getProductData = getProductData;
  WS.ui.applySizeInventory = applySizeInventory;
  WS.ui.getOptionIndexByKeyword = getOptionIndexByKeyword;
  WS.ui.formatPrice = formatPrice;
  WS.ui.prefetchUrls = prefetchUrls;
  WS.ui.initResize = initResize;
  WS.ui.asyncLoadUrls = asyncLoadUrls;
  WS.ui.reportInteractiveTime = reportInteractiveTime;
  WS.ui.renderBottomDrawer = renderBottomDrawer;
  WS.ui.genDialogConfirm = genDialogConfirm;
  WS.ui.toastShowHandle = toastShowHandle;
  WS.ui.loadingPopShow = loadingPopShow;
  WS.ui.loadingPopHide = loadingPopHide;
  WS.ui.loadingBtnShow = loadingBtnShow;
  WS.ui.loadingBtnHide = loadingBtnHide;
  WS.ui.copyToClip = copyToClip;
  WS.ui.initTextReadMore = initTextReadMore;
  WS.ui.bindTextReadMoreEvents = bindTextReadMoreEvents;
  WS.ui.makeTextReadMoreHtmlOpts = makeTextReadMoreHtmlOpts;
  WS.ui.singleDayDateFormat = singleDayDateFormat;
  WS.ui.scopeDayDateFormat = scopeDayDateFormat;
  WS.ui.reporterMuti = reporterMuti;
  WS.ui.reporterSingle = reporterSingle;
  WS.ui.reporterCollection = reporterCollection;
  WS.ui.globalListExposureHandle = globalListExposureHandle;
  WS.ui.initElementExposure = initElementExposure;
  WS.ui.setFirstView = setFirstView;
  WS.ui.setInteractive = setInteractive;
  WS.ui.onRequestCollectionData = onRequestCollectionData;
  WS.ui.setAddCartAnimation = setAddCartAnimation;
  WS.ui.getCartItem = getCartItem;
  WS.ui.getSoldoutCheckout = getSoldoutCheckout;
  WS.ui.getOnSellItems = getOnSellItems;
  WS.ui.getCartInfo = getCartInfo;
  WS.ui.getSoldoutItems = getSoldoutItems;
  WS.ui.getSourceByAddToCart = getSourceByAddToCart;
  WS.ui.reporterCartState = reporterCartState;
  WS.ui.handleBuyitnowBtn = handleBuyitnowBtn;
  WS.ui.popupNoScrollHandle = popupNoScrollHandle;
  WS.ui.popupRecoveryScrollHandle = popupRecoveryScrollHandle;
  WS.ui.initImgLazyloadHandle = initImgLazyloadHandle;
  WS.ui.globalModelShowHandle = globalModelShowHandle;
  WS.ui.genReviewsStar = genReviewsStar;
  WS.ui.batchInsertReviewsModule = batchInsertReviewsModule;
  WS.ui.handleHeaderBar = handleHeaderBar;
  WS.ui.resetHeaderBar = resetHeaderBar;
  WS.ui.initScrollInteractive = initScrollInteractive;
  WS.ui.initScrollToTop = initScrollToTop;
  WS.ui.isLogin = isLogin;
  WS.ui.hidePopupBox = hidePopupBox;
  WS.ui.publicEventBind = publicEventBind;
  WS.ui.customerServiceEntrance = customerServiceEntrance;
  WS.ui.insertDeliveryDelayTipModule = insertDeliveryDelayTipModule;
  WS.ui.checkUserCountry = checkUserCountry;
  WS.ui.renderCountDownTimer = renderCountDownTimer;
  WS.ui.renderCouponItem = renderCouponItem;
  WS.ui.renderCouponListHtml = renderCouponListHtml;
  WS.ui.showPage = showPage;
  WS.ui.showPageBlock = showPageBlock;
  WS.ui.isFunctionOpenCountry = isFunctionOpenCountry;
  WS.ui.getMemberIcon = getMemberIcon;
  WS.ui.watchAjaxError = watchAjaxError;
  WS.ui.formatMonthToEnglish = formatMonthToEnglish;
  WS.ui.handleUrlAndDataByLogin = handleUrlAndDataByLogin;
  WS.ui.getResultHtml = getResultHtml;
  WS.ui.escapeXSS = escapeXSS;
  WS.ui.createDialog = createDialog;
  WS.ui.createPopup = createPopup;
  WS.ui.showRegisteModule = showRegisteModule;
  WS.ui.storeIsRegisteAd = storeIsRegisteAd;
  WS.ui.handleHeaderInteractive = handleHeaderInteractive;
})();

// 动态插入模块方法
(function () {
  // 弹窗状态
  var firstLoad = false;
  var dynamicInsertModuleFn = {
    // 动态插入头部菜单方法
    insertHeaderMenuHander: function (callback) {
      // 获取接口地址
      var headerApiUrl = `${WS.site.baseUrl}/?sections=westyle-header-menu`;
      WS.ajax({
        url: headerApiUrl,
        type: "GET",
        dataType: "html",
        success: function (res) {
          // 获取接口数据
          var responseData = JSON.parse(res || '{}') || {};
          var responseHTML = responseData["westyle-header-menu"] || '';
          var $responseHTML = $('<div></div>').html(responseHTML);
          var $menuDrawer = $responseHTML.find('#ws-header-menu-drawer').first();
          // 插入头部菜单，剥掉 Shopify section 外壳，避免 section 嵌套
          $('#ws-header-model-menubox').html($menuDrawer.length ? $menuDrawer.prop('outerHTML') : responseHTML);
          
          // 头部相关点击事件
          dynamicInsertModuleFn.bindEvent();
          callback && typeof callback === 'function' && callback();
        },
        error: function (error) {
          // WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
        },
      });
    },
    // 动态插入底部方法
    insertFooterHander: function () {
      // 获取接口地址
      var footerApiUrl = `${WS.site.baseUrl}/?sections=westyle-footer`;
      WS.ajax({
        url: footerApiUrl,
        type: "GET",
        dataType: "html",
        success: function (res) {
          // 获取接口数据
          var responseHTML = JSON.parse(res || 'null')['westyle-footer'];
          // 插入页面底部
          $('#section-westyle-footer').html(responseHTML || '');
          dynamicInsertModuleFn.insertLangInfoInFooter();

          // 全站footer曝光
          WS.ui.globalModelShowHandle(document.querySelector('#section-westyle-footer'), WS.ui.globalReportMap['showFooter'], '', 0.2);
        },
        error: function (error) {
          // WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
        },
      });
    },
    // 动态插入订阅弹窗方法（打开弹窗时请求 section 后添加到 ws-subscribe-popup-container）
    insertSubscribePopupHander: function (callback) {
      // 获取接口地址
      var subscribePopupApiUrl = `${WS.site.baseUrl}/?sections=westyle-subscribe-popup`;
      WS.ajax({
        url: subscribePopupApiUrl,
        type: "GET",
        dataType: "html",
        success: function (res) {
          // 获取接口数据
          var responseHTML = JSON.parse(res || 'null')['westyle-subscribe-popup'];
          // 插入订阅弹窗容器
          $('#ws-subscribe-popup-container').html(responseHTML || '');
          callback && typeof callback === 'function' && callback();
        },
        error: function (error) {
          WS.ui.toastShowHandle && WS.ui.toastShowHandle('Failed to load. Please try again.', 2000);
        },
      });
    },
    insertLangInfoInFooter: function() {
      var curCountry = WS.ui.countryInfoMap[WS.site.country];
      var html = `
        <div class="footer-lang-module">
          <p class="footer-lang-module_text">${curCountry.symbolCode + curCountry.symbol}</p>
        </div>
      `;
      $('.footer-lang-btn').find('.footer-menu-title').html(html);      
    },

    // 头部announcement-bar滚动方法
    announcementBarSlide: function () {
      var subscribeSlide = `
        <div class="ws-bar-slide-item" data-type="top-banner">
          <div>
            <button type="button" data-open-subscribe-popup aria-haspopup="dialog">
              New here? Get 15% off your first order. <span class="slide-btn">Claim it →</span>
            </button>
          </div>
        </div>
      `;
      if (WS.site.subscribePopupEnabled) {
        $('.ws-bar-slide-wrapper').append(subscribeSlide);
      }
      var $container = $('.ws-bar-slide-container').first();
      if (!$container.length) return;
      var slider;
      var syncAnnouncementAccess = function(index) {
        if (!slider || !slider.slides.length) return;
        var activeIndex = ((index % slider.number) + slider.number) % slider.number;
        Array.prototype.forEach.call(slider.slides, function(slide, position) {
          var active = position === activeIndex;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a[href], button').forEach(function(control) {
            control.tabIndex = active ? 0 : -1;
          });
        });
      };
      slider = new WS.Slider({
        container: ".ws-bar-slide-container",
        wrapper: ".ws-bar-slide-wrapper",
        slide: ".ws-bar-slide-item",
        direction: 'x',
        isLoop: true,
        isAuto: true,
        slideSpeed: 300,
        autoInter: 4000,
        endCallback: function(index) {
          syncAnnouncementAccess(index);
        }
      });
      syncAnnouncementAccess(0);
      Array.prototype.forEach.call(slider.wrapper.children, function(slide, index) {
        if (index < slider.copyNumber || index >= slider.copyNumber + slider.number) {
          slide.setAttribute('aria-hidden', 'true');
          slide.inert = true;
        }
      });
      $container.on('focusin.wsAnnouncementA11y', function() {
        slider.stopAuto();
        slider.isAuto = false;
      });
      $container.on('focusout.wsAnnouncementA11y', function(event) {
        if (this.contains(event.relatedTarget)) return;
        slider.isAuto = true;
        slider.startAuto();
      });
    },

    // 头部相关点击事件
    bindEvent: function () {

      var desktopNav = document.querySelector('.ws-header-pc-nav');
      if (desktopNav && !desktopNav.dataset.accessibleMenuReady) {
        desktopNav.dataset.accessibleMenuReady = 'true';
        desktopNav.classList.add('ws-nav-enhanced');
        var desktopItems = desktopNav.querySelectorAll('.ws-header-pc-nav-item.ws-has-dropdown');

        function setDesktopMenuOpen(item, open) {
          var link = item.querySelector('.ws-header-pc-nav-link');
          var dropdown = item.querySelector('.ws-header-pc-dropdown');
          item.classList.toggle('is-open', open);
          link.setAttribute('aria-expanded', open ? 'true' : 'false');
          dropdown.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        function openDesktopMenu(item) {
          desktopItems.forEach(function(other) {
            if (other !== item) setDesktopMenuOpen(other, false);
          });
          setDesktopMenuOpen(item, true);
        }

        desktopItems.forEach(function(item) {
          var link = item.querySelector('.ws-header-pc-nav-link');
          item.addEventListener('mouseenter', function() {
            if (desktopNav.contains(document.activeElement) && !item.contains(document.activeElement)) return;
            if (!item.classList.contains('ws-menu-escape-closed')) openDesktopMenu(item);
          });
          item.addEventListener('mouseleave', function() {
            item.classList.remove('ws-menu-escape-closed');
            if (!item.contains(document.activeElement)) setDesktopMenuOpen(item, false);
          });
          item.addEventListener('focusin', function(event) {
            if (event.target === link && item.classList.contains('ws-menu-escape-closed')) return;
            openDesktopMenu(item);
          });
          item.addEventListener('focusout', function(event) {
            if (!item.contains(event.relatedTarget)) {
              setDesktopMenuOpen(item, false);
              item.classList.remove('ws-menu-escape-closed');
            }
          });
          item.addEventListener('keydown', function(event) {
            if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
            event.preventDefault();
            item.classList.add('ws-menu-escape-closed');
            setDesktopMenuOpen(item, false);
            link.focus();
          });
        });

        desktopNav.addEventListener('keydown', function(event) {
          if (event.key !== 'Tab' || !event.shiftKey || !event.target.classList.contains('ws-header-pc-nav-link')) return;
          var previousItem = event.target.closest('.ws-header-pc-nav-item').previousElementSibling;
          if (previousItem && previousItem.classList.contains('ws-has-dropdown')) {
            previousItem.classList.remove('ws-menu-escape-closed');
            openDesktopMenu(previousItem);
          }
        });
      }

      $(document).on('click', '.show-iframe_terms-of-service', function() {
        WS.ui.showPage('ws-terms-of-service');
        // 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.userSubscriptionReportMap['clickTermsOfServiceJoinCollectivePop'],
        });
      });

      $(document).on('click', '#terms-privacy', function() {
        WS.ui.showPageBlock('/pages/terms-conditions', '#MainContent');
      });

      $(document).on('click', '.show-iframe_privacy-policy', function() {
        WS.ui.showPage('ws-privacy-policy');
        // 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.userSubscriptionReportMap['clickPrivacyPolicyJoinCollectivePop'],
        });
      });

      $(document).on("click", "#popup-login-btn", function () {
        $('.ws-vertical-popupbox').remove();
        WS.ui.loginFn.createLoginPopup && WS.ui.loginFn.createLoginPopup(true, '', 'subscribe');
      })

      function openHeaderMenuDrawer() {
        // 禁止弹窗底部滚动方法
        WS.ui.popupNoScrollHandle();
        WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
        $("#ws-header-menu-drawer").addClass("is-active");
        setTimeout(function () {
          $("#ws-header-menu-drawer").addClass("is-visible");
        }, 50);

        WS.stat({
          eid: WS.ui.reportType['moduleShow'],
          ext1: WS.ui.globalReportMap['showMenu']
        });
      }

      // 点击顶部导航左侧菜单栏
      $(document).on("click", "#header-menu-open", function() {
        if (!$('#ws-header-menu-drawer').length) {
          WS.ui.dynamicInsertModuleFn.insertHeaderMenuHander(function () {
            openHeaderMenuDrawer();
          });
          return;
        }
        openHeaderMenuDrawer();
      });
      // 点击关闭弹窗
      $(document).on("click", "#menu-close-btn", function () {
        WS.ui.popupRecoveryScrollHandle(true);
        $("#ws-header-menu-drawer").removeClass("is-visible");
        setTimeout(function () {
          $("#ws-header-menu-drawer").removeClass("is-active");
          WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(2);
        }, 350);
      });

      // 点击遮罩/空白处关闭
      $(document).on("click", "#ws-header-menu-drawer .ws-header-menu-overlay", function () {
        WS.ui.popupRecoveryScrollHandle(true);
        $("#ws-header-menu-drawer").removeClass("is-visible");
        setTimeout(function () {
          $("#ws-header-menu-drawer").removeClass("is-active");
          WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(2);
        }, 350);
      });

      // 移动端分类链接始终导航；独立按钮和行内非链接区域负责展开。
      $(document).on("click", "[id^='ws-menu-row-']", function(e) {
        if ($(e.target).closest('.ws-menu-toggle-btn').length) return;
        if ($(e.target).closest('a').length) return;
        var $row = $(this);
        var $btn = $row.find('.ws-menu-toggle-btn.menu-icon_open').first();
        if (!$btn.length) return;
        e.preventDefault();
        e.stopPropagation();
        $btn.trigger('click');
      });

      $(document).on("click", ".menu-icon_open", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $btn = $(this);
        var $children = $btn.closest('.item-select-box').siblings('.menulist-item-nav-children');
        var $plus = $btn.find('.menu-icon--plus');
        var $minus = $btn.find('.menu-icon--minus');
        if ($btn.attr('aria-expanded') === 'false') {
          $btn.attr('aria-expanded', 'true');
          $btn.attr('aria-label', $btn.attr('data-collapse-label'));
          $plus.prop('hidden', true);
          $minus.prop('hidden', false);
          $children.prop('hidden', false);
          $children.addClass('module-open');
        } else {
          $btn.attr('aria-expanded', 'false');
          $btn.attr('aria-label', $btn.attr('data-expand-label'));
          $plus.prop('hidden', false);
          $minus.prop('hidden', true);
          $children.removeClass('module-open');
          $children.prop('hidden', true);
        }
      })

      // 点击底部footer菜单展开
      $(document).on("click", ".ws-footer-model .menu-list-title", function () {
        // 当没有展开时，添加class并展开
        if( !$(this).hasClass('title-active') ) {
          // 添加展开样式
          $(this).addClass('title-active');
          // 显示收起图片，隐藏打开图片
          $(this).find('.btn-close').show();
          $(this).find('.btn-open').hide();
          // 显示模块
          $(this).parents('.con-menu-list').find('.menu-list-con').attr('style', 'display: flex;')
        } else {
          // 去除展开样式
          $(this).removeClass('title-active');
          // 显示打开图片，隐藏收起图片
          $(this).find('.btn-close').hide();
          $(this).find('.btn-open').show();
          // 隐藏模块
          $(this).parents('.con-menu-list').find('.menu-list-con').attr('style', 'display: none;')
        }
      })

      // 点击icon关闭弹窗
      $(document).on("click", ".ws-vertical-popupbox .con-close-btn,.ws-vertical-popupbox-overlay",function () {
        var noHidePopup = $(this).attr('data-no-hide-popup');
        if (noHidePopup) return;
        WS.ui.hidePopupBox(this);
       });

      $(document).on('click', '#registe-rules-btn', function() {
        var innerText = `<p class="registe-module_rules-info">By clicking "Join the Collective for Free" you agree to the <a class="show-iframe_terms-of-service">Terms of Service</a> for the Grae Cove Collective, a membership program, and to email marketing. Click how we use your personal data in our <a class="show-iframe_privacy-policy">Privacy Policy</a>.</p>`;
        var popupStr = WS.ui.createDialog('registe-rules', innerText);
        $('body').append(popupStr);
      });
    },
  }

  WS.ui.dynamicInsertModuleFn = {
    insertHeaderMenuHander: dynamicInsertModuleFn.insertHeaderMenuHander,
    insertFooterHander: dynamicInsertModuleFn.insertFooterHander,
    insertSubscribePopupHander: dynamicInsertModuleFn.insertSubscribePopupHander,
    announcementBarSlide: dynamicInsertModuleFn.announcementBarSlide,
  };
})();

(function () {
  var allowConfirm = false;
  var pageFn = {
    bindEvent: function () {
      $(document).on('click', '.about-us_tab', function() {
        var scrollHeight = $(window).scrollTop();
        var moduleTop = 0;
        if ($(this).hasClass('about-us_tab1')) {
          moduleTop = $(".about-us-module-tab1").offset().top - 80;
        } else if ($(this).hasClass('about-us_tab2')) {
          moduleTop = $(".about-us-module-tab2").offset().top - 80;
        } else if ($(this).hasClass('about-us_tab3')) {
          moduleTop = $(".about-us-module-tab3").offset().top - 80;
        }

        if (scrollHeight < moduleTop) {
          $(window).scrollTo && $(window).scrollTo({pos : moduleTop});
        }
      });

			$(document).on('click', '#forget-pwd_confirm-btn', function() {
				pageFn.handleConfirm();
      });
      
      $(document).on('click', '#forget-pwd_login-btn', function() {
        WS.ui.loginFn.createLoginPopup(true, `${WS.site.baseUrl}/pages/my`, 'my_account');
      });

      $(document).on('click', '.forget-pwd_input-icon-show', function() {
				$(this).hide();
				$(this).siblings('.forget-pwd_input-icon-hide').show();
        $(this).siblings('.forget-pwd_input').attr("type", "password")
			});

      $(document).on('click', '.forget-pwd_input-icon-hide', function() {
				$(this).hide();
				$(this).siblings('.forget-pwd_input-icon-show').show();
        $(this).siblings('.forget-pwd_input').attr("type", "text");
			});

      $('.forget-pwd_input').on('keyup',function(e) {
        var val = $(this).val();
        var $errorTip = $(this).siblings('.forget-pwd_error-tip');
        var $title = $(this).siblings('.forget-pwd_input-title');
        var $hideValIcon = $(this).siblings('.forget-pwd_input-icon-hide');
        var $showValIcon = $(this).siblings('.forget-pwd_input-icon-show');
        var $comfirmBtn = $('#forget-pwd_confirm-btn');
        // 没输入
        if (!val) {
          $title.hide();
          $showValIcon.hide();
          $hideValIcon.hide();
          $errorTip.hide();
          allowConfirm = false;
          $(this).attr("type", "password")
        } else {
        // title显示
          $title.show();
          if ($hideValIcon.css('display') === 'none' && $showValIcon.css('display') === 'none') {
            $hideValIcon.show()
          }
          // 长度限制
          if($('#newPassword').val().length > 18 || $('#newPassword').val().length < 6) {
            $comfirmBtn.removeClass('allow-confirm');
            $errorTip.show().html('6～18 characters minimum');
            allowConfirm = false;
            return;
          } else {
            $errorTip.hide();
          }
          if (pageFn.checkPwd($('#newPassword').val()) && $('#againPassword').val()) {
            allowConfirm = true
          }
          // 都通过设置按钮可点击样式
          allowConfirm ? $comfirmBtn.addClass('allow-confirm') : $comfirmBtn.removeClass('allow-confirm');
        }
			});
		},
    checkPwd: function(val) {
      if (val.length > 18 || val.length < 6) {
        return false;
      }
      return true;
    },
		handleConfirm: function() {
      var newPwdVal = $('#newPassword').val();
      var againPwdVal = $('#againPassword').val();
      var $againPwdErrorTip = $('.again-password_error-tip');
      if (!newPwdVal) {
        return;
      }
      if (!againPwdVal) {
        return;
      }
      if (newPwdVal !== againPwdVal) {
        $againPwdErrorTip.show().html(WS.$t('public.customer.reset_password_text3'));
        return;
      }
      $againPwdErrorTip.hide();
      var params = JSON.stringify({
        newPassword: newPwdVal,
        newAgainPassword: againPwdVal,
        verifyToken: WS.getParam('verifyToken', location.href)
      })
			WS.ajax({
				url: WS.ui.routes.resetPasswordApi,
				type: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        data: params,
				success: function(resp) {
          if (!resp.hasError && resp.code == "0") {
            $('.forget-pwd_box').hide();
            $('.forget-pwd_success-box').show();
          } else if (resp.error.code == ( 'F10409' || 'f10410' )) {
            $('.forget-pwd_box').hide();
            $('.forget-pwd_fail-box').show();
          } else {
            WS.ui.toastShowHandle(resp.error.message);
          }
				},
				error: function (error) {
					WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
			 }
			});
		}
  };

  WS.ui.pageFn = {
    bindEvent: pageFn.bindEvent
  };
})();

/**
 * zepto 扩展方法
 */
(function() {
  $.fn.scrollTo = function(options){
    var defaultOpt = {
        pos: 0,    //滚动目标位置
        durTime : 600,  //过渡动画时间
        delay : 30,     //定时器时间
        callback: null   //回调函数
    };
    var opts = $.extend(defaultOpt,options),
        timer = null,
        _this = this,
        curTop = _this.scrollTop(),//滚动条当前的位置
        subTop = opts.pos - curTop,    //滚动条目标位置和当前位置的差值
        index = 0,
        dur = Math.round(opts.durTime / opts.delay),
        smoothScroll = function(t) {
          index++;
          var per = Math.round(subTop/dur);
          if(index >= dur){
              _this.scrollTop(t);
              timer && window.cancelAnimationFrame(timer);
              timer = null;
              // window.clearInterval(timer);
              if(opts.callback && typeof opts.callback == 'function'){
                  opts.callback();
              }
              return;
          } else {
            _this.scrollTop(curTop + index*per);
            timer = window.requestAnimationFrame(smoothScroll.bind(_this, opts.pos));
          }
        };
    smoothScroll(opts.pos);
    // timer = window.setInterval(function() {
    //   smoothScroll(opts.pos);
    // }, opts.delay);
    return _this;
  };
})();

/**
 * 订阅模块相关方法
 */
(function() {
  var EMAIL_REG = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var SUBSCRIBE_REPORT_PAGES = ['index', 'collection', 'product', 'search'];
  var SUBSCRIBE_AUTO_OPEN_DELAY = 10000;
  var POSTSCRIPT_EMBEDDED_FORM_SCRIPT_URL = 'https://sdk.postscript.io/embeddedForm.bundle.js';
  var POSTSCRIPT_EMBEDDED_READY_TIMEOUT = 1600;
  var POSTSCRIPT_EMBEDDED_READY_POLL_DELAY = 80;
  var POSTSCRIPT_EMBEDDED_READY_SETTLE_DELAY = 300;
  var POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR = '.iti--fullscreen-popup';
  var postscriptCountryTriggerRect = null;
  var postscriptCountryDropdownStylesBound = false;
  var postscriptCountryDropdownObserver = null;
  var postscriptCountryDropdownUpdateRaf = null;
  var postscriptCountryDropdownHydrating = false;
  var postscriptEmbeddedStepObserver = null;
  var postscriptEmbeddedStepShadowObserver = null;
  var postscriptEmbeddedStepUpdateRaf = null;
  var postscriptEmbeddedMountTimeoutId = null;
  var postscriptOtpFetchObserverBound = false;
  var postscriptVerificationCodeEntered = false;
  var postscriptEmbeddedCompletionHandled = false;
  var postscriptLastSubmitReportPhone = '';
  var postscriptLastSubmitReportAt = 0;
  var postscriptPopupOpenPending = false;
  var postscriptPopupReadyTimeoutId = null;
  var postscriptPopupEventsBound = false;
  var postscriptPopupEmailSyncByPopup = {};
  var postscriptPopupSuccessReportState = {};
  var subscribeScrollRestoreTimers = [];
  var subscribeAppliedToastTimer = null;
  var subscribePageLockActive = false;
  var subscribePageLockScrollY = 0;
  var subscribeTouchLockBound = false;
  var subscribeTouchStartY = 0;
  // 订阅弹窗移动端键盘兜底：仅移动端记录打开时高度，避免键盘弹起后 viewport 缩小导致整体上移。
  var subscribePopupViewportHeight = 0;
  var subscribePopupViewportUpdateRaf = null;
  var subscribePopupViewportBound = false;
  var subscriptionExposureState = {
    showSubscriptionIcon: false,
    showEmailSmsPopup: false
  };

  function shouldReportSubscribeModuleShow(allowedPages) {
    var page = WS && WS.site ? WS.site.page : '';
    return allowedPages.indexOf(page) !== -1;
  }

  function reportSubscribeModuleShowOnce(reportKey, allowedPages) {
    if (!reportKey || subscriptionExposureState[reportKey]) return;
    if (!shouldReportSubscribeModuleShow(allowedPages)) return;
    var ext1 = WS.ui.loginRegistrationProcessMap && WS.ui.loginRegistrationProcessMap[reportKey];
    if (!ext1) return;
    subscriptionExposureState[reportKey] = true;
    var payload = {
      eid: WS.ui.reportType['moduleShow'],
      ext1: ext1
    };
    WS.stat(payload);
  }

  function reportSubscribeClick(reportKey, ext2, ext3) {
    if (!reportKey) return;
    if (!shouldReportSubscribeModuleShow(SUBSCRIBE_REPORT_PAGES)) return;
    var ext1 = WS.ui.loginRegistrationProcessMap && WS.ui.loginRegistrationProcessMap[reportKey];
    if (!ext1) return;
    var payload = {
      eid: WS.ui.reportType['click'],
      ext1: ext1
    };
    if (typeof ext2 !== 'undefined') payload.ext2 = ext2;
    if (typeof ext3 !== 'undefined') payload.ext3 = ext3;
    WS.stat(payload);
  }

  // Postscript 官方 Popup 埋点：保留现有 ext1 事件名，并附带 Popup ID 与名称方便后台区分活动。
  function reportPostscriptPopupEvent(reportKey, detail, options) {
    // 官方 Popup 可配置在任意页面展示，因此不沿用旧自定义弹窗的页面白名单。
    if (!reportKey) return;
    var ext1 = WS.ui.loginRegistrationProcessMap && WS.ui.loginRegistrationProcessMap[reportKey];
    if (!ext1) return;

    detail = detail || {};
    options = options || {};
    var payload = {
      eid: options.eid || WS.ui.reportType['click'],
      ext1: ext1
    };
    if (typeof options.ext2 !== 'undefined') payload.ext2 = options.ext2;
    if (typeof options.ext3 !== 'undefined') payload.ext3 = options.ext3;
    if (detail.popupId != null) payload.ext4 = String(detail.popupId);
    if (detail.popupName) payload.ext5 = String(detail.popupName);
    if (typeof options.ext6 !== 'undefined') payload.ext6 = options.ext6;
    if (typeof options.ext7 !== 'undefined') payload.ext7 = options.ext7;
    WS.stat(payload);
  }

  function getSubscribeTrigger(e) {
    if (!e || !e.target || !e.target.closest) return null;
    return e.target.closest('#subscribe-fab-btn, [data-open-subscribe-popup]');
  }

  function getPostscriptPopupApi() {
    var postscript = window.postscript;
    if (
      !postscript ||
      typeof postscript !== 'object' ||
      !postscript.popups ||
      typeof postscript.popups.find !== 'function' ||
      typeof postscript.popups.open !== 'function'
    ) {
      return null;
    }
    return postscript.popups;
  }

  // 订阅成功后统一触发现有购物车折扣流程；空购物车会在后续购物车请求时继续自动应用。
  function applySubscribeWelcomeDiscount() {
    var showSuccess = function() {
      WS.ui.toastShowHandle && WS.ui.toastShowHandle("You've unlocked 15% off.", 4000);
    };
    if (WS.ui.cartFn && typeof WS.ui.cartFn.ensureAutoDiscountApplied === 'function') {
      WS.ui.cartFn.ensureAutoDiscountApplied(showSuccess);
      return;
    }
    showSuccess();
  }

  function getPostscriptPopupEventKey(detail) {
    if (detail && detail.popupId != null) return 'id:' + String(detail.popupId);
    if (detail && detail.popupName) return 'name:' + String(detail.popupName);
    return 'active-popup';
  }

  // Postscript 的 formSubmit 会返回 values.email；同步到自定义 Shopify 订阅接口并读取首单状态。
  function syncPostscriptPopupEmail(detail) {
    var values = detail && detail.values ? detail.values : {};
    var email = String(values.email || '').trim();
    if (!email || !EMAIL_REG.test(email)) return;

    var popupKey = getPostscriptPopupEventKey(detail);
    var normalizedEmail = email.toLowerCase();
    var currentState = postscriptPopupEmailSyncByPopup[popupKey];
    if (currentState && currentState.email === normalizedEmail) return;

    var syncState = { email: normalizedEmail };
    postscriptPopupEmailSyncByPopup[popupKey] = syncState;

    subscribeModuleFn.customerSubscription(email, '', function(isSuccess) {
      if (postscriptPopupEmailSyncByPopup[popupKey] !== syncState) return;
      if (!isSuccess) {
        delete postscriptPopupEmailSyncByPopup[popupKey];
        return;
      }
      if (subscribeModuleFn.isFirstOrder) {
        applySubscribeWelcomeDiscount();
      }
    });
  }

  // 自定义弹窗关闭后，购物车等主动入口改为打开 Postscript 原生 Popup。
  function openPostscriptPopup() {
    function showUnavailableMessage() {
      WS.ui.toastShowHandle && WS.ui.toastShowHandle('SMS signup is unavailable right now. Please try again later.', 2500);
    }

    function findAndOpen() {
      var popupApi = getPostscriptPopupApi();
      if (!popupApi) return false;

      try {
        var subscriberId = typeof window.postscript.getSubscriberId === 'function'
          ? window.postscript.getSubscriberId()
          : '';
        if (
          (typeof subscriberId === 'string' || typeof subscriberId === 'number') &&
          String(subscriberId).trim()
        ) {
          subscribeModuleFn.updateCustomerFlags({
            subscribed: true,
            // Postscript 原生 Popup 自行管理优惠，避免再触发旧版 WELCOME15 自动优惠逻辑。
            firstOrder: false
          });
          window.dispatchEvent(new CustomEvent('ws:subscribe:submit', {
            detail: {
              isSuccess: true,
              popup: null,
              source: 'postscript-existing-subscriber'
            }
          }));
          WS.ui.toastShowHandle && WS.ui.toastShowHandle("You're already subscribed.", 2500);
          return true;
        }
      } catch (err) {
        // Subscriber detection should not block the explicit popup trigger.
      }

      var findOptions = {
        type: 'standard',
        respectPage: true,
        respectSubscriber: true,
        respectCountry: true,
        respectPlatform: true,
        // 用户主动点击购物车入口时，允许重新打开之前关闭过的 Popup。
        respectStatus: false
      };

      Promise.resolve(popupApi.find(Object.assign({}, findOptions, { triggerType: 'Custom' })))
        .then(function(popupId) {
          if (popupId) return popupId;
          return popupApi.find(Object.assign({}, findOptions, { triggerType: 'Delay' }));
        })
        .then(function(popupId) {
          if (!popupId) {
            showUnavailableMessage();
            return;
          }
          popupApi.open(popupId, {
            activePopupBehavior: 'ALWAYS_DISMISS',
            respectPopupStatus: false,
            respectCooldown: false
          });
        })
        .catch(function() {
          showUnavailableMessage();
        });
      return true;
    }

    if (findAndOpen() || postscriptPopupOpenPending) return;

    postscriptPopupOpenPending = true;
    var handleReady = function() {
      postscriptPopupOpenPending = false;
      if (postscriptPopupReadyTimeoutId) {
        window.clearTimeout(postscriptPopupReadyTimeoutId);
        postscriptPopupReadyTimeoutId = null;
      }
      window.removeEventListener('postscriptReady', handleReady);
      if (!findAndOpen()) showUnavailableMessage();
    };

    window.addEventListener('postscriptReady', handleReady);
    postscriptPopupReadyTimeoutId = window.setTimeout(function() {
      postscriptPopupReadyTimeoutId = null;
      postscriptPopupOpenPending = false;
      window.removeEventListener('postscriptReady', handleReady);
      showUnavailableMessage();
    }, 5000);
  }

  function bindPostscriptPopupEvents() {
    if (postscriptPopupEventsBound) return;
    postscriptPopupEventsBound = true;

    window.addEventListener('postscriptPopup', function(ev) {
      var detail = ev && ev.detail ? ev.detail : {};
      var eventType = detail.type || '';

      if (eventType === 'impression') {
        // isReopen=true 表示用户从最小化状态重新打开，仍按一次新的展示上报。
        reportPostscriptPopupEvent('showEmailSmsPopup', detail, {
          eid: WS.ui.reportType['moduleShow'],
          ext2: detail.isReopen ? 'reopen' : 'open'
        });
        return;
      }

      if (eventType === 'close') {
        reportPostscriptPopupEvent('emailSmsPopupClose', detail, {
          ext2: detail.hard === true ? 'hard' : (detail.hard === false ? 'soft' : '')
        });
        return;
      }

      if (eventType === 'formSubmit') {
        var values = detail.values || {};
        // 多步骤 Popup 会分别提交邮箱和手机号，每次 formSubmit 都保留一条提交埋点。
        reportPostscriptPopupEvent('emailSmsSubmit', detail, {
          ext2: String(values.email || '').trim(),
          ext3: String(values.phone || '').trim()
        });
        syncPostscriptPopupEmail(detail);
        return;
      }
      if (eventType !== 'subscriberCreated') return;

      var subscriberId = detail.subscriberId != null ? String(detail.subscriberId) : '';
      var successReportKey = subscriberId
        ? getPostscriptPopupEventKey(detail) + ':subscriber:' + subscriberId
        : '';
      // SDK 极端情况下可能重复派发成功事件；有 subscriberId 时只上报一次。
      if (!successReportKey || !postscriptPopupSuccessReportState[successReportKey]) {
        if (successReportKey) postscriptPopupSuccessReportState[successReportKey] = true;
        reportPostscriptPopupEvent('emailSmsSubscribeSuccess', detail, {
          eid: WS.ui.reportType['custom'],
          ext2: subscriberId,
          ext3: detail.discountCode || '',
          ext6: detail.cashbackCode || '',
          ext7: typeof detail.autoApplyOfferEnabled === 'boolean'
            ? String(detail.autoApplyOfferEnabled)
            : ''
        });
      }

      var emailSyncState = postscriptPopupEmailSyncByPopup[getPostscriptPopupEventKey(detail)];
      if (!emailSyncState) {
        subscribeModuleFn.updateCustomerFlags({
          subscribed: true,
          // 未捕获邮箱时仍沿用 Postscript 自身的订阅状态，不额外发放首单优惠。
          firstOrder: false
        });
      }
      if (detail.subscriberId) {
        localStorage.setItem('westyle_postscript_subscriber_id', detail.subscriberId);
      }
      // 邮箱提交已经调用自定义接口并处理折扣，避免 subscriberCreated 再次触发购物车逻辑。
      if (emailSyncState) return;

      window.dispatchEvent(new CustomEvent('ws:subscribe:submit', {
        detail: {
          isSuccess: true,
          popup: null,
          source: 'postscript-popup',
          discountCode: detail.discountCode || ''
        }
      }));
    });
  }

  function shouldReportSubscriptionClick() {
    var page = WS && WS.site ? WS.site.page : '';
    return SUBSCRIBE_REPORT_PAGES.indexOf(page) !== -1;
  }

  function resetSubscribeTrackingSession(popup) {
    postscriptLastSubmitReportPhone = '';
    postscriptLastSubmitReportAt = 0;
    if (popup && popup.removeAttribute) popup.removeAttribute('data-form-started-reported');
  }

  // 使用 layout viewport 高度作为弹窗基准，不使用键盘弹起后的 visual viewport 高度。
  function getSubscribeLayoutViewportHeight() {
    return Math.round(Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0));
  }

  function getSubscribeFocusedElementPath(ev) {
    if (ev && ev.composedPath) return ev.composedPath();
    return ev && ev.target ? [ev.target] : [];
  }

  // Postscript 输入框可能在 Shadow DOM 内，通过 composedPath 判断是否来自订阅弹窗里的文本控件。
  function isSubscribePopupTextControl(ev) {
    var path = getSubscribeFocusedElementPath(ev);
    var hasPopup = false;
    var hasTextControl = false;

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;

      if (node.classList && node.classList.contains('ws-subscribe-popup')) {
        hasPopup = true;
      }

      var tagName = String(node.tagName || '').toLowerCase();
      if (
        tagName === 'textarea' ||
        tagName === 'select' ||
        node.isContentEditable ||
        (tagName === 'input' && !/checkbox|radio|button|submit|reset|hidden/i.test(String(node.type || '')))
      ) {
        hasTextControl = true;
      }
    }

    var target = ev && ev.target && ev.target.closest ? ev.target : null;
    if (!hasPopup && target && target.closest('.ws-subscribe-popup')) hasPopup = true;
    if (!hasTextControl && target && target.closest('.ws-postscript-embedded-form')) hasTextControl = true;

    return hasPopup && hasTextControl;
  }

  function setSubscribePopupKeyboardState(isActive) {
    var shouldActivate = !!isActive && isSubscribePopupMobileViewport();
    document.documentElement.classList.toggle('ws-subscribe-keyboard-open', shouldActivate);
    document.body.classList.toggle('ws-subscribe-keyboard-open', shouldActivate);
  }

  // 移动端键盘会改变 visual viewport，高度锁定在弹窗打开瞬间；PC 端不写入该变量。
  function syncSubscribePopupViewportHeight(forceMeasure) {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    if (!popup) return;

    if (!isSubscribePopupMobileViewport()) {
      resetSubscribePopupViewportLock(popup);
      return;
    }

    if (forceMeasure || !subscribePopupViewportHeight) {
      var nextHeight = getSubscribeLayoutViewportHeight();
      if (subscribePopupViewportHeight && nextHeight && nextHeight < subscribePopupViewportHeight * 0.85) {
        return;
      }
      subscribePopupViewportHeight = nextHeight;
    }

    if (!subscribePopupViewportHeight) return;
    popup.style.setProperty('--ws-subscribe-popup-height', subscribePopupViewportHeight + 'px');
  }

  // resize/visualViewport 事件可能连续触发，用 RAF 合并更新，降低真实机键盘动画期间的抖动。
  function scheduleSubscribePopupViewportSync(forceMeasure) {
    if (!isSubscribePopupMobileViewport()) {
      resetSubscribePopupViewportLock(document.querySelector('.ws-subscribe-popup.is-visible'));
      schedulePostscriptCountryDropdownUpdate();
      return;
    }

    if (subscribePopupViewportUpdateRaf) {
      if (window.cancelAnimationFrame) window.cancelAnimationFrame(subscribePopupViewportUpdateRaf);
      window.clearTimeout(subscribePopupViewportUpdateRaf);
    }

    var runSync = function() {
      subscribePopupViewportUpdateRaf = null;
      var keyboardOpen = document.body.classList.contains('ws-subscribe-keyboard-open');
      syncSubscribePopupViewportHeight(forceMeasure && !keyboardOpen);
      schedulePostscriptCountryDropdownUpdate();
    };

    subscribePopupViewportUpdateRaf = window.requestAnimationFrame ? window.requestAnimationFrame(runSync) : window.setTimeout(runSync, 0);
  }

  function bindSubscribePopupViewportLock() {
    if (subscribePopupViewportBound) return;
    subscribePopupViewportBound = true;

    document.addEventListener('focusin', function(ev) {
      if (!isSubscribePopupMobileViewport()) return;
      if (!isSubscribePopupTextControl(ev)) return;
      setSubscribePopupKeyboardState(true);
      scheduleSubscribePopupViewportSync(false);
    }, true);

    document.addEventListener('focusout', function(ev) {
      if (!isSubscribePopupMobileViewport()) return;
      if (!isSubscribePopupTextControl(ev)) return;
      window.setTimeout(function() {
        // Shadow DOM 内输入框失焦会先把 activeElement 指到 custom element，延迟判断可避免误清键盘态。
        var activeEl = document.activeElement;
        var popup = document.querySelector('.ws-subscribe-popup.is-visible');
        var activeTag = String(activeEl && activeEl.tagName || '').toLowerCase();
        var stillFocused = !!(
          popup &&
          activeEl &&
          popup.contains(activeEl) &&
          (
            /input|textarea|select/i.test(activeTag) ||
            activeTag === 'postscript-embedded-form' ||
            (activeEl.closest && activeEl.closest('.ws-postscript-embedded-form'))
          )
        );
        if (stillFocused) return;
        setSubscribePopupKeyboardState(false);
        scheduleSubscribePopupViewportSync(true);
      }, 120);
    }, true);

    window.addEventListener('resize', function() {
      if (!isSubscribePopupMobileViewport()) {
        resetSubscribePopupViewportLock(document.querySelector('.ws-subscribe-popup.is-visible'));
        return;
      }
      scheduleSubscribePopupViewportSync(true);
    });

    window.addEventListener('orientationchange', function() {
      if (!isSubscribePopupMobileViewport()) {
        resetSubscribePopupViewportLock(document.querySelector('.ws-subscribe-popup.is-visible'));
        return;
      }
      subscribePopupViewportHeight = 0;
      window.setTimeout(function() {
        scheduleSubscribePopupViewportSync(true);
      }, 250);
    });

    if (window.visualViewport) {
      // iOS/Instagram WebView 键盘弹出时主要触发 visualViewport resize/scroll。
      window.visualViewport.addEventListener('resize', function() {
        if (!isSubscribePopupMobileViewport()) return;
        scheduleSubscribePopupViewportSync(false);
      });
      window.visualViewport.addEventListener('scroll', function() {
        if (!isSubscribePopupMobileViewport()) return;
        scheduleSubscribePopupViewportSync(false);
      });
    }
  }

  // 弹窗关闭时移除高度变量和键盘态，避免影响下一次打开或页面滚动恢复。
  function resetSubscribePopupViewportLock(popup) {
    setSubscribePopupKeyboardState(false);
    subscribePopupViewportHeight = 0;
    if (subscribePopupViewportUpdateRaf) {
      if (window.cancelAnimationFrame) window.cancelAnimationFrame(subscribePopupViewportUpdateRaf);
      window.clearTimeout(subscribePopupViewportUpdateRaf);
      subscribePopupViewportUpdateRaf = null;
    }
    if (popup && popup.style) popup.style.removeProperty('--ws-subscribe-popup-height');
  }

  function closeSubscribePopup(popup, keepScrollLocked) {
    if (!popup) return;
    requestPostscriptCountryDropdownClose();
    resetPostscriptEmbeddedForm(popup);
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    resetSubscribePopupViewportLock(popup);
    cleanupPostscriptExternalLayers();
    WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(2);
    if (!keepScrollLocked) {
      scheduleSubscribePageScrollRestore();
    }
  }

  // Keep closing independent from the embedded SDK's event propagation. Some
  // Postscript steps stop/retarget pointer events inside their custom element.
  function bindSubscribePopupCloseControls(popup) {
    if (!popup || popup.getAttribute('data-close-controls-bound') === '1') return;
    popup.setAttribute('data-close-controls-bound', '1');

    var controls = popup.querySelectorAll('.ws-subscribe__close, [data-close-popup], [data-subscribe-maybe-later]');
    for (var i = 0; i < controls.length; i++) {
      controls[i].addEventListener('click', function(ev) {
        ev.preventDefault();
        closeSubscribePopup(popup);
      });
    }
  }

  function getSubscribeStorageValue(key) {
    try {
      return String(localStorage.getItem(key) || '').trim();
    } catch (err) {
      return '';
    }
  }

  function getStoredSubscribeEmail() {
    return getSubscribeStorageValue('westyle_email');
  }

  function getStoredSubscribePhone() {
    return getSubscribeStorageValue('westyle_phone');
  }

  function hasCompletedSmsSubscribe() {
    return !!getStoredSubscribePhone();
  }

  function hasCompletedSubscribe() {
    return !!getStoredSubscribeEmail() && hasCompletedSmsSubscribe();
  }

  function getInitialSubscribeStep(initialStep) {
    if (hasCompletedSubscribe()) return 'subscribed';
    if (getStoredSubscribeEmail()) return 'phone';
    return initialStep === 'phone' ? 'phone' : 'email';
  }

  function showSubscribeStep(popup, step) {
    if (!popup) return;
    var steps = popup.querySelectorAll('[data-subscribe-step]');
    for (var i = 0; i < steps.length; i++) {
      steps[i].hidden = String(steps[i].getAttribute('data-subscribe-step') || '') !== step;
    }
    if (step === 'phone') {
      startPostscriptEmbeddedStepObserver(popup);
      setPostscriptEmbeddedState(popup, true, '');
      var loadPhoneStep = function() {
        if (popup.classList && !popup.classList.contains('is-visible')) return;
        loadPostscriptEmbeddedFormScript(popup);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(loadPhoneStep);
      } else {
        window.setTimeout(loadPhoneStep, 0);
      }
    } else if (step === 'email') {
      stopPostscriptEmbeddedStepObserver();
      resetPostscriptEmbeddedStepCopy(popup);
      preloadPostscriptEmbeddedFormScript();
    } else if (step === 'subscribed') {
      resetPostscriptEmbeddedForm(popup);
    }
  }

  // Postscript 移动端国家列表由 SDK 输出；缺失国旗时用国家码兜底渲染。
  function getCountryFlagEmoji(countryCode) {
    var code = String(countryCode || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return '';
    return code.replace(/./g, function(letter) {
      return String.fromCodePoint(127397 + letter.charCodeAt(0));
    });
  }

  function hydratePostscriptCountryFlags(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var dropdown = scope.matches && scope.matches(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR) ? scope : scope.querySelector(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR);
    if (!dropdown) return;
    if (dropdown.getAttribute('data-ws-flags-hydrated') === '1') return;

    var countries = dropdown.querySelectorAll('.iti__country[data-country-code]');
    if (!countries.length) return;

    postscriptCountryDropdownHydrating = true;

    try {
      for (var i = 0; i < countries.length; i++) {
        var country = countries[i];
        var countryCode = String(country.getAttribute('data-country-code') || '').toLowerCase();
        var flagEmoji = getCountryFlagEmoji(countryCode);
        if (!flagEmoji) continue;

        var flagBox = country.querySelector('.iti__flag-box');
        if (!flagBox) {
          flagBox = document.createElement('span');
          flagBox.className = 'iti__flag-box';
          country.insertBefore(flagBox, country.firstChild);
        }

        var flag = flagBox.querySelector('.iti__flag');
        if (!flag) {
          flag = document.createElement('span');
          flag.className = 'iti__flag iti__' + countryCode;
          flagBox.appendChild(flag);
        }

        if (flag.getAttribute('data-ws-flag-hydrated') === '1') continue;
        if (!String(flag.textContent || '').trim()) flag.textContent = flagEmoji;
        flag.setAttribute('data-ws-flag-hydrated', '1');
        flag.setAttribute('aria-hidden', 'true');
      }

      dropdown.setAttribute('data-ws-flags-hydrated', '1');
    } finally {
      postscriptCountryDropdownHydrating = false;
    }
  }

  function isSubscribePopupMobileViewport() {
    if (window.matchMedia) return window.matchMedia('(max-width: 749px)').matches;
    return (window.innerWidth || document.documentElement.clientWidth || 0) < 750;
  }

  function getVisibleRect(el) {
    if (!el || !el.getBoundingClientRect) return null;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? rect : null;
  }

  function getEventClientPoint(ev) {
    if (!ev) return null;
    if (typeof ev.clientX === 'number' && typeof ev.clientY === 'number') {
      return {
        clientX: ev.clientX,
        clientY: ev.clientY
      };
    }

    var touch = (ev.touches && ev.touches[0]) || (ev.changedTouches && ev.changedTouches[0]);
    if (!touch) return null;

    return {
      clientX: touch.clientX,
      clientY: touch.clientY
    };
  }

  function getPostscriptPhoneInputRect() {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    if (!popup || !popup.querySelector) return null;
    if (postscriptCountryTriggerRect) return postscriptCountryTriggerRect;

    var selectors = [
      '.ws-postscript-embedded-form .iti',
      '.ws-postscript-embedded-form ps-phone-input-block-iti-wrapper',
      '.ws-postscript-embedded-form [aria-haspopup="listbox"]',
      '.ws-postscript-embedded-form input[type="tel"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var rect = getVisibleRect(popup.querySelector(selectors[i]));
      if (rect) return rect;
    }

    var wrapperRect = getVisibleRect(popup.querySelector('.ws-postscript-embedded-form'));
    if (!wrapperRect) return null;

    var phoneFieldHeight = Math.min(46, wrapperRect.height);
    return {
      left: wrapperRect.left,
      right: wrapperRect.right,
      top: wrapperRect.top,
      bottom: wrapperRect.top + phoneFieldHeight,
      width: wrapperRect.width,
      height: phoneFieldHeight
    };
  }

  // SDK 在移动端会把国家下拉层插到 body 下，这里按当前手机号输入框重新定位。
  function positionPostscriptCountryDropdown() {
    var dropdown = document.querySelector(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR);
    if (!dropdown || !document.body.classList.contains('ws-subscribe-popup-open') || !isSubscribePopupMobileViewport()) return;

    var rect = getPostscriptPhoneInputRect();
    if (!rect) return;

    var viewportWidth = document.documentElement.clientWidth || window.innerWidth || 0;
    var viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;
    var sidePadding = 16;
    var gap = 0;
    var width = Math.min(Math.max(rect.width, 240), Math.max(240, viewportWidth - sidePadding * 2));
    var left = Math.max(sidePadding, Math.min(rect.left, viewportWidth - width - sidePadding));
    var top = rect.bottom + gap;
    var maxHeight = Math.min(220, Math.max(140, viewportHeight - top - sidePadding));

    dropdown.style.setProperty('--ws-postscript-country-top', Math.round(top) + 'px');
    dropdown.style.setProperty('--ws-postscript-country-left', Math.round(left) + 'px');
    dropdown.style.setProperty('--ws-postscript-country-width', Math.round(width) + 'px');
    dropdown.style.setProperty('max-height', Math.round(maxHeight) + 'px', 'important');
    dropdown.setAttribute('data-ws-positioned', '1');

    var list = dropdown.querySelector('.iti__country-list');
    if (list) list.style.setProperty('max-height', Math.round(maxHeight) + 'px', 'important');
  }

  // 下拉层创建和尺寸计算是异步的，使用 RAF 同步，避免滚动/点击时位置跳动。
  function schedulePostscriptCountryDropdownUpdate(root) {
    if (postscriptCountryDropdownUpdateRaf && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(postscriptCountryDropdownUpdateRaf);
    }

    var runUpdate = function() {
      postscriptCountryDropdownUpdateRaf = null;
      var dropdown = root && root.matches && root.matches(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR)
        ? root
        : document.querySelector(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR);
      if (!dropdown) return;
      hydratePostscriptCountryFlags(dropdown);
      positionPostscriptCountryDropdown();
    };

    postscriptCountryDropdownUpdateRaf = window.requestAnimationFrame ? window.requestAnimationFrame(runUpdate) : window.setTimeout(runUpdate, 0);
  }

  function updatePostscriptCountryTriggerRectFromEvent(ev) {
    if (!ev || !document.body.classList.contains('ws-subscribe-popup-open')) return false;
    var target = ev.target && ev.target.closest ? ev.target : null;
    var trigger = target ? target.closest('.ws-postscript-embedded-form .iti__selected-country, .ws-postscript-embedded-form [aria-haspopup="listbox"], .ws-postscript-embedded-form .iti') : null;
    var rect = getVisibleRect(trigger);

    if (!rect && target) {
      var wrapper = target.closest('.ws-postscript-embedded-form');
      var wrapperRect = getVisibleRect(wrapper);
      var point = getEventClientPoint(ev);
      if (wrapperRect && point) {
        var leftAreaWidth = Math.min(140, wrapperRect.width * 0.45);
        var phoneFieldHeight = 46;
        if (point.clientX <= wrapperRect.left + leftAreaWidth && point.clientY <= wrapperRect.top + phoneFieldHeight) {
          rect = {
            left: wrapperRect.left,
            right: wrapperRect.right,
            top: wrapperRect.top,
            bottom: wrapperRect.top + phoneFieldHeight,
            width: wrapperRect.width,
            height: phoneFieldHeight
          };
        }
      }
    }

    if (rect) postscriptCountryTriggerRect = rect;
    return !!rect;
  }

  function isPostscriptCountryControlNode(target) {
    if (!target || target.nodeType !== 1 || !target.closest) return false;
    return !!target.closest('.ws-postscript-embedded-form .iti, .ws-postscript-embedded-form ps-phone-input-block-iti-wrapper, .ws-postscript-embedded-form .iti__selected-country, .ws-postscript-embedded-form [aria-haspopup="listbox"]');
  }

  function shouldWatchPostscriptCountryMutation(target) {
    if (!target || target.nodeType !== 1) return false;
    if (target.matches && target.matches(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR)) return true;
    if (target.closest && target.closest(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR)) return true;
    return isPostscriptCountryControlNode(target);
  }

  function getPostscriptCountryDropdownFromNode(node) {
    if (!node || node.nodeType !== 1) return null;
    if (node.matches && node.matches(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR)) return node;
    if (node.querySelector) {
      var childDropdown = node.querySelector(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR);
      if (childDropdown) return childDropdown;
    }
    return node.closest ? node.closest(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR) : null;
  }

  function schedulePostscriptCountryDropdownUpdateSoon(root) {
    schedulePostscriptCountryDropdownUpdate(root);
    [80, 200, 360].forEach(function(delay) {
      window.setTimeout(function() {
        schedulePostscriptCountryDropdownUpdate(root);
      }, delay);
    });
  }

  function handlePostscriptCountryMutations(mutations) {
    if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
    if (postscriptCountryDropdownHydrating) return;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'attributes' && shouldWatchPostscriptCountryMutation(mutation.target)) {
        schedulePostscriptCountryDropdownUpdateSoon(getPostscriptCountryDropdownFromNode(mutation.target));
        return;
      }

      var nodes = mutation.addedNodes;
      if (!nodes || !nodes.length) continue;

      for (var j = 0; j < nodes.length; j++) {
        var dropdown = getPostscriptCountryDropdownFromNode(nodes[j]);
        if (!dropdown) continue;
        schedulePostscriptCountryDropdownUpdateSoon(dropdown);
        return;
      }
    }
  }

  function startPostscriptCountryDropdownObserver() {
    if (!window.MutationObserver || postscriptCountryDropdownObserver) return;
    postscriptCountryDropdownObserver = new MutationObserver(handlePostscriptCountryMutations);
    postscriptCountryDropdownObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-expanded'],
      childList: true,
      subtree: true
    });
  }

  function stopPostscriptCountryDropdownObserver() {
    if (!postscriptCountryDropdownObserver) return;
    postscriptCountryDropdownObserver.disconnect();
    postscriptCountryDropdownObserver = null;
  }

  function bindPostscriptCountryDropdownStyles() {
    if (postscriptCountryDropdownStylesBound) return;
    postscriptCountryDropdownStylesBound = true;

    var handleTriggerInteraction = function(ev) {
      if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
      var target = ev.target && ev.target.closest ? ev.target : null;
      if (!target || !target.closest('.ws-postscript-embedded-form')) return;
      if (!updatePostscriptCountryTriggerRectFromEvent(ev)) return;
      schedulePostscriptCountryDropdownUpdateSoon();
    };

    document.addEventListener('pointerdown', handleTriggerInteraction, true);
    document.addEventListener('touchstart', handleTriggerInteraction, true);
    document.addEventListener('click', handleTriggerInteraction, true);

    window.addEventListener('resize', positionPostscriptCountryDropdown);
    window.addEventListener('orientationchange', positionPostscriptCountryDropdown);
  }

  function requestPostscriptCountryDropdownClose() {
    var dropdown = document.querySelector(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR);
    if (!dropdown) return;

    var eventOptions = {
      key: 'Escape',
      code: 'Escape',
      keyCode: 27,
      which: 27,
      bubbles: true,
      cancelable: true
    };

    try {
      document.dispatchEvent(new KeyboardEvent('keydown', eventOptions));
      window.dispatchEvent(new KeyboardEvent('keydown', eventOptions));
    } catch (err) {
      var fallbackEvent = document.createEvent('Event');
      fallbackEvent.initEvent('keydown', true, true);
      fallbackEvent.key = 'Escape';
      fallbackEvent.keyCode = 27;
      document.dispatchEvent(fallbackEvent);
    }

    var expandedControls = document.querySelectorAll('.ws-postscript-embedded-form [aria-expanded="true"]');
    for (var i = 0; i < expandedControls.length; i++) {
      expandedControls[i].setAttribute('aria-expanded', 'false');
    }
  }

  function cleanupPostscriptCountryDropdown() {
    stopPostscriptCountryDropdownObserver();

    if (postscriptCountryDropdownUpdateRaf) {
      if (window.cancelAnimationFrame) window.cancelAnimationFrame(postscriptCountryDropdownUpdateRaf);
      window.clearTimeout(postscriptCountryDropdownUpdateRaf);
      postscriptCountryDropdownUpdateRaf = null;
    }

    postscriptCountryTriggerRect = null;

    var dropdowns = document.querySelectorAll(POSTSCRIPT_COUNTRY_DROPDOWN_SELECTOR);
    for (var i = 0; i < dropdowns.length; i++) {
      var dropdown = dropdowns[i];
      if (dropdown && dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
    }
  }

  function resetPostscriptWidgetLayers() {
    var widgets = document.querySelectorAll('#ps__widget_container, #ps__widget, .ps__widget_container, .ps__widget, iframe[src*="sdk.postscript.io/desktop"], iframe[data-testid="ps__widget"]');
    for (var i = 0; i < widgets.length; i++) {
      widgets[i].setAttribute('data-ps-popup-status', 'closed');
      widgets[i].style.setProperty('z-index', '0', 'important');
      widgets[i].style.setProperty('pointer-events', 'none', 'important');
      widgets[i].style.setProperty('display', 'none', 'important');
      widgets[i].style.setProperty('visibility', 'hidden', 'important');
      widgets[i].style.setProperty('opacity', '0', 'important');
      widgets[i].style.setProperty('width', '0px', 'important');
      widgets[i].style.setProperty('height', '0px', 'important');
    }
  }

  function cleanupPostscriptExternalLayers() {
    cleanupPostscriptCountryDropdown();
    resetPostscriptWidgetLayers();
  }

  function clearSubscribeScrollRestoreTimers() {
    for (var i = 0; i < subscribeScrollRestoreTimers.length; i++) {
      window.clearTimeout(subscribeScrollRestoreTimers[i]);
    }
    subscribeScrollRestoreTimers = [];
  }

  function getSubscribePageScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  // iOS 在键盘打开时会忽略单纯的 overflow:hidden，这里把 body 固定在当前滚动位置。
  function lockSubscribePageScroll() {
    if (subscribePageLockActive) return;
    subscribePageLockActive = true;
    subscribePageLockScrollY = getSubscribePageScrollY();

    document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    document.documentElement.style.setProperty('height', '100%', 'important');
    document.documentElement.style.setProperty('touch-action', 'none', 'important');
    document.documentElement.style.setProperty('overscroll-behavior', 'none', 'important');

    document.body.style.setProperty('position', 'fixed', 'important');
    document.body.style.setProperty('top', '-' + subscribePageLockScrollY + 'px', 'important');
    document.body.style.setProperty('right', '0', 'important');
    document.body.style.setProperty('left', '0', 'important');
    document.body.style.setProperty('width', '100%', 'important');
    document.body.style.setProperty('overflow', 'hidden', 'important');
    document.body.style.setProperty('touch-action', 'none', 'important');
    document.body.style.setProperty('overscroll-behavior', 'none', 'important');
  }

  function getSubscribeTouchScrollable(ev) {
    if (!ev) return null;

    // Wheel/touch events crossing Postscript's Shadow DOM are retargeted to the
    // custom-element host. composedPath() still exposes the actual country
    // list, so prefer it before falling back to the public event target.
    var path = typeof ev.composedPath === 'function' ? ev.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var pathNode = path[i];
      if (!pathNode || pathNode.nodeType !== 1 || !pathNode.matches) continue;
      if (pathNode.matches('.iti__country-list, [role="listbox"]')) return pathNode;
    }

    var target = ev.target;
    if (!target || target.nodeType !== 1 || !target.closest) return null;
    return target.closest('.iti--fullscreen-popup .iti__country-list, .iti--fullscreen-popup, .ws-subscribe-popup__content');
  }

  function canScrollSubscribeTouchTarget(el, deltaY) {
    if (!el) return false;
    var scrollHeight = el.scrollHeight || 0;
    var clientHeight = el.clientHeight || 0;
    if (scrollHeight <= clientHeight + 1) return false;

    var scrollTop = el.scrollTop || 0;
    if (deltaY > 0) return scrollTop + clientHeight < scrollHeight - 1;
    if (deltaY < 0) return scrollTop > 0;
    return false;
  }

  function bindSubscribePageTouchLock() {
    if (subscribeTouchLockBound) return;
    subscribeTouchLockBound = true;

    document.addEventListener('touchstart', function(ev) {
      var touch = ev.touches && ev.touches[0];
      subscribeTouchStartY = touch ? touch.clientY : 0;
    }, { capture: true, passive: true });

    document.addEventListener('touchmove', function(ev) {
      if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
      var touch = ev.touches && ev.touches[0];
      var currentY = touch ? touch.clientY : subscribeTouchStartY;
      var deltaY = subscribeTouchStartY - currentY;
      var scrollable = getSubscribeTouchScrollable(ev);

      if (canScrollSubscribeTouchTarget(scrollable, deltaY)) return;
      ev.preventDefault();
    }, { capture: true, passive: false });

    document.addEventListener('wheel', function(ev) {
      if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
      var scrollable = getSubscribeTouchScrollable(ev);
      if (canScrollSubscribeTouchTarget(scrollable, ev.deltaY || 0)) return;
      ev.preventDefault();
    }, { capture: true, passive: false });
  }

  function resetScrollLockStyle(el) {
    if (!el || !el.style) return;
    [
      'overflow',
      'overflow-x',
      'overflow-y',
      'position',
      'top',
      'right',
      'bottom',
      'left',
      'width',
      'height',
      'max-height',
      'min-height',
      'touch-action',
      'overscroll-behavior',
      '-webkit-overflow-scrolling'
    ].forEach(function(prop) {
      el.style.removeProperty(prop);
    });
  }

  // Postscript 会给 html/body 加滚动锁；弹窗关闭后必须统一释放，避免页面无法滑动。
  function releaseSubscribePageLock() {
    var shouldRestoreScroll = subscribePageLockActive;
    var restoreScrollY = subscribePageLockScrollY;
    subscribePageLockActive = false;
    subscribePageLockScrollY = 0;

    var lockedEls = [document.documentElement, document.body];
    for (var i = 0; i < lockedEls.length; i++) {
      var el = lockedEls[i];
      if (!el) continue;
      el.classList.remove('ws-subscribe-popup-open');
      el.classList.remove('ps-scroll-lock');
      el.classList.remove('iti-mobile');
      resetScrollLockStyle(el);
    }
    resetScrollLockStyle(document.scrollingElement);

    if (shouldRestoreScroll) {
      window.scrollTo(0, restoreScrollY || 0);
    }
  }

  function restoreSubscribePageScroll() {
    if (document.querySelector('.ws-subscribe-popup.is-visible')) return;

    releaseSubscribePageLock();
    cleanupPostscriptExternalLayers();
  }

  function scheduleSubscribePageScrollRestore() {
    clearSubscribeScrollRestoreTimers();
    restoreSubscribePageScroll();
    [50, 200, 600].forEach(function(delay) {
      subscribeScrollRestoreTimers.push(window.setTimeout(restoreSubscribePageScroll, delay));
    });
  }

  function getTodayStr() {
    var d = new Date();
    var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function shouldShowSubscribePopupToday() {
    var uuid = WS.cookie.get('westyle-uuid') || '';
    var cookieKey = 'ws-subscribe-popup-' + uuid;
    var lastShown = WS.cookie.get(cookieKey);
    var today = getTodayStr();
    return lastShown !== today;
  }

  function markSubscribePopupShownToday() {
    var uuid = WS.cookie.get('westyle-uuid') || '';
    var cookieKey = 'ws-subscribe-popup-' + uuid;
    var today = getTodayStr();
    WS.cookie.set(cookieKey, today, 24 * 2);
  }

  // Embedded Form SDK 全站只加载一次，避免重复注册 custom element。
  function getPostscriptEmbeddedScript() {
    return document.querySelector('script[src="' + POSTSCRIPT_EMBEDDED_FORM_SCRIPT_URL + '"]');
  }

  function preloadPostscriptEmbeddedFormScript() {
    if (window.customElements && window.customElements.get && window.customElements.get('postscript-embedded-form')) {
      return getPostscriptEmbeddedScript();
    }

    var existingScript = getPostscriptEmbeddedScript();
    if (existingScript && existingScript.getAttribute('data-load-error') !== '1') return existingScript;
    if (existingScript && existingScript.parentNode) existingScript.parentNode.removeChild(existingScript);

    var script = document.createElement('script');
    script.src = POSTSCRIPT_EMBEDDED_FORM_SCRIPT_URL;
    script.async = true;
    script.setAttribute('data-loading', '1');
    script.onload = function() {
      script.removeAttribute('data-loading');
      script.setAttribute('data-loaded', '1');
    };
    script.onerror = function() {
      script.removeAttribute('data-loading');
      script.setAttribute('data-load-error', '1');
    };
    document.head.appendChild(script);
    return script;
  }

  function setPostscriptEmbeddedState(popup, isLoading, errorMessage) {
    if (!popup || !popup.querySelector) return;
    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    var hint = popup.querySelector('[data-field-hint="postscript"]');

    if (target) {
      target.classList.toggle('is-loading', !!isLoading);
      if (isLoading) {
        target.setAttribute('data-loading-text', 'Loading SMS signup...');
      } else {
        target.removeAttribute('data-loading-text');
      }
    }

    if (hint) {
      if (errorMessage) hint.textContent = errorMessage;
      hint.hidden = !errorMessage;
    }
  }

  function inputLooksLikePostscriptCode(input) {
    if (!input || !input.getAttribute) return false;

    var attrs = ['name', 'id', 'aria-label', 'aria-labelledby', 'placeholder', 'autocomplete'];
    for (var i = 0; i < attrs.length; i++) {
      var value = String(input.getAttribute(attrs[i]) || '').toLowerCase();
      if (/one-time-code|otp|verification|verify|code/.test(value)) return true;
    }

    var maxLength = String(input.getAttribute('maxlength') || '');
    var inputMode = String(input.getAttribute('inputmode') || input.getAttribute('type') || '').toLowerCase();
    return maxLength === '4' && /numeric|tel|number|text/.test(inputMode);
  }

  function inputLooksLikePostscriptPhone(input) {
    if (!input || !input.getAttribute || inputLooksLikePostscriptCode(input)) return false;

    var type = String(input.getAttribute('type') || input.type || '').toLowerCase();
    var inputMode = String(input.getAttribute('inputmode') || '').toLowerCase();
    var descriptor = [
      input.getAttribute('name'),
      input.getAttribute('id'),
      input.getAttribute('autocomplete'),
      input.getAttribute('aria-label'),
      input.getAttribute('placeholder')
    ].join(' ').toLowerCase();

    return type === 'tel' || inputMode === 'tel' || /phone|mobile|telephone|\btel\b/.test(descriptor);
  }

  // Postscript 的手机号输入框位于 Shadow DOM 中，必须从 composedPath 读取真实 input。
  function getSubscribeContactFieldFromEvent(ev, popup) {
    if (!ev || !popup) return null;
    var path = getSubscribeFocusedElementPath(ev);
    var field = null;
    var belongsToPopup = false;

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node) continue;
      if (node === popup || (node.nodeType === 1 && popup.contains && popup.contains(node))) {
        belongsToPopup = true;
      }
      if (field || node.nodeType !== 1 || !node.tagName) continue;
      var tagName = String(node.tagName).toLowerCase();
      if (tagName !== 'input' && tagName !== 'textarea') continue;
      var name = String(node.getAttribute('name') || '').toLowerCase();
      var type = String(node.getAttribute('type') || node.type || '').toLowerCase();
      if (name === 'contact[email]' || type === 'email' || inputLooksLikePostscriptPhone(node)) field = node;
    }

    return belongsToPopup ? field : null;
  }

  function reportSubscribeFormStartedFromEvent(ev) {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    if (popup && getSubscribeContactFieldFromEvent(ev, popup)) {
      if (popup.getAttribute('data-form-started-reported') === '1') return;
      popup.setAttribute('data-form-started-reported', '1');
      reportSubscribeClick('formStarted');
      return;
    }

    // 保留页面其他订阅表单原有的 started 埋点。
    var input = ev && ev.target && ev.target.closest
      ? ev.target.closest('.ws-subscribe__form input[name="contact[email]"]')
      : null;
    var form = input && input.closest ? input.closest('.ws-subscribe__form') : null;
    if (!form || form.getAttribute('data-form-started-reported') === '1') return;
    form.setAttribute('data-form-started-reported', '1');
    reportSubscribeClick('formStarted');
  }

  function findPostscriptVerificationCodeInRoot(root) {
    if (!root || !root.querySelectorAll) return '';

    var inputs = root.querySelectorAll('input');
    var singleDigitCode = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (!getVisibleRect(input)) continue;
      if (!inputLooksLikePostscriptCode(input)) continue;
      var code = String(input.value || '').replace(/\D/g, '');
      if (code.length >= 4) return code;
      if (code.length === 1 && String(input.getAttribute('maxlength') || '') === '1') singleDigitCode.push(code);
    }

    if (singleDigitCode.length >= 4) return singleDigitCode.slice(0, 4).join('');

    var postscriptForms = root.querySelectorAll('postscript-embedded-form');
    for (var j = 0; j < postscriptForms.length; j++) {
      var form = postscriptForms[j];
      if (!form.shadowRoot) continue;
      var shadowCode = findPostscriptVerificationCodeInRoot(form.shadowRoot);
      if (shadowCode) return shadowCode;
    }

    return '';
  }

  function findCurrentPostscriptVerificationCode() {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    var target = popup && popup.querySelector ? popup.querySelector('[data-postscript-embedded-form-target]') : null;
    return findPostscriptVerificationCodeInRoot(target);
  }

  function rememberCurrentPostscriptVerificationCode() {
    if (findCurrentPostscriptVerificationCode()) postscriptVerificationCodeEntered = true;
  }

  function hasPostscriptVerificationContent(scope) {
    if (!scope || !scope.querySelectorAll) return false;

    var inputs = scope.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      if (getVisibleRect(inputs[i]) && inputLooksLikePostscriptCode(inputs[i])) return true;
    }

    return false;
  }

  function isPostscriptVerificationStep(popup) {
    if (!popup || !popup.querySelector) return false;

    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    if (!target) return false;
    if (hasPostscriptVerificationContent(target)) return true;

    var form = target.querySelector('postscript-embedded-form');
    return !!(form && form.shadowRoot && hasPostscriptVerificationContent(form.shadowRoot));
  }

  function setPostscriptStepTitle(title, text) {
    if (!title) return;
    var lines = String(text || '').split(/\r?\n/);
    title.textContent = '';
    for (var i = 0; i < lines.length; i++) {
      if (i) title.appendChild(document.createElement('br'));
      title.appendChild(document.createTextNode(lines[i]));
    }
  }

  function syncPostscriptEmbeddedStepCopy(popup) {
    if (!popup || !popup.querySelector) return;

    var title = popup.querySelector('.ws-subscribe-popup__phone-step .ws-subscribe-popup__step-title');
    if (!title) return;

    var defaultTitle = String(popup.getAttribute('data-subscribe-phone-title') || title.textContent || "YOU’VE GOT 15% OFF");
    var verifyTitle = String(popup.getAttribute('data-subscribe-verify-title') || 'VERIFY YOUR NUMBER');
    if (!title.hasAttribute('data-default-text')) title.setAttribute('data-default-text', defaultTitle);

    var isVerificationStep = isPostscriptVerificationStep(popup);
    var editPhone = popup.querySelector('.ws-subscribe-popup__edit-phone');
    popup.classList.toggle('ws-postscript-verification-step', isVerificationStep);
    if (editPhone) editPhone.hidden = !isVerificationStep;

    if (isVerificationStep) {
      if (title.getAttribute('data-ws-copy-state') !== 'verification') {
        setPostscriptStepTitle(title, verifyTitle);
        title.setAttribute('data-ws-copy-state', 'verification');
      }
      return;
    }

    if (title.getAttribute('data-ws-copy-state') === 'verification') {
      setPostscriptStepTitle(title, title.getAttribute('data-default-text') || "YOU’VE GOT 15% OFF");
      title.removeAttribute('data-ws-copy-state');
    }
  }

  function resetPostscriptEmbeddedStepCopy(popup) {
    if (!popup || !popup.querySelector) return;

    popup.classList.remove('ws-postscript-verification-step');
    var editPhone = popup.querySelector('.ws-subscribe-popup__edit-phone');
    if (editPhone) editPhone.hidden = true;

    var title = popup.querySelector('.ws-subscribe-popup__phone-step .ws-subscribe-popup__step-title');
    if (!title || title.getAttribute('data-ws-copy-state') !== 'verification') return;

    setPostscriptStepTitle(title, title.getAttribute('data-default-text') || "YOU’VE GOT 15% OFF");
    title.removeAttribute('data-ws-copy-state');
  }

  function schedulePostscriptEmbeddedStepCopySync(popup) {
    if (!popup) return;

    if (postscriptEmbeddedStepUpdateRaf) {
      if (window.cancelAnimationFrame) window.cancelAnimationFrame(postscriptEmbeddedStepUpdateRaf);
      window.clearTimeout(postscriptEmbeddedStepUpdateRaf);
    }

    postscriptEmbeddedStepUpdateRaf = window.requestAnimationFrame
      ? window.requestAnimationFrame(function() {
        postscriptEmbeddedStepUpdateRaf = null;
        syncPostscriptEmbeddedStepCopy(popup);
      })
      : window.setTimeout(function() {
        postscriptEmbeddedStepUpdateRaf = null;
        syncPostscriptEmbeddedStepCopy(popup);
      }, 0);
  }

  function stopPostscriptEmbeddedStepObserver() {
    if (postscriptEmbeddedStepObserver) {
      postscriptEmbeddedStepObserver.disconnect();
      postscriptEmbeddedStepObserver = null;
    }

    if (postscriptEmbeddedStepShadowObserver) {
      postscriptEmbeddedStepShadowObserver.disconnect();
      postscriptEmbeddedStepShadowObserver = null;
    }

    if (postscriptEmbeddedStepUpdateRaf) {
      if (window.cancelAnimationFrame) window.cancelAnimationFrame(postscriptEmbeddedStepUpdateRaf);
      window.clearTimeout(postscriptEmbeddedStepUpdateRaf);
      postscriptEmbeddedStepUpdateRaf = null;
    }
  }

  function startPostscriptEmbeddedStepObserver(popup) {
    if (!popup || !popup.querySelector) return;

    stopPostscriptEmbeddedStepObserver();
    schedulePostscriptEmbeddedStepCopySync(popup);

    if (!window.MutationObserver) return;

    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    if (!target) return;

    var handleMutation = function() {
      var form = target.querySelector('postscript-embedded-form');
      if (form && form.shadowRoot && !postscriptEmbeddedStepShadowObserver) {
        postscriptEmbeddedStepShadowObserver = new MutationObserver(handleMutation);
        postscriptEmbeddedStepShadowObserver.observe(form.shadowRoot, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      schedulePostscriptEmbeddedStepCopySync(popup);
    };

    postscriptEmbeddedStepObserver = new MutationObserver(handleMutation);
    postscriptEmbeddedStepObserver.observe(target, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    handleMutation();
  }

  function renderPostscriptEmbeddedForm(popup) {
    if (!popup || !popup.querySelector) return null;
    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    if (!target) return null;

    var shopId = String(popup.getAttribute('data-postscript-embedded-shop-id') || '').trim();
    var formId = String(popup.getAttribute('data-postscript-embedded-form-id') || '').trim();
    if (!shopId || !formId) {
      setPostscriptEmbeddedState(popup, false, 'SMS signup is not configured yet.');
      return null;
    }

    var renderKey = shopId + '|' + formId;
    var currentForm = target.querySelector('postscript-embedded-form');
    if (currentForm && target.getAttribute('data-render-key') === renderKey) return currentForm;

    target.innerHTML = '';
    target.setAttribute('data-render-key', renderKey);
    target.removeAttribute('data-postscript-mounted');
    target.removeAttribute('data-postscript-ready');

    var form = document.createElement('postscript-embedded-form');
    form.setAttribute('shop-id', shopId);
    form.setAttribute('form-id', formId);
    target.appendChild(form);
    return form;
  }

  function resetPostscriptEmbeddedForm(popup) {
    if (!popup || !popup.querySelector) return;
    if (postscriptEmbeddedMountTimeoutId) {
      window.clearTimeout(postscriptEmbeddedMountTimeoutId);
      postscriptEmbeddedMountTimeoutId = null;
    }
    postscriptVerificationCodeEntered = false;
    stopPostscriptEmbeddedStepObserver();
    resetPostscriptEmbeddedStepCopy(popup);
    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    if (!target) return;
    target.innerHTML = '';
    target.removeAttribute('data-render-key');
    target.removeAttribute('data-postscript-mounted');
    target.removeAttribute('data-postscript-ready');
    setPostscriptEmbeddedState(popup, false, '');
  }

  function restartPostscriptPhoneEntry(popup) {
    if (!popup) return;
    postscriptVerificationCodeEntered = false;
    localStorage.removeItem('westyle_phone_pending');
    requestPostscriptCountryDropdownClose();
    resetPostscriptEmbeddedForm(popup);
    showSubscribeStep(popup, 'phone');
    syncSubscribePopupViewportHeight(true);
  }

  function hasPostscriptEmbeddedInteractiveContent(form) {
    if (!form || !form.querySelector) return false;
    var selector = 'input, button, [type="submit"], [aria-haspopup="listbox"], ps-phone-input-block-iti-wrapper';
    if (form.querySelector(selector)) return true;
    if (form.shadowRoot && form.shadowRoot.querySelector && form.shadowRoot.querySelector(selector)) return true;
    return form.childElementCount > 0 && !!getVisibleRect(form);
  }

  function waitForPostscriptEmbeddedReady(form, callback) {
    var startedAt = Date.now();
    var timer = null;
    var observer = null;
    var shadowObserver = null;
    var done = false;

    function cleanup() {
      if (timer) window.clearTimeout(timer);
      if (observer) observer.disconnect();
      if (shadowObserver) shadowObserver.disconnect();
      timer = null;
      observer = null;
      shadowObserver = null;
    }

    function finish() {
      if (done) return;
      done = true;
      cleanup();
      window.setTimeout(callback, POSTSCRIPT_EMBEDDED_READY_SETTLE_DELAY);
    }

    function check() {
      if (done) return;
      if (!document.documentElement.contains(form)) {
        cleanup();
        done = true;
        return;
      }

      if (hasPostscriptEmbeddedInteractiveContent(form) || Date.now() - startedAt >= POSTSCRIPT_EMBEDDED_READY_TIMEOUT) {
        finish();
        return;
      }

      timer = window.setTimeout(check, POSTSCRIPT_EMBEDDED_READY_POLL_DELAY);
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(check);
      observer.observe(form, {
        attributes: true,
        childList: true,
        subtree: true
      });

      if (form.shadowRoot) {
        shadowObserver = new MutationObserver(check);
        shadowObserver.observe(form.shadowRoot, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }
    }

    check();
  }

  // `mount` is Postscript's authoritative signal that the embedded form has
  // loaded its configuration. Keep the SDK form hidden until both mount and
  // its interactive controls are ready, so users cannot submit during init.
  function revealMountedPostscriptEmbeddedForm(popup) {
    if (!popup || !popup.querySelector) return;
    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    if (!target || target.getAttribute('data-postscript-mounted') !== '1') return;
    if (target.getAttribute('data-postscript-ready') === '1') return;

    var form = target.querySelector('postscript-embedded-form');
    if (!form) return;
    target.setAttribute('data-postscript-ready', '1');
    waitForPostscriptEmbeddedReady(form, function() {
      if (!target.contains(form) || target.getAttribute('data-postscript-mounted') !== '1') return;
      setPostscriptEmbeddedState(popup, false, '');
    });
  }

  function handlePostscriptEmbeddedMount(detail) {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    if (!popup || !popup.querySelector) return false;

    var expectedShopId = String(popup.getAttribute('data-postscript-embedded-shop-id') || '');
    var expectedFormId = String(popup.getAttribute('data-postscript-embedded-form-id') || '');
    var eventShopId = detail && detail.shopId != null ? String(detail.shopId) : '';
    var eventFormId = detail && detail.formId != null ? String(detail.formId) : '';
    if ((eventShopId && eventShopId !== expectedShopId) || (eventFormId && eventFormId !== expectedFormId)) return false;

    var target = popup.querySelector('[data-postscript-embedded-form-target]');
    if (!target) return false;
    target.setAttribute('data-postscript-mounted', '1');
    if (postscriptEmbeddedMountTimeoutId) {
      window.clearTimeout(postscriptEmbeddedMountTimeoutId);
      postscriptEmbeddedMountTimeoutId = null;
    }
    revealMountedPostscriptEmbeddedForm(popup);
    return true;
  }

  function loadPostscriptEmbeddedFormScript(popup) {
    var embeddedForm = renderPostscriptEmbeddedForm(popup);
    if (!embeddedForm) return;

    startPostscriptEmbeddedStepObserver(popup);
    setPostscriptEmbeddedState(popup, true, '');

    var isDone = false;
    if (postscriptEmbeddedMountTimeoutId) window.clearTimeout(postscriptEmbeddedMountTimeoutId);
    postscriptEmbeddedMountTimeoutId = window.setTimeout(function() {
      postscriptEmbeddedMountTimeoutId = null;
      var target = popup && popup.querySelector ? popup.querySelector('[data-postscript-embedded-form-target]') : null;
      if (!target || !target.contains(embeddedForm) || target.getAttribute('data-postscript-mounted') === '1') return;
      setPostscriptEmbeddedState(popup, true, 'SMS signup is taking longer than expected. Please close and try again.');
    }, 10000);

    revealMountedPostscriptEmbeddedForm(popup);

    function markReady() {
      if (isDone) return;
      isDone = true;
      revealMountedPostscriptEmbeddedForm(popup);
    }

    function markError() {
      if (isDone) return;
      isDone = true;
      if (postscriptEmbeddedMountTimeoutId) {
        window.clearTimeout(postscriptEmbeddedMountTimeoutId);
        postscriptEmbeddedMountTimeoutId = null;
      }
      setPostscriptEmbeddedState(popup, true, 'SMS signup could not load. Please close and try again.');
    }

    if (window.customElements && window.customElements.get && window.customElements.get('postscript-embedded-form')) {
      markReady();
      return;
    }

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('postscript-embedded-form').then(markReady);
    }

    var script = preloadPostscriptEmbeddedFormScript();
    if (!script) return;

    if (script.getAttribute('data-load-error') === '1') {
      markError();
      return;
    }

    script.addEventListener('error', markError, { once: true });
    script.addEventListener('load', function() {
      if (!window.customElements || !window.customElements.whenDefined) markReady();
    }, { once: true });
  }

  function findPostscriptPhone(payload, keyHint, depth) {
    if (!payload || depth > 5) return '';

    if (typeof payload === 'string') {
      var text = payload.trim();
      if (!text) return '';
      if ((/phone|mobile|tel|e164/i).test(String(keyHint || '')) || text.charAt(0) === '+') {
        var digits = text.replace(/\D/g, '');
        if (digits.length >= 7 && digits.length <= 16) return text;
      }
      return '';
    }

    if (typeof payload !== 'object') return '';

    for (var key in payload) {
      if (!Object.prototype.hasOwnProperty.call(payload, key)) continue;
      var value = payload[key];
      var matched = findPostscriptPhone(value, key, depth + 1);
      if (matched) return matched;
    }

    return '';
  }

  function normalizePostscriptPhoneValue(phone, root) {
    var text = String(phone || '').trim();
    if (!text) return '';

    if (text.charAt(0) === '+') {
      var signedDigits = text.slice(1).replace(/\D+/g, '');
      return signedDigits ? ('+' + signedDigits) : '';
    }

    var digits = text.replace(/\D+/g, '');
    if (!digits) return '';

    var dialCode = findPostscriptSelectedDialCode(root);
    if (!dialCode) return digits;
    if (digits.indexOf(dialCode) === 0) return '+' + digits;
    return '+' + dialCode + digits;
  }

  function findPostscriptSelectedDialCode(root) {
    var scope = root && root.querySelector ? root : document;
    var selectors = [
      '.iti__selected-dial-code',
      '.iti__selected-country[title]',
      '.iti__selected-country[aria-label]',
      '[aria-haspopup="listbox"][title]',
      '[aria-haspopup="listbox"][aria-label]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = scope.querySelector(selectors[i]);
      if (!el) continue;
      var text = String(el.textContent || el.getAttribute('title') || el.getAttribute('aria-label') || '').trim();
      var match = text.match(/\+(\d{1,4})/);
      if (match && match[1]) return match[1];
    }

    return '';
  }

  function findPostscriptPhoneInRoot(root) {
    if (!root || !root.querySelectorAll) return '';

    var inputs = root.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var type = String(input.type || '').toLowerCase();
      var inputMode = String(input.getAttribute('inputmode') || '').toLowerCase();
      var name = String(input.name || input.id || input.getAttribute('autocomplete') || input.getAttribute('aria-label') || input.getAttribute('placeholder') || '').toLowerCase();
      if (type !== 'tel' && inputMode !== 'tel' && name.indexOf('phone') === -1 && name.indexOf('mobile') === -1 && name.indexOf('tel') === -1) continue;
      var phone = normalizePostscriptPhoneValue(input.value, root);
      if (phone) return phone;
    }

    var postscriptForms = root.querySelectorAll('postscript-embedded-form');
    for (var j = 0; j < postscriptForms.length; j++) {
      var form = postscriptForms[j];
      if (!form.shadowRoot) continue;
      var shadowPhone = findPostscriptPhoneInRoot(form.shadowRoot);
      if (shadowPhone) return shadowPhone;
    }

    return '';
  }

  function findCurrentPostscriptPhone() {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    var target = popup && popup.querySelector ? popup.querySelector('[data-postscript-embedded-form-target]') : null;
    return findPostscriptPhoneInRoot(target);
  }

  function reportPostscriptPhoneSubmit(detail, phone) {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    if (!popup) return;

    var stepName = String(detail && (detail.stepName || detail.step || detail.currentStepName) || '').toLowerCase();
    if (postscriptVerificationCodeEntered || isPostscriptVerificationStep(popup) || /verify|verification|code|otp/.test(stepName)) return;

    var normalizedPhone = normalizePostscriptPhoneValue(phone) || getSubscribeStorageValue('westyle_phone_pending');
    var reportPhoneKey = normalizedPhone || '__empty_phone__';
    var now = Date.now();
    if (
      reportPhoneKey === postscriptLastSubmitReportPhone &&
      now - postscriptLastSubmitReportAt < 1000
    ) return;

    postscriptLastSubmitReportPhone = reportPhoneKey;
    postscriptLastSubmitReportAt = now;
    reportSubscribeClick('emailSmsSubmit', getStoredSubscribeEmail(), normalizedPhone);
  }

  function getPostscriptEventType(payload) {
    if (!payload || typeof payload !== 'object') return '';
    return String(payload.type || payload.event || payload.eventName || payload.name || payload.action || '').trim();
  }

  function isPostscriptCompleteEvent(payload) {
    var type = getPostscriptEventType(payload);
    return /^(complete|otp:verified)$/i.test(type) || /subscriber[-_]?created|subscription[-_]?complete|opt[-_]?in[-_]?complete|optincomplete|subscribed|confirmed/i.test(type);
  }

  function storePendingPostscriptPhone(phone) {
    if (!phone) return;
    localStorage.setItem('westyle_phone_pending', normalizePostscriptPhoneValue(phone) || phone);
  }

  // 成功事件不一定带手机号，按事件值、pending、当前输入框顺序兜底写入 localStorage。
  function storeCompletedPostscriptPhone(phone) {
    var finalPhone = String(
      normalizePostscriptPhoneValue(phone) ||
      localStorage.getItem('westyle_phone_pending') ||
      findCurrentPostscriptPhone() ||
      localStorage.getItem('westyle_phone') ||
      'postscript_confirmed'
    ).trim();
    if (finalPhone) localStorage.setItem('westyle_phone', finalPhone);
    localStorage.removeItem('westyle_phone_pending');
  }

  function clearSubscribeAppliedToast() {
    var existing = document.querySelector('.ws-subscribe-applied-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    if (subscribeAppliedToastTimer) {
      window.clearTimeout(subscribeAppliedToastTimer);
      subscribeAppliedToastTimer = null;
    }
  }

  function showSubscribeAppliedToast() {
    clearSubscribeAppliedToast();

    var toast = document.createElement('div');
    toast.className = 'ws-subscribe-applied-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = [
      '<div class="ws-subscribe-applied-toast__icon" aria-hidden="true">',
        '<img src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-success-white.svg?v=1783936910" alt="" width="24" height="24">',
      '</div>',
      '<p class="ws-subscribe-applied-toast__title">15% OFF APPLIED ✨</p>',
      '<p class="ws-subscribe-applied-toast__text">Your discount is ready.<br>Enjoy shopping!</p>'
    ].join('');

    document.body.appendChild(toast);
    window.requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    subscribeAppliedToastTimer = window.setTimeout(function() {
      toast.classList.remove('is-visible');
      window.setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 250);
      subscribeAppliedToastTimer = null;
    }, 3600);
  }

  function showSubscribedStepFromPostscript() {
    var popup = document.querySelector('.ws-subscribe-popup.is-visible');
    if (popup) closeSubscribePopup(popup);
    showSubscribeAppliedToast();
  }

  // 只消费 Postscript 成功事件，不接管官方提交/验证码逻辑。
  function handlePostscriptSubscribePayload(payload) {
    var phone = findPostscriptPhone(payload, '', 0);
    var isComplete = isPostscriptCompleteEvent(payload);

    if (phone && !isComplete) {
      storePendingPostscriptPhone(phone);
    }

    if (!isComplete || postscriptEmbeddedCompletionHandled) return false;

    // Only the public `complete` event or a confirmed successful OTP response
    // is final. Postscript's `submit:success` can fire after the phone-number
    // step creates a pending subscriber, before the OTP has been entered.
    postscriptEmbeddedCompletionHandled = true;

    try {
      storeCompletedPostscriptPhone(phone);
      subscribeModuleFn.updateCustomerFlags({
        subscribed: true,
        firstOrder: subscribeModuleFn.isFirstOrder
      });
    } catch (err) {
      // In-app browsers can deny localStorage. Subscription completion should
      // still close the popup even when persisting the local marker fails.
      if (window.console && console.warn) console.warn('Unable to persist Postscript subscription state.', err);
    } finally {
      showSubscribedStepFromPostscript();
    }
    return true;
  }

  // Some Postscript form configurations route a successful OTP submission
  // back to the verification step instead of a terminal step, so the SDK does
  // not emit `complete`. Observe only the OTP verification endpoint and use
  // its `{ success: true }` response as the final fallback signal. The cloned
  // response leaves the SDK's own fetch flow untouched.
  function bindPostscriptOtpVerificationObserver() {
    if (postscriptOtpFetchObserverBound || typeof window.fetch !== 'function') return;
    postscriptOtpFetchObserverBound = true;

    var originalFetch = window.fetch;
    window.fetch = function(input) {
      var fetchPromise = originalFetch.apply(this, arguments);
      var requestUrl = '';
      if (typeof input === 'string') {
        requestUrl = input;
      } else if (input && input.url) {
        requestUrl = String(input.url);
      }

      if (!/\/v2\/opt_in\/one_time_passcode\/verify(?:[/?#]|$)/i.test(requestUrl)) return fetchPromise;

      return fetchPromise.then(function(response) {
        if (!response || !response.ok || !response.clone) return response;

        response.clone().json().then(function(data) {
          if (!data || data.success !== true) return;
          window.setTimeout(function() {
            if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
            handlePostscriptSubscribePayload({
              type: 'otp:verified',
              subscriberId: data.subscriber_id
            });
          }, 0);
        }).catch(function() {});

        return response;
      });
    };
  }

  // 统一绑定 Postscript 可能触发的事件名，并把成功状态同步到本地弹窗流程。
  function bindPostscriptEmbeddedFormEvents() {
    if (subscribeModuleFn.postscriptEmbeddedEventsBound) return;
    subscribeModuleFn.postscriptEmbeddedEventsBound = true;
    bindPostscriptOtpVerificationObserver();

    var rememberCurrentPostscriptPhone = function() {
      if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
      var phone = findCurrentPostscriptPhone();
      if (phone) storePendingPostscriptPhone(phone);
      rememberCurrentPostscriptVerificationCode();
    };

    document.addEventListener('input', rememberCurrentPostscriptPhone, true);
    document.addEventListener('change', rememberCurrentPostscriptPhone, true);
    document.addEventListener('click', function(ev) {
      if (!document.body.classList.contains('ws-subscribe-popup-open')) return;
      var target = ev && ev.target && ev.target.closest ? ev.target : null;
      if (!target || !target.closest('.ws-postscript-embedded-form')) return;
      rememberCurrentPostscriptPhone();
    }, true);

    window.addEventListener('postscript:embedded-form', function(ev) {
      var detail = ev && ev.detail ? ev.detail : {};
      var values = detail.values || detail.data || {};
      var phone = findPostscriptPhone(detail, '', 0) || findPostscriptPhone(values, '', 0);
      var eventType = getPostscriptEventType(detail);

      if (eventType.toLowerCase() === 'mount') handlePostscriptEmbeddedMount(detail);
      if (/^(formSubmit|submit:start)$/i.test(eventType)) {
        var submittedPhone = phone || findCurrentPostscriptPhone();
        storePendingPostscriptPhone(submittedPhone);
        reportPostscriptPhoneSubmit(detail, submittedPhone);
      }
      if (!handlePostscriptSubscribePayload(detail)) return;
      try {
        if (detail.subscriberId) localStorage.setItem('westyle_postscript_subscriber_id', detail.subscriberId);
        if (detail.discountCode) localStorage.setItem('westyle_postscript_discount_code', detail.discountCode);
        if (detail.cashbackCode) localStorage.setItem('westyle_postscript_cashback_code', detail.cashbackCode);
      } catch (err) {}
    });

    [
      'postscript:subscriberCreated',
      'postscript:subscriber-created',
      'postscript:subscriptionComplete',
      'postscript:subscription-complete',
      'postscript:optInComplete',
      'postscript:opt-in-complete'
    ].forEach(function(eventName) {
      window.addEventListener(eventName, function(ev) {
        var payload = ev && ev.detail ? ev.detail : {};
        if (!getPostscriptEventType(payload)) payload.type = eventName;
        handlePostscriptSubscribePayload(payload);
      });
    });

    window.addEventListener('message', function(ev) {
      if (!ev || !ev.origin || ev.origin.indexOf('postscript.io') === -1) return;
      if (!document.body.classList.contains('ws-subscribe-popup-open')) return;

      var data = ev.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          data = { message: data };
        }
      }
      handlePostscriptSubscribePayload(data);
    });
  }

  var subscribeModuleFn = {
    // 获取用户是否已订阅逻辑
    isSubscribed: localStorage.getItem('westyle_is_subscribed') == '1',
    // 获取用户是否首单逻辑
    isFirstOrder: localStorage.getItem('westyle_is_first_order') == '1',

    // 获取用户登录状态和邮箱逻辑
    getCustomer: function() {
      var customerSesstion = 'psCustomerData';
      if (!localStorage.getItem(customerSesstion)) {
        return;
      }
      var customerData = JSON.parse(localStorage.getItem(customerSesstion));
      var email = customerData.email || localStorage.getItem('westyle_email') || '';
      subscribeModuleFn.customerStatus(email);
    },

    // 统一更新订阅状态（内存 + localStorage
    updateCustomerFlags: function(flags) {
      var subscribed = flags && flags.subscribed;
      var firstOrder = flags && flags.firstOrder;
      subscribeModuleFn.isSubscribed = subscribed;
      subscribeModuleFn.isFirstOrder = firstOrder;
      localStorage.setItem('westyle_is_subscribed', subscribed ? 1 : 0);
      localStorage.setItem('westyle_is_first_order', firstOrder ? 1: 0);
    },

    loadAndShow: function(callback) {
      if (!WS.site.subscribePopupEnabled) return;
      var container = document.getElementById('ws-subscribe-popup-container');
      if (!container) return;
      var popup = container.querySelector('.ws-subscribe-popup');
      if (popup) {
        callback && callback(popup);
        return;
      }
      WS.ui.dynamicInsertModuleFn.insertSubscribePopupHander(function() {
        var popupEl = container.querySelector('.ws-subscribe-popup');
        if (popupEl) callback && callback(popupEl);
      });
    },

    // 查询客户状态
    customerStatus: function(email, callback) {
      if (!email) {
        callback && callback(false);
        return;
      }
      // 查询客户状态接口
      const customer_status_url = 'https://capi.westyle.ai/westyle-shopify/shopify/customer/status'

      // 发送查询客户状态请求
      WS.ajax({
        url: customer_status_url,
        type: 'POST',
        data: JSON.stringify({email: email}),
        headers: {
          'Content-Type': 'application/json'
        },
        success: function(response) {
          const customerStatusData = response.data || {};
          const firstOrder = customerStatusData.firstOrder;
          const subscribed = customerStatusData.subscribed;
          const marketingState = customerStatusData.marketingState;
          var isSubscribed = !!subscribed && marketingState === 'SUBSCRIBED';
          var isFirstOrder = !!firstOrder;
          subscribeModuleFn.updateCustomerFlags({
            subscribed: isSubscribed,
            firstOrder: isFirstOrder
          });
          callback && callback(isSubscribed);
        },
        error: function() {
          WS.ui.toastShowHandle(WS.ui.errorMsgMap ? WS.ui.errorMsgMap.baseError : 'Something went wrong. Please try again.', 2500);
          callback && callback(false);
        }
      });
    },

    // 订阅接口
    customerSubscription: function(email, phone, callback) {
      if (!email) {
        callback && callback(false);
        return;
      }
      var data = {
        email: email,
      }
      if (phone) data.phone = phone;
      // 订阅接口URL
      const subscribe_url = 'https://capi.westyle.ai/westyle-shopify/shopify/customer/subscription'
      WS.ajax({
        url: subscribe_url,
        type: 'POST',
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        },
        success: function(response) {
          if (!response.data || !response.data.subscribed) {
            WS.ui.toastShowHandle(WS.ui.errorMsgMap ? WS.ui.errorMsgMap.baseError : 'Something went wrong. Please try again.', 2500);
            callback && callback(false);
            return;
          }
          const subscribed = response.data.subscribed;
          const firstOrder = response.data.firstOrder;
          subscribeModuleFn.updateCustomerFlags({
            subscribed: !!subscribed,
            firstOrder: !!firstOrder
          });
          localStorage.setItem('westyle_email', email);
          if (phone) localStorage.setItem('westyle_phone', phone);
          callback && callback(true);
        },
        error: function() {
          WS.ui.toastShowHandle(WS.ui.errorMsgMap ? WS.ui.errorMsgMap.baseError : 'Something went wrong. Please try again.', 2500);
          callback && callback(false);
        }
      });
    },
    tryOpen: function(initialStep) {
      if (!WS.site.subscribePopupEnabled) return;
      subscribeModuleFn.loadAndShow(function(popup) {
        postscriptEmbeddedCompletionHandled = false;
        resetSubscribeTrackingSession(popup);
        bindSubscribePopupCloseControls(popup);
        clearSubscribeAppliedToast();
        showSubscribeStep(popup, getInitialSubscribeStep(initialStep));
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        clearSubscribeScrollRestoreTimers();
        lockSubscribePageScroll();
        syncSubscribePopupViewportHeight(true);
        document.documentElement.classList.add('ws-subscribe-popup-open');
        document.body.classList.add('ws-subscribe-popup-open');
        WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
        startPostscriptCountryDropdownObserver();
        reportSubscribeModuleShowOnce('showEmailSmsPopup', SUBSCRIBE_REPORT_PAGES);
      });
    },

    openSubscriptionPopup: function(initialStep) {
      if (WS.site.subscribePopupEnabled) {
        subscribeModuleFn.tryOpen(initialStep);
        return;
      }
      openPostscriptPopup();
    },

    // 订阅弹窗自动展示：保留原有判断，仅把触发时机交给调度方法统一管理。
    scheduleAutoOpen: function(delay) {
      if (subscribeModuleFn.autoOpenTimer || !shouldShowSubscribePopupToday()) return;

      subscribeModuleFn.autoOpenTimer = setTimeout(function() {
        subscribeModuleFn.autoOpenTimer = null;
        if (!shouldShowSubscribePopupToday()) return;

        // 如果营销弹窗正在展示，订阅弹窗等营销弹窗关闭后再延迟展示。
        if (WS.ui.activityPopupFn && WS.ui.activityPopupFn.isVisible && WS.ui.activityPopupFn.isVisible()) {
          subscribeModuleFn.scheduleAutoOpenAfterActivityPopup();
          return;
        }

        // 每天首次进站：未订阅状态下自动展开。
        if (subscribeModuleFn.isSubscribed) return;
        subscribeModuleFn.tryOpen();
        markSubscribePopupShownToday();
      }, delay || SUBSCRIBE_AUTO_OPEN_DELAY);
    },

    // 有营销弹窗时，监听营销弹窗关闭事件，再恢复订阅弹窗原本的延迟逻辑。
    scheduleAutoOpenAfterActivityPopup: function() {
      if (subscribeModuleFn.waitingForActivityPopup || !shouldShowSubscribePopupToday()) return;

      if (
        !WS.ui.activityPopupFn ||
        (WS.ui.activityPopupFn.hasPopup && !WS.ui.activityPopupFn.hasPopup()) ||
        (WS.ui.activityPopupFn.isClosed && WS.ui.activityPopupFn.isClosed())
      ) {
        subscribeModuleFn.scheduleAutoOpen(SUBSCRIBE_AUTO_OPEN_DELAY);
        return;
      }

      subscribeModuleFn.waitingForActivityPopup = true;

      document.addEventListener('ws:activity-popup:closed', function() {
        subscribeModuleFn.waitingForActivityPopup = false;
        subscribeModuleFn.scheduleAutoOpen(SUBSCRIBE_AUTO_OPEN_DELAY);
      }, { once: true });
    },

    bindEvent: function() {
      document.addEventListener('click', function(e) {
        // 订阅悬浮按钮和 Free Gift 悬浮按钮共用“点击关闭后隐藏当前模块”的逻辑。
        var fabClose = e.target && e.target.closest ? e.target.closest('#subscribe-fab-close') : null;
        var freeGiftFabClose = e.target && e.target.closest ? e.target.closest('#free-gift-fab-close') : null;
        if (!fabClose && !freeGiftFabClose) return;
        var fab = fabClose ? fabClose.closest('.ws-index-subscribe-fab') : freeGiftFabClose.closest('.ws-free-gift-fab');
        if (fab) fab.style.display = 'none';
      });

      // 页脚邮箱订阅不依赖自定义弹窗，弹窗关闭时仍需保留表单提交与校验。
      this.bindSubscribeForm();
      bindPostscriptPopupEvents();
      if (!WS.site.subscribePopupEnabled) return;

      var container = document.getElementById('ws-subscribe-popup-container');
      if (!container) return;

      var fabBtn = document.getElementById('subscribe-fab-btn');
      if (fabBtn) {
        // 悬浮订阅图标固定展示在左下角：检测到按钮存在即认为已曝光
        reportSubscribeModuleShowOnce('showSubscriptionIcon', SUBSCRIBE_REPORT_PAGES);
      }

      document.addEventListener('click', function(e) {
        var eventTarget = e.target && e.target.closest ? e.target : null;
        if (!eventTarget) return;
        var popup = container.querySelector('.ws-subscribe-popup.is-visible');
        if (!popup) return;

        var editPhoneTarget = eventTarget.closest('[data-subscribe-edit-phone]');
        if (editPhoneTarget && container.contains(editPhoneTarget)) {
          e.preventDefault();
          if (e.stopImmediatePropagation) {
            e.stopImmediatePropagation();
          } else {
            e.stopPropagation();
          }
          restartPostscriptPhoneEntry(popup);
          return;
        }

        var closeTarget = eventTarget.closest('.ws-subscribe__close, [data-close-popup], [data-subscribe-maybe-later]');
        if (!closeTarget || !container.contains(closeTarget)) return;

        e.preventDefault();
        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        } else {
          e.stopPropagation();
        }

        reportSubscribeClick('emailSmsPopupClose');
        closeSubscribePopup(popup);
      }, true);

      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) return;
        var popup = container.querySelector('.ws-subscribe-popup.is-visible');
        if (popup) closeSubscribePopup(popup);
      });

      document.addEventListener('click', function(e) {
        var eventTarget = e.target && e.target.closest ? e.target : null;
        var openTrigger = eventTarget ? getSubscribeTrigger(e) : null;
        var type = openTrigger ? openTrigger.getAttribute('data-type') : null;
        if (openTrigger) {
          e.preventDefault();
          if (shouldReportSubscriptionClick()) {
            if (type === 'top-banner') {
              reportSubscribeClick('subscriptionTopBannerClick');
            } else {
              reportSubscribeClick('subscriptionIconClick');
            }
          }
          subscribeModuleFn.tryOpen();
          return;
        }
      });

      if (shouldShowSubscribePopupToday()) {
        if (
          WS.ui.activityPopupFn &&
          WS.ui.activityPopupFn.hasPopup &&
          WS.ui.activityPopupFn.hasPopup() &&
          !(WS.ui.activityPopupFn.isClosed && WS.ui.activityPopupFn.isClosed())
        ) {
          subscribeModuleFn.scheduleAutoOpenAfterActivityPopup();
        } else {
          subscribeModuleFn.scheduleAutoOpen(SUBSCRIBE_AUTO_OPEN_DELAY);
        }
      }
      bindPostscriptEmbeddedFormEvents();
      bindPostscriptCountryDropdownStyles();
      bindSubscribePageTouchLock();
      bindSubscribePopupViewportLock();
    },
    bindSubscribeForm: function() {
      // 设置表单输入提示
      function setFieldHint(form, type, visible) {
        if (!form) return;
        var hintEl = form.querySelector('[data-field-hint="' + type + '"]');
        if (!hintEl) return;
        hintEl.hidden = !visible;
      }

      // 验证表单输入
      function validateFieldByInput(input) {
        if (!input || !input.closest) return true;
        var form = input.closest('.ws-subscribe__form');
        if (!form) return true;

        // 验证邮箱输入
        if (input.name === 'contact[email]') {
          var email = (input.value || '').trim();
          var isValidEmail = !!email && EMAIL_REG.test(email);
          // 设置邮箱输入提示
          setFieldHint(form, 'email', !isValidEmail);
          return isValidEmail;
        }

        return true;
      }

      function dispatchSubscribeSubmitEvent(isSuccess, popup) {
        if (typeof window === 'undefined' || !window.dispatchEvent) return;
        window.dispatchEvent(new CustomEvent('ws:subscribe:submit', {
          detail: { isSuccess: !!isSuccess, popup: popup }
        }));
      }

      // 点击首屏 15% CTA 与实际通过校验的表单提交分别上报。
      document.addEventListener('click', function(e) {
        var target = e.target && e.target.closest ? e.target : null;
        var cta = target && target.closest('[data-subscription-cta]');
        if (cta && cta.closest('.ws-subscribe-popup.is-visible')) {
          reportSubscribeClick('subscriptionClick');
        }
        reportSubscribeFormStartedFromEvent(e);
      }, true);

      document.addEventListener('focusin', reportSubscribeFormStartedFromEvent, true);

      // 订阅表单提交事件
      document.addEventListener('submit', function(e) {
        if (!e.target || !e.target.classList || !e.target.classList.contains('ws-subscribe__form')) return;
        e.preventDefault();
        e.stopPropagation();
        var form = e.target;
        var $form = $(form);
        var popup = form.closest('.ws-subscribe-popup');
        var isPopupEmailForm = !!(popup && form.classList.contains('ws-subscribe__form--email'));
        var isFooterForm = form.id === 'ws-footer-subscribe-form' || form.id === 'ws-footer-subscribe-form-desktop';
        // 获取邮箱输入框
        var emailInput = form.querySelector('input[name="contact[email]"]');
        // 获取邮箱
        var email = emailInput ? (emailInput.value || '').trim() : '';

        // 关闭邮箱输入提示
        setFieldHint(form, 'email', false);

        // 验证邮箱输入是否有效
        if (!email || !EMAIL_REG.test(email)) {
          // 设置邮箱输入提示
          setFieldHint(form, 'email', true);
          return;
        }

        if (isPopupEmailForm) {
          reportSubscribeClick('emailSmsSubmit', email, '');

          var $emailBtn = $form.find('button[type="submit"]').first();
          var emailBtnHtml = $emailBtn.html();
          WS.ui.loadingBtnShow && WS.ui.loadingBtnShow($emailBtn, 2);
          $emailBtn.prop('disabled', true);

          subscribeModuleFn.customerSubscription(email, '', function(isSuccess) {
            dispatchSubscribeSubmitEvent(isSuccess, popup);

            if (!isSuccess) {
              WS.ui.loadingBtnHide && WS.ui.loadingBtnHide($emailBtn, emailBtnHtml);
              $emailBtn.prop('disabled', false);
              return;
            }

            WS.ui.loadingBtnHide && WS.ui.loadingBtnHide($emailBtn, emailBtnHtml);
            $emailBtn.prop('disabled', false);
            showSubscribeStep(popup, getInitialSubscribeStep('phone'));
          });
          return;
        }

        reportSubscribeClick('emailSmsSubmit', email, '');

        var subscribeRoot = form.closest('.ws-subscribe');
        var checkbox = subscribeRoot && subscribeRoot.querySelector('.ws-subscribe__checkbox');
        if (checkbox && !checkbox.checked) {
          WS.ui.toastShowHandle(checkbox.getAttribute('data-consent-error') || 'Please agree to the terms before subscribing', 2000);
          return;
        }

        var $btn = $form.find('button[type="submit"]').first();
        var btnHtml = $btn.html();
        // 显示加载中状态
        WS.ui.loadingBtnShow && WS.ui.loadingBtnShow($btn, 2);
        // 禁用提交按钮
        $btn.prop('disabled', true);

        // footer 订阅只同步邮箱；手机号统一由弹窗里的 Postscript Embedded Form 处理。
        subscribeModuleFn.customerSubscription(email, '', function(isSuccess) {
          dispatchSubscribeSubmitEvent(isSuccess, popup);
          if (isSuccess) {
            if (subscribeModuleFn.isFirstOrder) {
              if (isFooterForm) {
                // 页脚仅收集邮箱；订阅成功后复用购物车逻辑自动应用 WELCOME15。
                applySubscribeWelcomeDiscount();
              }
            } else {
              setFieldHint(popup, 'tips', true);
              if (isFooterForm) {
                WS.ui.toastShowHandle('Thanks for subscribing. This account has used the welcome offer.', 3000);
              }
            }
          }
          WS.ui.loadingBtnHide && WS.ui.loadingBtnHide($btn, btnHtml);
          $btn.prop('disabled', false);
        });

      }, true);

      document.addEventListener('input', function(e) {
        // 获取输入框
        var input = e.target;
        // 如果输入框不存在，或者输入框不存在，则返回
        if (!input || !input.closest) return;
        // 获取表单
        var form = input.closest('.ws-subscribe__form');
        // 如果表单不存在，则返回
        if (!form) return;
        if (input.name === 'contact[email]') {
          // 关闭邮箱输入提示
          setFieldHint(form, 'email', false);
        }
      }, true);

      document.addEventListener('focusout', function(e) {
        // 获取输入框
        var input = e.target;
        // 如果输入框不存在，则返回
        if (!input) return;
        if (input.name !== 'contact[email]') return;
        // 验证输入框是否有效
        validateFieldByInput(input);
      }, true);

    }
  };

  WS.ui.subscribeModuleFn = subscribeModuleFn;
  WS.ui.subscribeModuleFn.isSubscribed = subscribeModuleFn.isSubscribed;
  WS.ui.subscribeModuleFn.isFirstOrder = subscribeModuleFn.isFirstOrder;
  WS.ui.subscribeModuleFn.tryOpen = subscribeModuleFn.tryOpen;
  WS.ui.subscribeModuleFn.closeSubscribePopup = closeSubscribePopup;
})();

(function(WS) {
  if (!WS || !WS.ui) return;

  // 活动弹窗：由 sections/westyle-activity-popup.liquid 输出 DOM，这里统一负责打开、倒计时和关闭。
  var activityPopupFn = {
    isKeydownBound: false,
    storageKey: 'ws-activity-popup-shown-date',
    reportPages: ['index', 'collection', 'product', 'search'],

    reportEvent: function(eventName, eid, options) {
      if (!eventName || !window.WS || !WS.stat || !WS.ui || !WS.ui.reportType) return;
      var page = WS.site && WS.site.page ? WS.site.page : '';
      if (activityPopupFn.reportPages.indexOf(page) === -1) return;
      WS.stat({
        eid: eid || WS.ui.reportType['click'],
        event_name: eventName
      }, null, null, options);
    },

    // 获取当天日期，用来控制营销弹窗每天只展示一次。
    getToday: function() {
      var d = new Date();
      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    },

    // 读取今日是否已经展示过营销弹窗。
    getShownDate: function() {
      var localDate = '';
      try {
        localDate = localStorage.getItem(activityPopupFn.storageKey) || '';
      } catch (e) {}
      return localDate || (WS.cookie && WS.cookie.get ? WS.cookie.get(activityPopupFn.storageKey) : '');
    },

    // 标记营销弹窗今日已经展示，刷新页面也不会再次弹出。
    markShownToday: function() {
      var today = activityPopupFn.getToday();
      try {
        localStorage.setItem(activityPopupFn.storageKey, today);
      } catch (e) {}
      if (WS.cookie && WS.cookie.set) {
        WS.cookie.set(activityPopupFn.storageKey, today, 24 * 2);
      }
    },

    // Shopify 后台编辑时仍允许反复预览弹窗。
    shouldShowToday: function() {
      if (window.Shopify && window.Shopify.designMode) return true;
      return activityPopupFn.getShownDate() !== activityPopupFn.getToday();
    },

    // 格式化倒计时文案：60 秒以上展示为 3:00，60 秒以下展示为 59S。
    formatCountdown: function(seconds) {
      seconds = parseInt(seconds, 10) || 0;
      if (seconds >= 60) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return minutes + ':' + (remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds);
      }
      return seconds + 'S';
    },

    // 更新弹窗右上角倒计时。
    updateCountdown: function(popup, seconds) {
      var countdownEl = popup && popup.querySelector ? popup.querySelector('[data-ws-activity-countdown]') : null;
      if (countdownEl) countdownEl.textContent = activityPopupFn.formatCountdown(seconds);
    },

    // 关闭弹窗并恢复页面滚动。
    close: function(popup) {
      if (!popup) return;
      var wasVisible = popup.classList.contains('is-visible');
      window.clearInterval(popup._wsActivityTimer);
      popup._wsActivityTimer = null;
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('data-ws-activity-closed', '1');

      if (!document.querySelector('[data-ws-activity-popup].is-visible')) {
        document.body.classList.remove('ws-activity-popup-open');
        if (wasVisible) {
          var closeEvent;
          if (typeof CustomEvent === 'function') {
            closeEvent = new CustomEvent('ws:activity-popup:closed');
          } else {
            closeEvent = document.createEvent('CustomEvent');
            closeEvent.initCustomEvent('ws:activity-popup:closed', false, false, {});
          }
          document.dispatchEvent(closeEvent);
        }
      }
    },

    // 判断当前页面是否配置了营销弹窗。
    hasPopup: function() {
      return !!document.querySelector('[data-ws-activity-popup]');
    },

    // 判断营销弹窗是否正在展示。
    isVisible: function() {
      return !!document.querySelector('[data-ws-activity-popup].is-visible');
    },

    // 判断营销弹窗是否已经关闭过。
    isClosed: function() {
      var popup = document.querySelector('[data-ws-activity-popup]');
      return !!(popup && popup.getAttribute('data-ws-activity-closed') === '1');
    },

    // 开始倒计时，倒计时结束后自动关闭弹窗。
    startCountdown: function(popup) {
      // 当前营销弹窗固定展示 3 秒。
      var seconds = 5;
      var remaining = seconds;

      activityPopupFn.updateCountdown(popup, remaining);
      window.clearInterval(popup._wsActivityTimer);

      var timer = window.setInterval(function() {
        remaining -= 1;
        if (remaining <= 0) {
          activityPopupFn.close(popup);
          return;
        }
        activityPopupFn.updateCountdown(popup, remaining);
      }, 1000);

      popup._wsActivityTimer = timer;
    },

    // 打开弹窗并锁定页面滚动。
    open: function(popup) {
      if (!popup) return;
      activityPopupFn.markShownToday();
      popup.setAttribute('data-ws-activity-closed', '0');
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ws-activity-popup-open');
      activityPopupFn.reportEvent('july_sale_show', WS.ui.reportType['moduleShow']);
      activityPopupFn.startCountdown(popup);
    },

    // 单个弹窗 DOM 初始化：绑定关闭按钮，并在进站后立即展示。
    initPopup: function(popup) {
      if (!popup || popup.getAttribute('data-ws-activity-initialized') === '1') return;
      popup.setAttribute('data-ws-activity-initialized', '1');
      popup.setAttribute('data-ws-activity-closed', '0');

      var closeBtn = popup.querySelector('[data-ws-activity-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          activityPopupFn.close(popup);
        });
      }

      var imageLink = popup.querySelector('.ws-activity-popup__image-link');
      if (imageLink) {
        imageLink.addEventListener('click', function() {
          activityPopupFn.reportEvent('july_sale_shop_click', WS.ui.reportType['click'], { useBeacon: true });
        });
      }

      if (!activityPopupFn.shouldShowToday()) {
        popup.setAttribute('data-ws-activity-closed', '1');
        popup.setAttribute('aria-hidden', 'true');
        return;
      }

      activityPopupFn.open(popup);
    },

    // 全局事件只绑定一次：支持 ESC 关闭，并兼容 Shopify 后台 section 刷新。
    bindGlobalEvents: function() {
      if (activityPopupFn.isKeydownBound) return;
      activityPopupFn.isKeydownBound = true;

      document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;
        var popups = document.querySelectorAll('[data-ws-activity-popup].is-visible');
        for (var i = 0; i < popups.length; i++) {
          activityPopupFn.close(popups[i]);
        }
      });

      document.addEventListener('shopify:section:load', function() {
        activityPopupFn.init();
      });
    },

    // 初始化页面上所有活动弹窗。
    init: function() {
      activityPopupFn.bindGlobalEvents();
      var popups = document.querySelectorAll('[data-ws-activity-popup]');
      for (var i = 0; i < popups.length; i++) {
        activityPopupFn.initPopup(popups[i]);
      }
    }
  };

  WS.ui.activityPopupFn = activityPopupFn;
})(WeStyle);

(function() {
  window.onload = function() {
    // 阻止双击放大
    var lastTouchEnd = 0;
    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    });
    document.addEventListener('touchend', function(event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);

    // 阻止双指放大
    document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
    });
  }
})();


(function () {

  async function init() {
    WS.ui.getScreenHeight();

    WS.ui.setClientClassName();
    
    WS.ui.watchAjaxError();

    WS.ui.initResize();

    if (WS.ui.isLogin()) {
      WS.ui.checkUserCountry();
    }
    
    // 动态插入模块方法
    WS.ui.dynamicInsertModuleFn.insertFooterHander();
    WS.ui.dynamicInsertModuleFn.insertHeaderMenuHander();

    WS.ui.handleHeaderInteractive();

    // if (WS.site.page === 'index') {
    //   WS.ui.onRequestCollectionData();
    // }

    
    // 头部announcement-bar滚动方法
    WS.ui.dynamicInsertModuleFn.announcementBarSlide();

    WS.ui.collectionFn.handleCollectAll();
    WS.ui.productPopupFn.productPopBindEvent();

    WS.ui.activityPopupFn.init();
    WS.ui.subscribeModuleFn.bindEvent();
    WS.ui.subscribeModuleFn.getCustomer();

    // 全局公共事件绑定方法
    WS.ui.publicEventBind();

    // 当为搜索页时
    if (WS.site.page == 'search') {
      WS.ui.searchFn.handleSearchAll();
    }

    // 图片懒加载公共方法
    WS.ui.initImgLazyloadHandle();
    // 获取元素
    var lazyLoadContainer = document.querySelector("body");
    // 配置选项
    var lazyLoadConfig = { attributes: true, childList: true, subtree: true };
    var lazyLoadObserver = new MutationObserver(function (mutationsList, observer) {
      for (var mutation of mutationsList) {
        if (mutation.type == 'childList') {
          WS.ui.initImgLazyloadHandle();
        }
      }
    });
    // 开始观测
    lazyLoadObserver.observe(lazyLoadContainer, lazyLoadConfig);

    WS.ui.asyncLoadUrls();
  }

  var initConfig = {
    abt: Object.values(WS.ui.abtMap)
  };

  WS.init(initConfig);
  init();

})();
